
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6PK7Y", function(module, exports) {
/*!
 * Materialize v1.0.0 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */ var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */ (function(factory) {
    window.cash = factory();
})(function() {
    var doc = document, win = window, ArrayProto = Array.prototype, slice = ArrayProto.slice, filter = ArrayProto.filter, push = ArrayProto.push;
    var noop = function() {}, isFunction = function(item) {
        // @see https://crbug.com/568448
        return typeof item === typeof noop && item.call;
    }, isString = function(item) {
        return typeof item === "string";
    };
    var idMatch = /^#[\w-]*$/, classMatch = /^\.[\w-]*$/, htmlMatch = /<.+>/, singlet = /^\w+$/;
    function find(selector, context) {
        context = context || doc;
        var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
        return elems;
    }
    var frag;
    function parseHTML(str) {
        if (!frag) {
            frag = doc.implementation.createHTMLDocument(null);
            var base = frag.createElement("base");
            base.href = doc.location.href;
            frag.head.appendChild(base);
        }
        frag.body.innerHTML = str;
        return frag.body.childNodes;
    }
    function onReady(fn) {
        if (doc.readyState !== "loading") fn();
        else doc.addEventListener("DOMContentLoaded", fn);
    }
    function Init(selector, context) {
        if (!selector) return this;
        // If already a cash collection, don't do any further processing
        if (selector.cash && selector !== win) return selector;
        var elems = selector, i = 0, length;
        if (isString(selector)) elems = idMatch.test(selector) ? // If an ID use the faster getElementById check
        doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ? // If HTML, parse it into real elements
        parseHTML(selector) : // else use `find`
        find(selector, context);
        else if (isFunction(selector)) {
            onReady(selector);
            return this;
        }
        if (!elems) return this;
        // If a single DOM element is passed in or received via ID, return the single element
        if (elems.nodeType || elems === win) {
            this[0] = elems;
            this.length = 1;
        } else {
            // Treat like an array and loop through each item.
            length = this.length = elems.length;
            for(; i < length; i++)this[i] = elems[i];
        }
        return this;
    }
    function cash1(selector, context) {
        return new Init(selector, context);
    }
    var fn = cash1.fn = cash1.prototype = Init.prototype = {
        cash: true,
        length: 0,
        push: push,
        splice: ArrayProto.splice,
        map: ArrayProto.map,
        init: Init
    };
    Object.defineProperty(fn, "constructor", {
        value: cash1
    });
    cash1.parseHTML = parseHTML;
    cash1.noop = noop;
    cash1.isFunction = isFunction;
    cash1.isString = isString;
    cash1.extend = fn.extend = function(target) {
        target = target || {};
        var args = slice.call(arguments), length = args.length, i = 1;
        if (args.length === 1) {
            target = this;
            i = 0;
        }
        for(; i < length; i++){
            if (!args[i]) continue;
            for(var key in args[i])if (args[i].hasOwnProperty(key)) target[key] = args[i][key];
        }
        return target;
    };
    function each(collection, callback) {
        var l = collection.length, i = 0;
        for(; i < l; i++){
            if (callback.call(collection[i], collection[i], i, collection) === false) break;
        }
    }
    function matches(el, selector) {
        var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
        return !!m && m.call(el, selector);
    }
    function getCompareFunction(selector) {
        return /* Use browser's `matches` function if string */ isString(selector) ? matches : /* Match a cash element */ selector.cash ? function(el) {
            return selector.is(el);
        } : /* Direct comparison */ function(el, selector) {
            return el === selector;
        };
    }
    function unique(collection) {
        return cash1(slice.call(collection).filter(function(item, index, self) {
            return self.indexOf(item) === index;
        }));
    }
    cash1.extend({
        merge: function(first, second) {
            var len = +second.length, i = first.length, j = 0;
            for(; j < len; i++, j++)first[i] = second[j];
            first.length = i;
            return first;
        },
        each: each,
        matches: matches,
        unique: unique,
        isArray: Array.isArray,
        isNumeric: function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
    });
    var uid = cash1.uid = "_cash" + Date.now();
    function getDataCache(node) {
        return node[uid] = node[uid] || {};
    }
    function setData(node, key, value) {
        return getDataCache(node)[key] = value;
    }
    function getData(node, key) {
        var c = getDataCache(node);
        if (c[key] === undefined) c[key] = node.dataset ? node.dataset[key] : cash1(node).attr("data-" + key);
        return c[key];
    }
    function removeData(node, key) {
        var c = getDataCache(node);
        if (c) delete c[key];
        else if (node.dataset) delete node.dataset[key];
        else cash1(node).removeAttr("data-" + name);
    }
    fn.extend({
        data: function(name1, value) {
            if (isString(name1)) return value === undefined ? getData(this[0], name1) : this.each(function(v) {
                return setData(v, name1, value);
            });
            for(var key in name1)this.data(key, name1[key]);
            return this;
        },
        removeData: function(key) {
            return this.each(function(v) {
                return removeData(v, key);
            });
        }
    });
    var notWhiteMatch = /\S+/g;
    function getClasses(c) {
        return isString(c) && c.match(notWhiteMatch);
    }
    function hasClass(v, c) {
        return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
    }
    function addClass(v, c, spacedName) {
        if (v.classList) v.classList.add(c);
        else if (spacedName.indexOf(" " + c + " ")) v.className += " " + c;
    }
    function removeClass(v, c) {
        if (v.classList) v.classList.remove(c);
        else v.className = v.className.replace(c, "");
    }
    fn.extend({
        addClass: function(c) {
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                var spacedName = " " + v.className + " ";
                each(classes, function(c) {
                    addClass(v, c, spacedName);
                });
            }) : this;
        },
        attr: function(name1, value) {
            if (!name1) return undefined;
            if (isString(name1)) {
                if (value === undefined) return this[0] ? this[0].getAttribute ? this[0].getAttribute(name1) : this[0][name1] : undefined;
                return this.each(function(v) {
                    if (v.setAttribute) v.setAttribute(name1, value);
                    else v[name1] = value;
                });
            }
            for(var key in name1)this.attr(key, name1[key]);
            return this;
        },
        hasClass: function(c) {
            var check = false, classes = getClasses(c);
            if (classes && classes.length) this.each(function(v) {
                check = hasClass(v, classes[0]);
                return !check;
            });
            return check;
        },
        prop: function(name1, value) {
            if (isString(name1)) return value === undefined ? this[0][name1] : this.each(function(v) {
                v[name1] = value;
            });
            for(var key in name1)this.prop(key, name1[key]);
            return this;
        },
        removeAttr: function(name1) {
            return this.each(function(v) {
                if (v.removeAttribute) v.removeAttribute(name1);
                else delete v[name1];
            });
        },
        removeClass: function(c) {
            if (!arguments.length) return this.attr("class", "");
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                each(classes, function(c) {
                    removeClass(v, c);
                });
            }) : this;
        },
        removeProp: function(name1) {
            return this.each(function(v) {
                delete v[name1];
            });
        },
        toggleClass: function(c, state) {
            if (state !== undefined) return this[state ? "addClass" : "removeClass"](c);
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                var spacedName = " " + v.className + " ";
                each(classes, function(c) {
                    if (hasClass(v, c)) removeClass(v, c);
                    else addClass(v, c, spacedName);
                });
            }) : this;
        }
    });
    fn.extend({
        add: function(selector, context) {
            return unique(cash1.merge(this, cash1(selector, context)));
        },
        each: function(callback) {
            each(this, callback);
            return this;
        },
        eq: function(index) {
            return cash1(this.get(index));
        },
        filter: function(selector) {
            if (!selector) return this;
            var comparator = isFunction(selector) ? selector : getCompareFunction(selector);
            return cash1(filter.call(this, function(e) {
                return comparator(e, selector);
            }));
        },
        first: function() {
            return this.eq(0);
        },
        get: function(index) {
            if (index === undefined) return slice.call(this);
            return index < 0 ? this[index + this.length] : this[index];
        },
        index: function(elem) {
            var child = elem ? cash1(elem)[0] : this[0], collection = elem ? this : cash1(child).parent().children();
            return slice.call(collection).indexOf(child);
        },
        last: function() {
            return this.eq(-1);
        }
    });
    var camelCase = function() {
        var camelRegex = /(?:^\w|[A-Z]|\b\w)/g, whiteSpace = /[\s-_]+/g;
        return function(str) {
            return str.replace(camelRegex, function(letter, index) {
                return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
            }).replace(whiteSpace, "");
        };
    }();
    var getPrefixedProp = function() {
        var cache = {}, doc = document, div = doc.createElement("div"), style = div.style;
        return function(prop) {
            prop = camelCase(prop);
            if (cache[prop]) return cache[prop];
            var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1), prefixes = [
                "webkit",
                "moz",
                "ms",
                "o"
            ], props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");
            each(props, function(p) {
                if (p in style) {
                    cache[p] = prop = cache[prop] = p;
                    return false;
                }
            });
            return cache[prop];
        };
    }();
    cash1.prefixedProp = getPrefixedProp;
    cash1.camelCase = camelCase;
    fn.extend({
        css: function(prop, value) {
            if (isString(prop)) {
                prop = getPrefixedProp(prop);
                return arguments.length > 1 ? this.each(function(v) {
                    return v.style[prop] = value;
                }) : win.getComputedStyle(this[0])[prop];
            }
            for(var key in prop)this.css(key, prop[key]);
            return this;
        }
    });
    function compute(el, prop) {
        return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
    }
    each([
        "Width",
        "Height"
    ], function(v) {
        var lower = v.toLowerCase();
        fn[lower] = function() {
            return this[0].getBoundingClientRect()[lower];
        };
        fn["inner" + v] = function() {
            return this[0]["client" + v];
        };
        fn["outer" + v] = function(margins) {
            return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
        };
    });
    function registerEvent(node, eventName, callback) {
        var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
        eventCache[eventName] = eventCache[eventName] || [];
        eventCache[eventName].push(callback);
        node.addEventListener(eventName, callback);
    }
    function removeEvent(node, eventName, callback) {
        var events = getData(node, "_cashEvents"), eventCache = events && events[eventName], index;
        if (!eventCache) return;
        if (callback) {
            node.removeEventListener(eventName, callback);
            index = eventCache.indexOf(callback);
            if (index >= 0) eventCache.splice(index, 1);
        } else {
            each(eventCache, function(event) {
                node.removeEventListener(eventName, event);
            });
            eventCache = [];
        }
    }
    fn.extend({
        off: function(eventName, callback) {
            return this.each(function(v) {
                return removeEvent(v, eventName, callback);
            });
        },
        on: function(eventName, delegate, callback, runOnce) {
            // jshint ignore:line
            var originalCallback;
            if (!isString(eventName)) {
                for(var key in eventName)this.on(key, delegate, eventName[key]);
                return this;
            }
            if (isFunction(delegate)) {
                callback = delegate;
                delegate = null;
            }
            if (eventName === "ready") {
                onReady(callback);
                return this;
            }
            if (delegate) {
                originalCallback = callback;
                callback = function(e) {
                    var t = e.target;
                    while(!matches(t, delegate)){
                        if (t === this || t === null) return t = false;
                        t = t.parentNode;
                    }
                    if (t) originalCallback.call(t, e);
                };
            }
            return this.each(function(v) {
                var finalCallback = callback;
                if (runOnce) finalCallback = function() {
                    callback.apply(this, arguments);
                    removeEvent(v, eventName, finalCallback);
                };
                registerEvent(v, eventName, finalCallback);
            });
        },
        one: function(eventName, delegate, callback) {
            return this.on(eventName, delegate, callback, true);
        },
        ready: onReady,
        /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */ trigger: function(eventName, data) {
            if (document.createEvent) {
                var evt = document.createEvent('HTMLEvents');
                evt.initEvent(eventName, true, false);
                evt = this.extend(evt, data);
                return this.each(function(v) {
                    return v.dispatchEvent(evt);
                });
            }
        }
    });
    function encode(name1, value) {
        return "&" + encodeURIComponent(name1) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
    }
    function getSelectMultiple_(el) {
        var values = [];
        each(el.options, function(o) {
            if (o.selected) values.push(o.value);
        });
        return values.length ? values : null;
    }
    function getSelectSingle_(el) {
        var selectedIndex = el.selectedIndex;
        return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
    }
    function getValue(el) {
        var type = el.type;
        if (!type) return null;
        switch(type.toLowerCase()){
            case "select-one":
                return getSelectSingle_(el);
            case "select-multiple":
                return getSelectMultiple_(el);
            case "radio":
                return el.checked ? el.value : null;
            case "checkbox":
                return el.checked ? el.value : null;
            default:
                return el.value ? el.value : null;
        }
    }
    fn.extend({
        serialize: function() {
            var query = "";
            each(this[0].elements || this, function(el) {
                if (el.disabled || el.tagName === "FIELDSET") return;
                var name1 = el.name;
                switch(el.type.toLowerCase()){
                    case "file":
                    case "reset":
                    case "submit":
                    case "button":
                        break;
                    case "select-multiple":
                        var values = getValue(el);
                        if (values !== null) each(values, function(value) {
                            query += encode(name1, value);
                        });
                        break;
                    default:
                        var value = getValue(el);
                        if (value !== null) query += encode(name1, value);
                }
            });
            return query.substr(1);
        },
        val: function(value) {
            if (value === undefined) return getValue(this[0]);
            return this.each(function(v) {
                return v.value = value;
            });
        }
    });
    function insertElement(el, child, prepend) {
        if (prepend) {
            var first = el.childNodes[0];
            el.insertBefore(child, first);
        } else el.appendChild(child);
    }
    function insertContent(parent, child, prepend) {
        var str = isString(child);
        if (!str && child.length) {
            each(child, function(v) {
                return insertContent(parent, v, prepend);
            });
            return;
        }
        each(parent, str ? function(v) {
            return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
        } : function(v, i) {
            return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
        });
    }
    fn.extend({
        after: function(selector) {
            cash1(selector).insertAfter(this);
            return this;
        },
        append: function(content) {
            insertContent(this, content);
            return this;
        },
        appendTo: function(parent) {
            insertContent(cash1(parent), this);
            return this;
        },
        before: function(selector) {
            cash1(selector).insertBefore(this);
            return this;
        },
        clone: function() {
            return cash1(this.map(function(v) {
                return v.cloneNode(true);
            }));
        },
        empty: function() {
            this.html("");
            return this;
        },
        html: function(content) {
            if (content === undefined) return this[0].innerHTML;
            var source = content.nodeType ? content[0].outerHTML : content;
            return this.each(function(v) {
                return v.innerHTML = source;
            });
        },
        insertAfter: function(selector) {
            var _this = this;
            cash1(selector).each(function(el, i) {
                var parent = el.parentNode, sibling = el.nextSibling;
                _this.each(function(v) {
                    parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
                });
            });
            return this;
        },
        insertBefore: function(selector) {
            var _this2 = this;
            cash1(selector).each(function(el, i) {
                var parent = el.parentNode;
                _this2.each(function(v) {
                    parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
                });
            });
            return this;
        },
        prepend: function(content) {
            insertContent(this, content, true);
            return this;
        },
        prependTo: function(parent) {
            insertContent(cash1(parent), this, true);
            return this;
        },
        remove: function() {
            return this.each(function(v) {
                if (!!v.parentNode) return v.parentNode.removeChild(v);
            });
        },
        text: function(content) {
            if (content === undefined) return this[0].textContent;
            return this.each(function(v) {
                return v.textContent = content;
            });
        }
    });
    var docEl = doc.documentElement;
    fn.extend({
        position: function() {
            var el = this[0];
            return {
                left: el.offsetLeft,
                top: el.offsetTop
            };
        },
        offset: function() {
            var rect = this[0].getBoundingClientRect();
            return {
                top: rect.top + win.pageYOffset - docEl.clientTop,
                left: rect.left + win.pageXOffset - docEl.clientLeft
            };
        },
        offsetParent: function() {
            return cash1(this[0].offsetParent);
        }
    });
    fn.extend({
        children: function(selector) {
            var elems = [];
            this.each(function(el) {
                push.apply(elems, el.children);
            });
            elems = unique(elems);
            return !selector ? elems : elems.filter(function(v) {
                return matches(v, selector);
            });
        },
        closest: function(selector) {
            if (!selector || this.length < 1) return cash1();
            if (this.is(selector)) return this.filter(selector);
            return this.parent().closest(selector);
        },
        is: function(selector) {
            if (!selector) return false;
            var match = false, comparator = getCompareFunction(selector);
            this.each(function(el) {
                match = comparator(el, selector);
                return !match;
            });
            return match;
        },
        find: function(selector) {
            if (!selector || selector.nodeType) return cash1(selector && this.has(selector).length ? selector : null);
            var elems = [];
            this.each(function(el) {
                push.apply(elems, find(selector, el));
            });
            return unique(elems);
        },
        has: function(selector) {
            var comparator = isString(selector) ? function(el) {
                return find(selector, el).length !== 0;
            } : function(el) {
                return el.contains(selector);
            };
            return this.filter(comparator);
        },
        next: function() {
            return cash1(this[0].nextElementSibling);
        },
        not: function(selector) {
            if (!selector) return this;
            var comparator = getCompareFunction(selector);
            return this.filter(function(el) {
                return !comparator(el, selector);
            });
        },
        parent: function() {
            var result = [];
            this.each(function(item) {
                if (item && item.parentNode) result.push(item.parentNode);
            });
            return unique(result);
        },
        parents: function(selector) {
            var last, result = [];
            this.each(function(item) {
                last = item;
                while(last && last.parentNode && last !== doc.body.parentNode){
                    last = last.parentNode;
                    if (!selector || selector && matches(last, selector)) result.push(last);
                }
            });
            return unique(result);
        },
        prev: function() {
            return cash1(this[0].previousElementSibling);
        },
        siblings: function(selector) {
            var collection = this.parent().children(selector), el = this[0];
            return collection.filter(function(i) {
                return i !== el;
            });
        }
    });
    return cash1;
});
var Component = function() {
    /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */ function Component(classDef, el, options) {
        _classCallCheck(this, Component);
        // Display error if el is valid HTML Element
        if (!(el instanceof Element)) console.error(Error(el + ' is not an HTML Element'));
        // If exists, destroy and reinitialize in child
        var ins = classDef.getInstance(el);
        if (!!ins) ins.destroy();
        this.el = el;
        this.$el = cash(el);
    }
    /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */ _createClass(Component, null, [
        {
            key: "init",
            value: function init(classDef, els, options) {
                var instances = null;
                if (els instanceof Element) instances = new classDef(els, options);
                else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
                    var instancesArr = [];
                    for(var i = 0; i < els.length; i++)instancesArr.push(new classDef(els[i], options));
                    instances = instancesArr;
                }
                return instances;
            }
        }
    ]);
    return Component;
}();
(function(window1) {
    if (window1.Package) M = {};
    else window1.M = {};
    // Check for jQuery
    M.jQueryLoaded = !!window1.jQuery;
})(window);
// AMD
if (typeof define === 'function' && define.amd) define('M', [], function() {
    return M;
});
else if (!exports.nodeType) {
    if (!module.nodeType && module.exports) exports = module.exports = M;
    exports.default = M;
}
M.version = '1.0.0';
M.keys = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};
/**
 * TabPress Keydown handler
 */ M.tabPressed = false;
M.keyDown = false;
var docHandleKeydown = function(e) {
    M.keyDown = true;
    if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) M.tabPressed = true;
};
var docHandleKeyup = function(e) {
    M.keyDown = false;
    if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) M.tabPressed = false;
};
var docHandleFocus = function(e) {
    if (M.keyDown) document.body.classList.add('keyboard-focused');
};
var docHandleBlur = function(e) {
    document.body.classList.remove('keyboard-focused');
};
document.addEventListener('keydown', docHandleKeydown, true);
document.addEventListener('keyup', docHandleKeyup, true);
document.addEventListener('focus', docHandleFocus, true);
document.addEventListener('blur', docHandleBlur, true);
/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */ M.initializeJqueryWrapper = function(plugin, pluginName, classRef) {
    jQuery.fn[pluginName] = function(methodOrOptions) {
        // Call plugin method if valid method name is passed in
        if (plugin.prototype[methodOrOptions]) {
            var params = Array.prototype.slice.call(arguments, 1);
            // Getter methods
            if (methodOrOptions.slice(0, 3) === 'get') {
                var instance = this.first()[0][classRef];
                return instance[methodOrOptions].apply(instance, params);
            }
            // Void methods
            return this.each(function() {
                var instance = this[classRef];
                instance[methodOrOptions].apply(instance, params);
            });
        // Initialize plugin if options or no argument is passed in
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            plugin.init(this, arguments[0]);
            return this;
        }
        // Return error if an unrecognized  method name is passed in
        jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
    };
};
/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */ M.AutoInit = function(context) {
    // Use document.body if no context is given
    var root = !!context ? context : document.body;
    var registry = {
        Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
        Carousel: root.querySelectorAll('.carousel:not(.no-autoinit)'),
        Chips: root.querySelectorAll('.chips:not(.no-autoinit)'),
        Collapsible: root.querySelectorAll('.collapsible:not(.no-autoinit)'),
        Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
        Dropdown: root.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
        Materialbox: root.querySelectorAll('.materialboxed:not(.no-autoinit)'),
        Modal: root.querySelectorAll('.modal:not(.no-autoinit)'),
        Parallax: root.querySelectorAll('.parallax:not(.no-autoinit)'),
        Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
        ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
        FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
        Sidenav: root.querySelectorAll('.sidenav:not(.no-autoinit)'),
        Tabs: root.querySelectorAll('.tabs:not(.no-autoinit)'),
        TapTarget: root.querySelectorAll('.tap-target:not(.no-autoinit)'),
        Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
        Tooltip: root.querySelectorAll('.tooltipped:not(.no-autoinit)'),
        FloatingActionButton: root.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
    };
    for(var pluginName in registry){
        var plugin = M[pluginName];
        plugin.init(registry[pluginName]);
    }
};
/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */ M.objectSelectorString = function(obj) {
    var tagStr = obj.prop('tagName') || '';
    var idStr = obj.attr('id') || '';
    var classStr = obj.attr('class') || '';
    return (tagStr + idStr + classStr).replace(/\s/g, '');
};
// Unique Random ID
M.guid = function() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return function() {
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };
}();
/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */ M.escapeHash = function(hash) {
    return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
};
M.elementOrParentIsFixed = function(element) {
    var $element = $(element);
    var $checkElements = $element.add($element.parents());
    var isFixed = false;
    $checkElements.each(function() {
        if ($(this).css('position') === 'fixed') {
            isFixed = true;
            return false;
        }
    });
    return isFixed;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */ /**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */ /**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */ M.checkWithinContainer = function(container, bounding, offset) {
    var edges = {
        top: false,
        right: false,
        bottom: false,
        left: false
    };
    var containerRect = container.getBoundingClientRect();
    // If body element is smaller than viewport, use viewport height instead.
    var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;
    var scrollLeft = container.scrollLeft;
    var scrollTop = container.scrollTop;
    var scrolledX = bounding.left - scrollLeft;
    var scrolledY = bounding.top - scrollTop;
    // Check for container and viewport for each edge
    if (scrolledX < containerRect.left + offset || scrolledX < offset) edges.left = true;
    if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) edges.right = true;
    if (scrolledY < containerRect.top + offset || scrolledY < offset) edges.top = true;
    if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) edges.bottom = true;
    return edges;
};
M.checkPossibleAlignments = function(el, container, bounding, offset) {
    var canAlign = {
        top: true,
        right: true,
        bottom: true,
        left: true,
        spaceOnTop: null,
        spaceOnRight: null,
        spaceOnBottom: null,
        spaceOnLeft: null
    };
    var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
    var containerRect = container.getBoundingClientRect();
    var containerHeight = Math.min(containerRect.height, window.innerHeight);
    var containerWidth = Math.min(containerRect.width, window.innerWidth);
    var elOffsetRect = el.getBoundingClientRect();
    var scrollLeft = container.scrollLeft;
    var scrollTop = container.scrollTop;
    var scrolledX = bounding.left - scrollLeft;
    var scrolledYTopEdge = bounding.top - scrollTop;
    var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;
    // Check for container and viewport for left
    canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
    if (canAlign.spaceOnRight < 0) canAlign.left = false;
    // Check for container and viewport for Right
    canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
    if (canAlign.spaceOnLeft < 0) canAlign.right = false;
    // Check for container and viewport for Top
    canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
    if (canAlign.spaceOnBottom < 0) canAlign.top = false;
    // Check for container and viewport for Bottom
    canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
    if (canAlign.spaceOnTop < 0) canAlign.bottom = false;
    return canAlign;
};
M.getOverflowParent = function(element) {
    if (element == null) return null;
    if (element === document.body || getComputedStyle(element).overflow !== 'visible') return element;
    return M.getOverflowParent(element.parentElement);
};
/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */ M.getIdFromTrigger = function(trigger) {
    var id = trigger.getAttribute('data-target');
    if (!id) {
        id = trigger.getAttribute('href');
        if (id) id = id.slice(1);
        else id = '';
    }
    return id;
};
/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */ M.getDocumentScrollTop = function() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};
/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */ M.getDocumentScrollLeft = function() {
    return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */ /**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */ /**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */ var getTime = Date.now || function() {
    return new Date().getTime();
};
/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */ M.throttle = function(func, wait, options) {
    var context = void 0, args = void 0, result = void 0;
    var timeout = null;
    var previous = 0;
    options || (options = {});
    var later = function() {
        previous = options.leading === false ? 0 : getTime();
        timeout = null;
        result = func.apply(context, args);
        context = args = null;
    };
    return function() {
        var now = getTime();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
            context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
};
var $jscomp = {
    scope: {}
};
$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function(e, r, p) {
    if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");
    e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};
$jscomp.getGlobal = function(e) {
    return "undefined" != typeof window && window === e ? e : "undefined" != typeof $parcel$global && null != $parcel$global ? $parcel$global : e;
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$jscomp.initSymbol = function() {
    $jscomp.initSymbol = function() {};
    $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};
$jscomp.symbolCounter_ = 0;
$jscomp.Symbol = function(e) {
    return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function() {
    $jscomp.initSymbol();
    var e = $jscomp.global.Symbol.iterator;
    e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));
    "function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, {
        configurable: !0,
        writable: !0,
        value: function() {
            return $jscomp.arrayIterator(this);
        }
    });
    $jscomp.initSymbolIterator = function() {};
};
$jscomp.arrayIterator = function(e) {
    var r = 0;
    return $jscomp.iteratorPrototype(function() {
        return r < e.length ? {
            done: !1,
            value: e[r++]
        } : {
            done: !0
        };
    });
};
$jscomp.iteratorPrototype = function(e) {
    $jscomp.initSymbolIterator();
    e = {
        next: e
    };
    e[$jscomp.global.Symbol.iterator] = function() {
        return this;
    };
    return e;
};
$jscomp.array = $jscomp.array || {};
$jscomp.iteratorFromArray = function(e, r) {
    $jscomp.initSymbolIterator();
    e instanceof String && (e += "");
    var p = 0, m = {
        next: function() {
            if (p < e.length) {
                var u = p++;
                return {
                    value: r(u, e[u]),
                    done: !1
                };
            }
            m.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return m.next();
        }
    };
    m[Symbol.iterator] = function() {
        return m;
    };
    return m;
};
$jscomp.polyfill = function(e, r, p, m) {
    if (r) {
        p = $jscomp.global;
        e = e.split(".");
        for(m = 0; m < e.length - 1; m++){
            var u = e[m];
            u in p || (p[u] = {});
            p = p[u];
        }
        e = e[e.length - 1];
        m = p[e];
        r = r(m);
        r != m && null != r && $jscomp.defineProperty(p, e, {
            configurable: !0,
            writable: !0,
            value: r
        });
    }
};
$jscomp.polyfill("Array.prototype.keys", function(e) {
    return e ? e : function() {
        return $jscomp.iteratorFromArray(this, function(e) {
            return e;
        });
    };
}, "es6-impl", "es3");
var $jscomp$this = this;
(function(r) {
    M.anime = r();
})(function() {
    function e(a) {
        if (!h.col(a)) try {
            return document.querySelectorAll(a);
        } catch (c) {}
    }
    function r(a, c) {
        for(var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++)if (n in a) {
            var k = a[n];
            c.call(b, k, n, a) && f.push(k);
        }
        return f;
    }
    function p(a) {
        return a.reduce(function(a, d) {
            return a.concat(h.arr(d) ? p(d) : d);
        }, []);
    }
    function m(a) {
        if (h.arr(a)) return a;
        h.str(a) && (a = e(a) || a);
        return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [
            a
        ];
    }
    function u(a, c) {
        return a.some(function(a) {
            return a === c;
        });
    }
    function C(a) {
        var c = {}, d;
        for(d in a)c[d] = a[d];
        return c;
    }
    function D(a, c) {
        var d = C(a), b;
        for(b in a)d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
        return d;
    }
    function z(a, c) {
        var d = C(a), b;
        for(b in c)d[b] = h.und(a[b]) ? c[b] : a[b];
        return d;
    }
    function T(a) {
        a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(a, c, d, k) {
            return c + c + d + d + k + k;
        });
        var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
        a = parseInt(c[1], 16);
        var d = parseInt(c[2], 16), c = parseInt(c[3], 16);
        return "rgba(" + a + "," + d + "," + c + ",1)";
    }
    function U(a) {
        function c(a, c, b) {
            0 > b && (b += 1);
            1 < b && --b;
            return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
        }
        var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);
        a = parseInt(d[1]) / 360;
        var b = parseInt(d[2]) / 100, f = parseInt(d[3]) / 100, d = d[4] || 1;
        if (0 == b) f = b = a = f;
        else {
            var n = .5 > f ? f * (1 + b) : f + b - f * b, k = 2 * f - n, f = c(k, n, a + 1 / 3), b = c(k, n, a);
            a = c(k, n, a - 1 / 3);
        }
        return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
    }
    function y(a) {
        if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
    }
    function V(a) {
        if (-1 < a.indexOf("translate") || "perspective" === a) return "px";
        if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
    }
    function I(a, c) {
        return h.fnc(a) ? a(c.target, c.id, c.total) : a;
    }
    function E(a, c) {
        if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
    }
    function J(a, c) {
        if (h.dom(a) && u(W, c)) return "transform";
        if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";
        if (h.dom(a) && "transform" !== c && E(a, c)) return "css";
        if (null != a[c]) return "object";
    }
    function X(a, c) {
        var d = V(c), d = -1 < c.indexOf("scale") ? 1 : 0 + d;
        a = a.style.transform;
        if (!a) return d;
        for(var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);)f.push(b[1]), n.push(b[2]);
        a = r(n, function(a, b) {
            return f[b] === c;
        });
        return a.length ? a[0] : d;
    }
    function K(a, c) {
        switch(J(a, c)){
            case "transform":
                return X(a, c);
            case "css":
                return E(a, c);
            case "attribute":
                return a.getAttribute(c);
        }
        return a[c] || 0;
    }
    function L(a, c) {
        var d = /^(\*=|\+=|-=)/.exec(a);
        if (!d) return a;
        var b = y(a) || 0;
        c = parseFloat(c);
        a = parseFloat(a.replace(d[0], ""));
        switch(d[0][0]){
            case "+":
                return c + a + b;
            case "-":
                return c - a + b;
            case "*":
                return c * a + b;
        }
    }
    function F(a, c) {
        return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
    }
    function M1(a) {
        a = a.points;
        for(var c = 0, d, b = 0; b < a.numberOfItems; b++){
            var f = a.getItem(b);
            0 < b && (c += F(d, f));
            d = f;
        }
        return c;
    }
    function N(a) {
        if (a.getTotalLength) return a.getTotalLength();
        switch(a.tagName.toLowerCase()){
            case "circle":
                return 2 * Math.PI * a.getAttribute("r");
            case "rect":
                return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");
            case "line":
                return F({
                    x: a.getAttribute("x1"),
                    y: a.getAttribute("y1")
                }, {
                    x: a.getAttribute("x2"),
                    y: a.getAttribute("y2")
                });
            case "polyline":
                return M1(a);
            case "polygon":
                var c = a.points;
                return M1(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));
        }
    }
    function Y(a, c) {
        function d(b) {
            b = void 0 === b ? 0 : b;
            return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
        }
        var b = d(), f = d(-1), n = d(1);
        switch(a.property){
            case "x":
                return b.x;
            case "y":
                return b.y;
            case "angle":
                return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;
        }
    }
    function O(a, c) {
        var d = /-?\d*\.?\d+/g, b;
        b = h.pth(a) ? a.totalLength : a;
        if (h.col(b)) {
            if (h.rgb(b)) {
                var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);
                b = f ? "rgba(" + f[1] + ",1)" : b;
            } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
        } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;
        b += "";
        return {
            original: b,
            numbers: b.match(d) ? b.match(d).map(Number) : [
                0
            ],
            strings: h.str(a) || c ? b.split(d) : []
        };
    }
    function P(a) {
        a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];
        return r(a, function(a, d, b) {
            return b.indexOf(a) === d;
        });
    }
    function Z(a) {
        var c = P(a);
        return c.map(function(a, b) {
            return {
                target: a,
                id: b,
                total: c.length
            };
        });
    }
    function aa(a, c) {
        var d = C(c);
        if (h.arr(a)) {
            var b = a.length;
            2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = {
                value: a
            };
        }
        return m(a).map(function(a, b) {
            b = b ? 0 : c.delay;
            a = h.obj(a) && !h.pth(a) ? a : {
                value: a
            };
            h.und(a.delay) && (a.delay = b);
            return a;
        }).map(function(a) {
            return z(a, d);
        });
    }
    function ba(a, c) {
        var d = {}, b;
        for(b in a){
            var f = I(a[b], c);
            h.arr(f) && (f = f.map(function(a) {
                return I(a, c);
            }), 1 === f.length && (f = f[0]));
            d[b] = f;
        }
        d.duration = parseFloat(d.duration);
        d.delay = parseFloat(d.delay);
        return d;
    }
    function ca(a) {
        return h.arr(a) ? A.apply(this, a) : Q[a];
    }
    function da(a, c) {
        var d;
        return a.tweens.map(function(b) {
            b = ba(b, c);
            var f = b.value, e = K(c.target, a.name), k = d ? d.to.original : e, k = h.arr(f) ? f[0] : k, w = L(h.arr(f) ? f[1] : f, k), e = y(w) || y(k) || y(e);
            b.from = O(k, e);
            b.to = O(w, e);
            b.start = d ? d.end : a.offset;
            b.end = b.start + b.delay + b.duration;
            b.easing = ca(b.easing);
            b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;
            b.isPath = h.pth(f);
            b.isColor = h.col(b.from.original);
            b.isColor && (b.round = 1);
            return d = b;
        });
    }
    function ea(a, c) {
        return r(p(a.map(function(a) {
            return c.map(function(b) {
                var c = J(a.target, b.name);
                if (c) {
                    var d = da(b, a);
                    b = {
                        type: c,
                        property: b.name,
                        animatable: a,
                        tweens: d,
                        duration: d[d.length - 1].end,
                        delay: d[0].delay
                    };
                } else b = void 0;
                return b;
            });
        })), function(a) {
            return !h.und(a);
        });
    }
    function R(a, c, d, b) {
        var f = "delay" === a;
        return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function(b) {
            return b[a];
        })) : f ? b.delay : d.offset + b.delay + b.duration;
    }
    function fa(a) {
        var c = D(ga, a), d = D(S, a), b = Z(a.targets), f = [], e = z(c, d), k;
        for(k in a)e.hasOwnProperty(k) || "targets" === k || f.push({
            name: k,
            offset: e.offset,
            tweens: aa(a[k], d)
        });
        a = ea(b, f);
        return z(c, {
            children: [],
            animatables: b,
            animations: a,
            duration: R("duration", a, c, d),
            delay: R("delay", a, c, d)
        });
    }
    function q(a) {
        function c() {
            return window.Promise && new Promise(function(a) {
                return p = a;
            });
        }
        function d(a) {
            return g.reversed ? g.duration - a : a;
        }
        function b(a) {
            for(var b = 0, c = {}, d = g.animations, f = d.length; b < f;){
                var e = d[b], k = e.animatable, h = e.tweens, n = h.length - 1, l = h[n];
                n && (l = r(h, function(b) {
                    return a < b.end;
                })[0] || l);
                for(var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++){
                    var x = void 0, x = l.to.numbers[t], q = l.from.numbers[t], x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);
                    p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));
                    n.push(x);
                }
                if (l = h.length) for(m = h[0], w = 0; w < l; w++)p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
                else m = n[0];
                ha[e.type](k.target, e.property, m, c, k.id);
                e.currentValue = m;
                b++;
            }
            if (b = Object.keys(c).length) for(d = 0; d < b; d++)H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
            g.currentTime = a;
            g.progress = a / g.duration * 100;
        }
        function f(a) {
            if (g[a]) g[a](g);
        }
        function e() {
            g.remaining && !0 !== g.remaining && g.remaining--;
        }
        function k(a) {
            var k = g.duration, n = g.offset, w = n + g.delay, r = g.currentTime, x = g.reversed, q = d(a);
            if (g.children.length) {
                var u = g.children, v = u.length;
                if (q >= g.currentTime) for(var G = 0; G < v; G++)u[G].seek(q);
                else for(; v--;)u[v].seek(q);
            }
            if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");
            if (q > n && q < k) b(q);
            else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();
            f("update");
            a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
        }
        a = void 0 === a ? {} : a;
        var h, t, l = 0, p = null, m = c(), g = fa(a);
        g.reset = function() {
            var a = g.direction, c = g.loop;
            g.currentTime = 0;
            g.progress = 0;
            g.paused = !0;
            g.began = !1;
            g.completed = !1;
            g.reversed = "reverse" === a;
            g.remaining = "alternate" === a && 1 === c ? 2 : c;
            b(0);
            for(a = g.children.length; a--;)g.children[a].reset();
        };
        g.tick = function(a) {
            h = a;
            t || (t = h);
            k((l + h - t) * q.speed);
        };
        g.seek = function(a) {
            k(d(a));
        };
        g.pause = function() {
            var a = v.indexOf(g);
            -1 < a && v.splice(a, 1);
            g.paused = !0;
        };
        g.play = function() {
            g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
        };
        g.reverse = function() {
            g.reversed = !g.reversed;
            t = 0;
            l = d(g.currentTime);
        };
        g.restart = function() {
            g.pause();
            g.reset();
            g.play();
        };
        g.finished = m;
        g.reset();
        g.autoplay && g.play();
        return g;
    }
    var ga = {
        update: void 0,
        begin: void 0,
        run: void 0,
        complete: void 0,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        offset: 0
    }, S = {
        duration: 1E3,
        delay: 0,
        easing: "easeOutElastic",
        elasticity: 500,
        round: 0
    }, W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "), H, h = {
        arr: function(a) {
            return Array.isArray(a);
        },
        obj: function(a) {
            return -1 < Object.prototype.toString.call(a).indexOf("Object");
        },
        pth: function(a) {
            return h.obj(a) && a.hasOwnProperty("totalLength");
        },
        svg: function(a) {
            return a instanceof SVGElement;
        },
        dom: function(a) {
            return a.nodeType || h.svg(a);
        },
        str: function(a) {
            return "string" === typeof a;
        },
        fnc: function(a) {
            return "function" === typeof a;
        },
        und: function(a) {
            return "undefined" === typeof a;
        },
        hex: function(a) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
        },
        rgb: function(a) {
            return /^rgb/.test(a);
        },
        hsl: function(a) {
            return /^hsl/.test(a);
        },
        col: function(a) {
            return h.hex(a) || h.rgb(a) || h.hsl(a);
        }
    }, A = function() {
        function a(a, d, b) {
            return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
        }
        return function(c, d, b, f) {
            if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
                var e = new Float32Array(11);
                if (c !== d || b !== f) for(var k = 0; 11 > k; ++k)e[k] = a(.1 * k, c, b);
                return function(k) {
                    if (c === d && b === f) return k;
                    if (0 === k) return 0;
                    if (1 === k) return 1;
                    for(var h = 0, l = 1; 10 !== l && e[l] <= k; ++l)h += .1;
                    --l;
                    var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1, n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;
                    if (.001 <= n) {
                        for(h = 0; 4 > h; ++h){
                            n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;
                            if (0 === n) break;
                            var m = a(l, c, b) - k, l = l - m / n;
                        }
                        k = l;
                    } else if (0 === n) k = l;
                    else {
                        var l = h, h = h + .1, g = 0;
                        do m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
                        while (1e-7 < Math.abs(n) && 10 > ++g);
                        k = m;
                    }
                    return a(k, d, f);
                };
            }
        };
    }(), Q = function() {
        function a(a, b) {
            return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
        }
        var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "), d = {
            In: [
                [
                    .55,
                    .085,
                    .68,
                    .53
                ],
                [
                    .55,
                    .055,
                    .675,
                    .19
                ],
                [
                    .895,
                    .03,
                    .685,
                    .22
                ],
                [
                    .755,
                    .05,
                    .855,
                    .06
                ],
                [
                    .47,
                    0,
                    .745,
                    .715
                ],
                [
                    .95,
                    .05,
                    .795,
                    .035
                ],
                [
                    .6,
                    .04,
                    .98,
                    .335
                ],
                [
                    .6,
                    -0.28,
                    .735,
                    .045
                ],
                a
            ],
            Out: [
                [
                    .25,
                    .46,
                    .45,
                    .94
                ],
                [
                    .215,
                    .61,
                    .355,
                    1
                ],
                [
                    .165,
                    .84,
                    .44,
                    1
                ],
                [
                    .23,
                    1,
                    .32,
                    1
                ],
                [
                    .39,
                    .575,
                    .565,
                    1
                ],
                [
                    .19,
                    1,
                    .22,
                    1
                ],
                [
                    .075,
                    .82,
                    .165,
                    1
                ],
                [
                    .175,
                    .885,
                    .32,
                    1.275
                ],
                function(b, c) {
                    return 1 - a(1 - b, c);
                }
            ],
            InOut: [
                [
                    .455,
                    .03,
                    .515,
                    .955
                ],
                [
                    .645,
                    .045,
                    .355,
                    1
                ],
                [
                    .77,
                    0,
                    .175,
                    1
                ],
                [
                    .86,
                    0,
                    .07,
                    1
                ],
                [
                    .445,
                    .05,
                    .55,
                    .95
                ],
                [
                    1,
                    0,
                    0,
                    1
                ],
                [
                    .785,
                    .135,
                    .15,
                    .86
                ],
                [
                    .68,
                    -0.55,
                    .265,
                    1.55
                ],
                function(b, c) {
                    return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
                }
            ]
        }, b = {
            linear: A(.25, .25, .75, .75)
        }, f = {}, e;
        for(e in d)f.type = e, d[f.type].forEach(function(a) {
            return function(d, f) {
                b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
            };
        }(f)), f = {
            type: f.type
        };
        return b;
    }(), ha = {
        css: function(a, c, d) {
            return a.style[c] = d;
        },
        attribute: function(a, c, d) {
            return a.setAttribute(c, d);
        },
        object: function(a, c, d) {
            return a[c] = d;
        },
        transform: function(a, c, d, b, f) {
            b[f] || (b[f] = []);
            b[f].push(c + "(" + d + ")");
        }
    }, v = [], B = 0, ia = function() {
        function a() {
            B = requestAnimationFrame(c);
        }
        function c(c) {
            var b = v.length;
            if (b) {
                for(var d = 0; d < b;)v[d] && v[d].tick(c), d++;
                a();
            } else cancelAnimationFrame(B), B = 0;
        }
        return a;
    }();
    q.version = "2.2.0";
    q.speed = 1;
    q.running = v;
    q.remove = function(a) {
        a = P(a);
        for(var c = v.length; c--;)for(var d = v[c], b = d.animations, f = b.length; f--;)u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
    };
    q.getValue = K;
    q.path = function(a, c) {
        var d = h.str(a) ? e(a)[0] : a, b = c || 100;
        return function(a) {
            return {
                el: d,
                property: a,
                totalLength: N(d) * (b / 100)
            };
        };
    };
    q.setDashoffset = function(a) {
        var c = N(a);
        a.setAttribute("stroke-dasharray", c);
        return c;
    };
    q.bezier = A;
    q.easings = Q;
    q.timeline = function(a) {
        var c = q(a);
        c.pause();
        c.duration = 0;
        c.add = function(d) {
            c.children.forEach(function(a) {
                a.began = !0;
                a.completed = !0;
            });
            m(d).forEach(function(b) {
                var d = z(b, D(S, a || {}));
                d.targets = d.targets || a.targets;
                b = c.duration;
                var e = d.offset;
                d.autoplay = !1;
                d.direction = c.direction;
                d.offset = h.und(e) ? b : L(e, b);
                c.began = !0;
                c.completed = !0;
                c.seek(d.offset);
                d = q(d);
                d.began = !0;
                d.completed = !0;
                d.duration > b && (c.duration = d.duration);
                c.children.push(d);
            });
            c.seek(0);
            c.reset();
            c.autoplay && c.restart();
            return c;
        };
        return c;
    };
    q.random = function(a, c) {
        return Math.floor(Math.random() * (c - a + 1)) + a;
    };
    return q;
});
(function($1, anim) {
    'use strict';
    var _defaults = {
        accordion: true,
        onOpenStart: undefined,
        onOpenEnd: undefined,
        onCloseStart: undefined,
        onCloseEnd: undefined,
        inDuration: 300,
        outDuration: 300
    };
    /**
   * @class
   *
   */ var Collapsible = function(_Component) {
        _inherits(Collapsible, _Component);
        /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Collapsible(el, options) {
            _classCallCheck(this, Collapsible);
            var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));
            _this3.el.M_Collapsible = _this3;
            /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */ _this3.options = $1.extend({}, Collapsible.defaults, options);
            // Setup tab indices
            _this3.$headers = _this3.$el.children('li').children('.collapsible-header');
            _this3.$headers.attr('tabindex', 0);
            _this3._setupEventHandlers();
            // Open first active
            var $activeBodies = _this3.$el.children('li.active').children('.collapsible-body');
            if (_this3.options.accordion) // Handle Accordion
            $activeBodies.first().css('display', 'block');
            else // Handle Expandables
            $activeBodies.css('display', 'block');
            return _this3;
        }
        _createClass(Collapsible, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Collapsible = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this4 = this;
                    this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
                    this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
                    this.el.addEventListener('click', this._handleCollapsibleClickBound);
                    this.$headers.each(function(header) {
                        header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
                    });
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this5 = this;
                    this.el.removeEventListener('click', this._handleCollapsibleClickBound);
                    this.$headers.each(function(header) {
                        header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
                    });
                }
            },
            {
                key: "_handleCollapsibleClick",
                value: function _handleCollapsibleClick(e) {
                    var $header = $1(e.target).closest('.collapsible-header');
                    if (e.target && $header.length) {
                        var $collapsible = $header.closest('.collapsible');
                        if ($collapsible[0] === this.el) {
                            var $collapsibleLi = $header.closest('li');
                            var $collapsibleLis = $collapsible.children('li');
                            var isActive = $collapsibleLi[0].classList.contains('active');
                            var index = $collapsibleLis.index($collapsibleLi);
                            if (isActive) this.close(index);
                            else this.open(index);
                        }
                    }
                }
            },
            {
                key: "_handleCollapsibleKeydown",
                value: function _handleCollapsibleKeydown(e) {
                    if (e.keyCode === 13) this._handleCollapsibleClickBound(e);
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn(index) {
                    var _this6 = this;
                    var $collapsibleLi = this.$el.children('li').eq(index);
                    if ($collapsibleLi.length) {
                        var $body = $collapsibleLi.children('.collapsible-body');
                        anim.remove($body[0]);
                        $body.css({
                            display: 'block',
                            overflow: 'hidden',
                            height: 0,
                            paddingTop: '',
                            paddingBottom: ''
                        });
                        var pTop = $body.css('padding-top');
                        var pBottom = $body.css('padding-bottom');
                        var finalHeight = $body[0].scrollHeight;
                        $body.css({
                            paddingTop: 0,
                            paddingBottom: 0
                        });
                        anim({
                            targets: $body[0],
                            height: finalHeight,
                            paddingTop: pTop,
                            paddingBottom: pBottom,
                            duration: this.options.inDuration,
                            easing: 'easeInOutCubic',
                            complete: function(anim) {
                                $body.css({
                                    overflow: '',
                                    paddingTop: '',
                                    paddingBottom: '',
                                    height: ''
                                });
                                // onOpenEnd callback
                                if (typeof _this6.options.onOpenEnd === 'function') _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
                            }
                        });
                    }
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut(index) {
                    var _this7 = this;
                    var $collapsibleLi = this.$el.children('li').eq(index);
                    if ($collapsibleLi.length) {
                        var $body = $collapsibleLi.children('.collapsible-body');
                        anim.remove($body[0]);
                        $body.css('overflow', 'hidden');
                        anim({
                            targets: $body[0],
                            height: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            duration: this.options.outDuration,
                            easing: 'easeInOutCubic',
                            complete: function() {
                                $body.css({
                                    height: '',
                                    overflow: '',
                                    padding: '',
                                    display: ''
                                });
                                // onCloseEnd callback
                                if (typeof _this7.options.onCloseEnd === 'function') _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
                            }
                        });
                    }
                }
            },
            {
                key: "open",
                value: function open(index) {
                    var _this8 = this;
                    var $collapsibleLi = this.$el.children('li').eq(index);
                    if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('active')) {
                        // onOpenStart callback
                        if (typeof this.options.onOpenStart === 'function') this.options.onOpenStart.call(this, $collapsibleLi[0]);
                        // Handle accordion behavior
                        if (this.options.accordion) {
                            var $collapsibleLis = this.$el.children('li');
                            var $activeLis = this.$el.children('li.active');
                            $activeLis.each(function(el) {
                                var index = $collapsibleLis.index($1(el));
                                _this8.close(index);
                            });
                        }
                        // Animate in
                        $collapsibleLi[0].classList.add('active');
                        this._animateIn(index);
                    }
                }
            },
            {
                key: "close",
                value: function close(index) {
                    var $collapsibleLi = this.$el.children('li').eq(index);
                    if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('active')) {
                        // onCloseStart callback
                        if (typeof this.options.onCloseStart === 'function') this.options.onCloseStart.call(this, $collapsibleLi[0]);
                        // Animate out
                        $collapsibleLi[0].classList.remove('active');
                        this._animateOut(index);
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Collapsible;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Collapsible;
    }(Component);
    M.Collapsible = Collapsible;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        alignment: 'left',
        autoFocus: true,
        constrainWidth: true,
        container: null,
        coverTrigger: true,
        closeOnClick: true,
        hover: false,
        inDuration: 150,
        outDuration: 250,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        onItemClick: null
    };
    /**
   * @class
   */ var Dropdown = function(_Component2) {
        _inherits(Dropdown, _Component2);
        function Dropdown(el, options) {
            _classCallCheck(this, Dropdown);
            var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));
            _this9.el.M_Dropdown = _this9;
            Dropdown._dropdowns.push(_this9);
            _this9.id = M.getIdFromTrigger(el);
            _this9.dropdownEl = document.getElementById(_this9.id);
            _this9.$dropdownEl = $1(_this9.dropdownEl);
            /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */ _this9.options = $1.extend({}, Dropdown.defaults, options);
            /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */ _this9.isOpen = false;
            /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */ _this9.isScrollable = false;
            /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */ _this9.isTouchMoving = false;
            _this9.focusedIndex = -1;
            _this9.filterQuery = [];
            // Move dropdown-content after dropdown-trigger
            if (!!_this9.options.container) $1(_this9.options.container).append(_this9.dropdownEl);
            else _this9.$el.after(_this9.dropdownEl);
            _this9._makeDropdownFocusable();
            _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
            _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
            _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
            _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
            _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
            _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
            _this9._setupEventHandlers();
            return _this9;
        }
        _createClass(Dropdown, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._resetDropdownStyles();
                    this._removeEventHandlers();
                    Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
                    this.el.M_Dropdown = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    // Trigger keydown handler
                    this.el.addEventListener('keydown', this._handleTriggerKeydownBound);
                    // Item click handler
                    this.dropdownEl.addEventListener('click', this._handleDropdownClickBound);
                    // Hover event handlers
                    if (this.options.hover) {
                        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
                        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
                        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
                        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
                        this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound);
                    // Click event handlers
                    } else {
                        this._handleClickBound = this._handleClick.bind(this);
                        this.el.addEventListener('click', this._handleClickBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
                    this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);
                    if (this.options.hover) {
                        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
                        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
                        this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
                    } else this.el.removeEventListener('click', this._handleClickBound);
                }
            },
            {
                key: "_setupTemporaryEventHandlers",
                value: function _setupTemporaryEventHandlers() {
                    // Use capture phase event handler to prevent click
                    document.body.addEventListener('click', this._handleDocumentClickBound, true);
                    document.body.addEventListener('touchend', this._handleDocumentClickBound);
                    document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
                    this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
                }
            },
            {
                key: "_removeTemporaryEventHandlers",
                value: function _removeTemporaryEventHandlers() {
                    // Use capture phase event handler to prevent click
                    document.body.removeEventListener('click', this._handleDocumentClickBound, true);
                    document.body.removeEventListener('touchend', this._handleDocumentClickBound);
                    document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
                    this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
                }
            },
            {
                key: "_handleClick",
                value: function _handleClick(e) {
                    e.preventDefault();
                    this.open();
                }
            },
            {
                key: "_handleMouseEnter",
                value: function _handleMouseEnter() {
                    this.open();
                }
            },
            {
                key: "_handleMouseLeave",
                value: function _handleMouseLeave(e) {
                    var toEl = e.toElement || e.relatedTarget;
                    var leaveToDropdownContent = !!$1(toEl).closest('.dropdown-content').length;
                    var leaveToActiveDropdownTrigger = false;
                    var $closestTrigger = $1(toEl).closest('.dropdown-trigger');
                    if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) leaveToActiveDropdownTrigger = true;
                    // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
                    if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) this.close();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    var _this10 = this;
                    var $target = $1(e.target);
                    if (this.options.closeOnClick && $target.closest('.dropdown-content').length && !this.isTouchMoving) // isTouchMoving to check if scrolling on mobile.
                    setTimeout(function() {
                        _this10.close();
                    }, 0);
                    else if ($target.closest('.dropdown-trigger').length || !$target.closest('.dropdown-content').length) setTimeout(function() {
                        _this10.close();
                    }, 0);
                    this.isTouchMoving = false;
                }
            },
            {
                key: "_handleTriggerKeydown",
                value: function _handleTriggerKeydown(e) {
                    // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
                    if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleDocumentTouchmove",
                value: function _handleDocumentTouchmove(e) {
                    var $target = $1(e.target);
                    if ($target.closest('.dropdown-content').length) this.isTouchMoving = true;
                }
            },
            {
                key: "_handleDropdownClick",
                value: function _handleDropdownClick(e) {
                    // onItemClick callback
                    if (typeof this.options.onItemClick === 'function') {
                        var itemEl = $1(e.target).closest('li')[0];
                        this.options.onItemClick.call(this, itemEl);
                    }
                }
            },
            {
                key: "_handleDropdownKeydown",
                value: function _handleDropdownKeydown(e) {
                    if (e.which === M.keys.TAB) {
                        e.preventDefault();
                        this.close();
                    // Navigate down dropdown list
                    } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
                        e.preventDefault();
                        var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
                        var newFocusedIndex = this.focusedIndex;
                        var foundNewIndex = false;
                        do {
                            newFocusedIndex = newFocusedIndex + direction;
                            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
                                foundNewIndex = true;
                                break;
                            }
                        }while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);
                        if (foundNewIndex) {
                            this.focusedIndex = newFocusedIndex;
                            this._focusFocusedItem();
                        }
                    // ENTER selects choice on focused item
                    } else if (e.which === M.keys.ENTER && this.isOpen) {
                        // Search for <a> and <button>
                        var focusedElement = this.dropdownEl.children[this.focusedIndex];
                        var $activatableElement = $1(focusedElement).find('a, button').first();
                        // Click a or button tag if exists, otherwise click li tag
                        if (!!$activatableElement.length) $activatableElement[0].click();
                        else if (!!focusedElement) focusedElement.click();
                    // Close dropdown on ESC
                    } else if (e.which === M.keys.ESC && this.isOpen) {
                        e.preventDefault();
                        this.close();
                    }
                    // CASE WHEN USER TYPE LETTERS
                    var letter = String.fromCharCode(e.which).toLowerCase(), nonLetters = [
                        9,
                        13,
                        27,
                        38,
                        40
                    ];
                    if (letter && nonLetters.indexOf(e.which) === -1) {
                        this.filterQuery.push(letter);
                        var string = this.filterQuery.join(''), newOptionEl = $1(this.dropdownEl).find('li').filter(function(el) {
                            return $1(el).text().toLowerCase().indexOf(string) === 0;
                        })[0];
                        if (newOptionEl) {
                            this.focusedIndex = $1(newOptionEl).index();
                            this._focusFocusedItem();
                        }
                    }
                    this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
                }
            },
            {
                key: "_resetFilterQuery",
                value: function _resetFilterQuery() {
                    this.filterQuery = [];
                }
            },
            {
                key: "_resetDropdownStyles",
                value: function _resetDropdownStyles() {
                    this.$dropdownEl.css({
                        display: '',
                        width: '',
                        height: '',
                        left: '',
                        top: '',
                        'transform-origin': '',
                        transform: '',
                        opacity: ''
                    });
                }
            },
            {
                key: "_makeDropdownFocusable",
                value: function _makeDropdownFocusable() {
                    // Needed for arrow key navigation
                    this.dropdownEl.tabIndex = 0;
                    // Only set tabindex if it hasn't been set by user
                    $1(this.dropdownEl).children().each(function(el) {
                        if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);
                    });
                }
            },
            {
                key: "_focusFocusedItem",
                value: function _focusFocusedItem() {
                    if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) this.dropdownEl.children[this.focusedIndex].focus();
                }
            },
            {
                key: "_getDropdownPosition",
                value: function _getDropdownPosition() {
                    var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
                    var triggerBRect = this.el.getBoundingClientRect();
                    var dropdownBRect = this.dropdownEl.getBoundingClientRect();
                    var idealHeight = dropdownBRect.height;
                    var idealWidth = dropdownBRect.width;
                    var idealXPos = triggerBRect.left - dropdownBRect.left;
                    var idealYPos = triggerBRect.top - dropdownBRect.top;
                    var dropdownBounds = {
                        left: idealXPos,
                        top: idealYPos,
                        height: idealHeight,
                        width: idealWidth
                    };
                    // Countainer here will be closest ancestor with overflow: hidden
                    var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;
                    var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);
                    var verticalAlignment = 'top';
                    var horizontalAlignment = this.options.alignment;
                    idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;
                    // Reset isScrollable
                    this.isScrollable = false;
                    if (!alignments.top) {
                        if (alignments.bottom) verticalAlignment = 'bottom';
                        else {
                            this.isScrollable = true;
                            // Determine which side has most space and cutoff at correct height
                            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
                                verticalAlignment = 'bottom';
                                idealHeight += alignments.spaceOnTop;
                                idealYPos -= alignments.spaceOnTop;
                            } else idealHeight += alignments.spaceOnBottom;
                        }
                    }
                    // If preferred horizontal alignment is possible
                    if (!alignments[horizontalAlignment]) {
                        var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';
                        if (alignments[oppositeAlignment]) horizontalAlignment = oppositeAlignment;
                        else // Determine which side has most space and cutoff at correct height
                        if (alignments.spaceOnLeft > alignments.spaceOnRight) {
                            horizontalAlignment = 'right';
                            idealWidth += alignments.spaceOnLeft;
                            idealXPos -= alignments.spaceOnLeft;
                        } else {
                            horizontalAlignment = 'left';
                            idealWidth += alignments.spaceOnRight;
                        }
                    }
                    if (verticalAlignment === 'bottom') idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
                    if (horizontalAlignment === 'right') idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
                    return {
                        x: idealXPos,
                        y: idealYPos,
                        verticalAlignment: verticalAlignment,
                        horizontalAlignment: horizontalAlignment,
                        height: idealHeight,
                        width: idealWidth
                    };
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    var _this11 = this;
                    anim.remove(this.dropdownEl);
                    anim({
                        targets: this.dropdownEl,
                        opacity: {
                            value: [
                                0,
                                1
                            ],
                            easing: 'easeOutQuad'
                        },
                        scaleX: [
                            0.3,
                            1
                        ],
                        scaleY: [
                            0.3,
                            1
                        ],
                        duration: this.options.inDuration,
                        easing: 'easeOutQuint',
                        complete: function(anim) {
                            if (_this11.options.autoFocus) _this11.dropdownEl.focus();
                            // onOpenEnd callback
                            if (typeof _this11.options.onOpenEnd === 'function') _this11.options.onOpenEnd.call(_this11, _this11.el);
                        }
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    var _this12 = this;
                    anim.remove(this.dropdownEl);
                    anim({
                        targets: this.dropdownEl,
                        opacity: {
                            value: 0,
                            easing: 'easeOutQuint'
                        },
                        scaleX: 0.3,
                        scaleY: 0.3,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuint',
                        complete: function(anim) {
                            _this12._resetDropdownStyles();
                            // onCloseEnd callback
                            if (typeof _this12.options.onCloseEnd === 'function') _this12.options.onCloseEnd.call(_this12, _this12.el);
                        }
                    });
                }
            },
            {
                key: "_placeDropdown",
                value: function _placeDropdown() {
                    // Set width before calculating positionInfo
                    var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
                    this.dropdownEl.style.width = idealWidth + 'px';
                    var positionInfo = this._getDropdownPosition();
                    this.dropdownEl.style.left = positionInfo.x + 'px';
                    this.dropdownEl.style.top = positionInfo.y + 'px';
                    this.dropdownEl.style.height = positionInfo.height + 'px';
                    this.dropdownEl.style.width = positionInfo.width + 'px';
                    this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === 'function') this.options.onOpenStart.call(this, this.el);
                    // Reset styles
                    this._resetDropdownStyles();
                    this.dropdownEl.style.display = 'block';
                    this._placeDropdown();
                    this._animateIn();
                    this._setupTemporaryEventHandlers();
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    this.focusedIndex = -1;
                    // onCloseStart callback
                    if (typeof this.options.onCloseStart === 'function') this.options.onCloseStart.call(this, this.el);
                    this._animateOut();
                    this._removeTemporaryEventHandlers();
                    if (this.options.autoFocus) this.el.focus();
                }
            },
            {
                key: "recalculateDimensions",
                value: function recalculateDimensions() {
                    if (this.isOpen) {
                        this.$dropdownEl.css({
                            width: '',
                            height: '',
                            left: '',
                            top: '',
                            'transform-origin': ''
                        });
                        this._placeDropdown();
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Dropdown;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Dropdown;
    }(Component);
    /**
   * @static
   * @memberof Dropdown
   */ Dropdown._dropdowns = [];
    M.Dropdown = Dropdown;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        opacity: 0.5,
        inDuration: 250,
        outDuration: 250,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        preventScrolling: true,
        dismissible: true,
        startingTop: '4%',
        endingTop: '10%'
    };
    /**
   * @class
   *
   */ var Modal = function(_Component3) {
        _inherits(Modal, _Component3);
        /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Modal(el, options) {
            _classCallCheck(this, Modal);
            var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));
            _this13.el.M_Modal = _this13;
            /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */ _this13.options = $1.extend({}, Modal.defaults, options);
            /**
       * Describes open/close state of modal
       * @type {Boolean}
       */ _this13.isOpen = false;
            _this13.id = _this13.$el.attr('id');
            _this13._openingTrigger = undefined;
            _this13.$overlay = $1('<div class="modal-overlay"></div>');
            _this13.el.tabIndex = 0;
            _this13._nthModalOpened = 0;
            Modal._count++;
            _this13._setupEventHandlers();
            return _this13;
        }
        _createClass(Modal, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    Modal._count--;
                    this._removeEventHandlers();
                    this.el.removeAttribute('style');
                    this.$overlay.remove();
                    this.el.M_Modal = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
                    this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);
                    if (Modal._count === 1) document.body.addEventListener('click', this._handleTriggerClick);
                    this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
                    this.el.addEventListener('click', this._handleModalCloseClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (Modal._count === 0) document.body.removeEventListener('click', this._handleTriggerClick);
                    this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
                    this.el.removeEventListener('click', this._handleModalCloseClickBound);
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target).closest('.modal-trigger');
                    if ($trigger.length) {
                        var modalId = M.getIdFromTrigger($trigger[0]);
                        var modalInstance = document.getElementById(modalId).M_Modal;
                        if (modalInstance) modalInstance.open($trigger);
                        e.preventDefault();
                    }
                }
            },
            {
                key: "_handleOverlayClick",
                value: function _handleOverlayClick() {
                    if (this.options.dismissible) this.close();
                }
            },
            {
                key: "_handleModalCloseClick",
                value: function _handleModalCloseClick(e) {
                    var $closeTrigger = $1(e.target).closest('.modal-close');
                    if ($closeTrigger.length) this.close();
                }
            },
            {
                key: "_handleKeydown",
                value: function _handleKeydown(e) {
                    // ESC key
                    if (e.keyCode === 27 && this.options.dismissible) this.close();
                }
            },
            {
                key: "_handleFocus",
                value: function _handleFocus(e) {
                    // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
                    if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) this.el.focus();
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    var _this14 = this;
                    // Set initial styles
                    $1.extend(this.el.style, {
                        display: 'block',
                        opacity: 0
                    });
                    $1.extend(this.$overlay[0].style, {
                        display: 'block',
                        opacity: 0
                    });
                    // Animate overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: this.options.opacity,
                        duration: this.options.inDuration,
                        easing: 'easeOutQuad'
                    });
                    // Define modal animation options
                    var enterAnimOptions = {
                        targets: this.el,
                        duration: this.options.inDuration,
                        easing: 'easeOutCubic',
                        // Handle modal onOpenEnd callback
                        complete: function() {
                            if (typeof _this14.options.onOpenEnd === 'function') _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
                        }
                    };
                    // Bottom sheet animation
                    if (this.el.classList.contains('bottom-sheet')) {
                        $1.extend(enterAnimOptions, {
                            bottom: 0,
                            opacity: 1
                        });
                        anim(enterAnimOptions);
                    // Normal modal animation
                    } else {
                        $1.extend(enterAnimOptions, {
                            top: [
                                this.options.startingTop,
                                this.options.endingTop
                            ],
                            opacity: 1,
                            scaleX: [
                                0.8,
                                1
                            ],
                            scaleY: [
                                0.8,
                                1
                            ]
                        });
                        anim(enterAnimOptions);
                    }
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    var _this15 = this;
                    // Animate overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuart'
                    });
                    // Define modal animation options
                    var exitAnimOptions = {
                        targets: this.el,
                        duration: this.options.outDuration,
                        easing: 'easeOutCubic',
                        // Handle modal ready callback
                        complete: function() {
                            _this15.el.style.display = 'none';
                            _this15.$overlay.remove();
                            // Call onCloseEnd callback
                            if (typeof _this15.options.onCloseEnd === 'function') _this15.options.onCloseEnd.call(_this15, _this15.el);
                        }
                    };
                    // Bottom sheet animation
                    if (this.el.classList.contains('bottom-sheet')) {
                        $1.extend(exitAnimOptions, {
                            bottom: '-100%',
                            opacity: 0
                        });
                        anim(exitAnimOptions);
                    // Normal modal animation
                    } else {
                        $1.extend(exitAnimOptions, {
                            top: [
                                this.options.endingTop,
                                this.options.startingTop
                            ],
                            opacity: 0,
                            scaleX: 0.8,
                            scaleY: 0.8
                        });
                        anim(exitAnimOptions);
                    }
                }
            },
            {
                key: "open",
                value: function open($trigger) {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    Modal._modalsOpen++;
                    this._nthModalOpened = Modal._modalsOpen;
                    // Set Z-Index based on number of currently open modals
                    this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
                    this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;
                    // Set opening trigger, undefined indicates modal was opened by javascript
                    this._openingTrigger = !!$trigger ? $trigger[0] : undefined;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === 'function') this.options.onOpenStart.call(this, this.el, this._openingTrigger);
                    if (this.options.preventScrolling) document.body.style.overflow = 'hidden';
                    this.el.classList.add('open');
                    this.el.insertAdjacentElement('afterend', this.$overlay[0]);
                    if (this.options.dismissible) {
                        this._handleKeydownBound = this._handleKeydown.bind(this);
                        this._handleFocusBound = this._handleFocus.bind(this);
                        document.addEventListener('keydown', this._handleKeydownBound);
                        document.addEventListener('focus', this._handleFocusBound, true);
                    }
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    this._animateIn();
                    // Focus modal
                    this.el.focus();
                    return this;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    Modal._modalsOpen--;
                    this._nthModalOpened = 0;
                    // Call onCloseStart callback
                    if (typeof this.options.onCloseStart === 'function') this.options.onCloseStart.call(this, this.el);
                    this.el.classList.remove('open');
                    // Enable body scrolling only if there are no more modals open.
                    if (Modal._modalsOpen === 0) document.body.style.overflow = '';
                    if (this.options.dismissible) {
                        document.removeEventListener('keydown', this._handleKeydownBound);
                        document.removeEventListener('focus', this._handleFocusBound, true);
                    }
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    this._animateOut();
                    return this;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Modal;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Modal;
    }(Component);
    /**
   * @static
   * @memberof Modal
   */ Modal._modalsOpen = 0;
    /**
   * @static
   * @memberof Modal
   */ Modal._count = 0;
    M.Modal = Modal;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        inDuration: 275,
        outDuration: 200,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null
    };
    /**
   * @class
   *
   */ var Materialbox = function(_Component4) {
        _inherits(Materialbox, _Component4);
        /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Materialbox(el, options) {
            _classCallCheck(this, Materialbox);
            var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));
            _this16.el.M_Materialbox = _this16;
            /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */ _this16.options = $1.extend({}, Materialbox.defaults, options);
            _this16.overlayActive = false;
            _this16.doneAnimating = true;
            _this16.placeholder = $1('<div></div>').addClass('material-placeholder');
            _this16.originalWidth = 0;
            _this16.originalHeight = 0;
            _this16.originInlineStyles = _this16.$el.attr('style');
            _this16.caption = _this16.el.getAttribute('data-caption') || '';
            // Wrap
            _this16.$el.before(_this16.placeholder);
            _this16.placeholder.append(_this16.$el);
            _this16._setupEventHandlers();
            return _this16;
        }
        _createClass(Materialbox, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Materialbox = undefined;
                    // Unwrap image
                    $1(this.placeholder).after(this.el).remove();
                    this.$el.removeAttr('style');
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
                    this.el.addEventListener('click', this._handleMaterialboxClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('click', this._handleMaterialboxClickBound);
                }
            },
            {
                key: "_handleMaterialboxClick",
                value: function _handleMaterialboxClick(e) {
                    // If already modal, return to original
                    if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) this.close();
                    else this.open();
                }
            },
            {
                key: "_handleWindowScroll",
                value: function _handleWindowScroll() {
                    if (this.overlayActive) this.close();
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    if (this.overlayActive) this.close();
                }
            },
            {
                key: "_handleWindowEscape",
                value: function _handleWindowEscape(e) {
                    // ESC key
                    if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) this.close();
                }
            },
            {
                key: "_makeAncestorsOverflowVisible",
                value: function _makeAncestorsOverflowVisible() {
                    this.ancestorsChanged = $1();
                    var ancestor = this.placeholder[0].parentNode;
                    while(ancestor !== null && !$1(ancestor).is(document)){
                        var curr = $1(ancestor);
                        if (curr.css('overflow') !== 'visible') {
                            curr.css('overflow', 'visible');
                            if (this.ancestorsChanged === undefined) this.ancestorsChanged = curr;
                            else this.ancestorsChanged = this.ancestorsChanged.add(curr);
                        }
                        ancestor = ancestor.parentNode;
                    }
                }
            },
            {
                key: "_animateImageIn",
                value: function _animateImageIn() {
                    var _this17 = this;
                    var animOptions = {
                        targets: this.el,
                        height: [
                            this.originalHeight,
                            this.newHeight
                        ],
                        width: [
                            this.originalWidth,
                            this.newWidth
                        ],
                        left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
                        top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
                        duration: this.options.inDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            _this17.doneAnimating = true;
                            // onOpenEnd callback
                            if (typeof _this17.options.onOpenEnd === 'function') _this17.options.onOpenEnd.call(_this17, _this17.el);
                        }
                    };
                    // Override max-width or max-height if needed
                    this.maxWidth = this.$el.css('max-width');
                    this.maxHeight = this.$el.css('max-height');
                    if (this.maxWidth !== 'none') animOptions.maxWidth = this.newWidth;
                    if (this.maxHeight !== 'none') animOptions.maxHeight = this.newHeight;
                    anim(animOptions);
                }
            },
            {
                key: "_animateImageOut",
                value: function _animateImageOut() {
                    var _this18 = this;
                    var animOptions = {
                        targets: this.el,
                        width: this.originalWidth,
                        height: this.originalHeight,
                        left: 0,
                        top: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            _this18.placeholder.css({
                                height: '',
                                width: '',
                                position: '',
                                top: '',
                                left: ''
                            });
                            // Revert to width or height attribute
                            if (_this18.attrWidth) _this18.$el.attr('width', _this18.attrWidth);
                            if (_this18.attrHeight) _this18.$el.attr('height', _this18.attrHeight);
                            _this18.$el.removeAttr('style');
                            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles);
                            // Remove class
                            _this18.$el.removeClass('active');
                            _this18.doneAnimating = true;
                            // Remove overflow overrides on ancestors
                            if (_this18.ancestorsChanged.length) _this18.ancestorsChanged.css('overflow', '');
                            // onCloseEnd callback
                            if (typeof _this18.options.onCloseEnd === 'function') _this18.options.onCloseEnd.call(_this18, _this18.el);
                        }
                    };
                    anim(animOptions);
                }
            },
            {
                key: "_updateVars",
                value: function _updateVars() {
                    this.windowWidth = window.innerWidth;
                    this.windowHeight = window.innerHeight;
                    this.caption = this.el.getAttribute('data-caption') || '';
                }
            },
            {
                key: "open",
                value: function open() {
                    var _this19 = this;
                    this._updateVars();
                    this.originalWidth = this.el.getBoundingClientRect().width;
                    this.originalHeight = this.el.getBoundingClientRect().height;
                    // Set states
                    this.doneAnimating = false;
                    this.$el.addClass('active');
                    this.overlayActive = true;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === 'function') this.options.onOpenStart.call(this, this.el);
                    // Set positioning for placeholder
                    this.placeholder.css({
                        width: this.placeholder[0].getBoundingClientRect().width + 'px',
                        height: this.placeholder[0].getBoundingClientRect().height + 'px',
                        position: 'relative',
                        top: 0,
                        left: 0
                    });
                    this._makeAncestorsOverflowVisible();
                    // Set css on origin
                    this.$el.css({
                        position: 'absolute',
                        'z-index': 1000,
                        'will-change': 'left, top, width, height'
                    });
                    // Change from width or height attribute to css
                    this.attrWidth = this.$el.attr('width');
                    this.attrHeight = this.$el.attr('height');
                    if (this.attrWidth) {
                        this.$el.css('width', this.attrWidth + 'px');
                        this.$el.removeAttr('width');
                    }
                    if (this.attrHeight) {
                        this.$el.css('width', this.attrHeight + 'px');
                        this.$el.removeAttr('height');
                    }
                    // Add overlay
                    this.$overlay = $1('<div id="materialbox-overlay"></div>').css({
                        opacity: 0
                    }).one('click', function() {
                        if (_this19.doneAnimating) _this19.close();
                    });
                    // Put before in origin image to preserve z-index layering.
                    this.$el.before(this.$overlay);
                    // Set dimensions if needed
                    var overlayOffset = this.$overlay[0].getBoundingClientRect();
                    this.$overlay.css({
                        width: this.windowWidth + 'px',
                        height: this.windowHeight + 'px',
                        left: -1 * overlayOffset.left + 'px',
                        top: -1 * overlayOffset.top + 'px'
                    });
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    // Animate Overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: 1,
                        duration: this.options.inDuration,
                        easing: 'easeOutQuad'
                    });
                    // Add and animate caption if it exists
                    if (this.caption !== '') {
                        if (this.$photocaption) anim.remove(this.$photoCaption[0]);
                        this.$photoCaption = $1('<div class="materialbox-caption"></div>');
                        this.$photoCaption.text(this.caption);
                        $1('body').append(this.$photoCaption);
                        this.$photoCaption.css({
                            display: 'inline'
                        });
                        anim({
                            targets: this.$photoCaption[0],
                            opacity: 1,
                            duration: this.options.inDuration,
                            easing: 'easeOutQuad'
                        });
                    }
                    // Resize Image
                    var ratio = 0;
                    var widthPercent = this.originalWidth / this.windowWidth;
                    var heightPercent = this.originalHeight / this.windowHeight;
                    this.newWidth = 0;
                    this.newHeight = 0;
                    if (widthPercent > heightPercent) {
                        ratio = this.originalHeight / this.originalWidth;
                        this.newWidth = this.windowWidth * 0.9;
                        this.newHeight = this.windowWidth * 0.9 * ratio;
                    } else {
                        ratio = this.originalWidth / this.originalHeight;
                        this.newWidth = this.windowHeight * 0.9 * ratio;
                        this.newHeight = this.windowHeight * 0.9;
                    }
                    this._animateImageIn();
                    // Handle Exit triggers
                    this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
                    this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                    this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);
                    window.addEventListener('scroll', this._handleWindowScrollBound);
                    window.addEventListener('resize', this._handleWindowResizeBound);
                    window.addEventListener('keyup', this._handleWindowEscapeBound);
                }
            },
            {
                key: "close",
                value: function close() {
                    var _this20 = this;
                    this._updateVars();
                    this.doneAnimating = false;
                    // onCloseStart callback
                    if (typeof this.options.onCloseStart === 'function') this.options.onCloseStart.call(this, this.el);
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    if (this.caption !== '') anim.remove(this.$photoCaption[0]);
                    // disable exit handlers
                    window.removeEventListener('scroll', this._handleWindowScrollBound);
                    window.removeEventListener('resize', this._handleWindowResizeBound);
                    window.removeEventListener('keyup', this._handleWindowEscapeBound);
                    anim({
                        targets: this.$overlay[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            _this20.overlayActive = false;
                            _this20.$overlay.remove();
                        }
                    });
                    this._animateImageOut();
                    // Remove Caption + reset css settings on image
                    if (this.caption !== '') anim({
                        targets: this.$photoCaption[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            _this20.$photoCaption.remove();
                        }
                    });
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Materialbox;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Materialbox;
    }(Component);
    M.Materialbox = Materialbox;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
})(cash, M.anime);
(function($1) {
    'use strict';
    var _defaults = {
        responsiveThreshold: 0 // breakpoint for swipeable
    };
    var Parallax = function(_Component5) {
        _inherits(Parallax, _Component5);
        function Parallax(el, options) {
            _classCallCheck(this, Parallax);
            var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));
            _this21.el.M_Parallax = _this21;
            /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */ _this21.options = $1.extend({}, Parallax.defaults, options);
            _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;
            _this21.$img = _this21.$el.find('img').first();
            _this21.$img.each(function() {
                var el = this;
                if (el.complete) $1(el).trigger('load');
            });
            _this21._updateParallax();
            _this21._setupEventHandlers();
            _this21._setupStyles();
            Parallax._parallaxes.push(_this21);
            return _this21;
        }
        _createClass(Parallax, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
                    this.$img[0].style.transform = '';
                    this._removeEventHandlers();
                    this.$el[0].M_Parallax = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleImageLoadBound = this._handleImageLoad.bind(this);
                    this.$img[0].addEventListener('load', this._handleImageLoadBound);
                    if (Parallax._parallaxes.length === 0) {
                        Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
                        window.addEventListener('scroll', Parallax._handleScrollThrottled);
                        Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
                        window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.$img[0].removeEventListener('load', this._handleImageLoadBound);
                    if (Parallax._parallaxes.length === 0) {
                        window.removeEventListener('scroll', Parallax._handleScrollThrottled);
                        window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
                    }
                }
            },
            {
                key: "_setupStyles",
                value: function _setupStyles() {
                    this.$img[0].style.opacity = 1;
                }
            },
            {
                key: "_handleImageLoad",
                value: function _handleImageLoad() {
                    this._updateParallax();
                }
            },
            {
                key: "_updateParallax",
                value: function _updateParallax() {
                    var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
                    var imgHeight = this.$img[0].offsetHeight;
                    var parallaxDist = imgHeight - containerHeight;
                    var bottom = this.$el.offset().top + containerHeight;
                    var top = this.$el.offset().top;
                    var scrollTop = M.getDocumentScrollTop();
                    var windowHeight = window.innerHeight;
                    var windowBottom = scrollTop + windowHeight;
                    var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
                    var parallax = parallaxDist * percentScrolled;
                    if (!this._enabled) this.$img[0].style.transform = '';
                    else if (bottom > scrollTop && top < scrollTop + windowHeight) this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Parallax;
                }
            },
            {
                key: "_handleScroll",
                value: function _handleScroll() {
                    for(var i = 0; i < Parallax._parallaxes.length; i++){
                        var parallaxInstance = Parallax._parallaxes[i];
                        parallaxInstance._updateParallax.call(parallaxInstance);
                    }
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    for(var i = 0; i < Parallax._parallaxes.length; i++){
                        var parallaxInstance = Parallax._parallaxes[i];
                        parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Parallax;
    }(Component);
    /**
   * @static
   * @memberof Parallax
   */ Parallax._parallaxes = [];
    M.Parallax = Parallax;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
})(cash);
(function($1, anim) {
    'use strict';
    var _defaults = {
        duration: 300,
        onShow: null,
        swipeable: false,
        responsiveThreshold: Infinity // breakpoint for swipeable
    };
    /**
   * @class
   *
   */ var Tabs = function(_Component6) {
        _inherits(Tabs, _Component6);
        /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Tabs(el, options) {
            _classCallCheck(this, Tabs);
            var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));
            _this22.el.M_Tabs = _this22;
            /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */ _this22.options = $1.extend({}, Tabs.defaults, options);
            // Setup
            _this22.$tabLinks = _this22.$el.children('li.tab').children('a');
            _this22.index = 0;
            _this22._setupActiveTabLink();
            // Setup tabs content
            if (_this22.options.swipeable) _this22._setupSwipeableTabs();
            else _this22._setupNormalTabs();
            // Setup tabs indicator after content to ensure accurate widths
            _this22._setTabsAndTabWidth();
            _this22._createIndicator();
            _this22._setupEventHandlers();
            return _this22;
        }
        _createClass(Tabs, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._indicator.parentNode.removeChild(this._indicator);
                    if (this.options.swipeable) this._teardownSwipeableTabs();
                    else this._teardownNormalTabs();
                    this.$el[0].M_Tabs = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                    window.addEventListener('resize', this._handleWindowResizeBound);
                    this._handleTabClickBound = this._handleTabClick.bind(this);
                    this.el.addEventListener('click', this._handleTabClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    window.removeEventListener('resize', this._handleWindowResizeBound);
                    this.el.removeEventListener('click', this._handleTabClickBound);
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    this._setTabsAndTabWidth();
                    if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
                        this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
                        this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
                    }
                }
            },
            {
                key: "_handleTabClick",
                value: function _handleTabClick(e) {
                    var _this23 = this;
                    var tab = $1(e.target).closest('li.tab');
                    var tabLink = $1(e.target).closest('a');
                    // Handle click on tab link only
                    if (!tabLink.length || !tabLink.parent().hasClass('tab')) return;
                    if (tab.hasClass('disabled')) {
                        e.preventDefault();
                        return;
                    }
                    // Act as regular link if target attribute is specified.
                    if (!!tabLink.attr('target')) return;
                    // Make the old tab inactive.
                    this.$activeTabLink.removeClass('active');
                    var $oldContent = this.$content;
                    // Update the variables with the new link and content
                    this.$activeTabLink = tabLink;
                    this.$content = $1(M.escapeHash(tabLink[0].hash));
                    this.$tabLinks = this.$el.children('li.tab').children('a');
                    // Make the tab active.
                    this.$activeTabLink.addClass('active');
                    var prevIndex = this.index;
                    this.index = Math.max(this.$tabLinks.index(tabLink), 0);
                    // Swap content
                    if (this.options.swipeable) {
                        if (this._tabsCarousel) this._tabsCarousel.set(this.index, function() {
                            if (typeof _this23.options.onShow === 'function') _this23.options.onShow.call(_this23, _this23.$content[0]);
                        });
                    } else if (this.$content.length) {
                        this.$content[0].style.display = 'block';
                        this.$content.addClass('active');
                        if (typeof this.options.onShow === 'function') this.options.onShow.call(this, this.$content[0]);
                        if ($oldContent.length && !$oldContent.is(this.$content)) {
                            $oldContent[0].style.display = 'none';
                            $oldContent.removeClass('active');
                        }
                    }
                    // Update widths after content is swapped (scrollbar bugfix)
                    this._setTabsAndTabWidth();
                    // Update indicator
                    this._animateIndicator(prevIndex);
                    // Prevent the anchor's default click action
                    e.preventDefault();
                }
            },
            {
                key: "_createIndicator",
                value: function _createIndicator() {
                    var _this24 = this;
                    var indicator = document.createElement('li');
                    indicator.classList.add('indicator');
                    this.el.appendChild(indicator);
                    this._indicator = indicator;
                    setTimeout(function() {
                        _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
                        _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
                    }, 0);
                }
            },
            {
                key: "_setupActiveTabLink",
                value: function _setupActiveTabLink() {
                    // If the location.hash matches one of the links, use that as the active tab.
                    this.$activeTabLink = $1(this.$tabLinks.filter('[href="' + location.hash + '"]'));
                    // If no match is found, use the first link or any with class 'active' as the initial active tab.
                    if (this.$activeTabLink.length === 0) this.$activeTabLink = this.$el.children('li.tab').children('a.active').first();
                    if (this.$activeTabLink.length === 0) this.$activeTabLink = this.$el.children('li.tab').children('a').first();
                    this.$tabLinks.removeClass('active');
                    this.$activeTabLink[0].classList.add('active');
                    this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);
                    if (this.$activeTabLink.length) {
                        this.$content = $1(M.escapeHash(this.$activeTabLink[0].hash));
                        this.$content.addClass('active');
                    }
                }
            },
            {
                key: "_setupSwipeableTabs",
                value: function _setupSwipeableTabs() {
                    var _this25 = this;
                    // Change swipeable according to responsive threshold
                    if (window.innerWidth > this.options.responsiveThreshold) this.options.swipeable = false;
                    var $tabsContent = $1();
                    this.$tabLinks.each(function(link) {
                        var $currContent = $1(M.escapeHash(link.hash));
                        $currContent.addClass('carousel-item');
                        $tabsContent = $tabsContent.add($currContent);
                    });
                    var $tabsWrapper = $1('<div class="tabs-content carousel carousel-slider"></div>');
                    $tabsContent.first().before($tabsWrapper);
                    $tabsWrapper.append($tabsContent);
                    $tabsContent[0].style.display = '';
                    // Keep active tab index to set initial carousel slide
                    var activeTabIndex = this.$activeTabLink.closest('.tab').index();
                    this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
                        fullWidth: true,
                        noWrap: true,
                        onCycleTo: function(item) {
                            var prevIndex = _this25.index;
                            _this25.index = $1(item).index();
                            _this25.$activeTabLink.removeClass('active');
                            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
                            _this25.$activeTabLink.addClass('active');
                            _this25._animateIndicator(prevIndex);
                            if (typeof _this25.options.onShow === 'function') _this25.options.onShow.call(_this25, _this25.$content[0]);
                        }
                    });
                    // Set initial carousel slide to active tab
                    this._tabsCarousel.set(activeTabIndex);
                }
            },
            {
                key: "_teardownSwipeableTabs",
                value: function _teardownSwipeableTabs() {
                    var $tabsWrapper = this._tabsCarousel.$el;
                    this._tabsCarousel.destroy();
                    // Unwrap
                    $tabsWrapper.after($tabsWrapper.children());
                    $tabsWrapper.remove();
                }
            },
            {
                key: "_setupNormalTabs",
                value: function _setupNormalTabs() {
                    // Hide Tabs Content
                    this.$tabLinks.not(this.$activeTabLink).each(function(link) {
                        if (!!link.hash) {
                            var $currContent = $1(M.escapeHash(link.hash));
                            if ($currContent.length) $currContent[0].style.display = 'none';
                        }
                    });
                }
            },
            {
                key: "_teardownNormalTabs",
                value: function _teardownNormalTabs() {
                    // show Tabs Content
                    this.$tabLinks.each(function(link) {
                        if (!!link.hash) {
                            var $currContent = $1(M.escapeHash(link.hash));
                            if ($currContent.length) $currContent[0].style.display = '';
                        }
                    });
                }
            },
            {
                key: "_setTabsAndTabWidth",
                value: function _setTabsAndTabWidth() {
                    this.tabsWidth = this.$el.width();
                    this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
                }
            },
            {
                key: "_calcRightPos",
                value: function _calcRightPos(el) {
                    return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
                }
            },
            {
                key: "_calcLeftPos",
                value: function _calcLeftPos(el) {
                    return Math.floor(el.position().left);
                }
            },
            {
                key: "updateTabIndicator",
                value: function updateTabIndicator() {
                    this._setTabsAndTabWidth();
                    this._animateIndicator(this.index);
                }
            },
            {
                key: "_animateIndicator",
                value: function _animateIndicator(prevIndex) {
                    var leftDelay = 0, rightDelay = 0;
                    if (this.index - prevIndex >= 0) leftDelay = 90;
                    else rightDelay = 90;
                    // Animate
                    var animOptions = {
                        targets: this._indicator,
                        left: {
                            value: this._calcLeftPos(this.$activeTabLink),
                            delay: leftDelay
                        },
                        right: {
                            value: this._calcRightPos(this.$activeTabLink),
                            delay: rightDelay
                        },
                        duration: this.options.duration,
                        easing: 'easeOutQuad'
                    };
                    anim.remove(this._indicator);
                    anim(animOptions);
                }
            },
            {
                key: "select",
                value: function select(tabId) {
                    var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
                    if (tab.length) tab.trigger('click');
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Tabs;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Tabs;
    }(Component);
    M.Tabs = Tabs;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        exitDelay: 200,
        enterDelay: 0,
        html: null,
        margin: 5,
        inDuration: 250,
        outDuration: 200,
        position: 'bottom',
        transitionMovement: 10
    };
    /**
   * @class
   *
   */ var Tooltip = function(_Component7) {
        _inherits(Tooltip, _Component7);
        /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Tooltip(el, options) {
            _classCallCheck(this, Tooltip);
            var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));
            _this26.el.M_Tooltip = _this26;
            _this26.options = $1.extend({}, Tooltip.defaults, options);
            _this26.isOpen = false;
            _this26.isHovered = false;
            _this26.isFocused = false;
            _this26._appendTooltipEl();
            _this26._setupEventHandlers();
            return _this26;
        }
        _createClass(Tooltip, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    $1(this.tooltipEl).remove();
                    this._removeEventHandlers();
                    this.el.M_Tooltip = undefined;
                }
            },
            {
                key: "_appendTooltipEl",
                value: function _appendTooltipEl() {
                    var tooltipEl = document.createElement('div');
                    tooltipEl.classList.add('material-tooltip');
                    this.tooltipEl = tooltipEl;
                    var tooltipContentEl = document.createElement('div');
                    tooltipContentEl.classList.add('tooltip-content');
                    tooltipContentEl.innerHTML = this.options.html;
                    tooltipEl.appendChild(tooltipContentEl);
                    document.body.appendChild(tooltipEl);
                }
            },
            {
                key: "_updateTooltipContent",
                value: function _updateTooltipContent() {
                    this.tooltipEl.querySelector('.tooltip-content').innerHTML = this.options.html;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
                    this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
                    this._handleFocusBound = this._handleFocus.bind(this);
                    this._handleBlurBound = this._handleBlur.bind(this);
                    this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
                    this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
                    this.el.addEventListener('focus', this._handleFocusBound, true);
                    this.el.addEventListener('blur', this._handleBlurBound, true);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
                    this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
                    this.el.removeEventListener('focus', this._handleFocusBound, true);
                    this.el.removeEventListener('blur', this._handleBlurBound, true);
                }
            },
            {
                key: "open",
                value: function open(isManual) {
                    if (this.isOpen) return;
                    isManual = isManual === undefined ? true : undefined; // Default value true
                    this.isOpen = true;
                    // Update tooltip content with HTML attribute options
                    this.options = $1.extend({}, this.options, this._getAttributeOptions());
                    this._updateTooltipContent();
                    this._setEnterDelayTimeout(isManual);
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isHovered = false;
                    this.isFocused = false;
                    this.isOpen = false;
                    this._setExitDelayTimeout();
                }
            },
            {
                key: "_setExitDelayTimeout",
                value: function _setExitDelayTimeout() {
                    var _this27 = this;
                    clearTimeout(this._exitDelayTimeout);
                    this._exitDelayTimeout = setTimeout(function() {
                        if (_this27.isHovered || _this27.isFocused) return;
                        _this27._animateOut();
                    }, this.options.exitDelay);
                }
            },
            {
                key: "_setEnterDelayTimeout",
                value: function _setEnterDelayTimeout(isManual) {
                    var _this28 = this;
                    clearTimeout(this._enterDelayTimeout);
                    this._enterDelayTimeout = setTimeout(function() {
                        if (!_this28.isHovered && !_this28.isFocused && !isManual) return;
                        _this28._animateIn();
                    }, this.options.enterDelay);
                }
            },
            {
                key: "_positionTooltip",
                value: function _positionTooltip() {
                    var origin = this.el, tooltip = this.tooltipEl, originHeight = origin.offsetHeight, originWidth = origin.offsetWidth, tooltipHeight = tooltip.offsetHeight, tooltipWidth = tooltip.offsetWidth, newCoordinates = void 0, margin = this.options.margin, targetTop = void 0, targetLeft = void 0;
                    this.xMovement = 0, this.yMovement = 0;
                    targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
                    targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();
                    if (this.options.position === 'top') {
                        targetTop += -tooltipHeight - margin;
                        targetLeft += originWidth / 2 - tooltipWidth / 2;
                        this.yMovement = -this.options.transitionMovement;
                    } else if (this.options.position === 'right') {
                        targetTop += originHeight / 2 - tooltipHeight / 2;
                        targetLeft += originWidth + margin;
                        this.xMovement = this.options.transitionMovement;
                    } else if (this.options.position === 'left') {
                        targetTop += originHeight / 2 - tooltipHeight / 2;
                        targetLeft += -tooltipWidth - margin;
                        this.xMovement = -this.options.transitionMovement;
                    } else {
                        targetTop += originHeight + margin;
                        targetLeft += originWidth / 2 - tooltipWidth / 2;
                        this.yMovement = this.options.transitionMovement;
                    }
                    newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
                    $1(tooltip).css({
                        top: newCoordinates.y + 'px',
                        left: newCoordinates.x + 'px'
                    });
                }
            },
            {
                key: "_repositionWithinScreen",
                value: function _repositionWithinScreen(x, y, width, height) {
                    var scrollLeft = M.getDocumentScrollLeft();
                    var scrollTop = M.getDocumentScrollTop();
                    var newX = x - scrollLeft;
                    var newY = y - scrollTop;
                    var bounding = {
                        left: newX,
                        top: newY,
                        width: width,
                        height: height
                    };
                    var offset = this.options.margin + this.options.transitionMovement;
                    var edges = M.checkWithinContainer(document.body, bounding, offset);
                    if (edges.left) newX = offset;
                    else if (edges.right) newX -= newX + width - window.innerWidth;
                    if (edges.top) newY = offset;
                    else if (edges.bottom) newY -= newY + height - window.innerHeight;
                    return {
                        x: newX + scrollLeft,
                        y: newY + scrollTop
                    };
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    this._positionTooltip();
                    this.tooltipEl.style.visibility = 'visible';
                    anim.remove(this.tooltipEl);
                    anim({
                        targets: this.tooltipEl,
                        opacity: 1,
                        translateX: this.xMovement,
                        translateY: this.yMovement,
                        duration: this.options.inDuration,
                        easing: 'easeOutCubic'
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    anim.remove(this.tooltipEl);
                    anim({
                        targets: this.tooltipEl,
                        opacity: 0,
                        translateX: 0,
                        translateY: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutCubic'
                    });
                }
            },
            {
                key: "_handleMouseEnter",
                value: function _handleMouseEnter() {
                    this.isHovered = true;
                    this.isFocused = false; // Allows close of tooltip when opened by focus.
                    this.open(false);
                }
            },
            {
                key: "_handleMouseLeave",
                value: function _handleMouseLeave() {
                    this.isHovered = false;
                    this.isFocused = false; // Allows close of tooltip when opened by focus.
                    this.close();
                }
            },
            {
                key: "_handleFocus",
                value: function _handleFocus() {
                    if (M.tabPressed) {
                        this.isFocused = true;
                        this.open(false);
                    }
                }
            },
            {
                key: "_handleBlur",
                value: function _handleBlur() {
                    this.isFocused = false;
                    this.close();
                }
            },
            {
                key: "_getAttributeOptions",
                value: function _getAttributeOptions() {
                    var attributeOptions = {};
                    var tooltipTextOption = this.el.getAttribute('data-tooltip');
                    var positionOption = this.el.getAttribute('data-position');
                    if (tooltipTextOption) attributeOptions.html = tooltipTextOption;
                    if (positionOption) attributeOptions.position = positionOption;
                    return attributeOptions;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Tooltip;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Tooltip;
    }(Component);
    M.Tooltip = Tooltip;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
})(cash, M.anime);
(function(window1) {
    'use strict';
    var Waves = Waves || {};
    var $$ = document.querySelectorAll.bind(document);
    // Find exact position of element
    function isWindow(obj) {
        return obj !== null && obj === obj.window;
    }
    function getWindow(elem) {
        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    }
    function offset(elem) {
        var docElem, win, box = {
            top: 0,
            left: 0
        }, doc = elem && elem.ownerDocument;
        docElem = doc.documentElement;
        if (typeof elem.getBoundingClientRect !== "undefined") box = elem.getBoundingClientRect();
        win = getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    }
    function convertStyle(obj) {
        var style = '';
        for(var a in obj)if (obj.hasOwnProperty(a)) style += a + ':' + obj[a] + ';';
        return style;
    }
    var Effect = {
        // Effect delay
        duration: 750,
        show: function(e, element) {
            // Disable right click
            if (e.button === 2) return false;
            var el = element || this;
            // Create ripple
            var ripple = document.createElement('div');
            ripple.className = 'waves-ripple';
            el.appendChild(ripple);
            // Get click coordinate and element witdh
            var pos = offset(el);
            var relativeY = e.pageY - pos.top;
            var relativeX = e.pageX - pos.left;
            var scale = 'scale(' + el.clientWidth / 100 * 10 + ')';
            // Support for touch devices
            if ('touches' in e) {
                relativeY = e.touches[0].pageY - pos.top;
                relativeX = e.touches[0].pageX - pos.left;
            }
            // Attach data to element
            ripple.setAttribute('data-hold', Date.now());
            ripple.setAttribute('data-scale', scale);
            ripple.setAttribute('data-x', relativeX);
            ripple.setAttribute('data-y', relativeY);
            // Set ripple position
            var rippleStyle = {
                'top': relativeY + 'px',
                'left': relativeX + 'px'
            };
            ripple.className = ripple.className + ' waves-notransition';
            ripple.setAttribute('style', convertStyle(rippleStyle));
            ripple.className = ripple.className.replace('waves-notransition', '');
            // Scale the ripple
            rippleStyle['-webkit-transform'] = scale;
            rippleStyle['-moz-transform'] = scale;
            rippleStyle['-ms-transform'] = scale;
            rippleStyle['-o-transform'] = scale;
            rippleStyle.transform = scale;
            rippleStyle.opacity = '1';
            rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            ripple.setAttribute('style', convertStyle(rippleStyle));
        },
        hide: function(e) {
            TouchHandler.touchup(e);
            var el = this;
            var width = el.clientWidth * 1.4;
            // Get first ripple
            var ripple = null;
            var ripples = el.getElementsByClassName('waves-ripple');
            if (ripples.length > 0) ripple = ripples[ripples.length - 1];
            else return false;
            var relativeX = ripple.getAttribute('data-x');
            var relativeY = ripple.getAttribute('data-y');
            var scale = ripple.getAttribute('data-scale');
            // Get delay beetween mousedown and mouse leave
            var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
            var delay = 350 - diff;
            if (delay < 0) delay = 0;
            // Fade out ripple after delay
            setTimeout(function() {
                var style = {
                    'top': relativeY + 'px',
                    'left': relativeX + 'px',
                    'opacity': '0',
                    // Duration
                    '-webkit-transition-duration': Effect.duration + 'ms',
                    '-moz-transition-duration': Effect.duration + 'ms',
                    '-o-transition-duration': Effect.duration + 'ms',
                    'transition-duration': Effect.duration + 'ms',
                    '-webkit-transform': scale,
                    '-moz-transform': scale,
                    '-ms-transform': scale,
                    '-o-transform': scale,
                    'transform': scale
                };
                ripple.setAttribute('style', convertStyle(style));
                setTimeout(function() {
                    try {
                        el.removeChild(ripple);
                    } catch (e) {
                        return false;
                    }
                }, Effect.duration);
            }, delay);
        },
        // Little hack to make <input> can perform waves effect
        wrapInput: function(elements) {
            for(var a = 0; a < elements.length; a++){
                var el = elements[a];
                if (el.tagName.toLowerCase() === 'input') {
                    var parent = el.parentNode;
                    // If input already have parent just pass through
                    if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) continue;
                    // Put element class and style to the specified parent
                    var wrapper = document.createElement('i');
                    wrapper.className = el.className + ' waves-input-wrapper';
                    var elementStyle = el.getAttribute('style');
                    if (!elementStyle) elementStyle = '';
                    wrapper.setAttribute('style', elementStyle);
                    el.className = 'waves-button-input';
                    el.removeAttribute('style');
                    // Put element as child
                    parent.replaceChild(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        }
    };
    /**
   * Disable mousedown event for 500ms during and after touch
   */ var TouchHandler = {
        /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */ touches: 0,
        allowEvent: function(e) {
            var allow = true;
            if (e.type === 'touchstart') TouchHandler.touches += 1; //push
            else if (e.type === 'touchend' || e.type === 'touchcancel') setTimeout(function() {
                if (TouchHandler.touches > 0) TouchHandler.touches -= 1; //pop after 500ms
            }, 500);
            else if (e.type === 'mousedown' && TouchHandler.touches > 0) allow = false;
            return allow;
        },
        touchup: function(e) {
            TouchHandler.allowEvent(e);
        }
    };
    /**
   * Delegated click handler for .waves-effect element.
   * returns null when .waves-effect element not in "click tree"
   */ function getWavesEffectElement(e) {
        if (TouchHandler.allowEvent(e) === false) return null;
        var element = null;
        var target = e.target || e.srcElement;
        while(target.parentNode !== null){
            if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
                element = target;
                break;
            }
            target = target.parentNode;
        }
        return element;
    }
    /**
   * Bubble the click and show effect if .waves-effect elem was found
   */ function showEffect(e) {
        var element = getWavesEffectElement(e);
        if (element !== null) {
            Effect.show(e, element);
            if ('ontouchstart' in window1) {
                element.addEventListener('touchend', Effect.hide, false);
                element.addEventListener('touchcancel', Effect.hide, false);
            }
            element.addEventListener('mouseup', Effect.hide, false);
            element.addEventListener('mouseleave', Effect.hide, false);
            element.addEventListener('dragend', Effect.hide, false);
        }
    }
    Waves.displayEffect = function(options) {
        options = options || {};
        if ('duration' in options) Effect.duration = options.duration;
        //Wrap input inside <i> tag
        Effect.wrapInput($$('.waves-effect'));
        if ('ontouchstart' in window1) document.body.addEventListener('touchstart', showEffect, false);
        document.body.addEventListener('mousedown', showEffect, false);
    };
    /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */ Waves.attach = function(element) {
        //FUTURE: automatically add waves classes and allow users
        // to specify them with an options param? Eg. light/classic/button
        if (element.tagName.toLowerCase() === 'input') {
            Effect.wrapInput([
                element
            ]);
            element = element.parentNode;
        }
        if ('ontouchstart' in window1) element.addEventListener('touchstart', showEffect, false);
        element.addEventListener('mousedown', showEffect, false);
    };
    window1.Waves = Waves;
    document.addEventListener('DOMContentLoaded', function() {
        Waves.displayEffect();
    }, false);
})(window);
(function($1, anim) {
    'use strict';
    var _defaults = {
        html: '',
        displayLength: 4000,
        inDuration: 300,
        outDuration: 375,
        classes: '',
        completeCallback: null,
        activationPercent: 0.8
    };
    var Toast = function() {
        function Toast(options) {
            _classCallCheck(this, Toast);
            /**
       * Options for the toast
       * @member Toast#options
       */ this.options = $1.extend({}, Toast.defaults, options);
            this.message = this.options.html;
            /**
       * Describes current pan state toast
       * @type {Boolean}
       */ this.panning = false;
            /**
       * Time remaining until toast is removed
       */ this.timeRemaining = this.options.displayLength;
            if (Toast._toasts.length === 0) Toast._createContainer();
            // Create new toast
            Toast._toasts.push(this);
            var toastElement = this._createToast();
            toastElement.M_Toast = this;
            this.el = toastElement;
            this.$el = $1(toastElement);
            this._animateIn();
            this._setTimer();
        }
        _createClass(Toast, [
            {
                key: "_createToast",
                /**
       * Create toast and append it to toast container
       */ value: function _createToast() {
                    var toast = document.createElement('div');
                    toast.classList.add('toast');
                    // Add custom classes onto toast
                    if (!!this.options.classes.length) $1(toast).addClass(this.options.classes);
                    // Set content
                    if (typeof HTMLElement === 'object' ? this.message instanceof HTMLElement : this.message && typeof this.message === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') toast.appendChild(this.message);
                    else if (!!this.message.jquery) $1(toast).append(this.message[0]);
                    else toast.innerHTML = this.message;
                    // Append toasft
                    Toast._container.appendChild(toast);
                    return toast;
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    // Animate toast in
                    anim({
                        targets: this.el,
                        top: 0,
                        opacity: 1,
                        duration: this.options.inDuration,
                        easing: 'easeOutCubic'
                    });
                }
            },
            {
                key: "_setTimer",
                value: function _setTimer() {
                    var _this29 = this;
                    if (this.timeRemaining !== Infinity) this.counterInterval = setInterval(function() {
                        // If toast is not being dragged, decrease its time remaining
                        if (!_this29.panning) _this29.timeRemaining -= 20;
                        // Animate toast out
                        if (_this29.timeRemaining <= 0) _this29.dismiss();
                    }, 20);
                }
            },
            {
                key: "dismiss",
                value: function dismiss() {
                    var _this30 = this;
                    window.clearInterval(this.counterInterval);
                    var activationDistance = this.el.offsetWidth * this.options.activationPercent;
                    if (this.wasSwiped) {
                        this.el.style.transition = 'transform .05s, opacity .05s';
                        this.el.style.transform = "translateX(" + activationDistance + "px)";
                        this.el.style.opacity = 0;
                    }
                    anim({
                        targets: this.el,
                        opacity: 0,
                        marginTop: -40,
                        duration: this.options.outDuration,
                        easing: 'easeOutExpo',
                        complete: function() {
                            // Call the optional callback
                            if (typeof _this30.options.completeCallback === 'function') _this30.options.completeCallback();
                            // Remove toast from DOM
                            _this30.$el.remove();
                            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
                            if (Toast._toasts.length === 0) Toast._removeContainer();
                        }
                    });
                }
            }
        ], [
            {
                key: "getInstance",
                /**
       * Get Instance
       */ value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Toast;
                }
            },
            {
                key: "_createContainer",
                value: function _createContainer() {
                    var container = document.createElement('div');
                    container.setAttribute('id', 'toast-container');
                    // Add event handler
                    container.addEventListener('touchstart', Toast._onDragStart);
                    container.addEventListener('touchmove', Toast._onDragMove);
                    container.addEventListener('touchend', Toast._onDragEnd);
                    container.addEventListener('mousedown', Toast._onDragStart);
                    document.addEventListener('mousemove', Toast._onDragMove);
                    document.addEventListener('mouseup', Toast._onDragEnd);
                    document.body.appendChild(container);
                    Toast._container = container;
                }
            },
            {
                key: "_removeContainer",
                value: function _removeContainer() {
                    // Add event handler
                    document.removeEventListener('mousemove', Toast._onDragMove);
                    document.removeEventListener('mouseup', Toast._onDragEnd);
                    $1(Toast._container).remove();
                    Toast._container = null;
                }
            },
            {
                key: "_onDragStart",
                value: function _onDragStart(e) {
                    if (e.target && $1(e.target).closest('.toast').length) {
                        var $toast = $1(e.target).closest('.toast');
                        var toast = $toast[0].M_Toast;
                        toast.panning = true;
                        Toast._draggedToast = toast;
                        toast.el.classList.add('panning');
                        toast.el.style.transition = '';
                        toast.startingXPos = Toast._xPos(e);
                        toast.time = Date.now();
                        toast.xPos = Toast._xPos(e);
                    }
                }
            },
            {
                key: "_onDragMove",
                value: function _onDragMove(e) {
                    if (!!Toast._draggedToast) {
                        e.preventDefault();
                        var toast = Toast._draggedToast;
                        toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
                        toast.xPos = Toast._xPos(e);
                        toast.velocityX = toast.deltaX / (Date.now() - toast.time);
                        toast.time = Date.now();
                        var totalDeltaX = toast.xPos - toast.startingXPos;
                        var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
                        toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
                        toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
                    }
                }
            },
            {
                key: "_onDragEnd",
                value: function _onDragEnd() {
                    if (!!Toast._draggedToast) {
                        var toast = Toast._draggedToast;
                        toast.panning = false;
                        toast.el.classList.remove('panning');
                        var totalDeltaX = toast.xPos - toast.startingXPos;
                        var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
                        var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;
                        // Remove toast
                        if (shouldBeDismissed) {
                            toast.wasSwiped = true;
                            toast.dismiss();
                        // Animate toast back to original position
                        } else {
                            toast.el.style.transition = 'transform .2s, opacity .2s';
                            toast.el.style.transform = '';
                            toast.el.style.opacity = '';
                        }
                        Toast._draggedToast = null;
                    }
                }
            },
            {
                key: "_xPos",
                value: function _xPos(e) {
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientX;
                    // mouse event
                    return e.clientX;
                }
            },
            {
                key: "dismissAll",
                value: function dismissAll() {
                    for(var toastIndex in Toast._toasts)Toast._toasts[toastIndex].dismiss();
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */ Toast._toasts = [];
    /**
   * @static
   * @memberof Toast
   */ Toast._container = null;
    /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */ Toast._draggedToast = null;
    M.Toast = Toast;
    M.toast = function(options) {
        return new Toast(options);
    };
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        edge: 'left',
        draggable: true,
        inDuration: 250,
        outDuration: 200,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        preventScrolling: true
    };
    /**
   * @class
   */ var Sidenav = function(_Component8) {
        _inherits(Sidenav, _Component8);
        /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Sidenav(el, options) {
            _classCallCheck(this, Sidenav);
            var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));
            _this31.el.M_Sidenav = _this31;
            _this31.id = _this31.$el.attr('id');
            /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */ _this31.options = $1.extend({}, Sidenav.defaults, options);
            /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */ _this31.isOpen = false;
            /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */ _this31.isFixed = _this31.el.classList.contains('sidenav-fixed');
            /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */ _this31.isDragged = false;
            // Window size variables for window resize checks
            _this31.lastWindowWidth = window.innerWidth;
            _this31.lastWindowHeight = window.innerHeight;
            _this31._createOverlay();
            _this31._createDragTarget();
            _this31._setupEventHandlers();
            _this31._setupClasses();
            _this31._setupFixed();
            Sidenav._sidenavs.push(_this31);
            return _this31;
        }
        _createClass(Sidenav, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._enableBodyScrolling();
                    this._overlay.parentNode.removeChild(this._overlay);
                    this.dragTarget.parentNode.removeChild(this.dragTarget);
                    this.el.M_Sidenav = undefined;
                    this.el.style.transform = '';
                    var index = Sidenav._sidenavs.indexOf(this);
                    if (index >= 0) Sidenav._sidenavs.splice(index, 1);
                }
            },
            {
                key: "_createOverlay",
                value: function _createOverlay() {
                    var overlay = document.createElement('div');
                    this._closeBound = this.close.bind(this);
                    overlay.classList.add('sidenav-overlay');
                    overlay.addEventListener('click', this._closeBound);
                    document.body.appendChild(overlay);
                    this._overlay = overlay;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    if (Sidenav._sidenavs.length === 0) document.body.addEventListener('click', this._handleTriggerClick);
                    this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
                    this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
                    this._handleCloseDragBound = this._handleCloseDrag.bind(this);
                    this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
                    this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);
                    this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
                    this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);
                    this._overlay.addEventListener('touchmove', this._handleCloseDragBound);
                    this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);
                    this.el.addEventListener('touchmove', this._handleCloseDragBound);
                    this.el.addEventListener('touchend', this._handleCloseReleaseBound);
                    this.el.addEventListener('click', this._handleCloseTriggerClickBound);
                    // Add resize for side nav fixed
                    if (this.isFixed) {
                        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                        window.addEventListener('resize', this._handleWindowResizeBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (Sidenav._sidenavs.length === 1) document.body.removeEventListener('click', this._handleTriggerClick);
                    this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
                    this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);
                    this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);
                    this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);
                    this.el.removeEventListener('touchmove', this._handleCloseDragBound);
                    this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
                    this.el.removeEventListener('click', this._handleCloseTriggerClickBound);
                    // Remove resize for side nav fixed
                    if (this.isFixed) window.removeEventListener('resize', this._handleWindowResizeBound);
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target).closest('.sidenav-trigger');
                    if (e.target && $trigger.length) {
                        var sidenavId = M.getIdFromTrigger($trigger[0]);
                        var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
                        if (sidenavInstance) sidenavInstance.open($trigger);
                        e.preventDefault();
                    }
                }
            },
            {
                key: "_startDrag",
                value: function _startDrag(e) {
                    var clientX = e.targetTouches[0].clientX;
                    this.isDragged = true;
                    this._startingXpos = clientX;
                    this._xPos = this._startingXpos;
                    this._time = Date.now();
                    this._width = this.el.getBoundingClientRect().width;
                    this._overlay.style.display = 'block';
                    this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
                    this._verticallyScrolling = false;
                    anim.remove(this.el);
                    anim.remove(this._overlay);
                }
            },
            {
                key: "_dragMoveUpdate",
                value: function _dragMoveUpdate(e) {
                    var clientX = e.targetTouches[0].clientX;
                    var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
                    this.deltaX = Math.abs(this._xPos - clientX);
                    this._xPos = clientX;
                    this.velocityX = this.deltaX / (Date.now() - this._time);
                    this._time = Date.now();
                    if (this._initialScrollTop !== currentScrollTop) this._verticallyScrolling = true;
                }
            },
            {
                key: "_handleDragTargetDrag",
                value: function _handleDragTargetDrag(e) {
                    // Check if draggable
                    if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) return;
                    // If not being dragged, set initial drag start variables
                    if (!this.isDragged) this._startDrag(e);
                    // Run touchmove updates
                    this._dragMoveUpdate(e);
                    // Calculate raw deltaX
                    var totalDeltaX = this._xPos - this._startingXpos;
                    // dragDirection is the attempted user drag direction
                    var dragDirection = totalDeltaX > 0 ? 'right' : 'left';
                    // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
                    totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
                    if (this.options.edge === dragDirection) totalDeltaX = 0;
                    /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */ var transformX = totalDeltaX;
                    var transformPrefix = 'translateX(-100%)';
                    if (this.options.edge === 'right') {
                        transformPrefix = 'translateX(100%)';
                        transformX = -transformX;
                    }
                    // Calculate open/close percentage of sidenav, with open = 1 and close = 0
                    this.percentOpen = Math.min(1, totalDeltaX / this._width);
                    // Set transform and opacity styles
                    this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
                    this._overlay.style.opacity = this.percentOpen;
                }
            },
            {
                key: "_handleDragTargetRelease",
                value: function _handleDragTargetRelease() {
                    if (this.isDragged) {
                        if (this.percentOpen > 0.2) this.open();
                        else this._animateOut();
                        this.isDragged = false;
                        this._verticallyScrolling = false;
                    }
                }
            },
            {
                key: "_handleCloseDrag",
                value: function _handleCloseDrag(e) {
                    if (this.isOpen) {
                        // Check if draggable
                        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) return;
                        // If not being dragged, set initial drag start variables
                        if (!this.isDragged) this._startDrag(e);
                        // Run touchmove updates
                        this._dragMoveUpdate(e);
                        // Calculate raw deltaX
                        var totalDeltaX = this._xPos - this._startingXpos;
                        // dragDirection is the attempted user drag direction
                        var dragDirection = totalDeltaX > 0 ? 'right' : 'left';
                        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
                        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
                        if (this.options.edge !== dragDirection) totalDeltaX = 0;
                        var transformX = -totalDeltaX;
                        if (this.options.edge === 'right') transformX = -transformX;
                        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
                        this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);
                        // Set transform and opacity styles
                        this.el.style.transform = "translateX(" + transformX + "px)";
                        this._overlay.style.opacity = this.percentOpen;
                    }
                }
            },
            {
                key: "_handleCloseRelease",
                value: function _handleCloseRelease() {
                    if (this.isOpen && this.isDragged) {
                        if (this.percentOpen > 0.8) this._animateIn();
                        else this.close();
                        this.isDragged = false;
                        this._verticallyScrolling = false;
                    }
                }
            },
            {
                key: "_handleCloseTriggerClick",
                value: function _handleCloseTriggerClick(e) {
                    var $closeTrigger = $1(e.target).closest('.sidenav-close');
                    if ($closeTrigger.length && !this._isCurrentlyFixed()) this.close();
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    // Only handle horizontal resizes
                    if (this.lastWindowWidth !== window.innerWidth) {
                        if (window.innerWidth > 992) this.open();
                        else this.close();
                    }
                    this.lastWindowWidth = window.innerWidth;
                    this.lastWindowHeight = window.innerHeight;
                }
            },
            {
                key: "_setupClasses",
                value: function _setupClasses() {
                    if (this.options.edge === 'right') {
                        this.el.classList.add('right-aligned');
                        this.dragTarget.classList.add('right-aligned');
                    }
                }
            },
            {
                key: "_removeClasses",
                value: function _removeClasses() {
                    this.el.classList.remove('right-aligned');
                    this.dragTarget.classList.remove('right-aligned');
                }
            },
            {
                key: "_setupFixed",
                value: function _setupFixed() {
                    if (this._isCurrentlyFixed()) this.open();
                }
            },
            {
                key: "_isCurrentlyFixed",
                value: function _isCurrentlyFixed() {
                    return this.isFixed && window.innerWidth > 992;
                }
            },
            {
                key: "_createDragTarget",
                value: function _createDragTarget() {
                    var dragTarget = document.createElement('div');
                    dragTarget.classList.add('drag-target');
                    document.body.appendChild(dragTarget);
                    this.dragTarget = dragTarget;
                }
            },
            {
                key: "_preventBodyScrolling",
                value: function _preventBodyScrolling() {
                    var body = document.body;
                    body.style.overflow = 'hidden';
                }
            },
            {
                key: "_enableBodyScrolling",
                value: function _enableBodyScrolling() {
                    var body = document.body;
                    body.style.overflow = '';
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen === true) return;
                    this.isOpen = true;
                    // Run onOpenStart callback
                    if (typeof this.options.onOpenStart === 'function') this.options.onOpenStart.call(this, this.el);
                    // Handle fixed Sidenav
                    if (this._isCurrentlyFixed()) {
                        anim.remove(this.el);
                        anim({
                            targets: this.el,
                            translateX: 0,
                            duration: 0,
                            easing: 'easeOutQuad'
                        });
                        this._enableBodyScrolling();
                        this._overlay.style.display = 'none';
                    // Handle non-fixed Sidenav
                    } else {
                        if (this.options.preventScrolling) this._preventBodyScrolling();
                        if (!this.isDragged || this.percentOpen != 1) this._animateIn();
                    }
                }
            },
            {
                key: "close",
                value: function close() {
                    if (this.isOpen === false) return;
                    this.isOpen = false;
                    // Run onCloseStart callback
                    if (typeof this.options.onCloseStart === 'function') this.options.onCloseStart.call(this, this.el);
                    // Handle fixed Sidenav
                    if (this._isCurrentlyFixed()) {
                        var transformX = this.options.edge === 'left' ? '-105%' : '105%';
                        this.el.style.transform = "translateX(" + transformX + ")";
                    // Handle non-fixed Sidenav
                    } else {
                        this._enableBodyScrolling();
                        if (!this.isDragged || this.percentOpen != 0) this._animateOut();
                        else this._overlay.style.display = 'none';
                    }
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    this._animateSidenavIn();
                    this._animateOverlayIn();
                }
            },
            {
                key: "_animateSidenavIn",
                value: function _animateSidenavIn() {
                    var _this32 = this;
                    var slideOutPercent = this.options.edge === 'left' ? -1 : 1;
                    if (this.isDragged) slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
                    anim.remove(this.el);
                    anim({
                        targets: this.el,
                        translateX: [
                            slideOutPercent * 100 + "%",
                            0
                        ],
                        duration: this.options.inDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            // Run onOpenEnd callback
                            if (typeof _this32.options.onOpenEnd === 'function') _this32.options.onOpenEnd.call(_this32, _this32.el);
                        }
                    });
                }
            },
            {
                key: "_animateOverlayIn",
                value: function _animateOverlayIn() {
                    var start = 0;
                    if (this.isDragged) start = this.percentOpen;
                    else $1(this._overlay).css({
                        display: 'block'
                    });
                    anim.remove(this._overlay);
                    anim({
                        targets: this._overlay,
                        opacity: [
                            start,
                            1
                        ],
                        duration: this.options.inDuration,
                        easing: 'easeOutQuad'
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    this._animateSidenavOut();
                    this._animateOverlayOut();
                }
            },
            {
                key: "_animateSidenavOut",
                value: function _animateSidenavOut() {
                    var _this33 = this;
                    var endPercent = this.options.edge === 'left' ? -1 : 1;
                    var slideOutPercent = 0;
                    if (this.isDragged) slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
                    anim.remove(this.el);
                    anim({
                        targets: this.el,
                        translateX: [
                            slideOutPercent * 100 + "%",
                            endPercent * 105 + "%"
                        ],
                        duration: this.options.outDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            // Run onOpenEnd callback
                            if (typeof _this33.options.onCloseEnd === 'function') _this33.options.onCloseEnd.call(_this33, _this33.el);
                        }
                    });
                }
            },
            {
                key: "_animateOverlayOut",
                value: function _animateOverlayOut() {
                    var _this34 = this;
                    anim.remove(this._overlay);
                    anim({
                        targets: this._overlay,
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: 'easeOutQuad',
                        complete: function() {
                            $1(_this34._overlay).css('display', 'none');
                        }
                    });
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Sidenav;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Sidenav;
    }(Component);
    /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */ Sidenav._sidenavs = [];
    M.Sidenav = Sidenav;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
})(cash, M.anime);
(function($1, anim) {
    'use strict';
    var _defaults = {
        throttle: 100,
        scrollOffset: 200,
        activeClass: 'active',
        getActiveElement: function(id) {
            return 'a[href="#' + id + '"]';
        }
    };
    /**
   * @class
   *
   */ var ScrollSpy = function(_Component9) {
        _inherits(ScrollSpy, _Component9);
        /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function ScrollSpy(el, options) {
            _classCallCheck(this, ScrollSpy);
            var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));
            _this35.el.M_ScrollSpy = _this35;
            /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */ _this35.options = $1.extend({}, ScrollSpy.defaults, options);
            // setup
            ScrollSpy._elements.push(_this35);
            ScrollSpy._count++;
            ScrollSpy._increment++;
            _this35.tickId = -1;
            _this35.id = ScrollSpy._increment;
            _this35._setupEventHandlers();
            _this35._handleWindowScroll();
            return _this35;
        }
        _createClass(ScrollSpy, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
                    ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
                    ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
                    ScrollSpy._count--;
                    this._removeEventHandlers();
                    $1(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
                    this.el.M_ScrollSpy = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var throttledResize = M.throttle(this._handleWindowScroll, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
                    if (ScrollSpy._count === 1) {
                        window.addEventListener('scroll', this._handleWindowScrollBound);
                        window.addEventListener('resize', this._handleThrottledResizeBound);
                        document.body.addEventListener('click', this._handleTriggerClick);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (ScrollSpy._count === 0) {
                        window.removeEventListener('scroll', this._handleWindowScrollBound);
                        window.removeEventListener('resize', this._handleThrottledResizeBound);
                        document.body.removeEventListener('click', this._handleTriggerClick);
                    }
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target);
                    for(var i = ScrollSpy._elements.length - 1; i >= 0; i--){
                        var scrollspy = ScrollSpy._elements[i];
                        if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
                            e.preventDefault();
                            var offset = scrollspy.$el.offset().top + 1;
                            anim({
                                targets: [
                                    document.documentElement,
                                    document.body
                                ],
                                scrollTop: offset - scrollspy.options.scrollOffset,
                                duration: 400,
                                easing: 'easeOutCubic'
                            });
                            break;
                        }
                    }
                }
            },
            {
                key: "_handleWindowScroll",
                value: function _handleWindowScroll() {
                    // unique tick id
                    ScrollSpy._ticks++;
                    // viewport rectangle
                    var top = M.getDocumentScrollTop(), left = M.getDocumentScrollLeft(), right = left + window.innerWidth, bottom = top + window.innerHeight;
                    // determine which elements are in view
                    var intersections = ScrollSpy._findElements(top, right, bottom, left);
                    for(var i = 0; i < intersections.length; i++){
                        var scrollspy = intersections[i];
                        var lastTick = scrollspy.tickId;
                        if (lastTick < 0) // entered into view
                        scrollspy._enter();
                        // update tick id
                        scrollspy.tickId = ScrollSpy._ticks;
                    }
                    for(var _i = 0; _i < ScrollSpy._elementsInView.length; _i++){
                        var _scrollspy = ScrollSpy._elementsInView[_i];
                        var _lastTick = _scrollspy.tickId;
                        if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
                            // exited from view
                            _scrollspy._exit();
                            _scrollspy.tickId = -1;
                        }
                    }
                    // remember elements in view for next tick
                    ScrollSpy._elementsInView = intersections;
                }
            },
            {
                key: "_enter",
                value: function _enter() {
                    ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(value) {
                        return value.height() != 0;
                    });
                    if (ScrollSpy._visibleElements[0]) {
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
                        if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) ScrollSpy._visibleElements.unshift(this.$el);
                        else ScrollSpy._visibleElements.push(this.$el);
                    } else ScrollSpy._visibleElements.push(this.$el);
                    $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
                }
            },
            {
                key: "_exit",
                value: function _exit() {
                    var _this36 = this;
                    ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(value) {
                        return value.height() != 0;
                    });
                    if (ScrollSpy._visibleElements[0]) {
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
                        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(el) {
                            return el.attr('id') != _this36.$el.attr('id');
                        });
                        if (ScrollSpy._visibleElements[0]) // Check if empty
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_ScrollSpy;
                }
            },
            {
                key: "_findElements",
                value: function _findElements(top, right, bottom, left) {
                    var hits = [];
                    for(var i = 0; i < ScrollSpy._elements.length; i++){
                        var scrollspy = ScrollSpy._elements[i];
                        var currTop = top + scrollspy.options.scrollOffset || 200;
                        if (scrollspy.$el.height() > 0) {
                            var elTop = scrollspy.$el.offset().top, elLeft = scrollspy.$el.offset().left, elRight = elLeft + scrollspy.$el.width(), elBottom = elTop + scrollspy.$el.height();
                            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);
                            if (isIntersect) hits.push(scrollspy);
                        }
                    }
                    return hits;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return ScrollSpy;
    }(Component);
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */ ScrollSpy._elements = [];
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */ ScrollSpy._elementsInView = [];
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */ ScrollSpy._visibleElements = [];
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._count = 0;
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._increment = 0;
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._ticks = 0;
    M.ScrollSpy = ScrollSpy;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
})(cash, M.anime);
(function($1) {
    'use strict';
    var _defaults = {
        data: {},
        limit: Infinity,
        onAutocomplete: null,
        minLength: 1,
        sortFunction: function(a, b, inputString) {
            // Sort function for sorting autocomplete results
            return a.indexOf(inputString) - b.indexOf(inputString);
        }
    };
    /**
   * @class
   *
   */ var Autocomplete = function(_Component10) {
        _inherits(Autocomplete, _Component10);
        /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Autocomplete(el, options) {
            _classCallCheck(this, Autocomplete);
            var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));
            _this37.el.M_Autocomplete = _this37;
            /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */ _this37.options = $1.extend({}, Autocomplete.defaults, options);
            // Setup
            _this37.isOpen = false;
            _this37.count = 0;
            _this37.activeIndex = -1;
            _this37.oldVal;
            _this37.$inputField = _this37.$el.closest('.input-field');
            _this37.$active = $1();
            _this37._mousedown = false;
            _this37._setupDropdown();
            _this37._setupEventHandlers();
            return _this37;
        }
        _createClass(Autocomplete, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeDropdown();
                    this.el.M_Autocomplete = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputBlurBound = this._handleInputBlur.bind(this);
                    this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
                    this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);
                    this.el.addEventListener('blur', this._handleInputBlurBound);
                    this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
                    this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
                    this.el.addEventListener('keydown', this._handleInputKeydownBound);
                    this.el.addEventListener('click', this._handleInputClickBound);
                    this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
                    this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);
                    if (typeof window.ontouchstart !== 'undefined') {
                        this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
                        this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('blur', this._handleInputBlurBound);
                    this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
                    this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
                    this.el.removeEventListener('keydown', this._handleInputKeydownBound);
                    this.el.removeEventListener('click', this._handleInputClickBound);
                    this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
                    this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);
                    if (typeof window.ontouchstart !== 'undefined') {
                        this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
                        this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
                    }
                }
            },
            {
                key: "_setupDropdown",
                value: function _setupDropdown() {
                    var _this38 = this;
                    this.container = document.createElement('ul');
                    this.container.id = "autocomplete-options-" + M.guid();
                    $1(this.container).addClass('autocomplete-content dropdown-content');
                    this.$inputField.append(this.container);
                    this.el.setAttribute('data-target', this.container.id);
                    this.dropdown = M.Dropdown.init(this.el, {
                        autoFocus: false,
                        closeOnClick: false,
                        coverTrigger: false,
                        onItemClick: function(itemEl) {
                            _this38.selectOption($1(itemEl));
                        }
                    });
                    // Sketchy removal of dropdown click handler
                    this.el.removeEventListener('click', this.dropdown._handleClickBound);
                }
            },
            {
                key: "_removeDropdown",
                value: function _removeDropdown() {
                    this.container.parentNode.removeChild(this.container);
                }
            },
            {
                key: "_handleInputBlur",
                value: function _handleInputBlur() {
                    if (!this._mousedown) {
                        this.close();
                        this._resetAutocomplete();
                    }
                }
            },
            {
                key: "_handleInputKeyupAndFocus",
                value: function _handleInputKeyupAndFocus(e) {
                    if (e.type === 'keyup') Autocomplete._keydown = false;
                    this.count = 0;
                    var val = this.el.value.toLowerCase();
                    // Don't capture enter or arrow key usage.
                    if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) return;
                    // Check if the input isn't empty
                    // Check if focus triggered by tab
                    if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) this.open();
                    // Update oldVal
                    this.oldVal = val;
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    Autocomplete._keydown = true;
                    // Arrow keys and enter key usage
                    var keyCode = e.keyCode, liElement = void 0, numItems = $1(this.container).children('li').length;
                    // select element on Enter
                    if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
                        liElement = $1(this.container).children('li').eq(this.activeIndex);
                        if (liElement.length) {
                            this.selectOption(liElement);
                            e.preventDefault();
                        }
                        return;
                    }
                    // Capture up and down key
                    if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
                        e.preventDefault();
                        if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) this.activeIndex--;
                        if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) this.activeIndex++;
                        this.$active.removeClass('active');
                        if (this.activeIndex >= 0) {
                            this.$active = $1(this.container).children('li').eq(this.activeIndex);
                            this.$active.addClass('active');
                        }
                    }
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick(e) {
                    this.open();
                }
            },
            {
                key: "_handleContainerMousedownAndTouchstart",
                value: function _handleContainerMousedownAndTouchstart(e) {
                    this._mousedown = true;
                }
            },
            {
                key: "_handleContainerMouseupAndTouchend",
                value: function _handleContainerMouseupAndTouchend(e) {
                    this._mousedown = false;
                }
            },
            {
                key: "_highlight",
                value: function _highlight(string, $el) {
                    var img = $el.find('img');
                    var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''), matchEnd = matchStart + string.length - 1, beforeMatch = $el.text().slice(0, matchStart), matchText = $el.text().slice(matchStart, matchEnd + 1), afterMatch = $el.text().slice(matchEnd + 1);
                    $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
                    if (img.length) $el.prepend(img);
                }
            },
            {
                key: "_resetCurrentElement",
                value: function _resetCurrentElement() {
                    this.activeIndex = -1;
                    this.$active.removeClass('active');
                }
            },
            {
                key: "_resetAutocomplete",
                value: function _resetAutocomplete() {
                    $1(this.container).empty();
                    this._resetCurrentElement();
                    this.oldVal = null;
                    this.isOpen = false;
                    this._mousedown = false;
                }
            },
            {
                key: "selectOption",
                value: function selectOption(el) {
                    var text = el.text().trim();
                    this.el.value = text;
                    this.$el.trigger('change');
                    this._resetAutocomplete();
                    this.close();
                    // Handle onAutocomplete callback.
                    if (typeof this.options.onAutocomplete === 'function') this.options.onAutocomplete.call(this, text);
                }
            },
            {
                key: "_renderDropdown",
                value: function _renderDropdown(data, val) {
                    var _this39 = this;
                    this._resetAutocomplete();
                    var matchingData = [];
                    // Gather all matching data
                    for(var key in data)if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
                        // Break if past limit
                        if (this.count >= this.options.limit) break;
                        var entry = {
                            data: data[key],
                            key: key
                        };
                        matchingData.push(entry);
                        this.count++;
                    }
                    // Sort
                    if (this.options.sortFunction) {
                        var sortFunctionBound = function(a, b) {
                            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
                        };
                        matchingData.sort(sortFunctionBound);
                    }
                    // Render
                    for(var i = 0; i < matchingData.length; i++){
                        var _entry = matchingData[i];
                        var $autocompleteOption = $1('<li></li>');
                        if (!!_entry.data) $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"right circle\"><span>" + _entry.key + "</span>");
                        else $autocompleteOption.append('<span>' + _entry.key + '</span>');
                        $1(this.container).append($autocompleteOption);
                        this._highlight(val, $autocompleteOption);
                    }
                }
            },
            {
                key: "open",
                value: function open() {
                    var val = this.el.value.toLowerCase();
                    this._resetAutocomplete();
                    if (val.length >= this.options.minLength) {
                        this.isOpen = true;
                        this._renderDropdown(this.options.data, val);
                    }
                    // Open dropdown
                    if (!this.dropdown.isOpen) this.dropdown.open();
                    else // Recalculate dropdown when its already open
                    this.dropdown.recalculateDimensions();
                }
            },
            {
                key: "close",
                value: function close() {
                    this.dropdown.close();
                }
            },
            {
                key: "updateData",
                value: function updateData(data) {
                    var val = this.el.value.toLowerCase();
                    this.options.data = data;
                    if (this.isOpen) this._renderDropdown(data, val);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Autocomplete;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Autocomplete;
    }(Component);
    /**
   * @static
   * @memberof Autocomplete
   */ Autocomplete._keydown = false;
    M.Autocomplete = Autocomplete;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
})(cash);
(function($1) {
    // Function to update labels of text fields
    M.updateTextFields = function() {
        var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
        $1(input_selector).each(function(element, index) {
            var $this = $1(this);
            if (element.value.length > 0 || $1(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) $this.siblings('label').addClass('active');
            else if (element.validity) $this.siblings('label').toggleClass('active', element.validity.badInput === true);
            else $this.siblings('label').removeClass('active');
        });
    };
    M.validate_field = function(object) {
        var hasLength = object.attr('data-length') !== null;
        var lenAttr = parseInt(object.attr('data-length'));
        var len = object[0].value.length;
        if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
            if (object.hasClass('validate')) {
                object.removeClass('valid');
                object.removeClass('invalid');
            }
        } else if (object.hasClass('validate')) {
            // Check for character counter attributes
            if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
                object.removeClass('invalid');
                object.addClass('valid');
            } else {
                object.removeClass('valid');
                object.addClass('invalid');
            }
        }
    };
    M.textareaAutoResize = function($textarea) {
        // Wrap if native element
        if ($textarea instanceof Element) $textarea = $1($textarea);
        if (!$textarea.length) {
            console.error('No textarea element found');
            return;
        }
        // Textarea Auto Resize
        var hiddenDiv = $1('.hiddendiv').first();
        if (!hiddenDiv.length) {
            hiddenDiv = $1('<div class="hiddendiv common"></div>');
            $1('body').append(hiddenDiv);
        }
        // Set font properties of hiddenDiv
        var fontFamily = $textarea.css('font-family');
        var fontSize = $textarea.css('font-size');
        var lineHeight = $textarea.css('line-height');
        // Firefox can't handle padding shorthand.
        var paddingTop = $textarea.css('padding-top');
        var paddingRight = $textarea.css('padding-right');
        var paddingBottom = $textarea.css('padding-bottom');
        var paddingLeft = $textarea.css('padding-left');
        if (fontSize) hiddenDiv.css('font-size', fontSize);
        if (fontFamily) hiddenDiv.css('font-family', fontFamily);
        if (lineHeight) hiddenDiv.css('line-height', lineHeight);
        if (paddingTop) hiddenDiv.css('padding-top', paddingTop);
        if (paddingRight) hiddenDiv.css('padding-right', paddingRight);
        if (paddingBottom) hiddenDiv.css('padding-bottom', paddingBottom);
        if (paddingLeft) hiddenDiv.css('padding-left', paddingLeft);
        // Set original-height, if none
        if (!$textarea.data('original-height')) $textarea.data('original-height', $textarea.height());
        if ($textarea.attr('wrap') === 'off') hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
        hiddenDiv.text($textarea[0].value + '\n');
        var content = hiddenDiv.html().replace(/\n/g, '<br>');
        hiddenDiv.html(content);
        // When textarea is hidden, width goes crazy.
        // Approximate with half of window size
        if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) hiddenDiv.css('width', $textarea.width() + 'px');
        else hiddenDiv.css('width', window.innerWidth / 2 + 'px');
        /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */ if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) $textarea.css('height', hiddenDiv.innerHeight() + 'px');
        else if ($textarea[0].value.length < $textarea.data('previous-length')) /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */ $textarea.css('height', $textarea.data('original-height') + 'px');
        $textarea.data('previous-length', $textarea[0].value.length);
    };
    $1(document).ready(function() {
        // Text based inputs
        var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
        // Add active if form auto complete
        $1(document).on('change', input_selector, function() {
            if (this.value.length !== 0 || $1(this).attr('placeholder') !== null) $1(this).siblings('label').addClass('active');
            M.validate_field($1(this));
        });
        // Add active if input element has been pre-populated on document ready
        $1(document).ready(function() {
            M.updateTextFields();
        });
        // HTML DOM FORM RESET handling
        $1(document).on('reset', function(e) {
            var formReset = $1(e.target);
            if (formReset.is('form')) {
                formReset.find(input_selector).removeClass('valid').removeClass('invalid');
                formReset.find(input_selector).each(function(e) {
                    if (this.value.length) $1(this).siblings('label').removeClass('active');
                });
                // Reset select (after native reset)
                setTimeout(function() {
                    formReset.find('select').each(function() {
                        // check if initialized
                        if (this.M_FormSelect) $1(this).trigger('change');
                    });
                }, 0);
            }
        });
        /**
     * Add active when element has focus
     * @param {Event} e
     */ document.addEventListener('focus', function(e) {
            if ($1(e.target).is(input_selector)) $1(e.target).siblings('label, .prefix').addClass('active');
        }, true);
        /**
     * Remove active when element is blurred
     * @param {Event} e
     */ document.addEventListener('blur', function(e) {
            var $inputElement = $1(e.target);
            if ($inputElement.is(input_selector)) {
                var selector = '.prefix';
                if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) selector += ', label';
                $inputElement.siblings(selector).removeClass('active');
                M.validate_field($inputElement);
            }
        }, true);
        // Radio and Checkbox focus class
        var radio_checkbox = 'input[type=radio], input[type=checkbox]';
        $1(document).on('keyup', radio_checkbox, function(e) {
            // TAB, check if tabbing to radio or checkbox.
            if (e.which === M.keys.TAB) {
                $1(this).addClass('tabbed');
                var $this = $1(this);
                $this.one('blur', function(e) {
                    $1(this).removeClass('tabbed');
                });
                return;
            }
        });
        var text_area_selector = '.materialize-textarea';
        $1(text_area_selector).each(function() {
            var $textarea = $1(this);
            /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */ $textarea.data('original-height', $textarea.height());
            $textarea.data('previous-length', this.value.length);
            M.textareaAutoResize($textarea);
        });
        $1(document).on('keyup', text_area_selector, function() {
            M.textareaAutoResize($1(this));
        });
        $1(document).on('keydown', text_area_selector, function() {
            M.textareaAutoResize($1(this));
        });
        // File Input Path
        $1(document).on('change', '.file-field input[type="file"]', function() {
            var file_field = $1(this).closest('.file-field');
            var path_input = file_field.find('input.file-path');
            var files = $1(this)[0].files;
            var file_names = [];
            for(var i = 0; i < files.length; i++)file_names.push(files[i].name);
            path_input[0].value = file_names.join(', ');
            path_input.trigger('change');
        });
    }); // End of $(document).ready
})(cash);
(function($1, anim) {
    'use strict';
    var _defaults = {
        indicators: true,
        height: 400,
        duration: 500,
        interval: 6000
    };
    /**
   * @class
   *
   */ var Slider = function(_Component11) {
        _inherits(Slider, _Component11);
        /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Slider(el, options) {
            _classCallCheck(this, Slider);
            var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));
            _this40.el.M_Slider = _this40;
            /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */ _this40.options = $1.extend({}, Slider.defaults, options);
            // setup
            _this40.$slider = _this40.$el.find('.slides');
            _this40.$slides = _this40.$slider.children('li');
            _this40.activeIndex = _this40.$slides.filter(function(item) {
                return $1(item).hasClass('active');
            }).first().index();
            if (_this40.activeIndex != -1) _this40.$active = _this40.$slides.eq(_this40.activeIndex);
            _this40._setSliderHeight();
            // Set initial positions of captions
            _this40.$slides.find('.caption').each(function(el) {
                _this40._animateCaptionIn(el, 0);
            });
            // Move img src into background-image
            _this40.$slides.find('img').each(function(el) {
                var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
                if ($1(el).attr('src') !== placeholderBase64) {
                    $1(el).css('background-image', 'url("' + $1(el).attr('src') + '")');
                    $1(el).attr('src', placeholderBase64);
                }
            });
            _this40._setupIndicators();
            // Show active slide
            if (_this40.$active) _this40.$active.css('display', 'block');
            else {
                _this40.$slides.first().addClass('active');
                anim({
                    targets: _this40.$slides.first()[0],
                    opacity: 1,
                    duration: _this40.options.duration,
                    easing: 'easeOutQuad'
                });
                _this40.activeIndex = 0;
                _this40.$active = _this40.$slides.eq(_this40.activeIndex);
                // Update indicators
                if (_this40.options.indicators) _this40.$indicators.eq(_this40.activeIndex).addClass('active');
            }
            // Adjust height to current slide
            _this40.$active.find('img').each(function(el) {
                anim({
                    targets: _this40.$active.find('.caption')[0],
                    opacity: 1,
                    translateX: 0,
                    translateY: 0,
                    duration: _this40.options.duration,
                    easing: 'easeOutQuad'
                });
            });
            _this40._setupEventHandlers();
            // auto scroll
            _this40.start();
            return _this40;
        }
        _createClass(Slider, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this.pause();
                    this._removeIndicators();
                    this._removeEventHandlers();
                    this.el.M_Slider = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this41 = this;
                    this._handleIntervalBound = this._handleInterval.bind(this);
                    this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
                    if (this.options.indicators) this.$indicators.each(function(el) {
                        el.addEventListener('click', _this41._handleIndicatorClickBound);
                    });
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this42 = this;
                    if (this.options.indicators) this.$indicators.each(function(el) {
                        el.removeEventListener('click', _this42._handleIndicatorClickBound);
                    });
                }
            },
            {
                key: "_handleIndicatorClick",
                value: function _handleIndicatorClick(e) {
                    var currIndex = $1(e.target).index();
                    this.set(currIndex);
                }
            },
            {
                key: "_handleInterval",
                value: function _handleInterval() {
                    var newActiveIndex = this.$slider.find('.active').index();
                    if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
                    else newActiveIndex += 1;
                    this.set(newActiveIndex);
                }
            },
            {
                key: "_animateCaptionIn",
                value: function _animateCaptionIn(caption, duration) {
                    var animOptions = {
                        targets: caption,
                        opacity: 0,
                        duration: duration,
                        easing: 'easeOutQuad'
                    };
                    if ($1(caption).hasClass('center-align')) animOptions.translateY = -100;
                    else if ($1(caption).hasClass('right-align')) animOptions.translateX = 100;
                    else if ($1(caption).hasClass('left-align')) animOptions.translateX = -100;
                    anim(animOptions);
                }
            },
            {
                key: "_setSliderHeight",
                value: function _setSliderHeight() {
                    // If fullscreen, do nothing
                    if (!this.$el.hasClass('fullscreen')) {
                        if (this.options.indicators) // Add height if indicators are present
                        this.$el.css('height', this.options.height + 40 + 'px');
                        else this.$el.css('height', this.options.height + 'px');
                        this.$slider.css('height', this.options.height + 'px');
                    }
                }
            },
            {
                key: "_setupIndicators",
                value: function _setupIndicators() {
                    var _this43 = this;
                    if (this.options.indicators) {
                        this.$indicators = $1('<ul class="indicators"></ul>');
                        this.$slides.each(function(el, index) {
                            var $indicator = $1('<li class="indicator-item"></li>');
                            _this43.$indicators.append($indicator[0]);
                        });
                        this.$el.append(this.$indicators[0]);
                        this.$indicators = this.$indicators.children('li.indicator-item');
                    }
                }
            },
            {
                key: "_removeIndicators",
                value: function _removeIndicators() {
                    this.$el.find('ul.indicators').remove();
                }
            },
            {
                key: "set",
                value: function set(index) {
                    var _this44 = this;
                    // Wrap around indices.
                    if (index >= this.$slides.length) index = 0;
                    else if (index < 0) index = this.$slides.length - 1;
                    // Only do if index changes
                    if (this.activeIndex != index) {
                        this.$active = this.$slides.eq(this.activeIndex);
                        var $caption = this.$active.find('.caption');
                        this.$active.removeClass('active');
                        anim({
                            targets: this.$active[0],
                            opacity: 0,
                            duration: this.options.duration,
                            easing: 'easeOutQuad',
                            complete: function() {
                                _this44.$slides.not('.active').each(function(el) {
                                    anim({
                                        targets: el,
                                        opacity: 0,
                                        translateX: 0,
                                        translateY: 0,
                                        duration: 0,
                                        easing: 'easeOutQuad'
                                    });
                                });
                            }
                        });
                        this._animateCaptionIn($caption[0], this.options.duration);
                        // Update indicators
                        if (this.options.indicators) {
                            this.$indicators.eq(this.activeIndex).removeClass('active');
                            this.$indicators.eq(index).addClass('active');
                        }
                        anim({
                            targets: this.$slides.eq(index)[0],
                            opacity: 1,
                            duration: this.options.duration,
                            easing: 'easeOutQuad'
                        });
                        anim({
                            targets: this.$slides.eq(index).find('.caption')[0],
                            opacity: 1,
                            translateX: 0,
                            translateY: 0,
                            duration: this.options.duration,
                            delay: this.options.duration,
                            easing: 'easeOutQuad'
                        });
                        this.$slides.eq(index).addClass('active');
                        this.activeIndex = index;
                        // Reset interval
                        this.start();
                    }
                }
            },
            {
                key: "pause",
                value: function pause() {
                    clearInterval(this.interval);
                }
            },
            {
                key: "start",
                value: function start() {
                    clearInterval(this.interval);
                    this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
                }
            },
            {
                key: "next",
                value: function next() {
                    var newIndex = this.activeIndex + 1;
                    // Wrap around indices.
                    if (newIndex >= this.$slides.length) newIndex = 0;
                    else if (newIndex < 0) newIndex = this.$slides.length - 1;
                    this.set(newIndex);
                }
            },
            {
                key: "prev",
                value: function prev() {
                    var newIndex = this.activeIndex - 1;
                    // Wrap around indices.
                    if (newIndex >= this.$slides.length) newIndex = 0;
                    else if (newIndex < 0) newIndex = this.$slides.length - 1;
                    this.set(newIndex);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Slider;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Slider;
    }(Component);
    M.Slider = Slider;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
})(cash, M.anime);
(function($1, anim) {
    $1(document).on('click', '.card', function(e) {
        if ($1(this).children('.card-reveal').length) {
            var $card = $1(e.target).closest('.card');
            if ($card.data('initialOverflow') === undefined) $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
            var $cardReveal = $1(this).find('.card-reveal');
            if ($1(e.target).is($1('.card-reveal .card-title')) || $1(e.target).is($1('.card-reveal .card-title i'))) // Make Reveal animate down and display none
            anim({
                targets: $cardReveal[0],
                translateY: 0,
                duration: 225,
                easing: 'easeInOutQuad',
                complete: function(anim) {
                    var el = anim.animatables[0].target;
                    $1(el).css({
                        display: 'none'
                    });
                    $card.css('overflow', $card.data('initialOverflow'));
                }
            });
            else if ($1(e.target).is($1('.card .activator')) || $1(e.target).is($1('.card .activator i'))) {
                $card.css('overflow', 'hidden');
                $cardReveal.css({
                    display: 'block'
                });
                anim({
                    targets: $cardReveal[0],
                    translateY: '-100%',
                    duration: 300,
                    easing: 'easeInOutQuad'
                });
            }
        }
    });
})(cash, M.anime);
(function($1) {
    'use strict';
    var _defaults = {
        data: [],
        placeholder: '',
        secondaryPlaceholder: '',
        autocompleteOptions: {},
        limit: Infinity,
        onChipAdd: null,
        onChipSelect: null,
        onChipDelete: null
    };
    /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */ /**
   * @class
   *
   */ var Chips = function(_Component12) {
        _inherits(Chips, _Component12);
        /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Chips(el, options) {
            _classCallCheck(this, Chips);
            var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));
            _this45.el.M_Chips = _this45;
            /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */ _this45.options = $1.extend({}, Chips.defaults, options);
            _this45.$el.addClass('chips input-field');
            _this45.chipsData = [];
            _this45.$chips = $1();
            _this45._setupInput();
            _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;
            // Set input id
            if (!_this45.$input.attr('id')) _this45.$input.attr('id', M.guid());
            // Render initial chips
            if (_this45.options.data.length) {
                _this45.chipsData = _this45.options.data;
                _this45._renderChips(_this45.chipsData);
            }
            // Setup autocomplete if needed
            if (_this45.hasAutocomplete) _this45._setupAutocomplete();
            _this45._setPlaceholder();
            _this45._setupLabel();
            _this45._setupEventHandlers();
            return _this45;
        }
        _createClass(Chips, [
            {
                key: "getData",
                /**
       * Get Chips Data
       */ value: function getData() {
                    return this.chipsData;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    this._removeEventHandlers();
                    this.$chips.remove();
                    this.el.M_Chips = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleChipClickBound = this._handleChipClick.bind(this);
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputFocusBound = this._handleInputFocus.bind(this);
                    this._handleInputBlurBound = this._handleInputBlur.bind(this);
                    this.el.addEventListener('click', this._handleChipClickBound);
                    document.addEventListener('keydown', Chips._handleChipsKeydown);
                    document.addEventListener('keyup', Chips._handleChipsKeyup);
                    this.el.addEventListener('blur', Chips._handleChipsBlur, true);
                    this.$input[0].addEventListener('focus', this._handleInputFocusBound);
                    this.$input[0].addEventListener('blur', this._handleInputBlurBound);
                    this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('click', this._handleChipClickBound);
                    document.removeEventListener('keydown', Chips._handleChipsKeydown);
                    document.removeEventListener('keyup', Chips._handleChipsKeyup);
                    this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
                    this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
                    this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
                    this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
                }
            },
            {
                key: "_handleChipClick",
                value: function _handleChipClick(e) {
                    var $chip = $1(e.target).closest('.chip');
                    var clickedClose = $1(e.target).is('.close');
                    if ($chip.length) {
                        var index = $chip.index();
                        if (clickedClose) {
                            // delete chip
                            this.deleteChip(index);
                            this.$input[0].focus();
                        } else // select chip
                        this.selectChip(index);
                    // Default handle click to focus on input
                    } else this.$input[0].focus();
                }
            },
            {
                key: "_handleInputFocus",
                /**
       * Handle Input Focus
       */ value: function _handleInputFocus() {
                    this.$el.addClass('focus');
                }
            },
            {
                key: "_handleInputBlur",
                value: function _handleInputBlur() {
                    this.$el.removeClass('focus');
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    Chips._keydown = true;
                    // enter
                    if (e.keyCode === 13) {
                        // Override enter if autocompleting.
                        if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) return;
                        e.preventDefault();
                        this.addChip({
                            tag: this.$input[0].value
                        });
                        this.$input[0].value = '';
                    // delete or left
                    } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
                        e.preventDefault();
                        this.selectChip(this.chipsData.length - 1);
                    }
                }
            },
            {
                key: "_renderChip",
                value: function _renderChip(chip) {
                    if (!chip.tag) return;
                    var renderedChip = document.createElement('div');
                    var closeIcon = document.createElement('i');
                    renderedChip.classList.add('chip');
                    renderedChip.textContent = chip.tag;
                    renderedChip.setAttribute('tabindex', 0);
                    $1(closeIcon).addClass('material-icons close');
                    closeIcon.textContent = 'close';
                    // attach image if needed
                    if (chip.image) {
                        var img = document.createElement('img');
                        img.setAttribute('src', chip.image);
                        renderedChip.insertBefore(img, renderedChip.firstChild);
                    }
                    renderedChip.appendChild(closeIcon);
                    return renderedChip;
                }
            },
            {
                key: "_renderChips",
                value: function _renderChips() {
                    this.$chips.remove();
                    for(var i = 0; i < this.chipsData.length; i++){
                        var chipEl = this._renderChip(this.chipsData[i]);
                        this.$el.append(chipEl);
                        this.$chips.add(chipEl);
                    }
                    // move input to end
                    this.$el.append(this.$input[0]);
                }
            },
            {
                key: "_setupAutocomplete",
                value: function _setupAutocomplete() {
                    var _this46 = this;
                    this.options.autocompleteOptions.onAutocomplete = function(val) {
                        _this46.addChip({
                            tag: val
                        });
                        _this46.$input[0].value = '';
                        _this46.$input[0].focus();
                    };
                    this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
                }
            },
            {
                key: "_setupInput",
                value: function _setupInput() {
                    this.$input = this.$el.find('input');
                    if (!this.$input.length) {
                        this.$input = $1('<input></input>');
                        this.$el.append(this.$input);
                    }
                    this.$input.addClass('input');
                }
            },
            {
                key: "_setupLabel",
                value: function _setupLabel() {
                    this.$label = this.$el.find('label');
                    if (this.$label.length) this.$label.setAttribute('for', this.$input.attr('id'));
                }
            },
            {
                key: "_setPlaceholder",
                value: function _setPlaceholder() {
                    if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) $1(this.$input).prop('placeholder', this.options.placeholder);
                    else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) $1(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
                }
            },
            {
                key: "_isValid",
                value: function _isValid(chip) {
                    if (chip.hasOwnProperty('tag') && chip.tag !== '') {
                        var exists = false;
                        for(var i = 0; i < this.chipsData.length; i++)if (this.chipsData[i].tag === chip.tag) {
                            exists = true;
                            break;
                        }
                        return !exists;
                    }
                    return false;
                }
            },
            {
                key: "addChip",
                value: function addChip(chip) {
                    if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) return;
                    var renderedChip = this._renderChip(chip);
                    this.$chips.add(renderedChip);
                    this.chipsData.push(chip);
                    $1(this.$input).before(renderedChip);
                    this._setPlaceholder();
                    // fire chipAdd callback
                    if (typeof this.options.onChipAdd === 'function') this.options.onChipAdd.call(this, this.$el, renderedChip);
                }
            },
            {
                key: "deleteChip",
                value: function deleteChip(chipIndex) {
                    var $chip = this.$chips.eq(chipIndex);
                    this.$chips.eq(chipIndex).remove();
                    this.$chips = this.$chips.filter(function(el) {
                        return $1(el).index() >= 0;
                    });
                    this.chipsData.splice(chipIndex, 1);
                    this._setPlaceholder();
                    // fire chipDelete callback
                    if (typeof this.options.onChipDelete === 'function') this.options.onChipDelete.call(this, this.$el, $chip[0]);
                }
            },
            {
                key: "selectChip",
                value: function selectChip(chipIndex) {
                    var $chip = this.$chips.eq(chipIndex);
                    this._selectedChip = $chip;
                    $chip[0].focus();
                    // fire chipSelect callback
                    if (typeof this.options.onChipSelect === 'function') this.options.onChipSelect.call(this, this.$el, $chip[0]);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Chips;
                }
            },
            {
                key: "_handleChipsKeydown",
                value: function _handleChipsKeydown(e) {
                    Chips._keydown = true;
                    var $chips = $1(e.target).closest('.chips');
                    var chipsKeydown = e.target && $chips.length;
                    // Don't handle keydown inputs on input and textarea
                    if ($1(e.target).is('input, textarea') || !chipsKeydown) return;
                    var currChips = $chips[0].M_Chips;
                    // backspace and delete
                    if (e.keyCode === 8 || e.keyCode === 46) {
                        e.preventDefault();
                        var selectIndex = currChips.chipsData.length;
                        if (currChips._selectedChip) {
                            var index = currChips._selectedChip.index();
                            currChips.deleteChip(index);
                            currChips._selectedChip = null;
                            // Make sure selectIndex doesn't go negative
                            selectIndex = Math.max(index - 1, 0);
                        }
                        if (currChips.chipsData.length) currChips.selectChip(selectIndex);
                    // left arrow key
                    } else if (e.keyCode === 37) {
                        if (currChips._selectedChip) {
                            var _selectIndex = currChips._selectedChip.index() - 1;
                            if (_selectIndex < 0) return;
                            currChips.selectChip(_selectIndex);
                        }
                    } else if (e.keyCode === 39) {
                        if (currChips._selectedChip) {
                            var _selectIndex2 = currChips._selectedChip.index() + 1;
                            if (_selectIndex2 >= currChips.chipsData.length) currChips.$input[0].focus();
                            else currChips.selectChip(_selectIndex2);
                        }
                    }
                }
            },
            {
                key: "_handleChipsKeyup",
                value: function _handleChipsKeyup(e) {
                    Chips._keydown = false;
                }
            },
            {
                key: "_handleChipsBlur",
                value: function _handleChipsBlur(e) {
                    if (!Chips._keydown) {
                        var $chips = $1(e.target).closest('.chips');
                        var currChips = $chips[0].M_Chips;
                        currChips._selectedChip = null;
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Chips;
    }(Component);
    /**
   * @static
   * @memberof Chips
   */ Chips._keydown = false;
    M.Chips = Chips;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
    $1(document).ready(function() {
        // Handle removal of static chips.
        $1(document.body).on('click', '.chip .close', function() {
            var $chips = $1(this).closest('.chips');
            if ($chips.length && $chips[0].M_Chips) return;
            $1(this).closest('.chip').remove();
        });
    });
})(cash);
(function($1) {
    'use strict';
    var _defaults = {
        top: 0,
        bottom: Infinity,
        offset: 0,
        onPositionChange: null
    };
    /**
   * @class
   *
   */ var Pushpin = function(_Component13) {
        _inherits(Pushpin, _Component13);
        /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Pushpin(el, options) {
            _classCallCheck(this, Pushpin);
            var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));
            _this47.el.M_Pushpin = _this47;
            /**
       * Options for the modal
       * @member Pushpin#options
       */ _this47.options = $1.extend({}, Pushpin.defaults, options);
            _this47.originalOffset = _this47.el.offsetTop;
            Pushpin._pushpins.push(_this47);
            _this47._setupEventHandlers();
            _this47._updatePosition();
            return _this47;
        }
        _createClass(Pushpin, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this.el.style.top = null;
                    this._removePinClasses();
                    this._removeEventHandlers();
                    // Remove pushpin Inst
                    var index = Pushpin._pushpins.indexOf(this);
                    Pushpin._pushpins.splice(index, 1);
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    document.addEventListener('scroll', Pushpin._updateElements);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    document.removeEventListener('scroll', Pushpin._updateElements);
                }
            },
            {
                key: "_updatePosition",
                value: function _updatePosition() {
                    var scrolled = M.getDocumentScrollTop() + this.options.offset;
                    if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('pinned')) {
                        this._removePinClasses();
                        this.el.style.top = this.options.offset + "px";
                        this.el.classList.add('pinned');
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === 'function') this.options.onPositionChange.call(this, 'pinned');
                    }
                    // Add pin-top (when scrolled position is above top)
                    if (scrolled < this.options.top && !this.el.classList.contains('pin-top')) {
                        this._removePinClasses();
                        this.el.style.top = 0;
                        this.el.classList.add('pin-top');
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === 'function') this.options.onPositionChange.call(this, 'pin-top');
                    }
                    // Add pin-bottom (when scrolled position is below bottom)
                    if (scrolled > this.options.bottom && !this.el.classList.contains('pin-bottom')) {
                        this._removePinClasses();
                        this.el.classList.add('pin-bottom');
                        this.el.style.top = this.options.bottom - this.originalOffset + "px";
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === 'function') this.options.onPositionChange.call(this, 'pin-bottom');
                    }
                }
            },
            {
                key: "_removePinClasses",
                value: function _removePinClasses() {
                    // IE 11 bug (can't remove multiple classes in one line)
                    this.el.classList.remove('pin-top');
                    this.el.classList.remove('pinned');
                    this.el.classList.remove('pin-bottom');
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Pushpin;
                }
            },
            {
                key: "_updateElements",
                value: function _updateElements() {
                    for(var elIndex in Pushpin._pushpins){
                        var pInstance = Pushpin._pushpins[elIndex];
                        pInstance._updatePosition();
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Pushpin;
    }(Component);
    /**
   * @static
   * @memberof Pushpin
   */ Pushpin._pushpins = [];
    M.Pushpin = Pushpin;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
})(cash);
(function($1, anim) {
    'use strict';
    var _defaults = {
        direction: 'top',
        hoverEnabled: true,
        toolbarEnabled: false
    };
    $1.fn.reverse = [].reverse;
    /**
   * @class
   *
   */ var FloatingActionButton = function(_Component14) {
        _inherits(FloatingActionButton, _Component14);
        /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function FloatingActionButton(el, options) {
            _classCallCheck(this, FloatingActionButton);
            var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));
            _this48.el.M_FloatingActionButton = _this48;
            /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */ _this48.options = $1.extend({}, FloatingActionButton.defaults, options);
            _this48.isOpen = false;
            _this48.$anchor = _this48.$el.children('a').first();
            _this48.$menu = _this48.$el.children('ul').first();
            _this48.$floatingBtns = _this48.$el.find('ul .btn-floating');
            _this48.$floatingBtnsReverse = _this48.$el.find('ul .btn-floating').reverse();
            _this48.offsetY = 0;
            _this48.offsetX = 0;
            _this48.$el.addClass("direction-" + _this48.options.direction);
            if (_this48.options.direction === 'top') _this48.offsetY = 40;
            else if (_this48.options.direction === 'right') _this48.offsetX = -40;
            else if (_this48.options.direction === 'bottom') _this48.offsetY = -40;
            else _this48.offsetX = 40;
            _this48._setupEventHandlers();
            return _this48;
        }
        _createClass(FloatingActionButton, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_FloatingActionButton = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleFABClickBound = this._handleFABClick.bind(this);
                    this._handleOpenBound = this.open.bind(this);
                    this._handleCloseBound = this.close.bind(this);
                    if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
                        this.el.addEventListener('mouseenter', this._handleOpenBound);
                        this.el.addEventListener('mouseleave', this._handleCloseBound);
                    } else this.el.addEventListener('click', this._handleFABClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
                        this.el.removeEventListener('mouseenter', this._handleOpenBound);
                        this.el.removeEventListener('mouseleave', this._handleCloseBound);
                    } else this.el.removeEventListener('click', this._handleFABClickBound);
                }
            },
            {
                key: "_handleFABClick",
                value: function _handleFABClick() {
                    if (this.isOpen) this.close();
                    else this.open();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    if (!$1(e.target).closest(this.$menu).length) this.close();
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    if (this.options.toolbarEnabled) this._animateInToolbar();
                    else this._animateInFAB();
                    this.isOpen = true;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    if (this.options.toolbarEnabled) {
                        window.removeEventListener('scroll', this._handleCloseBound, true);
                        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
                        this._animateOutToolbar();
                    } else this._animateOutFAB();
                    this.isOpen = false;
                }
            },
            {
                key: "_animateInFAB",
                value: function _animateInFAB() {
                    var _this49 = this;
                    this.$el.addClass('active');
                    var time = 0;
                    this.$floatingBtnsReverse.each(function(el) {
                        anim({
                            targets: el,
                            opacity: 1,
                            scale: [
                                0.4,
                                1
                            ],
                            translateY: [
                                _this49.offsetY,
                                0
                            ],
                            translateX: [
                                _this49.offsetX,
                                0
                            ],
                            duration: 275,
                            delay: time,
                            easing: 'easeInOutQuad'
                        });
                        time += 40;
                    });
                }
            },
            {
                key: "_animateOutFAB",
                value: function _animateOutFAB() {
                    var _this50 = this;
                    this.$floatingBtnsReverse.each(function(el) {
                        anim.remove(el);
                        anim({
                            targets: el,
                            opacity: 0,
                            scale: 0.4,
                            translateY: _this50.offsetY,
                            translateX: _this50.offsetX,
                            duration: 175,
                            easing: 'easeOutQuad',
                            complete: function() {
                                _this50.$el.removeClass('active');
                            }
                        });
                    });
                }
            },
            {
                key: "_animateInToolbar",
                value: function _animateInToolbar() {
                    var _this51 = this;
                    var scaleFactor = void 0;
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var btnRect = this.el.getBoundingClientRect();
                    var backdrop = $1('<div class="fab-backdrop"></div>');
                    var fabColor = this.$anchor.css('background-color');
                    this.$anchor.append(backdrop);
                    this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
                    this.offsetY = windowHeight - btnRect.bottom;
                    scaleFactor = windowWidth / backdrop[0].clientWidth;
                    this.btnBottom = btnRect.bottom;
                    this.btnLeft = btnRect.left;
                    this.btnWidth = btnRect.width;
                    // Set initial state
                    this.$el.addClass('active');
                    this.$el.css({
                        'text-align': 'center',
                        width: '100%',
                        bottom: 0,
                        left: 0,
                        transform: 'translateX(' + this.offsetX + 'px)',
                        transition: 'none'
                    });
                    this.$anchor.css({
                        transform: 'translateY(' + -this.offsetY + 'px)',
                        transition: 'none'
                    });
                    backdrop.css({
                        'background-color': fabColor
                    });
                    setTimeout(function() {
                        _this51.$el.css({
                            transform: '',
                            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
                        });
                        _this51.$anchor.css({
                            overflow: 'visible',
                            transform: '',
                            transition: 'transform .2s'
                        });
                        setTimeout(function() {
                            _this51.$el.css({
                                overflow: 'hidden',
                                'background-color': fabColor
                            });
                            backdrop.css({
                                transform: 'scale(' + scaleFactor + ')',
                                transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
                            });
                            _this51.$menu.children('li').children('a').css({
                                opacity: 1
                            });
                            // Scroll to close.
                            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
                            window.addEventListener('scroll', _this51._handleCloseBound, true);
                            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
                        }, 100);
                    }, 0);
                }
            },
            {
                key: "_animateOutToolbar",
                value: function _animateOutToolbar() {
                    var _this52 = this;
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var backdrop = this.$el.find('.fab-backdrop');
                    var fabColor = this.$anchor.css('background-color');
                    this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
                    this.offsetY = windowHeight - this.btnBottom;
                    // Hide backdrop
                    this.$el.removeClass('active');
                    this.$el.css({
                        'background-color': 'transparent',
                        transition: 'none'
                    });
                    this.$anchor.css({
                        transition: 'none'
                    });
                    backdrop.css({
                        transform: 'scale(0)',
                        'background-color': fabColor
                    });
                    this.$menu.children('li').children('a').css({
                        opacity: ''
                    });
                    setTimeout(function() {
                        backdrop.remove();
                        // Set initial state.
                        _this52.$el.css({
                            'text-align': '',
                            width: '',
                            bottom: '',
                            left: '',
                            overflow: '',
                            'background-color': '',
                            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
                        });
                        _this52.$anchor.css({
                            overflow: '',
                            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
                        });
                        setTimeout(function() {
                            _this52.$el.css({
                                transform: 'translate3d(0,0,0)',
                                transition: 'transform .2s'
                            });
                            _this52.$anchor.css({
                                transform: 'translate3d(0,0,0)',
                                transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
                            });
                        }, 20);
                    }, 200);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_FloatingActionButton;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return FloatingActionButton;
    }(Component);
    M.FloatingActionButton = FloatingActionButton;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
})(cash, M.anime);
(function($1) {
    'use strict';
    var _defaults = {
        // Close when date is selected
        autoClose: false,
        // the default output format for the input field value
        format: 'mmm dd, yyyy',
        // Used to create date object from current input string
        parse: null,
        // The initial date to view when first opened
        defaultDate: null,
        // Make the `defaultDate` the initial selected value
        setDefaultDate: false,
        disableWeekends: false,
        disableDayFn: null,
        // First day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,
        // The earliest date that can be selected
        minDate: null,
        // Thelatest date that can be selected
        maxDate: null,
        // Number of years either side, or array of upper/lower range
        yearRange: 10,
        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,
        startRange: null,
        endRange: null,
        isRTL: false,
        // Render the month after year in the calendar title
        showMonthAfterYear: false,
        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,
        // Specify a DOM element to render the calendar in
        container: null,
        // Show clear button
        showClearBtn: false,
        // internationalization
        i18n: {
            cancel: 'Cancel',
            clear: 'Clear',
            done: 'Ok',
            previousMonth: "\u2039",
            nextMonth: "\u203A",
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            monthsShort: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            weekdays: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            weekdaysShort: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ],
            weekdaysAbbrev: [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S'
            ]
        },
        // events array
        events: [],
        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    };
    /**
   * @class
   *
   */ var Datepicker = function(_Component15) {
        _inherits(Datepicker, _Component15);
        /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Datepicker(el, options) {
            _classCallCheck(this, Datepicker);
            var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));
            _this53.el.M_Datepicker = _this53;
            _this53.options = $1.extend({}, Datepicker.defaults, options);
            // make sure i18n defaults are not lost when only few i18n option properties are passed
            if (!!options && options.hasOwnProperty('i18n') && typeof options.i18n === 'object') _this53.options.i18n = $1.extend({}, Datepicker.defaults.i18n, options.i18n);
            // Remove time component from minDate and maxDate options
            if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
            if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);
            _this53.id = M.guid();
            _this53._setupVariables();
            _this53._insertHTMLIntoDOM();
            _this53._setupModal();
            _this53._setupEventHandlers();
            if (!_this53.options.defaultDate) _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
            var defDate = _this53.options.defaultDate;
            if (Datepicker._isDate(defDate)) {
                if (_this53.options.setDefaultDate) {
                    _this53.setDate(defDate, true);
                    _this53.setInputValue();
                } else _this53.gotoDate(defDate);
            } else _this53.gotoDate(new Date());
            /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */ _this53.isOpen = false;
            return _this53;
        }
        _createClass(Datepicker, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.modal.destroy();
                    $1(this.modalEl).remove();
                    this.destroySelects();
                    this.el.M_Datepicker = undefined;
                }
            },
            {
                key: "destroySelects",
                value: function destroySelects() {
                    var oldYearSelect = this.calendarEl.querySelector('.orig-select-year');
                    if (oldYearSelect) M.FormSelect.getInstance(oldYearSelect).destroy();
                    var oldMonthSelect = this.calendarEl.querySelector('.orig-select-month');
                    if (oldMonthSelect) M.FormSelect.getInstance(oldMonthSelect).destroy();
                }
            },
            {
                key: "_insertHTMLIntoDOM",
                value: function _insertHTMLIntoDOM() {
                    if (this.options.showClearBtn) {
                        $1(this.clearBtn).css({
                            visibility: ''
                        });
                        this.clearBtn.innerHTML = this.options.i18n.clear;
                    }
                    this.doneBtn.innerHTML = this.options.i18n.done;
                    this.cancelBtn.innerHTML = this.options.i18n.cancel;
                    if (this.options.container) this.$modalEl.appendTo(this.options.container);
                    else this.$modalEl.insertBefore(this.el);
                }
            },
            {
                key: "_setupModal",
                value: function _setupModal() {
                    var _this54 = this;
                    this.modalEl.id = 'modal-' + this.id;
                    this.modal = M.Modal.init(this.modalEl, {
                        onCloseEnd: function() {
                            _this54.isOpen = false;
                        }
                    });
                }
            },
            {
                key: "toString",
                value: function toString(format) {
                    var _this55 = this;
                    format = format || this.options.format;
                    if (!Datepicker._isDate(this.date)) return '';
                    var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
                    var formattedDate = formatArray.map(function(label) {
                        if (_this55.formats[label]) return _this55.formats[label]();
                        return label;
                    }).join('');
                    return formattedDate;
                }
            },
            {
                key: "setDate",
                value: function setDate(date, preventOnSelect) {
                    if (!date) {
                        this.date = null;
                        this._renderDateDisplay();
                        return this.draw();
                    }
                    if (typeof date === 'string') date = new Date(Date.parse(date));
                    if (!Datepicker._isDate(date)) return;
                    var min = this.options.minDate, max = this.options.maxDate;
                    if (Datepicker._isDate(min) && date < min) date = min;
                    else if (Datepicker._isDate(max) && date > max) date = max;
                    this.date = new Date(date.getTime());
                    this._renderDateDisplay();
                    Datepicker._setToStartOfDay(this.date);
                    this.gotoDate(this.date);
                    if (!preventOnSelect && typeof this.options.onSelect === 'function') this.options.onSelect.call(this, this.date);
                }
            },
            {
                key: "setInputValue",
                value: function setInputValue() {
                    this.el.value = this.toString();
                    this.$el.trigger('change', {
                        firedBy: this
                    });
                }
            },
            {
                key: "_renderDateDisplay",
                value: function _renderDateDisplay() {
                    var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
                    var i18n = this.options.i18n;
                    var day = i18n.weekdaysShort[displayDate.getDay()];
                    var month = i18n.monthsShort[displayDate.getMonth()];
                    var date = displayDate.getDate();
                    this.yearTextEl.innerHTML = displayDate.getFullYear();
                    this.dateTextEl.innerHTML = day + ", " + month + " " + date;
                }
            },
            {
                key: "gotoDate",
                value: function gotoDate(date) {
                    var newCalendar = true;
                    if (!Datepicker._isDate(date)) return;
                    if (this.calendars) {
                        var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1), lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1), visibleDate = date.getTime();
                        // get the end of the month
                        lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
                        lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
                        newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
                    }
                    if (newCalendar) this.calendars = [
                        {
                            month: date.getMonth(),
                            year: date.getFullYear()
                        }
                    ];
                    this.adjustCalendars();
                }
            },
            {
                key: "adjustCalendars",
                value: function adjustCalendars() {
                    this.calendars[0] = this.adjustCalendar(this.calendars[0]);
                    this.draw();
                }
            },
            {
                key: "adjustCalendar",
                value: function adjustCalendar(calendar) {
                    if (calendar.month < 0) {
                        calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
                        calendar.month += 12;
                    }
                    if (calendar.month > 11) {
                        calendar.year += Math.floor(Math.abs(calendar.month) / 12);
                        calendar.month -= 12;
                    }
                    return calendar;
                }
            },
            {
                key: "nextMonth",
                value: function nextMonth() {
                    this.calendars[0].month++;
                    this.adjustCalendars();
                }
            },
            {
                key: "prevMonth",
                value: function prevMonth() {
                    this.calendars[0].month--;
                    this.adjustCalendars();
                }
            },
            {
                key: "render",
                value: function render(year, month, randId) {
                    var opts = this.options, now = new Date(), days = Datepicker._getDaysInMonth(year, month), before = new Date(year, month, 1).getDay(), data = [], row = [];
                    Datepicker._setToStartOfDay(now);
                    if (opts.firstDay > 0) {
                        before -= opts.firstDay;
                        if (before < 0) before += 7;
                    }
                    var previousMonth = month === 0 ? 11 : month - 1, nextMonth = month === 11 ? 0 : month + 1, yearOfPreviousMonth = month === 0 ? year - 1 : year, yearOfNextMonth = month === 11 ? year + 1 : year, daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
                    var cells = days + before, after = cells;
                    while(after > 7)after -= 7;
                    cells += 7 - after;
                    var isWeekSelected = false;
                    for(var i = 0, r = 0; i < cells; i++){
                        var day = new Date(year, month, 1 + (i - before)), isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false, isToday = Datepicker._compareDates(day, now), hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false, isEmpty = i < before || i >= days + before, dayNumber = 1 + (i - before), monthNumber = month, yearNumber = year, isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day), isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day), isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange, isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);
                        if (isEmpty) {
                            if (i < before) {
                                dayNumber = daysInPreviousMonth + dayNumber;
                                monthNumber = previousMonth;
                                yearNumber = yearOfPreviousMonth;
                            } else {
                                dayNumber = dayNumber - days;
                                monthNumber = nextMonth;
                                yearNumber = yearOfNextMonth;
                            }
                        }
                        var dayConfig = {
                            day: dayNumber,
                            month: monthNumber,
                            year: yearNumber,
                            hasEvent: hasEvent,
                            isSelected: isSelected,
                            isToday: isToday,
                            isDisabled: isDisabled,
                            isEmpty: isEmpty,
                            isStartRange: isStartRange,
                            isEndRange: isEndRange,
                            isInRange: isInRange,
                            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
                        };
                        row.push(this.renderDay(dayConfig));
                        if (++r === 7) {
                            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
                            row = [];
                            r = 0;
                            isWeekSelected = false;
                        }
                    }
                    return this.renderTable(opts, data, randId);
                }
            },
            {
                key: "renderDay",
                value: function renderDay(opts) {
                    var arr = [];
                    var ariaSelected = 'false';
                    if (opts.isEmpty) {
                        if (opts.showDaysInNextAndPreviousMonths) {
                            arr.push('is-outside-current-month');
                            arr.push('is-selection-disabled');
                        } else return '<td class="is-empty"></td>';
                    }
                    if (opts.isDisabled) arr.push('is-disabled');
                    if (opts.isToday) arr.push('is-today');
                    if (opts.isSelected) {
                        arr.push('is-selected');
                        ariaSelected = 'true';
                    }
                    if (opts.hasEvent) arr.push('has-event');
                    if (opts.isInRange) arr.push('is-inrange');
                    if (opts.isStartRange) arr.push('is-startrange');
                    if (opts.isEndRange) arr.push('is-endrange');
                    return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
                }
            },
            {
                key: "renderRow",
                value: function renderRow(days, isRTL, isRowSelected) {
                    return '<tr class="datepicker-row' + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
                }
            },
            {
                key: "renderTable",
                value: function renderTable(opts, data, randId) {
                    return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
                }
            },
            {
                key: "renderHead",
                value: function renderHead(opts) {
                    var i = void 0, arr = [];
                    for(i = 0; i < 7; i++)arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
                    return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
                }
            },
            {
                key: "renderBody",
                value: function renderBody(rows) {
                    return '<tbody>' + rows.join('') + '</tbody>';
                }
            },
            {
                key: "renderTitle",
                value: function renderTitle(instance, c, year, month, refYear, randId) {
                    var i = void 0, j = void 0, arr = void 0, opts = this.options, isMinYear = year === opts.minYear, isMaxYear = year === opts.maxYear, html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">', monthHtml = void 0, yearHtml = void 0, prev = true, next = true;
                    for(arr = [], i = 0; i < 12; i++)arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
                    monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join('') + '</select>';
                    if ($1.isArray(opts.yearRange)) {
                        i = opts.yearRange[0];
                        j = opts.yearRange[1] + 1;
                    } else {
                        i = year - opts.yearRange;
                        j = 1 + year + opts.yearRange;
                    }
                    for(arr = []; i < j && i <= opts.maxYear; i++)if (i >= opts.minYear) arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
                    yearHtml = "<select class=\"datepicker-select orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";
                    var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
                    html += "<button class=\"month-prev" + (prev ? '' : ' is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";
                    html += '<div class="selects-container">';
                    if (opts.showMonthAfterYear) html += yearHtml + monthHtml;
                    else html += monthHtml + yearHtml;
                    html += '</div>';
                    if (isMinYear && (month === 0 || opts.minMonth >= month)) prev = false;
                    if (isMaxYear && (month === 11 || opts.maxMonth <= month)) next = false;
                    var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
                    html += "<button class=\"month-next" + (next ? '' : ' is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";
                    return html += '</div>';
                }
            },
            {
                key: "draw",
                value: function draw(force) {
                    if (!this.isOpen && !force) return;
                    var opts = this.options, minYear = opts.minYear, maxYear = opts.maxYear, minMonth = opts.minMonth, maxMonth = opts.maxMonth, html = '', randId = void 0;
                    if (this._y <= minYear) {
                        this._y = minYear;
                        if (!isNaN(minMonth) && this._m < minMonth) this._m = minMonth;
                    }
                    if (this._y >= maxYear) {
                        this._y = maxYear;
                        if (!isNaN(maxMonth) && this._m > maxMonth) this._m = maxMonth;
                    }
                    randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                    for(var c = 0; c < 1; c++){
                        this._renderDateDisplay();
                        html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
                    }
                    this.destroySelects();
                    this.calendarEl.innerHTML = html;
                    // Init Materialize Select
                    var yearSelect = this.calendarEl.querySelector('.orig-select-year');
                    var monthSelect = this.calendarEl.querySelector('.orig-select-month');
                    M.FormSelect.init(yearSelect, {
                        classes: 'select-year',
                        dropdownOptions: {
                            container: document.body,
                            constrainWidth: false
                        }
                    });
                    M.FormSelect.init(monthSelect, {
                        classes: 'select-month',
                        dropdownOptions: {
                            container: document.body,
                            constrainWidth: false
                        }
                    });
                    // Add change handlers for select
                    yearSelect.addEventListener('change', this._handleYearChange.bind(this));
                    monthSelect.addEventListener('change', this._handleMonthChange.bind(this));
                    if (typeof this.options.onDraw === 'function') this.options.onDraw(this);
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleInputChangeBound = this._handleInputChange.bind(this);
                    this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
                    this._finishSelectionBound = this._finishSelection.bind(this);
                    this._handleMonthChange = this._handleMonthChange.bind(this);
                    this._closeBound = this.close.bind(this);
                    this.el.addEventListener('click', this._handleInputClickBound);
                    this.el.addEventListener('keydown', this._handleInputKeydownBound);
                    this.el.addEventListener('change', this._handleInputChangeBound);
                    this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
                    this.doneBtn.addEventListener('click', this._finishSelectionBound);
                    this.cancelBtn.addEventListener('click', this._closeBound);
                    if (this.options.showClearBtn) {
                        this._handleClearClickBound = this._handleClearClick.bind(this);
                        this.clearBtn.addEventListener('click', this._handleClearClickBound);
                    }
                }
            },
            {
                key: "_setupVariables",
                value: function _setupVariables() {
                    var _this56 = this;
                    this.$modalEl = $1(Datepicker._template);
                    this.modalEl = this.$modalEl[0];
                    this.calendarEl = this.modalEl.querySelector('.datepicker-calendar');
                    this.yearTextEl = this.modalEl.querySelector('.year-text');
                    this.dateTextEl = this.modalEl.querySelector('.date-text');
                    if (this.options.showClearBtn) this.clearBtn = this.modalEl.querySelector('.datepicker-clear');
                    this.doneBtn = this.modalEl.querySelector('.datepicker-done');
                    this.cancelBtn = this.modalEl.querySelector('.datepicker-cancel');
                    this.formats = {
                        d: function() {
                            return _this56.date.getDate();
                        },
                        dd: function() {
                            var d = _this56.date.getDate();
                            return (d < 10 ? '0' : '') + d;
                        },
                        ddd: function() {
                            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
                        },
                        dddd: function() {
                            return _this56.options.i18n.weekdays[_this56.date.getDay()];
                        },
                        m: function() {
                            return _this56.date.getMonth() + 1;
                        },
                        mm: function() {
                            var m = _this56.date.getMonth() + 1;
                            return (m < 10 ? '0' : '') + m;
                        },
                        mmm: function() {
                            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
                        },
                        mmmm: function() {
                            return _this56.options.i18n.months[_this56.date.getMonth()];
                        },
                        yy: function() {
                            return ('' + _this56.date.getFullYear()).slice(2);
                        },
                        yyyy: function() {
                            return _this56.date.getFullYear();
                        }
                    };
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('click', this._handleInputClickBound);
                    this.el.removeEventListener('keydown', this._handleInputKeydownBound);
                    this.el.removeEventListener('change', this._handleInputChangeBound);
                    this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    this.open();
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    if (e.which === M.keys.ENTER) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleCalendarClick",
                value: function _handleCalendarClick(e) {
                    if (!this.isOpen) return;
                    var $target = $1(e.target);
                    if (!$target.hasClass('is-disabled')) {
                        if ($target.hasClass('datepicker-day-button') && !$target.hasClass('is-empty') && !$target.parent().hasClass('is-disabled')) {
                            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));
                            if (this.options.autoClose) this._finishSelection();
                        } else if ($target.closest('.month-prev').length) this.prevMonth();
                        else if ($target.closest('.month-next').length) this.nextMonth();
                    }
                }
            },
            {
                key: "_handleClearClick",
                value: function _handleClearClick() {
                    this.date = null;
                    this.setInputValue();
                    this.close();
                }
            },
            {
                key: "_handleMonthChange",
                value: function _handleMonthChange(e) {
                    this.gotoMonth(e.target.value);
                }
            },
            {
                key: "_handleYearChange",
                value: function _handleYearChange(e) {
                    this.gotoYear(e.target.value);
                }
            },
            {
                key: "gotoMonth",
                value: function gotoMonth(month) {
                    if (!isNaN(month)) {
                        this.calendars[0].month = parseInt(month, 10);
                        this.adjustCalendars();
                    }
                }
            },
            {
                key: "gotoYear",
                value: function gotoYear(year) {
                    if (!isNaN(year)) {
                        this.calendars[0].year = parseInt(year, 10);
                        this.adjustCalendars();
                    }
                }
            },
            {
                key: "_handleInputChange",
                value: function _handleInputChange(e) {
                    var date = void 0;
                    // Prevent change event from being fired when triggered by the plugin
                    if (e.firedBy === this) return;
                    if (this.options.parse) date = this.options.parse(this.el.value, this.options.format);
                    else date = new Date(Date.parse(this.el.value));
                    if (Datepicker._isDate(date)) this.setDate(date);
                }
            },
            {
                key: "renderDayName",
                value: function renderDayName(opts, day, abbr) {
                    day += opts.firstDay;
                    while(day >= 7)day -= 7;
                    return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
                }
            },
            {
                key: "_finishSelection",
                value: function _finishSelection() {
                    this.setInputValue();
                    this.close();
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    if (typeof this.options.onOpen === 'function') this.options.onOpen.call(this);
                    this.draw();
                    this.modal.open();
                    return this;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    if (typeof this.options.onClose === 'function') this.options.onClose.call(this);
                    this.modal.close();
                    return this;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "_isDate",
                value: function _isDate(obj) {
                    return /Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
                }
            },
            {
                key: "_isWeekend",
                value: function _isWeekend(date) {
                    var day = date.getDay();
                    return day === 0 || day === 6;
                }
            },
            {
                key: "_setToStartOfDay",
                value: function _setToStartOfDay(date) {
                    if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
                }
            },
            {
                key: "_getDaysInMonth",
                value: function _getDaysInMonth(year, month) {
                    return [
                        31,
                        Datepicker._isLeapYear(year) ? 29 : 28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ][month];
                }
            },
            {
                key: "_isLeapYear",
                value: function _isLeapYear(year) {
                    // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
                    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
                }
            },
            {
                key: "_compareDates",
                value: function _compareDates(a, b) {
                    // weak date comparison (use setToStartOfDay(date) to ensure correct result)
                    return a.getTime() === b.getTime();
                }
            },
            {
                key: "_setToStartOfDay",
                value: function _setToStartOfDay(date) {
                    if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Datepicker;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Datepicker;
    }(Component);
    Datepicker._template = [
        '<div class= "modal datepicker-modal">',
        '<div class="modal-content datepicker-container">',
        '<div class="datepicker-date-display">',
        '<span class="year-text"></span>',
        '<span class="date-text"></span>',
        '</div>',
        '<div class="datepicker-calendar-container">',
        '<div class="datepicker-calendar"></div>',
        '<div class="datepicker-footer">',
        '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>',
        '<div class="confirmation-btns">',
        '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>',
        '<button class="btn-flat datepicker-done waves-effect" type="button"></button>',
        '</div>',
        '</div>',
        '</div>',
        '</div>',
        '</div>'
    ].join('');
    M.Datepicker = Datepicker;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
})(cash);
(function($1) {
    'use strict';
    var _defaults = {
        dialRadius: 135,
        outerRadius: 105,
        innerRadius: 70,
        tickRadius: 20,
        duration: 350,
        container: null,
        defaultTime: 'now',
        fromNow: 0,
        showClearBtn: false,
        // internationalization
        i18n: {
            cancel: 'Cancel',
            clear: 'Clear',
            done: 'Ok'
        },
        autoClose: false,
        twelveHour: true,
        vibrate: true,
        // Callbacks
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        onSelect: null
    };
    /**
   * @class
   *
   */ var Timepicker = function(_Component16) {
        _inherits(Timepicker, _Component16);
        function Timepicker(el, options) {
            _classCallCheck(this, Timepicker);
            var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));
            _this57.el.M_Timepicker = _this57;
            _this57.options = $1.extend({}, Timepicker.defaults, options);
            _this57.id = M.guid();
            _this57._insertHTMLIntoDOM();
            _this57._setupModal();
            _this57._setupVariables();
            _this57._setupEventHandlers();
            _this57._clockSetup();
            _this57._pickerSetup();
            return _this57;
        }
        _createClass(Timepicker, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.modal.destroy();
                    $1(this.modalEl).remove();
                    this.el.M_Timepicker = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
                    this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
                    this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);
                    this.el.addEventListener('click', this._handleInputClickBound);
                    this.el.addEventListener('keydown', this._handleInputKeydownBound);
                    this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
                    this.plate.addEventListener('touchstart', this._handleClockClickStartBound);
                    $1(this.spanHours).on('click', this.showView.bind(this, 'hours'));
                    $1(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('click', this._handleInputClickBound);
                    this.el.removeEventListener('keydown', this._handleInputKeydownBound);
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    this.open();
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    if (e.which === M.keys.ENTER) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleClockClickStart",
                value: function _handleClockClickStart(e) {
                    e.preventDefault();
                    var clockPlateBR = this.plate.getBoundingClientRect();
                    var offset = {
                        x: clockPlateBR.left,
                        y: clockPlateBR.top
                    };
                    this.x0 = offset.x + this.options.dialRadius;
                    this.y0 = offset.y + this.options.dialRadius;
                    this.moved = false;
                    var clickPos = Timepicker._Pos(e);
                    this.dx = clickPos.x - this.x0;
                    this.dy = clickPos.y - this.y0;
                    // Set clock hands
                    this.setHand(this.dx, this.dy, false);
                    // Mousemove on document
                    document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
                    document.addEventListener('touchmove', this._handleDocumentClickMoveBound);
                    // Mouseup on document
                    document.addEventListener('mouseup', this._handleDocumentClickEndBound);
                    document.addEventListener('touchend', this._handleDocumentClickEndBound);
                }
            },
            {
                key: "_handleDocumentClickMove",
                value: function _handleDocumentClickMove(e) {
                    e.preventDefault();
                    var clickPos = Timepicker._Pos(e);
                    var x = clickPos.x - this.x0;
                    var y = clickPos.y - this.y0;
                    this.moved = true;
                    this.setHand(x, y, false, true);
                }
            },
            {
                key: "_handleDocumentClickEnd",
                value: function _handleDocumentClickEnd(e) {
                    var _this58 = this;
                    e.preventDefault();
                    document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
                    document.removeEventListener('touchend', this._handleDocumentClickEndBound);
                    var clickPos = Timepicker._Pos(e);
                    var x = clickPos.x - this.x0;
                    var y = clickPos.y - this.y0;
                    if (this.moved && x === this.dx && y === this.dy) this.setHand(x, y);
                    if (this.currentView === 'hours') this.showView('minutes', this.options.duration / 2);
                    else if (this.options.autoClose) {
                        $1(this.minutesView).addClass('timepicker-dial-out');
                        setTimeout(function() {
                            _this58.done();
                        }, this.options.duration / 2);
                    }
                    if (typeof this.options.onSelect === 'function') this.options.onSelect.call(this, this.hours, this.minutes);
                    // Unbind mousemove event
                    document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
                    document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
                }
            },
            {
                key: "_insertHTMLIntoDOM",
                value: function _insertHTMLIntoDOM() {
                    this.$modalEl = $1(Timepicker._template);
                    this.modalEl = this.$modalEl[0];
                    this.modalEl.id = 'modal-' + this.id;
                    // Append popover to input by default
                    var containerEl = document.querySelector(this.options.container);
                    if (this.options.container && !!containerEl) this.$modalEl.appendTo(containerEl);
                    else this.$modalEl.insertBefore(this.el);
                }
            },
            {
                key: "_setupModal",
                value: function _setupModal() {
                    var _this59 = this;
                    this.modal = M.Modal.init(this.modalEl, {
                        onOpenStart: this.options.onOpenStart,
                        onOpenEnd: this.options.onOpenEnd,
                        onCloseStart: this.options.onCloseStart,
                        onCloseEnd: function() {
                            if (typeof _this59.options.onCloseEnd === 'function') _this59.options.onCloseEnd.call(_this59);
                            _this59.isOpen = false;
                        }
                    });
                }
            },
            {
                key: "_setupVariables",
                value: function _setupVariables() {
                    this.currentView = 'hours';
                    this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;
                    this._canvas = this.modalEl.querySelector('.timepicker-canvas');
                    this.plate = this.modalEl.querySelector('.timepicker-plate');
                    this.hoursView = this.modalEl.querySelector('.timepicker-hours');
                    this.minutesView = this.modalEl.querySelector('.timepicker-minutes');
                    this.spanHours = this.modalEl.querySelector('.timepicker-span-hours');
                    this.spanMinutes = this.modalEl.querySelector('.timepicker-span-minutes');
                    this.spanAmPm = this.modalEl.querySelector('.timepicker-span-am-pm');
                    this.footer = this.modalEl.querySelector('.timepicker-footer');
                    this.amOrPm = 'PM';
                }
            },
            {
                key: "_pickerSetup",
                value: function _pickerSetup() {
                    var $clearBtn = $1("<button class=\"btn-flat timepicker-clear waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));
                    if (this.options.showClearBtn) $clearBtn.css({
                        visibility: ''
                    });
                    var confirmationBtnsContainer = $1('<div class="confirmation-btns"></div>');
                    $1('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
                    $1('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
                    confirmationBtnsContainer.appendTo(this.footer);
                }
            },
            {
                key: "_clockSetup",
                value: function _clockSetup() {
                    if (this.options.twelveHour) {
                        this.$amBtn = $1('<div class="am-btn">AM</div>');
                        this.$pmBtn = $1('<div class="pm-btn">PM</div>');
                        this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
                        this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
                    }
                    this._buildHoursView();
                    this._buildMinutesView();
                    this._buildSVGClock();
                }
            },
            {
                key: "_buildSVGClock",
                value: function _buildSVGClock() {
                    // Draw clock hands and others
                    var dialRadius = this.options.dialRadius;
                    var tickRadius = this.options.tickRadius;
                    var diameter = dialRadius * 2;
                    var svg = Timepicker._createSVGEl('svg');
                    svg.setAttribute('class', 'timepicker-svg');
                    svg.setAttribute('width', diameter);
                    svg.setAttribute('height', diameter);
                    var g = Timepicker._createSVGEl('g');
                    g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');
                    var bearing = Timepicker._createSVGEl('circle');
                    bearing.setAttribute('class', 'timepicker-canvas-bearing');
                    bearing.setAttribute('cx', 0);
                    bearing.setAttribute('cy', 0);
                    bearing.setAttribute('r', 4);
                    var hand = Timepicker._createSVGEl('line');
                    hand.setAttribute('x1', 0);
                    hand.setAttribute('y1', 0);
                    var bg = Timepicker._createSVGEl('circle');
                    bg.setAttribute('class', 'timepicker-canvas-bg');
                    bg.setAttribute('r', tickRadius);
                    g.appendChild(hand);
                    g.appendChild(bg);
                    g.appendChild(bearing);
                    svg.appendChild(g);
                    this._canvas.appendChild(svg);
                    this.hand = hand;
                    this.bg = bg;
                    this.bearing = bearing;
                    this.g = g;
                }
            },
            {
                key: "_buildHoursView",
                value: function _buildHoursView() {
                    var $tick = $1('<div class="timepicker-tick"></div>');
                    // Hours view
                    if (this.options.twelveHour) for(var i = 1; i < 13; i += 1){
                        var tick = $tick.clone();
                        var radian = i / 6 * Math.PI;
                        var radius = this.options.outerRadius;
                        tick.css({
                            left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
                            top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
                        });
                        tick.html(i === 0 ? '00' : i);
                        this.hoursView.appendChild(tick[0]);
                    // tick.on(mousedownEvent, mousedown);
                    }
                    else for(var _i2 = 0; _i2 < 24; _i2 += 1){
                        var _tick = $tick.clone();
                        var _radian = _i2 / 6 * Math.PI;
                        var inner = _i2 > 0 && _i2 < 13;
                        var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
                        _tick.css({
                            left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
                            top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
                        });
                        _tick.html(_i2 === 0 ? '00' : _i2);
                        this.hoursView.appendChild(_tick[0]);
                    // tick.on(mousedownEvent, mousedown);
                    }
                }
            },
            {
                key: "_buildMinutesView",
                value: function _buildMinutesView() {
                    var $tick = $1('<div class="timepicker-tick"></div>');
                    // Minutes view
                    for(var i = 0; i < 60; i += 5){
                        var tick = $tick.clone();
                        var radian = i / 30 * Math.PI;
                        tick.css({
                            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
                            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
                        });
                        tick.html(Timepicker._addLeadingZero(i));
                        this.minutesView.appendChild(tick[0]);
                    }
                }
            },
            {
                key: "_handleAmPmClick",
                value: function _handleAmPmClick(e) {
                    var $btnClicked = $1(e.target);
                    this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';
                    this._updateAmPmView();
                }
            },
            {
                key: "_updateAmPmView",
                value: function _updateAmPmView() {
                    if (this.options.twelveHour) {
                        this.$amBtn.toggleClass('text-primary', this.amOrPm === 'AM');
                        this.$pmBtn.toggleClass('text-primary', this.amOrPm === 'PM');
                    }
                }
            },
            {
                key: "_updateTimeFromInput",
                value: function _updateTimeFromInput() {
                    // Get the time
                    var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');
                    if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
                        if (value[1].toUpperCase().indexOf('AM') > 0) this.amOrPm = 'AM';
                        else this.amOrPm = 'PM';
                        value[1] = value[1].replace('AM', '').replace('PM', '');
                    }
                    if (value[0] === 'now') {
                        var now = new Date(+new Date() + this.options.fromNow);
                        value = [
                            now.getHours(),
                            now.getMinutes()
                        ];
                        if (this.options.twelveHour) this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
                    }
                    this.hours = +value[0] || 0;
                    this.minutes = +value[1] || 0;
                    this.spanHours.innerHTML = this.hours;
                    this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);
                    this._updateAmPmView();
                }
            },
            {
                key: "showView",
                value: function showView(view, delay) {
                    view === 'minutes' && $1(this.hoursView).css('visibility');
                    var isHours = view === 'hours', nextView = isHours ? this.hoursView : this.minutesView, hideView = isHours ? this.minutesView : this.hoursView;
                    this.currentView = view;
                    $1(this.spanHours).toggleClass('text-primary', isHours);
                    $1(this.spanMinutes).toggleClass('text-primary', !isHours);
                    // Transition view
                    hideView.classList.add('timepicker-dial-out');
                    $1(nextView).css('visibility', 'visible').removeClass('timepicker-dial-out');
                    // Reset clock hand
                    this.resetClock(delay);
                    // After transitions ended
                    clearTimeout(this.toggleViewTimer);
                    this.toggleViewTimer = setTimeout(function() {
                        $1(hideView).css('visibility', 'hidden');
                    }, this.options.duration);
                }
            },
            {
                key: "resetClock",
                value: function resetClock(delay) {
                    var view = this.currentView, value = this[view], isHours = view === 'hours', unit = Math.PI / (isHours ? 6 : 30), radian = value * unit, radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius, x = Math.sin(radian) * radius, y = -Math.cos(radian) * radius, self = this;
                    if (delay) {
                        $1(this.canvas).addClass('timepicker-canvas-out');
                        setTimeout(function() {
                            $1(self.canvas).removeClass('timepicker-canvas-out');
                            self.setHand(x, y);
                        }, delay);
                    } else this.setHand(x, y);
                }
            },
            {
                key: "setHand",
                value: function setHand(x, y, roundBy5) {
                    var _this60 = this;
                    var radian = Math.atan2(x, -y), isHours = this.currentView === 'hours', unit = Math.PI / (isHours || roundBy5 ? 6 : 30), z = Math.sqrt(x * x + y * y), inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2, radius = inner ? this.options.innerRadius : this.options.outerRadius;
                    if (this.options.twelveHour) radius = this.options.outerRadius;
                    // Radian should in range [0, 2PI]
                    if (radian < 0) radian = Math.PI * 2 + radian;
                    // Get the round value
                    var value = Math.round(radian / unit);
                    // Get the round radian
                    radian = value * unit;
                    // Correct the hours or minutes
                    if (this.options.twelveHour) {
                        if (isHours) {
                            if (value === 0) value = 12;
                        } else {
                            if (roundBy5) value *= 5;
                            if (value === 60) value = 0;
                        }
                    } else if (isHours) {
                        if (value === 12) value = 0;
                        value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
                    } else {
                        if (roundBy5) value *= 5;
                        if (value === 60) value = 0;
                    }
                    // Once hours or minutes changed, vibrate the device
                    if (this[this.currentView] !== value) {
                        if (this.vibrate && this.options.vibrate) // Do not vibrate too frequently
                        {
                            if (!this.vibrateTimer) {
                                navigator[this.vibrate](10);
                                this.vibrateTimer = setTimeout(function() {
                                    _this60.vibrateTimer = null;
                                }, 100);
                            }
                        }
                    }
                    this[this.currentView] = value;
                    if (isHours) this['spanHours'].innerHTML = value;
                    else this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
                    // Set clock hand and others' position
                    var cx1 = Math.sin(radian) * (radius - this.options.tickRadius), cy1 = -Math.cos(radian) * (radius - this.options.tickRadius), cx2 = Math.sin(radian) * radius, cy2 = -Math.cos(radian) * radius;
                    this.hand.setAttribute('x2', cx1);
                    this.hand.setAttribute('y2', cy1);
                    this.bg.setAttribute('cx', cx2);
                    this.bg.setAttribute('cy', cy2);
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    this._updateTimeFromInput();
                    this.showView('hours');
                    this.modal.open();
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    this.modal.close();
                }
            },
            {
                key: "done",
                value: function done(e, clearValue) {
                    // Set input value
                    var last = this.el.value;
                    var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
                    this.time = value;
                    if (!clearValue && this.options.twelveHour) value = value + " " + this.amOrPm;
                    this.el.value = value;
                    // Trigger change event
                    if (value !== last) this.$el.trigger('change');
                    this.close();
                    this.el.focus();
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.done(null, true);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "_addLeadingZero",
                value: function _addLeadingZero(num) {
                    return (num < 10 ? '0' : '') + num;
                }
            },
            {
                key: "_createSVGEl",
                value: function _createSVGEl(name1) {
                    var svgNS = 'http://www.w3.org/2000/svg';
                    return document.createElementNS(svgNS, name1);
                }
            },
            {
                key: "_Pos",
                value: function _Pos(e) {
                    if (e.targetTouches && e.targetTouches.length >= 1) return {
                        x: e.targetTouches[0].clientX,
                        y: e.targetTouches[0].clientY
                    };
                    // mouse event
                    return {
                        x: e.clientX,
                        y: e.clientY
                    };
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Timepicker;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Timepicker;
    }(Component);
    Timepicker._template = [
        '<div class= "modal timepicker-modal">',
        '<div class="modal-content timepicker-container">',
        '<div class="timepicker-digital-display">',
        '<div class="timepicker-text-container">',
        '<div class="timepicker-display-column">',
        '<span class="timepicker-span-hours text-primary"></span>',
        ':',
        '<span class="timepicker-span-minutes"></span>',
        '</div>',
        '<div class="timepicker-display-column timepicker-display-am-pm">',
        '<div class="timepicker-span-am-pm"></div>',
        '</div>',
        '</div>',
        '</div>',
        '<div class="timepicker-analog-display">',
        '<div class="timepicker-plate">',
        '<div class="timepicker-canvas"></div>',
        '<div class="timepicker-dial timepicker-hours"></div>',
        '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>',
        '</div>',
        '<div class="timepicker-footer"></div>',
        '</div>',
        '</div>',
        '</div>'
    ].join('');
    M.Timepicker = Timepicker;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
})(cash);
(function($1) {
    'use strict';
    var _defaults = {};
    /**
   * @class
   *
   */ var CharacterCounter = function(_Component17) {
        _inherits(CharacterCounter, _Component17);
        /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function CharacterCounter(el, options) {
            _classCallCheck(this, CharacterCounter);
            var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));
            _this61.el.M_CharacterCounter = _this61;
            /**
       * Options for the character counter
       */ _this61.options = $1.extend({}, CharacterCounter.defaults, options);
            _this61.isInvalid = false;
            _this61.isValidLength = false;
            _this61._setupCounter();
            _this61._setupEventHandlers();
            return _this61;
        }
        _createClass(CharacterCounter, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.CharacterCounter = undefined;
                    this._removeCounter();
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleUpdateCounterBound = this.updateCounter.bind(this);
                    this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
                    this.el.addEventListener('input', this._handleUpdateCounterBound, true);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
                    this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
                }
            },
            {
                key: "_setupCounter",
                value: function _setupCounter() {
                    this.counterEl = document.createElement('span');
                    $1(this.counterEl).addClass('character-counter').css({
                        float: 'right',
                        'font-size': '12px',
                        height: 1
                    });
                    this.$el.parent().append(this.counterEl);
                }
            },
            {
                key: "_removeCounter",
                value: function _removeCounter() {
                    $1(this.counterEl).remove();
                }
            },
            {
                key: "updateCounter",
                value: function updateCounter() {
                    var maxLength = +this.$el.attr('data-length'), actualLength = this.el.value.length;
                    this.isValidLength = actualLength <= maxLength;
                    var counterString = actualLength;
                    if (maxLength) {
                        counterString += '/' + maxLength;
                        this._validateInput();
                    }
                    $1(this.counterEl).html(counterString);
                }
            },
            {
                key: "_validateInput",
                value: function _validateInput() {
                    if (this.isValidLength && this.isInvalid) {
                        this.isInvalid = false;
                        this.$el.removeClass('invalid');
                    } else if (!this.isValidLength && !this.isInvalid) {
                        this.isInvalid = true;
                        this.$el.removeClass('valid');
                        this.$el.addClass('invalid');
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_CharacterCounter;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return CharacterCounter;
    }(Component);
    M.CharacterCounter = CharacterCounter;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
})(cash);
(function($1) {
    'use strict';
    var _defaults = {
        duration: 200,
        dist: -100,
        shift: 0,
        padding: 0,
        numVisible: 5,
        fullWidth: false,
        indicators: false,
        noWrap: false,
        onCycleTo: null // Callback for when a new slide is cycled to.
    };
    /**
   * @class
   *
   */ var Carousel = function(_Component18) {
        _inherits(Carousel, _Component18);
        /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Carousel(el, options) {
            _classCallCheck(this, Carousel);
            var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));
            _this62.el.M_Carousel = _this62;
            /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */ _this62.options = $1.extend({}, Carousel.defaults, options);
            // Setup
            _this62.hasMultipleSlides = _this62.$el.find('.carousel-item').length > 1;
            _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
            _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
            _this62.pressed = false;
            _this62.dragged = false;
            _this62.offset = _this62.target = 0;
            _this62.images = [];
            _this62.itemWidth = _this62.$el.find('.carousel-item').first().innerWidth();
            _this62.itemHeight = _this62.$el.find('.carousel-item').first().innerHeight();
            _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
            _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
            _this62._trackBound = _this62._track.bind(_this62);
            // Full Width carousel setup
            if (_this62.options.fullWidth) {
                _this62.options.dist = 0;
                _this62._setCarouselHeight();
                // Offset fixed items when indicators.
                if (_this62.showIndicators) _this62.$el.find('.carousel-fixed-item').addClass('with-indicators');
            }
            // Iterate through slides
            _this62.$indicators = $1('<ul class="indicators"></ul>');
            _this62.$el.find('.carousel-item').each(function(el, i) {
                _this62.images.push(el);
                if (_this62.showIndicators) {
                    var $indicator = $1('<li class="indicator-item"></li>');
                    // Add active to first by default.
                    if (i === 0) $indicator[0].classList.add('active');
                    _this62.$indicators.append($indicator);
                }
            });
            if (_this62.showIndicators) _this62.$el.append(_this62.$indicators);
            _this62.count = _this62.images.length;
            // Cap numVisible at count
            _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);
            // Setup cross browser string
            _this62.xform = 'transform';
            [
                'webkit',
                'Moz',
                'O',
                'ms'
            ].every(function(prefix) {
                var e = prefix + 'Transform';
                if (typeof document.body.style[e] !== 'undefined') {
                    _this62.xform = e;
                    return false;
                }
                return true;
            });
            _this62._setupEventHandlers();
            _this62._scroll(_this62.offset);
            return _this62;
        }
        _createClass(Carousel, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Carousel = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this63 = this;
                    this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
                    this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
                    this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
                    this._handleCarouselClickBound = this._handleCarouselClick.bind(this);
                    if (typeof window.ontouchstart !== 'undefined') {
                        this.el.addEventListener('touchstart', this._handleCarouselTapBound);
                        this.el.addEventListener('touchmove', this._handleCarouselDragBound);
                        this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
                    }
                    this.el.addEventListener('mousedown', this._handleCarouselTapBound);
                    this.el.addEventListener('mousemove', this._handleCarouselDragBound);
                    this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
                    this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
                    this.el.addEventListener('click', this._handleCarouselClickBound);
                    if (this.showIndicators && this.$indicators) {
                        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
                        this.$indicators.find('.indicator-item').each(function(el, i) {
                            el.addEventListener('click', _this63._handleIndicatorClickBound);
                        });
                    }
                    // Resize
                    var throttledResize = M.throttle(this._handleResize, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    window.addEventListener('resize', this._handleThrottledResizeBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this64 = this;
                    if (typeof window.ontouchstart !== 'undefined') {
                        this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
                        this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
                        this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
                    }
                    this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
                    this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
                    this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
                    this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
                    this.el.removeEventListener('click', this._handleCarouselClickBound);
                    if (this.showIndicators && this.$indicators) this.$indicators.find('.indicator-item').each(function(el, i) {
                        el.removeEventListener('click', _this64._handleIndicatorClickBound);
                    });
                    window.removeEventListener('resize', this._handleThrottledResizeBound);
                }
            },
            {
                key: "_handleCarouselTap",
                value: function _handleCarouselTap(e) {
                    // Fixes firefox draggable image bug
                    if (e.type === 'mousedown' && $1(e.target).is('img')) e.preventDefault();
                    this.pressed = true;
                    this.dragged = false;
                    this.verticalDragged = false;
                    this.reference = this._xpos(e);
                    this.referenceY = this._ypos(e);
                    this.velocity = this.amplitude = 0;
                    this.frame = this.offset;
                    this.timestamp = Date.now();
                    clearInterval(this.ticker);
                    this.ticker = setInterval(this._trackBound, 100);
                }
            },
            {
                key: "_handleCarouselDrag",
                value: function _handleCarouselDrag(e) {
                    var x = void 0, y = void 0, delta = void 0, deltaY = void 0;
                    if (this.pressed) {
                        x = this._xpos(e);
                        y = this._ypos(e);
                        delta = this.reference - x;
                        deltaY = Math.abs(this.referenceY - y);
                        if (deltaY < 30 && !this.verticalDragged) // If vertical scrolling don't allow dragging.
                        {
                            if (delta > 2 || delta < -2) {
                                this.dragged = true;
                                this.reference = x;
                                this._scroll(this.offset + delta);
                            }
                        } else if (this.dragged) {
                            // If dragging don't allow vertical scroll.
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        } else // Vertical scrolling.
                        this.verticalDragged = true;
                    }
                    if (this.dragged) {
                        // If dragging don't allow vertical scroll.
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }
            },
            {
                key: "_handleCarouselRelease",
                value: function _handleCarouselRelease(e) {
                    if (this.pressed) this.pressed = false;
                    else return;
                    clearInterval(this.ticker);
                    this.target = this.offset;
                    if (this.velocity > 10 || this.velocity < -10) {
                        this.amplitude = 0.9 * this.velocity;
                        this.target = this.offset + this.amplitude;
                    }
                    this.target = Math.round(this.target / this.dim) * this.dim;
                    // No wrap of items.
                    if (this.noWrap) {
                        if (this.target >= this.dim * (this.count - 1)) this.target = this.dim * (this.count - 1);
                        else if (this.target < 0) this.target = 0;
                    }
                    this.amplitude = this.target - this.offset;
                    this.timestamp = Date.now();
                    requestAnimationFrame(this._autoScrollBound);
                    if (this.dragged) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    return false;
                }
            },
            {
                key: "_handleCarouselClick",
                value: function _handleCarouselClick(e) {
                    // Disable clicks if carousel was dragged.
                    if (this.dragged) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    } else if (!this.options.fullWidth) {
                        var clickedIndex = $1(e.target).closest('.carousel-item').index();
                        var diff = this._wrap(this.center) - clickedIndex;
                        // Disable clicks if carousel was shifted by click
                        if (diff !== 0) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        this._cycleTo(clickedIndex);
                    }
                }
            },
            {
                key: "_handleIndicatorClick",
                value: function _handleIndicatorClick(e) {
                    e.stopPropagation();
                    var indicator = $1(e.target).closest('.indicator-item');
                    if (indicator.length) this._cycleTo(indicator.index());
                }
            },
            {
                key: "_handleResize",
                value: function _handleResize(e) {
                    if (this.options.fullWidth) {
                        this.itemWidth = this.$el.find('.carousel-item').first().innerWidth();
                        this.imageHeight = this.$el.find('.carousel-item.active').height();
                        this.dim = this.itemWidth * 2 + this.options.padding;
                        this.offset = this.center * 2 * this.itemWidth;
                        this.target = this.offset;
                        this._setCarouselHeight(true);
                    } else this._scroll();
                }
            },
            {
                key: "_setCarouselHeight",
                value: function _setCarouselHeight(imageOnly) {
                    var _this65 = this;
                    var firstSlide = this.$el.find('.carousel-item.active').length ? this.$el.find('.carousel-item.active').first() : this.$el.find('.carousel-item').first();
                    var firstImage = firstSlide.find('img').first();
                    if (firstImage.length) {
                        if (firstImage[0].complete) {
                            // If image won't trigger the load event
                            var imageHeight = firstImage.height();
                            if (imageHeight > 0) this.$el.css('height', imageHeight + 'px');
                            else {
                                // If image still has no height, use the natural dimensions to calculate
                                var naturalWidth = firstImage[0].naturalWidth;
                                var naturalHeight = firstImage[0].naturalHeight;
                                var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
                                this.$el.css('height', adjustedHeight + 'px');
                            }
                        } else // Get height when image is loaded normally
                        firstImage.one('load', function(el, i) {
                            _this65.$el.css('height', el.offsetHeight + 'px');
                        });
                    } else if (!imageOnly) {
                        var slideHeight = firstSlide.height();
                        this.$el.css('height', slideHeight + 'px');
                    }
                }
            },
            {
                key: "_xpos",
                value: function _xpos(e) {
                    // touch event
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientX;
                    // mouse event
                    return e.clientX;
                }
            },
            {
                key: "_ypos",
                value: function _ypos(e) {
                    // touch event
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientY;
                    // mouse event
                    return e.clientY;
                }
            },
            {
                key: "_wrap",
                value: function _wrap(x) {
                    return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
                }
            },
            {
                key: "_track",
                value: function _track() {
                    var now = void 0, elapsed = void 0, delta = void 0, v = void 0;
                    now = Date.now();
                    elapsed = now - this.timestamp;
                    this.timestamp = now;
                    delta = this.offset - this.frame;
                    this.frame = this.offset;
                    v = 1000 * delta / (1 + elapsed);
                    this.velocity = 0.8 * v + 0.2 * this.velocity;
                }
            },
            {
                key: "_autoScroll",
                value: function _autoScroll() {
                    var elapsed = void 0, delta = void 0;
                    if (this.amplitude) {
                        elapsed = Date.now() - this.timestamp;
                        delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
                        if (delta > 2 || delta < -2) {
                            this._scroll(this.target - delta);
                            requestAnimationFrame(this._autoScrollBound);
                        } else this._scroll(this.target);
                    }
                }
            },
            {
                key: "_scroll",
                value: function _scroll(x) {
                    var _this66 = this;
                    // Track scrolling state
                    if (!this.$el.hasClass('scrolling')) this.el.classList.add('scrolling');
                    if (this.scrollingTimeout != null) window.clearTimeout(this.scrollingTimeout);
                    this.scrollingTimeout = window.setTimeout(function() {
                        _this66.$el.removeClass('scrolling');
                    }, this.options.duration);
                    // Start actual scroll
                    var i = void 0, half = void 0, delta = void 0, dir = void 0, tween = void 0, el = void 0, alignment = void 0, zTranslation = void 0, tweenedOpacity = void 0, centerTweenedOpacity = void 0;
                    var lastCenter = this.center;
                    var numVisibleOffset = 1 / this.options.numVisible;
                    this.offset = typeof x === 'number' ? x : this.offset;
                    this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
                    delta = this.offset - this.center * this.dim;
                    dir = delta < 0 ? 1 : -1;
                    tween = -dir * delta * 2 / this.dim;
                    half = this.count >> 1;
                    if (this.options.fullWidth) {
                        alignment = 'translateX(0)';
                        centerTweenedOpacity = 1;
                    } else {
                        alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
                        alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
                        centerTweenedOpacity = 1 - numVisibleOffset * tween;
                    }
                    // Set indicator active
                    if (this.showIndicators) {
                        var diff = this.center % this.count;
                        var activeIndicator = this.$indicators.find('.indicator-item.active');
                        if (activeIndicator.index() !== diff) {
                            activeIndicator.removeClass('active');
                            this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
                        }
                    }
                    // center
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center >= 0 && this.center < this.count) {
                        el = this.images[this._wrap(this.center)];
                        // Add active class to center item.
                        if (!$1(el).hasClass('active')) {
                            this.$el.find('.carousel-item').removeClass('active');
                            el.classList.add('active');
                        }
                        var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
                        this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
                    }
                    for(i = 1; i <= half; ++i){
                        // right side
                        if (this.options.fullWidth) {
                            zTranslation = this.options.dist;
                            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
                        } else {
                            zTranslation = this.options.dist * (i * 2 + tween * dir);
                            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
                        }
                        // Don't show wrapped items.
                        if (!this.noWrap || this.center + i < this.count) {
                            el = this.images[this._wrap(this.center + i)];
                            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
                            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
                        }
                        // left side
                        if (this.options.fullWidth) {
                            zTranslation = this.options.dist;
                            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
                        } else {
                            zTranslation = this.options.dist * (i * 2 - tween * dir);
                            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
                        }
                        // Don't show wrapped items.
                        if (!this.noWrap || this.center - i >= 0) {
                            el = this.images[this._wrap(this.center - i)];
                            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
                            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
                        }
                    }
                    // center
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center >= 0 && this.center < this.count) {
                        el = this.images[this._wrap(this.center)];
                        var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
                        this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
                    }
                    // onCycleTo callback
                    var $currItem = this.$el.find('.carousel-item').eq(this._wrap(this.center));
                    if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') this.options.onCycleTo.call(this, $currItem[0], this.dragged);
                    // One time callback
                    if (typeof this.oneTimeCallback === 'function') {
                        this.oneTimeCallback.call(this, $currItem[0], this.dragged);
                        this.oneTimeCallback = null;
                    }
                }
            },
            {
                key: "_updateItemStyle",
                value: function _updateItemStyle(el, opacity, zIndex, transform) {
                    el.style[this.xform] = transform;
                    el.style.zIndex = zIndex;
                    el.style.opacity = opacity;
                    el.style.visibility = 'visible';
                }
            },
            {
                key: "_cycleTo",
                value: function _cycleTo(n, callback) {
                    var diff = this.center % this.count - n;
                    // Account for wraparound.
                    if (!this.noWrap) {
                        if (diff < 0) {
                            if (Math.abs(diff + this.count) < Math.abs(diff)) diff += this.count;
                        } else if (diff > 0) {
                            if (Math.abs(diff - this.count) < diff) diff -= this.count;
                        }
                    }
                    this.target = this.dim * Math.round(this.offset / this.dim);
                    // Next
                    if (diff < 0) this.target += this.dim * Math.abs(diff);
                    else if (diff > 0) this.target -= this.dim * diff;
                    // Set one time callback
                    if (typeof callback === 'function') this.oneTimeCallback = callback;
                    // Scroll
                    if (this.offset !== this.target) {
                        this.amplitude = this.target - this.offset;
                        this.timestamp = Date.now();
                        requestAnimationFrame(this._autoScrollBound);
                    }
                }
            },
            {
                key: "next",
                value: function next(n) {
                    if (n === undefined || isNaN(n)) n = 1;
                    var index = this.center + n;
                    if (index >= this.count || index < 0) {
                        if (this.noWrap) return;
                        index = this._wrap(index);
                    }
                    this._cycleTo(index);
                }
            },
            {
                key: "prev",
                value: function prev(n) {
                    if (n === undefined || isNaN(n)) n = 1;
                    var index = this.center - n;
                    if (index >= this.count || index < 0) {
                        if (this.noWrap) return;
                        index = this._wrap(index);
                    }
                    this._cycleTo(index);
                }
            },
            {
                key: "set",
                value: function set(n, callback) {
                    if (n === undefined || isNaN(n)) n = 0;
                    if (n > this.count || n < 0) {
                        if (this.noWrap) return;
                        n = this._wrap(n);
                    }
                    this._cycleTo(n, callback);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Carousel;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Carousel;
    }(Component);
    M.Carousel = Carousel;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
})(cash);
(function($1) {
    'use strict';
    var _defaults = {
        onOpen: undefined,
        onClose: undefined
    };
    /**
   * @class
   *
   */ var TapTarget = function(_Component19) {
        _inherits(TapTarget, _Component19);
        /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function TapTarget(el, options) {
            _classCallCheck(this, TapTarget);
            var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));
            _this67.el.M_TapTarget = _this67;
            /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */ _this67.options = $1.extend({}, TapTarget.defaults, options);
            _this67.isOpen = false;
            // setup
            _this67.$origin = $1('#' + _this67.$el.attr('data-target'));
            _this67._setup();
            _this67._calculatePositioning();
            _this67._setupEventHandlers();
            return _this67;
        }
        _createClass(TapTarget, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.TapTarget = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
                    this._handleTargetClickBound = this._handleTargetClick.bind(this);
                    this._handleOriginClickBound = this._handleOriginClick.bind(this);
                    this.el.addEventListener('click', this._handleTargetClickBound);
                    this.originEl.addEventListener('click', this._handleOriginClickBound);
                    // Resize
                    var throttledResize = M.throttle(this._handleResize, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    window.addEventListener('resize', this._handleThrottledResizeBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('click', this._handleTargetClickBound);
                    this.originEl.removeEventListener('click', this._handleOriginClickBound);
                    window.removeEventListener('resize', this._handleThrottledResizeBound);
                }
            },
            {
                key: "_handleTargetClick",
                value: function _handleTargetClick(e) {
                    this.open();
                }
            },
            {
                key: "_handleOriginClick",
                value: function _handleOriginClick(e) {
                    this.close();
                }
            },
            {
                key: "_handleResize",
                value: function _handleResize(e) {
                    this._calculatePositioning();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    if (!$1(e.target).closest('.tap-target-wrapper').length) {
                        this.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            },
            {
                key: "_setup",
                value: function _setup() {
                    // Creating tap target
                    this.wrapper = this.$el.parent()[0];
                    this.waveEl = $1(this.wrapper).find('.tap-target-wave')[0];
                    this.originEl = $1(this.wrapper).find('.tap-target-origin')[0];
                    this.contentEl = this.$el.find('.tap-target-content')[0];
                    // Creating wrapper
                    if (!$1(this.wrapper).hasClass('.tap-target-wrapper')) {
                        this.wrapper = document.createElement('div');
                        this.wrapper.classList.add('tap-target-wrapper');
                        this.$el.before($1(this.wrapper));
                        this.wrapper.append(this.el);
                    }
                    // Creating content
                    if (!this.contentEl) {
                        this.contentEl = document.createElement('div');
                        this.contentEl.classList.add('tap-target-content');
                        this.$el.append(this.contentEl);
                    }
                    // Creating foreground wave
                    if (!this.waveEl) {
                        this.waveEl = document.createElement('div');
                        this.waveEl.classList.add('tap-target-wave');
                        // Creating origin
                        if (!this.originEl) {
                            this.originEl = this.$origin.clone(true, true);
                            this.originEl.addClass('tap-target-origin');
                            this.originEl.removeAttr('id');
                            this.originEl.removeAttr('style');
                            this.originEl = this.originEl[0];
                            this.waveEl.append(this.originEl);
                        }
                        this.wrapper.append(this.waveEl);
                    }
                }
            },
            {
                key: "_calculatePositioning",
                value: function _calculatePositioning() {
                    // Element or parent is fixed position?
                    var isFixed = this.$origin.css('position') === 'fixed';
                    if (!isFixed) {
                        var parents = this.$origin.parents();
                        for(var i = 0; i < parents.length; i++){
                            isFixed = $1(parents[i]).css('position') == 'fixed';
                            if (isFixed) break;
                        }
                    }
                    // Calculating origin
                    var originWidth = this.$origin.outerWidth();
                    var originHeight = this.$origin.outerHeight();
                    var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
                    var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;
                    // Calculating screen
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var centerX = windowWidth / 2;
                    var centerY = windowHeight / 2;
                    var isLeft = originLeft <= centerX;
                    var isRight = originLeft > centerX;
                    var isTop = originTop <= centerY;
                    var isBottom = originTop > centerY;
                    var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;
                    // Calculating tap target
                    var tapTargetWidth = this.$el.outerWidth();
                    var tapTargetHeight = this.$el.outerHeight();
                    var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
                    var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
                    var tapTargetPosition = isFixed ? 'fixed' : 'absolute';
                    // Calculating content
                    var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
                    var tapTargetTextHeight = tapTargetHeight / 2;
                    var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
                    var tapTargetTextBottom = 0;
                    var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
                    var tapTargetTextRight = 0;
                    var tapTargetTextPadding = originWidth;
                    var tapTargetTextAlign = isBottom ? 'bottom' : 'top';
                    // Calculating wave
                    var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
                    var tapTargetWaveHeight = tapTargetWaveWidth;
                    var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
                    var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;
                    // Setting tap target
                    var tapTargetWrapperCssObj = {};
                    tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
                    tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
                    tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
                    tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
                    tapTargetWrapperCssObj.position = tapTargetPosition;
                    $1(this.wrapper).css(tapTargetWrapperCssObj);
                    // Setting content
                    $1(this.contentEl).css({
                        width: tapTargetTextWidth + 'px',
                        height: tapTargetTextHeight + 'px',
                        top: tapTargetTextTop + 'px',
                        right: tapTargetTextRight + 'px',
                        bottom: tapTargetTextBottom + 'px',
                        left: tapTargetTextLeft + 'px',
                        padding: tapTargetTextPadding + 'px',
                        verticalAlign: tapTargetTextAlign
                    });
                    // Setting wave
                    $1(this.waveEl).css({
                        top: tapTargetWaveTop + 'px',
                        left: tapTargetWaveLeft + 'px',
                        width: tapTargetWaveWidth + 'px',
                        height: tapTargetWaveHeight + 'px'
                    });
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    // onOpen callback
                    if (typeof this.options.onOpen === 'function') this.options.onOpen.call(this, this.$origin[0]);
                    this.isOpen = true;
                    this.wrapper.classList.add('open');
                    document.body.addEventListener('click', this._handleDocumentClickBound, true);
                    document.body.addEventListener('touchend', this._handleDocumentClickBound);
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    // onClose callback
                    if (typeof this.options.onClose === 'function') this.options.onClose.call(this, this.$origin[0]);
                    this.isOpen = false;
                    this.wrapper.classList.remove('open');
                    document.body.removeEventListener('click', this._handleDocumentClickBound, true);
                    document.body.removeEventListener('touchend', this._handleDocumentClickBound);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_TapTarget;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return TapTarget;
    }(Component);
    M.TapTarget = TapTarget;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
})(cash);
(function($1) {
    'use strict';
    var _defaults = {
        classes: '',
        dropdownOptions: {}
    };
    /**
   * @class
   *
   */ var FormSelect = function(_Component20) {
        _inherits(FormSelect, _Component20);
        /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function FormSelect(el, options) {
            _classCallCheck(this, FormSelect);
            // Don't init if browser default version
            var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));
            if (_this68.$el.hasClass('browser-default')) return _possibleConstructorReturn(_this68);
            _this68.el.M_FormSelect = _this68;
            /**
       * Options for the select
       * @member FormSelect#options
       */ _this68.options = $1.extend({}, FormSelect.defaults, options);
            _this68.isMultiple = _this68.$el.prop('multiple');
            // Setup
            _this68.el.tabIndex = -1;
            _this68._keysSelected = {};
            _this68._valueDict = {}; // Maps key to original and generated option element.
            _this68._setupDropdown();
            _this68._setupEventHandlers();
            return _this68;
        }
        _createClass(FormSelect, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeDropdown();
                    this.el.M_FormSelect = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this69 = this;
                    this._handleSelectChangeBound = this._handleSelectChange.bind(this);
                    this._handleOptionClickBound = this._handleOptionClick.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    $1(this.dropdownOptions).find('li:not(.optgroup)').each(function(el) {
                        el.addEventListener('click', _this69._handleOptionClickBound);
                    });
                    this.el.addEventListener('change', this._handleSelectChangeBound);
                    this.input.addEventListener('click', this._handleInputClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this70 = this;
                    $1(this.dropdownOptions).find('li:not(.optgroup)').each(function(el) {
                        el.removeEventListener('click', _this70._handleOptionClickBound);
                    });
                    this.el.removeEventListener('change', this._handleSelectChangeBound);
                    this.input.removeEventListener('click', this._handleInputClickBound);
                }
            },
            {
                key: "_handleSelectChange",
                value: function _handleSelectChange(e) {
                    this._setValueToInput();
                }
            },
            {
                key: "_handleOptionClick",
                value: function _handleOptionClick(e) {
                    e.preventDefault();
                    var option = $1(e.target).closest('li')[0];
                    var key = option.id;
                    if (!$1(option).hasClass('disabled') && !$1(option).hasClass('optgroup') && key.length) {
                        var selected = true;
                        if (this.isMultiple) {
                            // Deselect placeholder option if still selected.
                            var placeholderOption = $1(this.dropdownOptions).find('li.disabled.selected');
                            if (placeholderOption.length) {
                                placeholderOption.removeClass('selected');
                                placeholderOption.find('input[type="checkbox"]').prop('checked', false);
                                this._toggleEntryFromArray(placeholderOption[0].id);
                            }
                            selected = this._toggleEntryFromArray(key);
                        } else {
                            $1(this.dropdownOptions).find('li').removeClass('selected');
                            $1(option).toggleClass('selected', selected);
                        }
                        // Set selected on original select option
                        // Only trigger if selected state changed
                        var prevSelected = $1(this._valueDict[key].el).prop('selected');
                        if (prevSelected !== selected) {
                            $1(this._valueDict[key].el).prop('selected', selected);
                            this.$el.trigger('change');
                        }
                    }
                    e.stopPropagation();
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    if (this.dropdown && this.dropdown.isOpen) {
                        this._setValueToInput();
                        this._setSelectedStates();
                    }
                }
            },
            {
                key: "_setupDropdown",
                value: function _setupDropdown() {
                    var _this71 = this;
                    this.wrapper = document.createElement('div');
                    $1(this.wrapper).addClass('select-wrapper ' + this.options.classes);
                    this.$el.before($1(this.wrapper));
                    this.wrapper.appendChild(this.el);
                    if (this.el.disabled) this.wrapper.classList.add('disabled');
                    // Create dropdown
                    this.$selectOptions = this.$el.children('option, optgroup');
                    this.dropdownOptions = document.createElement('ul');
                    this.dropdownOptions.id = "select-options-" + M.guid();
                    $1(this.dropdownOptions).addClass('dropdown-content select-dropdown ' + (this.isMultiple ? 'multiple-select-dropdown' : ''));
                    // Create dropdown structure.
                    if (this.$selectOptions.length) this.$selectOptions.each(function(el) {
                        if ($1(el).is('option')) {
                            // Direct descendant option.
                            var optionEl = void 0;
                            if (_this71.isMultiple) optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
                            else optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
                            _this71._addOptionToValueDict(el, optionEl);
                        } else if ($1(el).is('optgroup')) {
                            // Optgroup.
                            var selectOptions = $1(el).children('option');
                            $1(_this71.dropdownOptions).append($1('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);
                            selectOptions.each(function(el) {
                                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'optgroup-option');
                                _this71._addOptionToValueDict(el, optionEl);
                            });
                        }
                    });
                    this.$el.after(this.dropdownOptions);
                    // Add input dropdown
                    this.input = document.createElement('input');
                    $1(this.input).addClass('select-dropdown dropdown-trigger');
                    this.input.setAttribute('type', 'text');
                    this.input.setAttribute('readonly', 'true');
                    this.input.setAttribute('data-target', this.dropdownOptions.id);
                    if (this.el.disabled) $1(this.input).prop('disabled', 'true');
                    this.$el.before(this.input);
                    this._setValueToInput();
                    // Add caret
                    var dropdownIcon = $1('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
                    this.$el.before(dropdownIcon[0]);
                    // Initialize dropdown
                    if (!this.el.disabled) {
                        var dropdownOptions = $1.extend({}, this.options.dropdownOptions);
                        // Add callback for centering selected option when dropdown content is scrollable
                        dropdownOptions.onOpenEnd = function(el) {
                            var selectedOption = $1(_this71.dropdownOptions).find('.selected').first();
                            if (selectedOption.length) {
                                // Focus selected option in dropdown
                                M.keyDown = true;
                                _this71.dropdown.focusedIndex = selectedOption.index();
                                _this71.dropdown._focusFocusedItem();
                                M.keyDown = false;
                                // Handle scrolling to selected option
                                if (_this71.dropdown.isScrollable) {
                                    var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
                                    scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
                                    _this71.dropdownOptions.scrollTop = scrollOffset;
                                }
                            }
                        };
                        if (this.isMultiple) dropdownOptions.closeOnClick = false;
                        this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
                    }
                    // Add initial selections
                    this._setSelectedStates();
                }
            },
            {
                key: "_addOptionToValueDict",
                value: function _addOptionToValueDict(el, optionEl) {
                    var index = Object.keys(this._valueDict).length;
                    var key = this.dropdownOptions.id + index;
                    var obj = {};
                    optionEl.id = key;
                    obj.el = el;
                    obj.optionEl = optionEl;
                    this._valueDict[key] = obj;
                }
            },
            {
                key: "_removeDropdown",
                value: function _removeDropdown() {
                    $1(this.wrapper).find('.caret').remove();
                    $1(this.input).remove();
                    $1(this.dropdownOptions).remove();
                    $1(this.wrapper).before(this.$el);
                    $1(this.wrapper).remove();
                }
            },
            {
                key: "_appendOptionWithIcon",
                value: function _appendOptionWithIcon(select, option, type) {
                    // Add disabled attr if disabled
                    var disabledClass = option.disabled ? 'disabled ' : '';
                    var optgroupClass = type === 'optgroup-option' ? 'optgroup-option ' : '';
                    var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + disabledClass + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
                    var liEl = $1('<li></li>');
                    var spanEl = $1('<span></span>');
                    spanEl.html(multipleCheckbox);
                    liEl.addClass(disabledClass + " " + optgroupClass);
                    liEl.append(spanEl);
                    // add icons
                    var iconUrl = option.getAttribute('data-icon');
                    if (!!iconUrl) {
                        var imgEl = $1("<img alt=\"\" src=\"" + iconUrl + "\">");
                        liEl.prepend(imgEl);
                    }
                    // Check for multiple type.
                    $1(this.dropdownOptions).append(liEl[0]);
                    return liEl[0];
                }
            },
            {
                key: "_toggleEntryFromArray",
                value: function _toggleEntryFromArray(key) {
                    var notAdded = !this._keysSelected.hasOwnProperty(key);
                    var $optionLi = $1(this._valueDict[key].optionEl);
                    if (notAdded) this._keysSelected[key] = true;
                    else delete this._keysSelected[key];
                    $optionLi.toggleClass('selected', notAdded);
                    // Set checkbox checked value
                    $optionLi.find('input[type="checkbox"]').prop('checked', notAdded);
                    // use notAdded instead of true (to detect if the option is selected or not)
                    $optionLi.prop('selected', notAdded);
                    return notAdded;
                }
            },
            {
                key: "_setValueToInput",
                value: function _setValueToInput() {
                    var values = [];
                    var options = this.$el.find('option');
                    options.each(function(el) {
                        if ($1(el).prop('selected')) {
                            var text = $1(el).text();
                            values.push(text);
                        }
                    });
                    if (!values.length) {
                        var firstDisabled = this.$el.find('option:disabled').eq(0);
                        if (firstDisabled.length && firstDisabled[0].value === '') values.push(firstDisabled.text());
                    }
                    this.input.value = values.join(', ');
                }
            },
            {
                key: "_setSelectedStates",
                value: function _setSelectedStates() {
                    this._keysSelected = {};
                    for(var key in this._valueDict){
                        var option = this._valueDict[key];
                        var optionIsSelected = $1(option.el).prop('selected');
                        $1(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);
                        if (optionIsSelected) {
                            this._activateOption($1(this.dropdownOptions), $1(option.optionEl));
                            this._keysSelected[key] = true;
                        } else $1(option.optionEl).removeClass('selected');
                    }
                }
            },
            {
                key: "_activateOption",
                value: function _activateOption(collection, newOption) {
                    if (newOption) {
                        if (!this.isMultiple) collection.find('li.selected').removeClass('selected');
                        var option = $1(newOption);
                        option.addClass('selected');
                    }
                }
            },
            {
                key: "getSelectedValues",
                value: function getSelectedValues() {
                    var selectedValues = [];
                    for(var key in this._keysSelected)selectedValues.push(this._valueDict[key].el.value);
                    return selectedValues;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_FormSelect;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return FormSelect;
    }(Component);
    M.FormSelect = FormSelect;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
})(cash);
(function($1, anim) {
    'use strict';
    var _defaults = {};
    /**
   * @class
   *
   */ var Range = function(_Component21) {
        _inherits(Range, _Component21);
        /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Range(el, options) {
            _classCallCheck(this, Range);
            var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));
            _this72.el.M_Range = _this72;
            /**
       * Options for the range
       * @member Range#options
       */ _this72.options = $1.extend({}, Range.defaults, options);
            _this72._mousedown = false;
            // Setup
            _this72._setupThumb();
            _this72._setupEventHandlers();
            return _this72;
        }
        _createClass(Range, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeThumb();
                    this.el.M_Range = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleRangeChangeBound = this._handleRangeChange.bind(this);
                    this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
                    this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
                    this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
                    this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);
                    this.el.addEventListener('change', this._handleRangeChangeBound);
                    this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
                    this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
                    this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
                    this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);
                    this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener('change', this._handleRangeChangeBound);
                    this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
                    this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
                    this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
                    this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);
                    this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
                }
            },
            {
                key: "_handleRangeChange",
                value: function _handleRangeChange() {
                    $1(this.value).html(this.$el.val());
                    if (!$1(this.thumb).hasClass('active')) this._showRangeBubble();
                    var offsetLeft = this._calcRangeOffset();
                    $1(this.thumb).addClass('active').css('left', offsetLeft + 'px');
                }
            },
            {
                key: "_handleRangeMousedownTouchstart",
                value: function _handleRangeMousedownTouchstart(e) {
                    // Set indicator value
                    $1(this.value).html(this.$el.val());
                    this._mousedown = true;
                    this.$el.addClass('active');
                    if (!$1(this.thumb).hasClass('active')) this._showRangeBubble();
                    if (e.type !== 'input') {
                        var offsetLeft = this._calcRangeOffset();
                        $1(this.thumb).addClass('active').css('left', offsetLeft + 'px');
                    }
                }
            },
            {
                key: "_handleRangeInputMousemoveTouchmove",
                value: function _handleRangeInputMousemoveTouchmove() {
                    if (this._mousedown) {
                        if (!$1(this.thumb).hasClass('active')) this._showRangeBubble();
                        var offsetLeft = this._calcRangeOffset();
                        $1(this.thumb).addClass('active').css('left', offsetLeft + 'px');
                        $1(this.value).html(this.$el.val());
                    }
                }
            },
            {
                key: "_handleRangeMouseupTouchend",
                value: function _handleRangeMouseupTouchend() {
                    this._mousedown = false;
                    this.$el.removeClass('active');
                }
            },
            {
                key: "_handleRangeBlurMouseoutTouchleave",
                value: function _handleRangeBlurMouseoutTouchleave() {
                    if (!this._mousedown) {
                        var paddingLeft = parseInt(this.$el.css('padding-left'));
                        var marginLeft = 7 + paddingLeft + 'px';
                        if ($1(this.thumb).hasClass('active')) {
                            anim.remove(this.thumb);
                            anim({
                                targets: this.thumb,
                                height: 0,
                                width: 0,
                                top: 10,
                                easing: 'easeOutQuad',
                                marginLeft: marginLeft,
                                duration: 100
                            });
                        }
                        $1(this.thumb).removeClass('active');
                    }
                }
            },
            {
                key: "_setupThumb",
                value: function _setupThumb() {
                    this.thumb = document.createElement('span');
                    this.value = document.createElement('span');
                    $1(this.thumb).addClass('thumb');
                    $1(this.value).addClass('value');
                    $1(this.thumb).append(this.value);
                    this.$el.after(this.thumb);
                }
            },
            {
                key: "_removeThumb",
                value: function _removeThumb() {
                    $1(this.thumb).remove();
                }
            },
            {
                key: "_showRangeBubble",
                value: function _showRangeBubble() {
                    var paddingLeft = parseInt($1(this.thumb).parent().css('padding-left'));
                    var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?
                    anim.remove(this.thumb);
                    anim({
                        targets: this.thumb,
                        height: 30,
                        width: 30,
                        top: -30,
                        marginLeft: marginLeft,
                        duration: 300,
                        easing: 'easeOutQuint'
                    });
                }
            },
            {
                key: "_calcRangeOffset",
                value: function _calcRangeOffset() {
                    var width = this.$el.width() - 15;
                    var max = parseFloat(this.$el.attr('max')) || 100; // Range default max
                    var min = parseFloat(this.$el.attr('min')) || 0; // Range default min
                    var percent = (parseFloat(this.$el.val()) - min) / (max - min);
                    return percent * width;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Range;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Range;
    }(Component);
    M.Range = Range;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Range, 'range', 'M_Range');
    Range.init($1('input[type=range]'));
})(cash, M.anime);

});



var $6PK7Y = parcelRequire("6PK7Y");


var $1adec76eab5629a7$exports = {};
/*!
 * fullPage 3.1.2
 * https://github.com/alvarotrigo/fullPage.js
 *
 * @license GPLv3 for open source use only
 * or Fullpage Commercial License for commercial use
 * http://alvarotrigo.com/fullPage/pricing/
 *
 * Copyright (C) 2018 http://alvarotrigo.com/fullPage - A project by Alvaro Trigo
 */ (function(root, window1, document1, factory, undefined1) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        root.fullpage = factory(window1, document1);
        return root.fullpage;
    });
    else // Node. Does not work with strict CommonJS.
    $1adec76eab5629a7$exports = factory(window1, document1);
})($1adec76eab5629a7$exports, window, document, function(window1, document1) {
    'use strict';
    // keeping central set of classnames and selectors
    var WRAPPER = 'fullpage-wrapper';
    var WRAPPER_SEL = '.' + WRAPPER;
    // slimscroll
    var SCROLLABLE = 'fp-scrollable';
    var SCROLLABLE_SEL = '.' + SCROLLABLE;
    // util
    var RESPONSIVE = 'fp-responsive';
    var NO_TRANSITION = 'fp-notransition';
    var DESTROYED = 'fp-destroyed';
    var ENABLED = 'fp-enabled';
    var VIEWING_PREFIX = 'fp-viewing';
    var ACTIVE = 'active';
    var ACTIVE_SEL = '.' + ACTIVE;
    var COMPLETELY = 'fp-completely';
    var COMPLETELY_SEL = '.' + COMPLETELY;
    // section
    var SECTION_DEFAULT_SEL = '.section';
    var SECTION = 'fp-section';
    var SECTION_SEL = '.' + SECTION;
    var SECTION_ACTIVE_SEL = SECTION_SEL + ACTIVE_SEL;
    var TABLE_CELL = 'fp-tableCell';
    var TABLE_CELL_SEL = '.' + TABLE_CELL;
    var AUTO_HEIGHT = 'fp-auto-height';
    var AUTO_HEIGHT_SEL = '.' + AUTO_HEIGHT;
    var AUTO_HEIGHT_RESPONSIVE = 'fp-auto-height-responsive';
    var AUTO_HEIGHT_RESPONSIVE_SEL = '.' + AUTO_HEIGHT_RESPONSIVE;
    var NORMAL_SCROLL = 'fp-normal-scroll';
    var NORMAL_SCROLL_SEL = '.' + NORMAL_SCROLL;
    // section nav
    var SECTION_NAV = 'fp-nav';
    var SECTION_NAV_SEL = '#' + SECTION_NAV;
    var SECTION_NAV_TOOLTIP = 'fp-tooltip';
    var SECTION_NAV_TOOLTIP_SEL = '.' + SECTION_NAV_TOOLTIP;
    var SHOW_ACTIVE_TOOLTIP = 'fp-show-active';
    // slide
    var SLIDE_DEFAULT_SEL = '.slide';
    var SLIDE = 'fp-slide';
    var SLIDE_SEL = '.' + SLIDE;
    var SLIDE_ACTIVE_SEL = SLIDE_SEL + ACTIVE_SEL;
    var SLIDES_WRAPPER = 'fp-slides';
    var SLIDES_WRAPPER_SEL = '.' + SLIDES_WRAPPER;
    var SLIDES_CONTAINER = 'fp-slidesContainer';
    var SLIDES_CONTAINER_SEL = '.' + SLIDES_CONTAINER;
    var TABLE = 'fp-table';
    // slide nav
    var SLIDES_NAV = 'fp-slidesNav';
    var SLIDES_NAV_SEL = '.' + SLIDES_NAV;
    var SLIDES_NAV_LINK_SEL = SLIDES_NAV_SEL + ' a';
    var SLIDES_ARROW = 'fp-controlArrow';
    var SLIDES_ARROW_SEL = '.' + SLIDES_ARROW;
    var SLIDES_PREV = 'fp-prev';
    var SLIDES_PREV_SEL = '.' + SLIDES_PREV;
    var SLIDES_ARROW_PREV = SLIDES_ARROW + ' ' + SLIDES_PREV;
    var SLIDES_ARROW_PREV_SEL = SLIDES_ARROW_SEL + SLIDES_PREV_SEL;
    var SLIDES_NEXT = 'fp-next';
    var SLIDES_NEXT_SEL = '.' + SLIDES_NEXT;
    var SLIDES_ARROW_NEXT = SLIDES_ARROW + ' ' + SLIDES_NEXT;
    var SLIDES_ARROW_NEXT_SEL = SLIDES_ARROW_SEL + SLIDES_NEXT_SEL;
    function initialise(containerSelector, options) {
        var isOK = options && new RegExp('([\\d\\w]{8}-){3}[\\d\\w]{8}|^(?=.*?[A-Y])(?=.*?[a-y])(?=.*?[0-8])(?=.*?[#?!@$%^&*-]).{8,}$').test(options["licenseKey"]) || document1.domain.indexOf("alvarotrigo.com") > -1;
        // cache common elements
        var $htmlBody = $('html, body');
        var $html = $('html')[0];
        var $body = $('body')[0];
        //only once my friend!
        if (hasClass($html, ENABLED)) {
            displayWarnings();
            return;
        }
        var FP = {};
        // Creating some defaults, extending them with any options that were provided
        options = deepExtend({
            //navigation
            menu: false,
            anchors: [],
            lockAnchors: false,
            navigation: false,
            navigationPosition: 'right',
            navigationTooltips: [],
            showActiveTooltip: false,
            slidesNavigation: false,
            slidesNavPosition: 'bottom',
            scrollBar: false,
            hybrid: false,
            //scrolling
            css3: true,
            scrollingSpeed: 700,
            autoScrolling: true,
            fitToSection: true,
            fitToSectionDelay: 1000,
            easing: 'easeInOutCubic',
            easingcss3: 'ease',
            loopBottom: false,
            loopTop: false,
            loopHorizontal: true,
            continuousVertical: false,
            continuousHorizontal: false,
            scrollHorizontally: false,
            interlockedSlides: false,
            dragAndMove: false,
            offsetSections: false,
            resetSliders: false,
            fadingEffect: false,
            normalScrollElements: null,
            scrollOverflow: false,
            scrollOverflowReset: false,
            scrollOverflowHandler: window1.fp_scrolloverflow ? window1.fp_scrolloverflow.iscrollHandler : null,
            scrollOverflowOptions: null,
            touchSensitivity: 5,
            touchWrapper: typeof containerSelector === 'string' ? $(containerSelector)[0] : containerSelector,
            bigSectionsDestination: null,
            //Accessibility
            keyboardScrolling: true,
            animateAnchor: true,
            recordHistory: true,
            //design
            controlArrows: true,
            controlArrowColor: '#fff',
            verticalCentered: true,
            sectionsColor: [],
            paddingTop: 0,
            paddingBottom: 0,
            fixedElements: null,
            responsive: 0,
            responsiveWidth: 0,
            responsiveHeight: 0,
            responsiveSlides: false,
            parallax: false,
            parallaxOptions: {
                type: 'reveal',
                percentage: 62,
                property: 'translate'
            },
            cards: false,
            cardsOptions: {
                perspective: 100,
                fadeContent: true,
                fadeBackground: true
            },
            //Custom selectors
            sectionSelector: SECTION_DEFAULT_SEL,
            slideSelector: SLIDE_DEFAULT_SEL,
            //events
            v2compatible: false,
            afterLoad: null,
            onLeave: null,
            afterRender: null,
            afterResize: null,
            afterReBuild: null,
            afterSlideLoad: null,
            onSlideLeave: null,
            afterResponsive: null,
            lazyLoading: true
        }, options);
        //flag to avoid very fast sliding for landscape sliders
        var slideMoving = false;
        var isTouchDevice = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/);
        var isTouch = 'ontouchstart' in window1 || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints;
        var container = typeof containerSelector === 'string' ? $(containerSelector)[0] : containerSelector;
        var windowsHeight = getWindowHeight();
        var windowsWidth = getWindowWidth();
        var isResizing = false;
        var isWindowFocused = true;
        var lastScrolledDestiny;
        var lastScrolledSlide;
        var canScroll = true;
        var scrollings = [];
        var controlPressed;
        var startingSection;
        var isScrollAllowed = {};
        isScrollAllowed.m = {
            'up': true,
            'down': true,
            'left': true,
            'right': true
        };
        isScrollAllowed.k = deepExtend({}, isScrollAllowed.m);
        var MSPointer = getMSPointer();
        var events = {
            touchmove: 'ontouchmove' in window1 ? 'touchmove' : MSPointer.move,
            touchstart: 'ontouchstart' in window1 ? 'touchstart' : MSPointer.down
        };
        var scrollBarHandler;
        // taken from https://github.com/udacity/ud891/blob/gh-pages/lesson2-focus/07-modals-and-keyboard-traps/solution/modal.js
        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        //cheks for passive event support
        var g_supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    g_supportsPassive = true;
                }
            });
            window1.addEventListener("testPassive", null, opts);
            window1.removeEventListener("testPassive", null, opts);
        } catch (e) {}
        //timeouts
        var resizeId;
        var resizeHandlerId;
        var afterSectionLoadsId;
        var afterSlideLoadsId;
        var scrollId;
        var scrollId2;
        var keydownId;
        var g_doubleCheckHeightId;
        var originals = deepExtend({}, options); //deep copy
        var activeAnimation;
        var g_initialAnchorsInDom = false;
        var g_canFireMouseEnterNormalScroll = true;
        var g_mediaLoadedId;
        var g_transitionLapseId;
        var extensions = [
            'parallax',
            'scrollOverflowReset',
            'dragAndMove',
            'offsetSections',
            'fadingEffect',
            'responsiveSlides',
            'continuousHorizontal',
            'interlockedSlides',
            'scrollHorizontally',
            'resetSliders',
            'cards',
            'dropEffect',
            'waterEffect'
        ];
        displayWarnings();
        //easeInOutCubic animation included in the plugin
        window1.fp_easings = deepExtend(window1.fp_easings, {
            easeInOutCubic: function(t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
                return c / 2 * ((t -= 2) * t * t + 2) + b;
            }
        });
        /**
        * Sets the autoScroll option.
        * It changes the scroll bar visibility and the history of the site as a result.
        */ function setAutoScrolling(value, type) {
            //removing the transformation
            if (!value) silentScroll(0);
            setVariableState('autoScrolling', value, type);
            var element = $(SECTION_ACTIVE_SEL)[0];
            if (options.autoScrolling && !options.scrollBar) {
                css($htmlBody, {
                    'overflow': 'hidden',
                    'height': '100%'
                });
                setRecordHistory(originals.recordHistory, 'internal');
                //for IE touch devices
                css(container, {
                    '-ms-touch-action': 'none',
                    'touch-action': 'none'
                });
                if (element != null) //moving the container up
                silentScroll(element.offsetTop);
            } else {
                css($htmlBody, {
                    'overflow': 'visible',
                    'height': 'initial'
                });
                var recordHistory = !options.autoScrolling ? false : originals.recordHistory;
                setRecordHistory(recordHistory, 'internal');
                //for IE touch devices
                css(container, {
                    '-ms-touch-action': '',
                    'touch-action': ''
                });
                //scrolling the page to the section with no animation
                if (element != null) {
                    var scrollSettings = getScrollSettings(element.offsetTop);
                    scrollSettings.element.scrollTo(0, scrollSettings.options);
                }
            }
        }
        /**
        * Defines wheter to record the history for each hash change in the URL.
        */ function setRecordHistory(value, type) {
            setVariableState('recordHistory', value, type);
        }
        /**
        * Defines the scrolling speed
        */ function setScrollingSpeed(value, type) {
            setVariableState('scrollingSpeed', value, type);
        }
        /**
        * Sets fitToSection
        */ function setFitToSection(value, type) {
            setVariableState('fitToSection', value, type);
        }
        /**
        * Sets lockAnchors
        */ function setLockAnchors(value) {
            options.lockAnchors = value;
        }
        /**
        * Adds or remove the possibility of scrolling through sections by using the mouse wheel or the trackpad.
        */ function setMouseWheelScrolling(value) {
            if (value) {
                addMouseWheelHandler();
                addMiddleWheelHandler();
            } else {
                removeMouseWheelHandler();
                removeMiddleWheelHandler();
            }
        }
        /**
        * Adds or remove the possibility of scrolling through sections by using the mouse wheel/trackpad or touch gestures.
        * Optionally a second parameter can be used to specify the direction for which the action will be applied.
        *
        * @param directions string containing the direction or directions separated by comma.
        */ function setAllowScrolling(value, directions) {
            if (typeof directions !== 'undefined') {
                directions = directions.replace(/ /g, '').split(',');
                directions.forEach(function(direction) {
                    setIsScrollAllowed(value, direction, 'm');
                });
            } else setIsScrollAllowed(value, 'all', 'm');
        }
        /**
        * Adds or remove the mouse wheel hijacking
        */ function setMouseHijack(value) {
            if (value) {
                setMouseWheelScrolling(true);
                addTouchHandler();
            } else {
                setMouseWheelScrolling(false);
                removeTouchHandler();
            }
        }
        /**
        * Adds or remove the possibility of scrolling through sections by using the keyboard arrow keys
        */ function setKeyboardScrolling(value, directions) {
            if (typeof directions !== 'undefined') {
                directions = directions.replace(/ /g, '').split(',');
                directions.forEach(function(direction) {
                    setIsScrollAllowed(value, direction, 'k');
                });
            } else {
                setIsScrollAllowed(value, 'all', 'k');
                options.keyboardScrolling = value;
            }
        }
        /**
        * Moves the page up one section.
        */ function moveSectionUp() {
            var prev = prevUntil($(SECTION_ACTIVE_SEL)[0], SECTION_SEL);
            //looping to the bottom if there's no more sections above
            if (!prev && (options.loopTop || options.continuousVertical)) prev = last($(SECTION_SEL));
            if (prev != null) scrollPage(prev, null, true);
        }
        /**
        * Moves the page down one section.
        */ function moveSectionDown() {
            var next = nextUntil($(SECTION_ACTIVE_SEL)[0], SECTION_SEL);
            //looping to the top if there's no more sections below
            if (!next && (options.loopBottom || options.continuousVertical)) next = $(SECTION_SEL)[0];
            if (next != null) scrollPage(next, null, false);
        }
        /**
        * Moves the page to the given section and slide with no animation.
        * Anchors or index positions can be used as params.
        */ function silentMoveTo(sectionAnchor, slideAnchor) {
            setScrollingSpeed(0, 'internal');
            moveTo(sectionAnchor, slideAnchor);
            setScrollingSpeed(originals.scrollingSpeed, 'internal');
        }
        /**
        * Moves the page to the given section and slide.
        * Anchors or index positions can be used as params.
        */ function moveTo(sectionAnchor, slideAnchor) {
            var destiny = getSectionByAnchor(sectionAnchor);
            if (typeof slideAnchor !== 'undefined') scrollPageAndSlide(sectionAnchor, slideAnchor);
            else if (destiny != null) scrollPage(destiny);
        }
        /**
        * Slides right the slider of the active section.
        * Optional `section` param.
        */ function moveSlideRight(section) {
            moveSlide('right', section);
        }
        /**
        * Slides left the slider of the active section.
        * Optional `section` param.
        */ function moveSlideLeft(section) {
            moveSlide('left', section);
        }
        /**
         * When resizing is finished, we adjust the slides sizes and positions
         */ function reBuild(resizing) {
            if (hasClass(container, DESTROYED)) return;
             //nothing to do if the plugin was destroyed
            isResizing = true;
            //updating global vars
            windowsHeight = getWindowHeight();
            windowsWidth = getWindowWidth();
            var sections = $(SECTION_SEL);
            for(var i = 0; i < sections.length; ++i){
                var section = sections[i];
                var slidesWrap = $(SLIDES_WRAPPER_SEL, section)[0];
                var slides = $(SLIDE_SEL, section);
                //adjusting the height of the table-cell for IE and Firefox
                if (options.verticalCentered) css($(TABLE_CELL_SEL, section), {
                    'height': getTableHeight(section) + 'px'
                });
                css(section, {
                    'height': windowsHeight + 'px'
                });
                //adjusting the position fo the FULL WIDTH slides...
                if (slides.length > 1) landscapeScroll(slidesWrap, $(SLIDE_ACTIVE_SEL, slidesWrap)[0]);
            }
            if (options.scrollOverflow) scrollBarHandler.createScrollBarForAll();
            var activeSection = $(SECTION_ACTIVE_SEL)[0];
            var sectionIndex = index(activeSection, SECTION_SEL);
            //isn't it the first section?
            if (sectionIndex) //adjusting the position for the current section
            silentMoveTo(sectionIndex + 1);
            isResizing = false;
            if (isFunction(options.afterResize) && resizing) options.afterResize.call(container, window1.innerWidth, window1.innerHeight);
            if (isFunction(options.afterReBuild) && !resizing) options.afterReBuild.call(container);
        }
        /**
        * Determines whether fullpage.js is in responsive mode or not.
        */ function isResponsiveMode() {
            return hasClass($body, RESPONSIVE);
        }
        /**
        * Turns fullPage.js to normal scrolling mode when the viewport `width` or `height`
        * are smaller than the set limit values.
        */ function setResponsive(active) {
            var isResponsive = isResponsiveMode();
            if (active) {
                if (!isResponsive) {
                    setAutoScrolling(false, 'internal');
                    setFitToSection(false, 'internal');
                    hide($(SECTION_NAV_SEL));
                    addClass($body, RESPONSIVE);
                    if (isFunction(options.afterResponsive)) options.afterResponsive.call(container, active);
                    //when on page load, we will remove scrolloverflow if necessary
                    if (options.scrollOverflow) scrollBarHandler.createScrollBarForAll();
                }
            } else if (isResponsive) {
                setAutoScrolling(originals.autoScrolling, 'internal');
                setFitToSection(originals.autoScrolling, 'internal');
                show($(SECTION_NAV_SEL));
                removeClass($body, RESPONSIVE);
                if (isFunction(options.afterResponsive)) options.afterResponsive.call(container, active);
            }
        }
        if (container) {
            //public functions
            FP.version = '3.1.1';
            FP.setAutoScrolling = setAutoScrolling;
            FP.setRecordHistory = setRecordHistory;
            FP.setScrollingSpeed = setScrollingSpeed;
            FP.setFitToSection = setFitToSection;
            FP.setLockAnchors = setLockAnchors;
            FP.setMouseWheelScrolling = setMouseWheelScrolling;
            FP.setAllowScrolling = setAllowScrolling;
            FP.setKeyboardScrolling = setKeyboardScrolling;
            FP.moveSectionUp = moveSectionUp;
            FP.moveSectionDown = moveSectionDown;
            FP.silentMoveTo = silentMoveTo;
            FP.moveTo = moveTo;
            FP.moveSlideRight = moveSlideRight;
            FP.moveSlideLeft = moveSlideLeft;
            FP.fitToSection = fitToSection;
            FP.reBuild = reBuild;
            FP.setResponsive = setResponsive;
            FP.getFullpageData = function() {
                return options;
            };
            FP.destroy = destroy;
            FP.getActiveSection = getActiveSection;
            FP.getActiveSlide = getActiveSlide;
            FP.test = {
                top: '0px',
                translate3d: 'translate3d(0px, 0px, 0px)',
                translate3dH: function() {
                    var a = [];
                    for(var i = 0; i < $(options.sectionSelector, container).length; i++)a.push('translate3d(0px, 0px, 0px)');
                    return a;
                }(),
                left: function() {
                    var a = [];
                    for(var i = 0; i < $(options.sectionSelector, container).length; i++)a.push(0);
                    return a;
                }(),
                options: options,
                setAutoScrolling: setAutoScrolling
            };
            //functions we want to share across files but which are not
            //mean to be used on their own by developers
            FP.shared = {
                afterRenderActions: afterRenderActions,
                isNormalScrollElement: false
            };
            window1.fullpage_api = FP;
            //using jQuery initialization? Creating the $.fn.fullpage object
            if (options.$) Object.keys(FP).forEach(function(key) {
                options.$.fn.fullpage[key] = FP[key];
            });
            init();
            bindEvents();
        }
        function init() {
            //if css3 is not supported, it will use jQuery animations
            if (options.css3) options.css3 = support3d();
            options.scrollBar = options.scrollBar || options.hybrid;
            setOptionsFromDOM();
            prepareDom();
            setAllowScrolling(true);
            setMouseHijack(true);
            setAutoScrolling(options.autoScrolling, 'internal');
            responsive();
            //setting the class for the body element
            setBodyClass();
            if (document1.readyState === 'complete') scrollToAnchor();
            window1.addEventListener('load', scrollToAnchor);
            //if we use scrollOverflow we'll fire afterRender in the scrolloverflow file
            if (!options.scrollOverflow) afterRenderActions();
            doubleCheckHeight();
        }
        function bindEvents() {
            //when scrolling...
            window1.addEventListener('scroll', scrollHandler);
            //detecting any change on the URL to scroll to the given anchor link
            //(a way to detect back history button as we play with the hashes on the URL)
            window1.addEventListener('hashchange', hashChangeHandler);
            // on window focus
            window1.addEventListener('focus', focusHandler);
            //when opening a new tab (ctrl + t), `control` won't be pressed when coming back.
            window1.addEventListener('blur', blurHandler);
            //when resizing the site, we adjust the heights of the sections, slimScroll...
            window1.addEventListener('resize', resizeHandler);
            //Sliding with arrow keys, both, vertical and horizontal
            document1.addEventListener('keydown', keydownHandler);
            //to prevent scrolling while zooming
            document1.addEventListener('keyup', keyUpHandler);
            //Scrolls to the section when clicking the navigation bullet
            //simulating the jQuery .on('click') event using delegation
            [
                'click',
                'touchstart'
            ].forEach(function(eventName) {
                document1.addEventListener(eventName, delegatedEvents);
            });
            /**
            * Applying normalScroll elements.
            * Ignoring the scrolls over the specified selectors.
            */ if (options.normalScrollElements) {
                [
                    'mouseenter',
                    'touchstart'
                ].forEach(function(eventName) {
                    forMouseLeaveOrTouch(eventName, false);
                });
                [
                    'mouseleave',
                    'touchend'
                ].forEach(function(eventName) {
                    forMouseLeaveOrTouch(eventName, true);
                });
            }
        }
        function delegatedEvents(e) {
            var target = e.target;
            if (target && closest(target, SECTION_NAV_SEL + ' a')) sectionBulletHandler.call(target, e);
            else if (matches(target, SECTION_NAV_TOOLTIP_SEL)) tooltipTextHandler.call(target);
            else if (matches(target, SLIDES_ARROW_SEL)) slideArrowHandler.call(target, e);
            else if (matches(target, SLIDES_NAV_LINK_SEL) || closest(target, SLIDES_NAV_LINK_SEL) != null) slideBulletHandler.call(target, e);
            else if (closest(target, options.menu + ' [data-menuanchor]')) menuItemsHandler.call(target, e);
        }
        function forMouseLeaveOrTouch(eventName, allowScrolling) {
            //a way to pass arguments to the onMouseEnterOrLeave function
            document1['fp_' + eventName] = allowScrolling;
            document1.addEventListener(eventName, onMouseEnterOrLeave, true); //capturing phase
        }
        function onMouseEnterOrLeave(e) {
            var type = e.type;
            var isInsideOneNormalScroll = false;
            var isUsingScrollOverflow = options.scrollOverflow;
            //onMouseLeave will use the destination target, not the one we are moving away from
            var target = type === 'mouseleave' ? e.toElement || e.relatedTarget : e.target;
            //coming from closing a normalScrollElements modal or moving outside viewport?
            if (target == document1 || !target) {
                setMouseHijack(true);
                if (isUsingScrollOverflow) options.scrollOverflowHandler.setIscroll(target, true);
                return;
            }
            if (type === 'touchend') {
                g_canFireMouseEnterNormalScroll = false;
                setTimeout(function() {
                    g_canFireMouseEnterNormalScroll = true;
                }, 800);
            }
            //preventing mouseenter event to do anything when coming from a touchEnd event
            //fixing issue #3576
            if (type === 'mouseenter' && !g_canFireMouseEnterNormalScroll) return;
            var normalSelectors = options.normalScrollElements.split(',');
            normalSelectors.forEach(function(normalSelector) {
                if (!isInsideOneNormalScroll) {
                    var isNormalScrollTarget = matches(target, normalSelector);
                    //leaving a child inside the normalScoll element is not leaving the normalScroll #3661
                    var isNormalScrollChildFocused = closest(target, normalSelector);
                    if (isNormalScrollTarget || isNormalScrollChildFocused) {
                        if (!FP.shared.isNormalScrollElement) {
                            setMouseHijack(false);
                            if (isUsingScrollOverflow) options.scrollOverflowHandler.setIscroll(target, false);
                        }
                        FP.shared.isNormalScrollElement = true;
                        isInsideOneNormalScroll = true;
                    }
                }
            });
            //not inside a single normal scroll element anymore?
            if (!isInsideOneNormalScroll && FP.shared.isNormalScrollElement) {
                setMouseHijack(true);
                if (isUsingScrollOverflow) options.scrollOverflowHandler.setIscroll(target, true);
                FP.shared.isNormalScrollElement = false;
            }
        }
        /**
        * Checks the viewport a few times on a define interval of time to 
        * see if it has changed in any of those. If that's the case, it resizes.
        */ function doubleCheckHeight() {
            for(var i = 1; i < 4; i++)g_doubleCheckHeightId = setTimeout(adjustToNewViewport, 350 * i);
        }
        /**
        * Adjusts a section to the viewport if it has changed.
        */ function adjustToNewViewport() {
            var newWindowHeight = getWindowHeight();
            var newWindowWidth = getWindowWidth();
            if (windowsHeight !== newWindowHeight || windowsWidth !== newWindowWidth) {
                windowsHeight = newWindowHeight;
                windowsWidth = newWindowWidth;
                reBuild(true);
            }
        }
        /**
        * Setting options from DOM elements if they are not provided.
        */ function setOptionsFromDOM() {
            //no anchors option? Checking for them in the DOM attributes
            if (!options.anchors.length) {
                var anchorsAttribute = '[data-anchor]';
                var anchors = $(options.sectionSelector.split(',').join(anchorsAttribute + ',') + anchorsAttribute, container);
                if (anchors.length && anchors.length === $(options.sectionSelector, container).length) {
                    g_initialAnchorsInDom = true;
                    anchors.forEach(function(item) {
                        options.anchors.push(item.getAttribute('data-anchor').toString());
                    });
                }
            }
            //no tooltips option? Checking for them in the DOM attributes
            if (!options.navigationTooltips.length) {
                var tooltipsAttribute = '[data-tooltip]';
                var tooltips = $(options.sectionSelector.split(',').join(tooltipsAttribute + ',') + tooltipsAttribute, container);
                if (tooltips.length) tooltips.forEach(function(item) {
                    options.navigationTooltips.push(item.getAttribute('data-tooltip').toString());
                });
            }
        }
        /**
        * Works over the DOM structure to set it up for the current fullpage options.
        */ function prepareDom() {
            css(container, {
                'height': '100%',
                'position': 'relative'
            });
            //adding a class to recognize the container internally in the code
            addClass(container, WRAPPER);
            addClass($html, ENABLED);
            //due to https://github.com/alvarotrigo/fullPage.js/issues/1502
            windowsHeight = getWindowHeight();
            removeClass(container, DESTROYED); //in case it was destroyed before initializing it again
            addInternalSelectors();
            var sections = $(SECTION_SEL);
            //styling the sections / slides / menu
            for(var i = 0; i < sections.length; i++){
                var sectionIndex = i;
                var section = sections[i];
                var slides = $(SLIDE_SEL, section);
                var numSlides = slides.length;
                //caching the original styles to add them back on destroy('all')
                section.setAttribute('data-fp-styles', section.getAttribute('style'));
                styleSection(section, sectionIndex);
                styleMenu(section, sectionIndex);
                // if there's any slide
                if (numSlides > 0) styleSlides(section, slides, numSlides);
                else if (options.verticalCentered) addTableClass(section);
            }
            //fixed elements need to be moved out of the plugin container due to problems with CSS3.
            if (options.fixedElements && options.css3) $(options.fixedElements).forEach(function(item) {
                $body.appendChild(item);
            });
            //vertical centered of the navigation + active bullet
            if (options.navigation) addVerticalNavigation();
            enableYoutubeAPI();
            if (options.scrollOverflow) scrollBarHandler = options.scrollOverflowHandler.init(options);
        }
        /**
        * Styles the horizontal slides for a section.
        */ function styleSlides(section, slides, numSlides) {
            var sliderWidth = numSlides * 100;
            var slideWidth = 100 / numSlides;
            var slidesWrapper = document1.createElement('div');
            slidesWrapper.className = SLIDES_WRAPPER; //fp-slides
            wrapAll(slides, slidesWrapper);
            var slidesContainer = document1.createElement('div');
            slidesContainer.className = SLIDES_CONTAINER; //fp-slidesContainer
            wrapAll(slides, slidesContainer);
            css($(SLIDES_CONTAINER_SEL, section), {
                'width': sliderWidth + '%'
            });
            if (numSlides > 1) {
                if (options.controlArrows) createSlideArrows(section);
                if (options.slidesNavigation) addSlidesNavigation(section, numSlides);
            }
            slides.forEach(function(slide) {
                css(slide, {
                    'width': slideWidth + '%'
                });
                if (options.verticalCentered) addTableClass(slide);
            });
            var startingSlide = $(SLIDE_ACTIVE_SEL, section)[0];
            //if the slide won't be an starting point, the default will be the first one
            //the active section isn't the first one? Is not the first slide of the first section? Then we load that section/slide by default.
            if (startingSlide != null && (index($(SECTION_ACTIVE_SEL), SECTION_SEL) !== 0 || index($(SECTION_ACTIVE_SEL), SECTION_SEL) === 0 && index(startingSlide) !== 0)) silentLandscapeScroll(startingSlide, 'internal');
            else addClass(slides[0], ACTIVE);
        }
        /**
        * Styling vertical sections
        */ function styleSection(section, index) {
            //if no active section is defined, the 1st one will be the default one
            if (!index && $(SECTION_ACTIVE_SEL)[0] == null) addClass(section, ACTIVE);
            startingSection = $(SECTION_ACTIVE_SEL)[0];
            css(section, {
                'height': windowsHeight + 'px'
            });
            if (options.paddingTop) css(section, {
                'padding-top': options.paddingTop
            });
            if (options.paddingBottom) css(section, {
                'padding-bottom': options.paddingBottom
            });
            if (typeof options.sectionsColor[index] !== 'undefined') css(section, {
                'background-color': options.sectionsColor[index]
            });
            if (typeof options.anchors[index] !== 'undefined') section.setAttribute('data-anchor', options.anchors[index]);
        }
        /**
        * Sets the data-anchor attributes to the menu elements and activates the current one.
        */ function styleMenu(section, index) {
            if (typeof options.anchors[index] !== 'undefined') //activating the menu / nav element on load
            {
                if (hasClass(section, ACTIVE)) activateMenuAndNav(options.anchors[index], index);
            }
            //moving the menu outside the main container if it is inside (avoid problems with fixed positions when using CSS3 tranforms)
            if (options.menu && options.css3 && closest($(options.menu)[0], WRAPPER_SEL) != null) $(options.menu).forEach(function(menu) {
                $body.appendChild(menu);
            });
        }
        /**
        * Adds internal classes to be able to provide customizable selectors
        * keeping the link with the style sheet.
        */ function addInternalSelectors() {
            addClass($(options.sectionSelector, container), SECTION);
            addClass($(options.slideSelector, container), SLIDE);
        }
        /**
        * Creates the control arrows for the given section
        */ function createSlideArrows(section) {
            var arrows = [
                createElementFromHTML('<div class="' + SLIDES_ARROW_PREV + '"></div>'),
                createElementFromHTML('<div class="' + SLIDES_ARROW_NEXT + '"></div>')
            ];
            after($(SLIDES_WRAPPER_SEL, section)[0], arrows);
            if (options.controlArrowColor !== '#fff') {
                css($(SLIDES_ARROW_NEXT_SEL, section), {
                    'border-color': 'transparent transparent transparent ' + options.controlArrowColor
                });
                css($(SLIDES_ARROW_PREV_SEL, section), {
                    'border-color': 'transparent ' + options.controlArrowColor + ' transparent transparent'
                });
            }
            if (!options.loopHorizontal) hide($(SLIDES_ARROW_PREV_SEL, section));
        }
        /**
        * Creates a vertical navigation bar.
        */ function addVerticalNavigation() {
            var navigation = document1.createElement('div');
            navigation.setAttribute('id', SECTION_NAV);
            var divUl = document1.createElement('ul');
            navigation.appendChild(divUl);
            appendTo(navigation, $body);
            var nav = $(SECTION_NAV_SEL)[0];
            addClass(nav, 'fp-' + options.navigationPosition);
            if (options.showActiveTooltip) addClass(nav, SHOW_ACTIVE_TOOLTIP);
            var li = '';
            for(var i = 0; i < $(SECTION_SEL).length; i++){
                var link = '';
                if (options.anchors.length) link = options.anchors[i];
                li += '<li><a href="#' + link + '"><span class="fp-sr-only">' + getBulletLinkName(i, 'Section') + '</span><span></span></a>';
                // Only add tooltip if needed (defined by user)
                var tooltip = options.navigationTooltips[i];
                if (typeof tooltip !== 'undefined' && tooltip !== '') li += '<div class="' + SECTION_NAV_TOOLTIP + ' fp-' + options.navigationPosition + '">' + tooltip + '</div>';
                li += '</li>';
            }
            $('ul', nav)[0].innerHTML = li;
            //activating the current active section
            var bullet = $('li', $(SECTION_NAV_SEL)[0])[index($(SECTION_ACTIVE_SEL)[0], SECTION_SEL)];
            addClass($('a', bullet), ACTIVE);
        }
        /**
        * Gets the name for screen readers for a section/slide navigation bullet.
        */ function getBulletLinkName(i, defaultName, item) {
            var anchor = defaultName === 'Section' ? options.anchors[i] : item.getAttribute('data-anchor');
            return options.navigationTooltips[i] || anchor || defaultName + ' ' + (i + 1);
        }
        /*
        * Enables the Youtube videos API so we can control their flow if necessary.
        */ function enableYoutubeAPI() {
            $('iframe[src*="youtube.com/embed/"]', container).forEach(function(item) {
                addURLParam(item, 'enablejsapi=1');
            });
        }
        /**
        * Adds a new parameter and its value to the `src` of a given element
        */ function addURLParam(element, newParam) {
            var originalSrc = element.getAttribute('src');
            element.setAttribute('src', originalSrc + getUrlParamSign(originalSrc) + newParam);
        }
        /*
        * Returns the prefix sign to use for a new parameter in an existen URL.
        *
        * @return {String}  ? | &
        */ function getUrlParamSign(url) {
            return !/\?/.test(url) ? '?' : '&';
        }
        /**
        * Actions and callbacks to fire afterRender
        */ function afterRenderActions() {
            var section = $(SECTION_ACTIVE_SEL)[0];
            addClass(section, COMPLETELY);
            lazyLoad(section);
            lazyLoadOthers();
            playMedia(section);
            if (options.scrollOverflow) options.scrollOverflowHandler.afterLoad();
            if (isDestinyTheStartingSection() && isFunction(options.afterLoad)) fireCallback('afterLoad', {
                activeSection: section,
                element: section,
                direction: null,
                //for backwards compatibility callback (to be removed in a future!)
                anchorLink: section.getAttribute('data-anchor'),
                sectionIndex: index(section, SECTION_SEL)
            });
            if (isFunction(options.afterRender)) fireCallback('afterRender');
        }
        /**
        * Determines if the URL anchor destiny is the starting section (the one using 'active' class before initialization)
        */ function isDestinyTheStartingSection() {
            var anchor = getAnchorsURL();
            var destinationSection = getSectionByAnchor(anchor.section);
            return !anchor.section || !destinationSection || typeof destinationSection !== 'undefined' && index(destinationSection) === index(startingSection);
        }
        var isScrolling = false;
        var lastScroll = 0;
        //when scrolling...
        function scrollHandler() {
            var currentSection;
            if (isResizing) return;
            if (!options.autoScrolling || options.scrollBar) {
                var currentScroll = getScrollTop();
                var scrollDirection = getScrollDirection(currentScroll);
                var visibleSectionIndex = 0;
                var screen_mid = currentScroll + getWindowHeight() / 2.0;
                var isAtBottom = $body.offsetHeight - getWindowHeight() === currentScroll;
                var sections = $(SECTION_SEL);
                //when using `auto-height` for a small last section it won't be centered in the viewport
                if (isAtBottom) visibleSectionIndex = sections.length - 1;
                else if (!currentScroll) visibleSectionIndex = 0;
                else for(var i = 0; i < sections.length; ++i){
                    var section = sections[i];
                    // Pick the the last section which passes the middle line of the screen.
                    if (section.offsetTop <= screen_mid) visibleSectionIndex = i;
                }
                if (isCompletelyInViewPort(scrollDirection)) {
                    if (!hasClass($(SECTION_ACTIVE_SEL)[0], COMPLETELY)) {
                        addClass($(SECTION_ACTIVE_SEL)[0], COMPLETELY);
                        removeClass(siblings($(SECTION_ACTIVE_SEL)[0]), COMPLETELY);
                    }
                }
                //geting the last one, the current one on the screen
                currentSection = sections[visibleSectionIndex];
                //setting the visible section as active when manually scrolling
                //executing only once the first time we reach the section
                if (!hasClass(currentSection, ACTIVE)) {
                    isScrolling = true;
                    var leavingSection = $(SECTION_ACTIVE_SEL)[0];
                    var leavingSectionIndex = index(leavingSection, SECTION_SEL) + 1;
                    var yMovement = getYmovement(currentSection);
                    var anchorLink = currentSection.getAttribute('data-anchor');
                    var sectionIndex = index(currentSection, SECTION_SEL) + 1;
                    var activeSlide = $(SLIDE_ACTIVE_SEL, currentSection)[0];
                    var slideIndex;
                    var slideAnchorLink;
                    var callbacksParams = {
                        activeSection: leavingSection,
                        sectionIndex: sectionIndex - 1,
                        anchorLink: anchorLink,
                        element: currentSection,
                        leavingSection: leavingSectionIndex,
                        direction: yMovement
                    };
                    if (activeSlide) {
                        slideAnchorLink = activeSlide.getAttribute('data-anchor');
                        slideIndex = index(activeSlide);
                    }
                    if (canScroll) {
                        addClass(currentSection, ACTIVE);
                        removeClass(siblings(currentSection), ACTIVE);
                        if (isFunction(options.onLeave)) fireCallback('onLeave', callbacksParams);
                        if (isFunction(options.afterLoad)) fireCallback('afterLoad', callbacksParams);
                        stopMedia(leavingSection);
                        lazyLoad(currentSection);
                        playMedia(currentSection);
                        activateMenuAndNav(anchorLink, sectionIndex - 1);
                        if (options.anchors.length) //needed to enter in hashChange event when using the menu with anchor links
                        lastScrolledDestiny = anchorLink;
                        setState(slideIndex, slideAnchorLink, anchorLink, sectionIndex);
                    }
                    //small timeout in order to avoid entering in hashChange event when scrolling is not finished yet
                    clearTimeout(scrollId);
                    scrollId = setTimeout(function() {
                        isScrolling = false;
                    }, 100);
                }
                if (options.fitToSection) {
                    //for the auto adjust of the viewport to fit a whole section
                    clearTimeout(scrollId2);
                    scrollId2 = setTimeout(function() {
                        //checking it again in case it changed during the delay
                        if (options.fitToSection && //is the destination element bigger than the viewport?
                        $(SECTION_ACTIVE_SEL)[0].offsetHeight <= windowsHeight) fitToSection();
                    }, options.fitToSectionDelay);
                }
            }
        }
        /**
        * Fits the site to the nearest active section
        */ function fitToSection() {
            //checking fitToSection again in case it was set to false before the timeout delay
            if (canScroll) {
                //allows to scroll to an active section and
                //if the section is already active, we prevent firing callbacks
                isResizing = true;
                scrollPage($(SECTION_ACTIVE_SEL)[0]);
                isResizing = false;
            }
        }
        /**
        * Determines whether the active section has seen in its whole or not.
        */ function isCompletelyInViewPort(movement) {
            var top = $(SECTION_ACTIVE_SEL)[0].offsetTop;
            var bottom = top + getWindowHeight();
            if (movement == 'up') return bottom >= getScrollTop() + getWindowHeight();
            return top <= getScrollTop();
        }
        /**
        * Determines whether a section is in the viewport or not.
        */ function isSectionInViewport(el) {
            var rect = el.getBoundingClientRect();
            var top = rect.top;
            var bottom = rect.bottom;
            //sometimes there's a 1px offset on the bottom of the screen even when the 
            //section's height is the window.innerHeight one. I guess because pixels won't allow decimals.
            //using this prevents from lazyLoading the section that is not yet visible 
            //(only 1 pixel offset is)
            var pixelOffset = 2;
            var isTopInView = top + pixelOffset < windowsHeight && top > 0;
            var isBottomInView = bottom > pixelOffset && bottom < windowsHeight;
            return isTopInView || isBottomInView;
        }
        /**
        * Gets the directon of the the scrolling fired by the scroll event.
        */ function getScrollDirection(currentScroll) {
            var direction = currentScroll > lastScroll ? 'down' : 'up';
            lastScroll = currentScroll;
            //needed for auto-height sections to determine if we want to scroll to the top or bottom of the destination
            previousDestTop = currentScroll;
            return direction;
        }
        /**
        * Determines the way of scrolling up or down:
        * by 'automatically' scrolling a section or by using the default and normal scrolling.
        */ function scrolling(type) {
            if (!isScrollAllowed.m[type]) return;
            var scrollSection = type === 'down' ? moveSectionDown : moveSectionUp;
            if (options.scrollOverflow) {
                var scrollable = options.scrollOverflowHandler.scrollable($(SECTION_ACTIVE_SEL)[0]);
                var check = type === 'down' ? 'bottom' : 'top';
                if (scrollable != null) {
                    //is the scrollbar at the start/end of the scroll?
                    if (options.scrollOverflowHandler.isScrolled(check, scrollable)) scrollSection();
                    else return true;
                } else // moved up/down
                scrollSection();
            } else // moved up/down
            scrollSection();
        }
        /*
        * Preventing bouncing in iOS #2285
        */ function preventBouncing(e) {
            if (options.autoScrolling && isReallyTouch(e) && isScrollAllowed.m.up) //preventing the easing on iOS devices
            preventDefault(e);
        }
        var touchStartY = 0;
        var touchStartX = 0;
        var touchEndY = 0;
        var touchEndX = 0;
        /* Detecting touch events

        * As we are changing the top property of the page on scrolling, we can not use the traditional way to detect it.
        * This way, the touchstart and the touch moves shows an small difference between them which is the
        * used one to determine the direction.
        */ function touchMoveHandler(e) {
            var activeSection = closest(e.target, SECTION_SEL) || $(SECTION_ACTIVE_SEL)[0];
            if (isReallyTouch(e)) {
                if (options.autoScrolling) //preventing the easing on iOS devices
                preventDefault(e);
                var touchEvents = getEventsPage(e);
                touchEndY = touchEvents.y;
                touchEndX = touchEvents.x;
                //if movement in the X axys is greater than in the Y and the currect section has slides...
                if ($(SLIDES_WRAPPER_SEL, activeSection).length && Math.abs(touchStartX - touchEndX) > Math.abs(touchStartY - touchEndY)) //is the movement greater than the minimum resistance to scroll?
                {
                    if (!slideMoving && Math.abs(touchStartX - touchEndX) > getWindowWidth() / 100 * options.touchSensitivity) {
                        if (touchStartX > touchEndX) {
                            if (isScrollAllowed.m.right) moveSlideRight(activeSection); //next
                        } else if (isScrollAllowed.m.left) moveSlideLeft(activeSection); //prev
                    }
                } else if (options.autoScrolling && canScroll) //is the movement greater than the minimum resistance to scroll?
                {
                    if (Math.abs(touchStartY - touchEndY) > window1.innerHeight / 100 * options.touchSensitivity) {
                        if (touchStartY > touchEndY) scrolling('down');
                        else if (touchEndY > touchStartY) scrolling('up');
                    }
                }
            }
        }
        /**
        * As IE >= 10 fires both touch and mouse events when using a mouse in a touchscreen
        * this way we make sure that is really a touch event what IE is detecting.
        */ function isReallyTouch(e) {
            //if is not IE   ||  IE is detecting `touch` or `pen`
            return typeof e.pointerType === 'undefined' || e.pointerType != 'mouse';
        }
        /**
        * Handler for the touch start event.
        */ function touchStartHandler(e) {
            //stopping the auto scroll to adjust to a section
            if (options.fitToSection) activeAnimation = false;
            if (isReallyTouch(e)) {
                var touchEvents = getEventsPage(e);
                touchStartY = touchEvents.y;
                touchStartX = touchEvents.x;
            }
        }
        /**
        * Gets the average of the last `number` elements of the given array.
        */ function getAverage(elements, number) {
            var sum = 0;
            //taking `number` elements from the end to make the average, if there are not enought, 1
            var lastElements = elements.slice(Math.max(elements.length - number, 1));
            for(var i = 0; i < lastElements.length; i++)sum = sum + lastElements[i];
            return Math.ceil(sum / number);
        }
        /**
         * Detecting mousewheel scrolling
         *
         * http://blogs.sitepointstatic.com/examples/tech/mouse-wheel/index.html
         * http://www.sitepoint.com/html5-javascript-mouse-wheel/
         */ var prevTime = new Date().getTime();
        function MouseWheelHandler(e) {
            var curTime = new Date().getTime();
            var isNormalScroll = hasClass($(COMPLETELY_SEL)[0], NORMAL_SCROLL);
            //is scroll allowed?
            if (!isScrollAllowed.m.down && !isScrollAllowed.m.up) {
                preventDefault(e);
                return false;
            }
            //autoscrolling and not zooming?
            if (options.autoScrolling && !controlPressed && !isNormalScroll) {
                // cross-browser wheel delta
                e = e || window1.event;
                var value = e.wheelDelta || -e.deltaY || -e.detail;
                var delta = Math.max(-1, Math.min(1, value));
                var horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
                var isScrollingVertically = Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta) || Math.abs(e.deltaX) < Math.abs(e.deltaY) || !horizontalDetection;
                //Limiting the array to 150 (lets not waste memory!)
                if (scrollings.length > 149) scrollings.shift();
                //keeping record of the previous scrollings
                scrollings.push(Math.abs(value));
                //preventing to scroll the site on mouse wheel when scrollbar is present
                if (options.scrollBar) preventDefault(e);
                //time difference between the last scroll and the current one
                var timeDiff = curTime - prevTime;
                prevTime = curTime;
                //haven't they scrolled in a while?
                //(enough to be consider a different scrolling action to scroll another section)
                if (timeDiff > 200) //emptying the array, we dont care about old scrollings for our averages
                scrollings = [];
                if (canScroll) {
                    var averageEnd = getAverage(scrollings, 10);
                    var averageMiddle = getAverage(scrollings, 70);
                    var isAccelerating = averageEnd >= averageMiddle;
                    //to avoid double swipes...
                    if (isAccelerating && isScrollingVertically) {
                        //scrolling down?
                        if (delta < 0) scrolling('down');
                        else scrolling('up');
                    }
                }
                return false;
            }
            if (options.fitToSection) //stopping the auto scroll to adjust to a section
            activeAnimation = false;
        }
        /**
        * Slides a slider to the given direction.
        * Optional `section` param.
        */ function moveSlide(direction, section) {
            var activeSection = section == null ? $(SECTION_ACTIVE_SEL)[0] : section;
            var slides = $(SLIDES_WRAPPER_SEL, activeSection)[0];
            // more than one slide needed and nothing should be sliding
            if (slides == null || slideMoving || $(SLIDE_SEL, slides).length < 2) return;
            var currentSlide = $(SLIDE_ACTIVE_SEL, slides)[0];
            var destiny = null;
            if (direction === 'left') destiny = prevUntil(currentSlide, SLIDE_SEL);
            else destiny = nextUntil(currentSlide, SLIDE_SEL);
            //isn't there a next slide in the secuence?
            if (destiny == null) {
                //respect loopHorizontal settin
                if (!options.loopHorizontal) return;
                var slideSiblings = siblings(currentSlide);
                if (direction === 'left') destiny = slideSiblings[slideSiblings.length - 1]; //last
                else destiny = slideSiblings[0]; //first
            }
            slideMoving = !FP.test.isTesting;
            landscapeScroll(slides, destiny, direction);
        }
        /**
        * Maintains the active slides in the viewport
        * (Because the `scroll` animation might get lost with some actions, such as when using continuousVertical)
        */ function keepSlidesPosition() {
            var activeSlides = $(SLIDE_ACTIVE_SEL);
            for(var i = 0; i < activeSlides.length; i++)silentLandscapeScroll(activeSlides[i], 'internal');
        }
        var previousDestTop = 0;
        /**
        * Returns the destination Y position based on the scrolling direction and
        * the height of the section.
        */ function getDestinationPosition(element) {
            var elementHeight = element.offsetHeight;
            var elementTop = element.offsetTop;
            //top of the desination will be at the top of the viewport
            var position = elementTop;
            var isScrollingDown = elementTop > previousDestTop;
            var sectionBottom = position - windowsHeight + elementHeight;
            var bigSectionsDestination = options.bigSectionsDestination;
            //is the destination element bigger than the viewport?
            if (elementHeight > windowsHeight) //scrolling up?
            {
                if (!isScrollingDown && !bigSectionsDestination || bigSectionsDestination === 'bottom') position = sectionBottom;
            } else if (isScrollingDown || isResizing && next(element) == null) //The bottom of the destination will be at the bottom of the viewport
            position = sectionBottom;
            /*
            Keeping record of the last scrolled position to determine the scrolling direction.
            No conventional methods can be used as the scroll bar might not be present
            AND the section might not be active if it is auto-height and didnt reach the middle
            of the viewport.
            */ previousDestTop = position;
            return position;
        }
        /**
        * Scrolls the site to the given element and scrolls to the slide if a callback is given.
        */ function scrollPage(element, callback, isMovementUp) {
            if (element == null) return;
             //there's no element to scroll, leaving the function
            var dtop = getDestinationPosition(element);
            var slideAnchorLink;
            var slideIndex;
            //local variables
            var v = {
                element: element,
                callback: callback,
                isMovementUp: isMovementUp,
                dtop: dtop,
                yMovement: getYmovement(element),
                anchorLink: element.getAttribute('data-anchor'),
                sectionIndex: index(element, SECTION_SEL),
                activeSlide: $(SLIDE_ACTIVE_SEL, element)[0],
                activeSection: $(SECTION_ACTIVE_SEL)[0],
                leavingSection: index($(SECTION_ACTIVE_SEL), SECTION_SEL) + 1,
                //caching the value of isResizing at the momment the function is called
                //because it will be checked later inside a setTimeout and the value might change
                localIsResizing: isResizing
            };
            //quiting when destination scroll is the same as the current one
            if (v.activeSection == element && !isResizing || options.scrollBar && getScrollTop() === v.dtop && !hasClass(element, AUTO_HEIGHT)) return;
            if (v.activeSlide != null) {
                slideAnchorLink = v.activeSlide.getAttribute('data-anchor');
                slideIndex = index(v.activeSlide);
            }
            //callback (onLeave) if the site is not just resizing and readjusting the slides
            if (!v.localIsResizing) {
                var direction = v.yMovement;
                //required for continousVertical
                if (typeof isMovementUp !== 'undefined') direction = isMovementUp ? 'up' : 'down';
                //for the callback
                v.direction = direction;
                if (isFunction(options.onLeave)) {
                    if (fireCallback('onLeave', v) === false) return;
                }
            }
            // If continuousVertical && we need to wrap around
            if (options.autoScrolling && options.continuousVertical && typeof v.isMovementUp !== "undefined" && (!v.isMovementUp && v.yMovement == 'up' || // Intending to scroll down but about to go up or
            v.isMovementUp && v.yMovement == 'down')) v = createInfiniteSections(v);
            //pausing media of the leaving section (if we are not just resizing, as destinatino will be the same one)
            if (!v.localIsResizing) stopMedia(v.activeSection);
            if (options.scrollOverflow) options.scrollOverflowHandler.beforeLeave();
            addClass(element, ACTIVE);
            removeClass(siblings(element), ACTIVE);
            lazyLoad(element);
            if (options.scrollOverflow) options.scrollOverflowHandler.onLeave();
            //preventing from activating the MouseWheelHandler event
            //more than once if the page is scrolling
            canScroll = FP.test.isTesting;
            setState(slideIndex, slideAnchorLink, v.anchorLink, v.sectionIndex);
            performMovement(v);
            //flag to avoid callingn `scrollPage()` twice in case of using anchor links
            lastScrolledDestiny = v.anchorLink;
            //avoid firing it twice (as it does also on scroll)
            activateMenuAndNav(v.anchorLink, v.sectionIndex);
        }
        /**
        * Dispatch events & callbacks making sure it does it on the right format, depending on
        * whether v2compatible is being used or not.
        */ function fireCallback(eventName, v) {
            var eventData = getEventData(eventName, v);
            if (!options.v2compatible) {
                trigger(container, eventName, eventData);
                if (options[eventName].apply(eventData[Object.keys(eventData)[0]], toArray(eventData)) === false) return false;
            } else {
                if (options[eventName].apply(eventData[0], eventData.slice(1)) === false) return false;
            }
            return true;
        }
        /**
        * Makes sure to only create a Panel object if the element exist
        */ function nullOrSection(el) {
            return el ? new Section(el) : null;
        }
        function nullOrSlide(el) {
            return el ? new Slide(el) : null;
        }
        /**
        * Gets the event's data for the given event on the right format. Depending on whether
        * v2compatible is being used or not.
        */ function getEventData(eventName, v) {
            var paramsPerEvent;
            if (!options.v2compatible) //using functions to run only the necessary bits within the object
            paramsPerEvent = {
                afterRender: function() {
                    return {
                        section: nullOrSection($(SECTION_ACTIVE_SEL)[0]),
                        slide: nullOrSlide($(SLIDE_ACTIVE_SEL, $(SECTION_ACTIVE_SEL)[0])[0])
                    };
                },
                onLeave: function() {
                    return {
                        origin: nullOrSection(v.activeSection),
                        destination: nullOrSection(v.element),
                        direction: v.direction
                    };
                },
                afterLoad: function() {
                    return paramsPerEvent.onLeave();
                },
                afterSlideLoad: function() {
                    return {
                        section: nullOrSection(v.section),
                        origin: nullOrSlide(v.prevSlide),
                        destination: nullOrSlide(v.destiny),
                        direction: v.direction
                    };
                },
                onSlideLeave: function() {
                    return paramsPerEvent.afterSlideLoad();
                }
            };
            else paramsPerEvent = {
                afterRender: function() {
                    return [
                        container
                    ];
                },
                onLeave: function() {
                    return [
                        v.activeSection,
                        v.leavingSection,
                        v.sectionIndex + 1,
                        v.direction
                    ];
                },
                afterLoad: function() {
                    return [
                        v.element,
                        v.anchorLink,
                        v.sectionIndex + 1
                    ];
                },
                afterSlideLoad: function() {
                    return [
                        v.destiny,
                        v.anchorLink,
                        v.sectionIndex + 1,
                        v.slideAnchor,
                        v.slideIndex
                    ];
                },
                onSlideLeave: function() {
                    return [
                        v.prevSlide,
                        v.anchorLink,
                        v.sectionIndex + 1,
                        v.prevSlideIndex,
                        v.direction,
                        v.slideIndex
                    ];
                }
            };
            return paramsPerEvent[eventName]();
        }
        /**
        * Performs the vertical movement (by CSS3 or by jQuery)
        */ function performMovement(v) {
            var isFastSpeed = options.scrollingSpeed < 700;
            var transitionLapse = isFastSpeed ? 700 : options.scrollingSpeed;
            // using CSS3 translate functionality
            if (options.css3 && options.autoScrolling && !options.scrollBar) {
                // The first section can have a negative value in iOS 10. Not quite sure why: -0.0142822265625
                // that's why we round it to 0.
                var translate3d = 'translate3d(0px, -' + Math.round(v.dtop) + 'px, 0px)';
                transformContainer(translate3d, true);
                //even when the scrollingSpeed is 0 there's a little delay, which might cause the
                //scrollingSpeed to change in case of using silentMoveTo();
                if (options.scrollingSpeed) {
                    clearTimeout(afterSectionLoadsId);
                    afterSectionLoadsId = setTimeout(function() {
                        afterSectionLoads(v);
                        //disabling canScroll when using fastSpeed
                        canScroll = !isFastSpeed;
                    }, options.scrollingSpeed);
                } else afterSectionLoads(v);
            } else {
                var scrollSettings = getScrollSettings(v.dtop);
                FP.test.top = -v.dtop + 'px';
                css($htmlBody, {
                    'scroll-behavior': 'unset'
                });
                scrollTo(scrollSettings.element, scrollSettings.options, options.scrollingSpeed, function() {
                    if (options.scrollBar) /* Hack!
                        The timeout prevents setting the most dominant section in the viewport as "active" when the user
                        scrolled to a smaller section by using the mousewheel (auto scrolling) rather than draging the scroll bar.

                        When using scrollBar:true It seems like the scroll events still getting propagated even after the scrolling animation has finished.
                        */ setTimeout(function() {
                        afterSectionLoads(v);
                    }, 30);
                    else {
                        afterSectionLoads(v);
                        //disabling canScroll when using fastSpeed
                        canScroll = !isFastSpeed;
                    }
                });
            }
            // enabling canScroll after the minimum transition laps
            if (isFastSpeed) {
                clearTimeout(g_transitionLapseId);
                g_transitionLapseId = setTimeout(function() {
                    canScroll = true;
                }, transitionLapse);
            }
        }
        /**
        * Gets the scrolling settings depending on the plugin autoScrolling option
        */ function getScrollSettings(top) {
            var scroll = {};
            //top property animation
            if (options.autoScrolling && !options.scrollBar) {
                scroll.options = -top;
                scroll.element = $(WRAPPER_SEL)[0];
            } else {
                scroll.options = top;
                scroll.element = window1;
            }
            return scroll;
        }
        /**
        * Adds sections before or after the current one to create the infinite effect.
        */ function createInfiniteSections(v) {
            // Scrolling down
            if (!v.isMovementUp) // Move all previous sections to after the active section
            after($(SECTION_ACTIVE_SEL)[0], prevAll(v.activeSection, SECTION_SEL).reverse());
            else // Move all next sections to before the active section
            before($(SECTION_ACTIVE_SEL)[0], nextAll(v.activeSection, SECTION_SEL));
            // Maintain the displayed position (now that we changed the element order)
            silentScroll($(SECTION_ACTIVE_SEL)[0].offsetTop);
            // Maintain the active slides visible in the viewport
            keepSlidesPosition();
            // save for later the elements that still need to be reordered
            v.wrapAroundElements = v.activeSection;
            // Recalculate animation variables
            v.dtop = v.element.offsetTop;
            v.yMovement = getYmovement(v.element);
            return v;
        }
        /**
        * Fix section order after continuousVertical changes have been animated
        */ function continuousVerticalFixSectionOrder(v) {
            // If continuousVertical is in effect (and autoScrolling would also be in effect then),
            // finish moving the elements around so the direct navigation will function more simply
            if (v.wrapAroundElements == null) return;
            if (v.isMovementUp) before($(SECTION_SEL)[0], v.wrapAroundElements);
            else after($(SECTION_SEL)[$(SECTION_SEL).length - 1], v.wrapAroundElements);
            silentScroll($(SECTION_ACTIVE_SEL)[0].offsetTop);
            // Maintain the active slides visible in the viewport
            keepSlidesPosition();
        }
        /**
        * Actions to do once the section is loaded.
        */ function afterSectionLoads(v) {
            continuousVerticalFixSectionOrder(v);
            //callback (afterLoad) if the site is not just resizing and readjusting the slides
            if (isFunction(options.afterLoad) && !v.localIsResizing) fireCallback('afterLoad', v);
            if (options.scrollOverflow) options.scrollOverflowHandler.afterLoad();
            if (!v.localIsResizing) playMedia(v.element);
            addClass(v.element, COMPLETELY);
            removeClass(siblings(v.element), COMPLETELY);
            lazyLoadOthers();
            canScroll = true;
            if (isFunction(v.callback)) v.callback();
        }
        /**
        * Sets the value for the given attribute from the `data-` attribute with the same suffix
        * ie: data-srcset ==> srcset  |  data-src ==> src
        */ function setSrc(element, attribute) {
            element.setAttribute(attribute, element.getAttribute('data-' + attribute));
            element.removeAttribute('data-' + attribute);
        }
        /**
        * Makes sure lazyload is done for other sections in the viewport that are not the
        * active one. 
        */ function lazyLoadOthers() {
            var hasAutoHeightSections = $(AUTO_HEIGHT_SEL)[0] || isResponsiveMode() && $(AUTO_HEIGHT_RESPONSIVE_SEL)[0];
            //quitting when it doesn't apply
            if (!options.lazyLoading || !hasAutoHeightSections) return;
            //making sure to lazy load auto-height sections that are in the viewport
            $(SECTION_SEL + ':not(' + ACTIVE_SEL + ')').forEach(function(section) {
                if (isSectionInViewport(section)) lazyLoad(section);
            });
        }
        /**
        * Lazy loads image, video and audio elements.
        */ function lazyLoad(destiny) {
            if (!options.lazyLoading) return;
            var panel = getSlideOrSection(destiny);
            $('img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]', panel).forEach(function(element) {
                [
                    'src',
                    'srcset'
                ].forEach(function(type) {
                    var attribute = element.getAttribute('data-' + type);
                    if (attribute != null && attribute) {
                        setSrc(element, type);
                        element.addEventListener('load', function() {
                            onMediaLoad(destiny);
                        });
                    }
                });
                if (matches(element, 'source')) {
                    var elementToPlay = closest(element, 'video, audio');
                    if (elementToPlay) {
                        elementToPlay.load();
                        elementToPlay.onloadeddata = function() {
                            onMediaLoad(destiny);
                        };
                    }
                }
            });
        }
        /**
        * Callback firing when a lazy load media element has loaded.
        * Making sure it only fires one per section in normal conditions (if load time is not huge)
        */ function onMediaLoad(section) {
            if (options.scrollOverflow) {
                clearTimeout(g_mediaLoadedId);
                g_mediaLoadedId = setTimeout(function() {
                    if (!hasClass($body, RESPONSIVE)) scrollBarHandler.createScrollBar(section);
                }, 200);
            }
        }
        /**
        * Plays video and audio elements.
        */ function playMedia(destiny) {
            var panel = getSlideOrSection(destiny);
            //playing HTML5 media elements
            $('video, audio', panel).forEach(function(element) {
                if (element.hasAttribute('data-autoplay') && typeof element.play === 'function') element.play();
            });
            //youtube videos
            $('iframe[src*="youtube.com/embed/"]', panel).forEach(function(element) {
                if (element.hasAttribute('data-autoplay')) playYoutube(element);
                //in case the URL was not loaded yet. On page load we need time for the new URL (with the API string) to load.
                element.onload = function() {
                    if (element.hasAttribute('data-autoplay')) playYoutube(element);
                };
            });
        }
        /**
        * Plays a youtube video
        */ function playYoutube(element) {
            element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        /**
        * Stops video and audio elements.
        */ function stopMedia(destiny) {
            var panel = getSlideOrSection(destiny);
            //stopping HTML5 media elements
            $('video, audio', panel).forEach(function(element) {
                if (!element.hasAttribute('data-keepplaying') && typeof element.pause === 'function') element.pause();
            });
            //youtube videos
            $('iframe[src*="youtube.com/embed/"]', panel).forEach(function(element) {
                if (/youtube\.com\/embed\//.test(element.getAttribute('src')) && !element.hasAttribute('data-keepplaying')) element.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            });
        }
        /**
        * Gets the active slide (or section) for the given section
        */ function getSlideOrSection(destiny) {
            var slide = $(SLIDE_ACTIVE_SEL, destiny);
            if (slide.length) destiny = slide[0];
            return destiny;
        }
        /**
        * Scrolls to the anchor in the URL when loading the site
        */ function scrollToAnchor() {
            var anchors = getAnchorsURL();
            var sectionAnchor = anchors.section;
            var slideAnchor = anchors.slide;
            if (sectionAnchor) {
                if (options.animateAnchor) scrollPageAndSlide(sectionAnchor, slideAnchor);
                else silentMoveTo(sectionAnchor, slideAnchor);
            }
        }
        /**
        * Detecting any change on the URL to scroll to the given anchor link
        * (a way to detect back history button as we play with the hashes on the URL)
        */ function hashChangeHandler() {
            if (!isScrolling && !options.lockAnchors) {
                var anchors = getAnchorsURL();
                var sectionAnchor = anchors.section;
                var slideAnchor = anchors.slide;
                //when moving to a slide in the first section for the first time (first time to add an anchor to the URL)
                var isFirstSlideMove = typeof lastScrolledDestiny === 'undefined';
                var isFirstScrollMove = typeof lastScrolledDestiny === 'undefined' && typeof slideAnchor === 'undefined' && !slideMoving;
                if (sectionAnchor && sectionAnchor.length) /*in order to call scrollpage() only once for each destination at a time
                    It is called twice for each scroll otherwise, as in case of using anchorlinks `hashChange`
                    event is fired on every scroll too.*/ {
                    if (sectionAnchor && sectionAnchor !== lastScrolledDestiny && !isFirstSlideMove || isFirstScrollMove || !slideMoving && lastScrolledSlide != slideAnchor) scrollPageAndSlide(sectionAnchor, slideAnchor);
                }
            }
        }
        //gets the URL anchors (section and slide)
        function getAnchorsURL() {
            var section;
            var slide;
            var hash = window1.location.hash;
            if (hash.length) {
                //getting the anchor link in the URL and deleting the `#`
                var anchorsParts = hash.replace('#', '').split('/');
                //using / for visual reasons and not as a section/slide separator #2803
                var isFunkyAnchor = hash.indexOf('#/') > -1;
                section = isFunkyAnchor ? '/' + anchorsParts[1] : decodeURIComponent(anchorsParts[0]);
                var slideAnchor = isFunkyAnchor ? anchorsParts[2] : anchorsParts[1];
                if (slideAnchor && slideAnchor.length) slide = decodeURIComponent(slideAnchor);
            }
            return {
                section: section,
                slide: slide
            };
        }
        //Sliding with arrow keys, both, vertical and horizontal
        function keydownHandler(e) {
            clearTimeout(keydownId);
            var activeElement = document1.activeElement;
            var keyCode = e.keyCode;
            //tab?
            if (keyCode === 9) onTab(e);
            else if (!matches(activeElement, 'textarea') && !matches(activeElement, 'input') && !matches(activeElement, 'select') && activeElement.getAttribute('contentEditable') !== "true" && activeElement.getAttribute('contentEditable') !== '' && options.keyboardScrolling && options.autoScrolling) {
                //preventing the scroll with arrow keys & spacebar & Page Up & Down keys
                var keyControls = [
                    40,
                    38,
                    32,
                    33,
                    34
                ];
                if (keyControls.indexOf(keyCode) > -1) preventDefault(e);
                controlPressed = e.ctrlKey;
                keydownId = setTimeout(function() {
                    onkeydown(e);
                }, 150);
            }
        }
        function tooltipTextHandler() {
            /*jshint validthis:true */ trigger(prev(this), 'click');
        }
        //to prevent scrolling while zooming
        function keyUpHandler(e) {
            if (isWindowFocused) controlPressed = e.ctrlKey;
        }
        //binding the mousemove when the mouse's middle button is released
        function mouseDownHandler(e) {
            //middle button
            if (e.which == 2) {
                oldPageY = e.pageY;
                container.addEventListener('mousemove', mouseMoveHandler);
            }
        }
        //unbinding the mousemove when the mouse's middle button is released
        function mouseUpHandler(e) {
            //middle button
            if (e.which == 2) container.removeEventListener('mousemove', mouseMoveHandler);
        }
        /**
        * Makes sure the tab key will only focus elements within the current section/slide
        * preventing this way from breaking the page.
        * Based on "Modals and keyboard traps"
        * from https://developers.google.com/web/fundamentals/accessibility/focus/using-tabindex
        */ function onTab(e) {
            var isShiftPressed = e.shiftKey;
            var activeElement = document1.activeElement;
            var focusableElements = getFocusables(getSlideOrSection($(SECTION_ACTIVE_SEL)[0]));
            function preventAndFocusFirst(e) {
                preventDefault(e);
                return focusableElements[0] ? focusableElements[0].focus() : null;
            }
            //outside any section or slide? Let's not hijack the tab!
            if (isFocusOutside(e)) return;
            //is there an element with focus?
            if (activeElement) {
                if (closest(activeElement, SECTION_ACTIVE_SEL + ',' + SECTION_ACTIVE_SEL + ' ' + SLIDE_ACTIVE_SEL) == null) activeElement = preventAndFocusFirst(e);
            } else preventAndFocusFirst(e);
            //when reached the first or last focusable element of the section/slide
            //we prevent the tab action to keep it in the last focusable element
            if (!isShiftPressed && activeElement == focusableElements[focusableElements.length - 1] || isShiftPressed && activeElement == focusableElements[0]) preventDefault(e);
        }
        /**
        * Gets all the focusable elements inside the passed element.
        */ function getFocusables(el) {
            return [].slice.call($(focusableElementsString, el)).filter(function(item) {
                return item.getAttribute('tabindex') !== '-1' && item.offsetParent !== null;
            });
        }
        /**
        * Determines whether the focus is outside fullpage.js sections/slides or not.
        */ function isFocusOutside(e) {
            var allFocusables = getFocusables(document1);
            var currentFocusIndex = allFocusables.indexOf(document1.activeElement);
            var focusDestinationIndex = e.shiftKey ? currentFocusIndex - 1 : currentFocusIndex + 1;
            var focusDestination = allFocusables[focusDestinationIndex];
            var destinationItemSlide = nullOrSlide(closest(focusDestination, SLIDE_SEL));
            var destinationItemSection = nullOrSection(closest(focusDestination, SECTION_SEL));
            return !destinationItemSlide && !destinationItemSection;
        }
        //Scrolling horizontally when clicking on the slider controls.
        function slideArrowHandler() {
            /*jshint validthis:true */ var section = closest(this, SECTION_SEL);
            /*jshint validthis:true */ if (hasClass(this, SLIDES_PREV)) {
                if (isScrollAllowed.m.left) moveSlideLeft(section);
            } else if (isScrollAllowed.m.right) moveSlideRight(section);
        }
        // changing isWindowFocused to true on focus event
        function focusHandler() {
            isWindowFocused = true;
        }
        //when opening a new tab (ctrl + t), `control` won't be pressed when coming back.
        function blurHandler() {
            isWindowFocused = false;
            controlPressed = false;
        }
        //Scrolls to the section when clicking the navigation bullet
        function sectionBulletHandler(e) {
            preventDefault(e);
            /*jshint validthis:true */ var indexBullet = index(closest(this, SECTION_NAV_SEL + ' li'));
            scrollPage($(SECTION_SEL)[indexBullet]);
        }
        //Scrolls the slider to the given slide destination for the given section
        function slideBulletHandler(e) {
            preventDefault(e);
            /*jshint validthis:true */ var slides = $(SLIDES_WRAPPER_SEL, closest(this, SECTION_SEL))[0];
            var destiny = $(SLIDE_SEL, slides)[index(closest(this, 'li'))];
            landscapeScroll(slides, destiny);
        }
        //Menu item handler when not using anchors or using lockAnchors:true
        function menuItemsHandler(e) {
            if ($(options.menu)[0] && (options.lockAnchors || !options.anchors.length)) {
                preventDefault(e);
                /*jshint validthis:true */ moveTo(this.getAttribute('data-menuanchor'));
            }
        }
        /**
        * Keydown event
        */ function onkeydown(e) {
            var shiftPressed = e.shiftKey;
            var activeElement = document1.activeElement;
            var isMediaFocused = matches(activeElement, 'video') || matches(activeElement, 'audio');
            //do nothing if we can not scroll or we are not using horizotnal key arrows.
            if (!canScroll && [
                37,
                39
            ].indexOf(e.keyCode) < 0) return;
            switch(e.keyCode){
                //up
                case 38:
                case 33:
                    if (isScrollAllowed.k.up) moveSectionUp();
                    break;
                //down
                case 32:
                    if (shiftPressed && isScrollAllowed.k.up && !isMediaFocused) {
                        moveSectionUp();
                        break;
                    }
                /* falls through */ case 40:
                case 34:
                    if (isScrollAllowed.k.down) // space bar?
                    {
                        if (e.keyCode !== 32 || !isMediaFocused) moveSectionDown();
                    }
                    break;
                //Home
                case 36:
                    if (isScrollAllowed.k.up) moveTo(1);
                    break;
                //End
                case 35:
                    if (isScrollAllowed.k.down) moveTo($(SECTION_SEL).length);
                    break;
                //left
                case 37:
                    if (isScrollAllowed.k.left) moveSlideLeft();
                    break;
                //right
                case 39:
                    if (isScrollAllowed.k.right) moveSlideRight();
                    break;
                default:
                    return; // exit this handler for other keys
            }
        }
        /**
        * Detecting the direction of the mouse movement.
        * Used only for the middle button of the mouse.
        */ var oldPageY = 0;
        function mouseMoveHandler(e) {
            if (!options.autoScrolling) return;
            if (canScroll) {
                // moving up
                if (e.pageY < oldPageY && isScrollAllowed.m.up) moveSectionUp();
                else if (e.pageY > oldPageY && isScrollAllowed.m.down) moveSectionDown();
            }
            oldPageY = e.pageY;
        }
        /**
        * Scrolls horizontal sliders.
        */ function landscapeScroll(slides, destiny, direction) {
            var section = closest(slides, SECTION_SEL);
            var v = {
                slides: slides,
                destiny: destiny,
                direction: direction,
                destinyPos: {
                    left: destiny.offsetLeft
                },
                slideIndex: index(destiny),
                section: section,
                sectionIndex: index(section, SECTION_SEL),
                anchorLink: section.getAttribute('data-anchor'),
                slidesNav: $(SLIDES_NAV_SEL, section)[0],
                slideAnchor: getAnchor(destiny),
                prevSlide: $(SLIDE_ACTIVE_SEL, section)[0],
                prevSlideIndex: index($(SLIDE_ACTIVE_SEL, section)[0]),
                //caching the value of isResizing at the momment the function is called
                //because it will be checked later inside a setTimeout and the value might change
                localIsResizing: isResizing
            };
            v.xMovement = getXmovement(v.prevSlideIndex, v.slideIndex);
            v.direction = v.direction ? v.direction : v.xMovement;
            //important!! Only do it when not resizing
            if (!v.localIsResizing) //preventing from scrolling to the next/prev section when using scrollHorizontally
            canScroll = false;
            if (options.onSlideLeave) //if the site is not just resizing and readjusting the slides
            {
                if (!v.localIsResizing && v.xMovement !== 'none') {
                    if (isFunction(options.onSlideLeave)) {
                        if (fireCallback('onSlideLeave', v) === false) {
                            slideMoving = false;
                            return;
                        }
                    }
                }
            }
            addClass(destiny, ACTIVE);
            removeClass(siblings(destiny), ACTIVE);
            if (!v.localIsResizing) {
                stopMedia(v.prevSlide);
                lazyLoad(destiny);
            }
            if (!options.loopHorizontal && options.controlArrows) {
                //hidding it for the fist slide, showing for the rest
                toggle($(SLIDES_ARROW_PREV_SEL, section), v.slideIndex !== 0);
                //hidding it for the last slide, showing for the rest
                toggle($(SLIDES_ARROW_NEXT_SEL, section), next(destiny) != null);
            }
            //only changing the URL if the slides are in the current section (not for resize re-adjusting)
            if (hasClass(section, ACTIVE) && !v.localIsResizing) setState(v.slideIndex, v.slideAnchor, v.anchorLink, v.sectionIndex);
            performHorizontalMove(slides, v, true);
        }
        function afterSlideLoads(v) {
            activeSlidesNavigation(v.slidesNav, v.slideIndex);
            //if the site is not just resizing and readjusting the slides
            if (!v.localIsResizing) {
                if (isFunction(options.afterSlideLoad)) fireCallback('afterSlideLoad', v);
                //needs to be inside the condition to prevent problems with continuousVertical and scrollHorizontally
                //and to prevent double scroll right after a windows resize
                canScroll = true;
                playMedia(v.destiny);
            }
            //letting them slide again
            slideMoving = false;
        }
        /**
        * Performs the horizontal movement. (CSS3 or jQuery)
        *
        * @param fireCallback {Bool} - determines whether or not to fire the callback
        */ function performHorizontalMove(slides, v, fireCallback) {
            var destinyPos = v.destinyPos;
            if (options.css3) {
                var translate3d = 'translate3d(-' + Math.round(destinyPos.left) + 'px, 0px, 0px)';
                FP.test.translate3dH[v.sectionIndex] = translate3d;
                css(addAnimation($(SLIDES_CONTAINER_SEL, slides)), getTransforms(translate3d));
                afterSlideLoadsId = setTimeout(function() {
                    if (fireCallback) afterSlideLoads(v);
                }, options.scrollingSpeed);
            } else {
                FP.test.left[v.sectionIndex] = Math.round(destinyPos.left);
                scrollTo(slides, Math.round(destinyPos.left), options.scrollingSpeed, function() {
                    if (fireCallback) afterSlideLoads(v);
                });
            }
        }
        /**
        * Sets the state for the horizontal bullet navigations.
        */ function activeSlidesNavigation(slidesNav, slideIndex) {
            if (options.slidesNavigation && slidesNav != null) {
                removeClass($(ACTIVE_SEL, slidesNav), ACTIVE);
                addClass($('a', $('li', slidesNav)[slideIndex]), ACTIVE);
            }
        }
        var previousHeight = windowsHeight;
        /*
        * Resize event handler.
        */ function resizeHandler() {
            clearTimeout(resizeId);
            //in order to call the functions only when the resize is finished
            //http://stackoverflow.com/questions/4298612/jquery-how-to-call-resize-event-only-once-its-finished-resizing    
            resizeId = setTimeout(function() {
                //issue #3336 
                //(some apps or browsers, like Chrome/Firefox for Mobile take time to report the real height)
                //so we check it 3 times with intervals in that case
                for(var i = 0; i < 4; i++)resizeHandlerId = setTimeout(resizeActions, 200 * i);
            }, 200);
        }
        /**
        * When resizing the site, we adjust the heights of the sections, slimScroll...
        */ function resizeActions() {
            isResizing = true;
            //checking if it needs to get responsive
            responsive();
            // rebuild immediately on touch devices
            if (isTouchDevice) {
                var activeElement = document1.activeElement;
                //if the keyboard is NOT visible
                if (!matches(activeElement, 'textarea') && !matches(activeElement, 'input') && !matches(activeElement, 'select')) {
                    var currentHeight = getWindowHeight();
                    //making sure the change in the viewport size is enough to force a rebuild. (20 % of the window to avoid problems when hidding scroll bars)
                    if (Math.abs(currentHeight - previousHeight) > 20 * Math.max(previousHeight, currentHeight) / 100) {
                        reBuild(true);
                        previousHeight = currentHeight;
                    }
                }
            } else adjustToNewViewport();
            isResizing = false;
        }
        /**
        * Checks if the site needs to get responsive and disables autoScrolling if so.
        * A class `fp-responsive` is added to the plugin's container in case the user wants to use it for his own responsive CSS.
        */ function responsive() {
            var widthLimit = options.responsive || options.responsiveWidth; //backwards compatiblity
            var heightLimit = options.responsiveHeight;
            //only calculating what we need. Remember its called on the resize event.
            var isBreakingPointWidth = widthLimit && window1.innerWidth < widthLimit;
            var isBreakingPointHeight = heightLimit && window1.innerHeight < heightLimit;
            if (widthLimit && heightLimit) setResponsive(isBreakingPointWidth || isBreakingPointHeight);
            else if (widthLimit) setResponsive(isBreakingPointWidth);
            else if (heightLimit) setResponsive(isBreakingPointHeight);
        }
        /**
        * Adds transition animations for the given element
        */ function addAnimation(element) {
            var transition = 'all ' + options.scrollingSpeed + 'ms ' + options.easingcss3;
            removeClass(element, NO_TRANSITION);
            return css(element, {
                '-webkit-transition': transition,
                'transition': transition
            });
        }
        /**
        * Remove transition animations for the given element
        */ function removeAnimation(element) {
            return addClass(element, NO_TRANSITION);
        }
        /**
        * Activating the vertical navigation bullets according to the given slide name.
        */ function activateNavDots(name, sectionIndex) {
            if (options.navigation && $(SECTION_NAV_SEL)[0] != null) {
                removeClass($(ACTIVE_SEL, $(SECTION_NAV_SEL)[0]), ACTIVE);
                if (name) addClass($('a[href="#' + name + '"]', $(SECTION_NAV_SEL)[0]), ACTIVE);
                else addClass($('a', $('li', $(SECTION_NAV_SEL)[0])[sectionIndex]), ACTIVE);
            }
        }
        /**
        * Activating the website main menu elements according to the given slide name.
        */ function activateMenuElement(name) {
            $(options.menu).forEach(function(menu) {
                if (options.menu && menu != null) {
                    removeClass($(ACTIVE_SEL, menu), ACTIVE);
                    addClass($('[data-menuanchor="' + name + '"]', menu), ACTIVE);
                }
            });
        }
        /**
        * Sets to active the current menu and vertical nav items.
        */ function activateMenuAndNav(anchor, index) {
            activateMenuElement(anchor);
            activateNavDots(anchor, index);
        }
        /**
        * Retuns `up` or `down` depending on the scrolling movement to reach its destination
        * from the current section.
        */ function getYmovement(destiny) {
            var fromIndex = index($(SECTION_ACTIVE_SEL)[0], SECTION_SEL);
            var toIndex = index(destiny, SECTION_SEL);
            if (fromIndex == toIndex) return 'none';
            if (fromIndex > toIndex) return 'up';
            return 'down';
        }
        /**
        * Retuns `right` or `left` depending on the scrolling movement to reach its destination
        * from the current slide.
        */ function getXmovement(fromIndex, toIndex) {
            if (fromIndex == toIndex) return 'none';
            if (fromIndex > toIndex) return 'left';
            return 'right';
        }
        function addTableClass(element) {
            //In case we are styling for the 2nd time as in with reponsiveSlides
            if (!hasClass(element, TABLE)) {
                var wrapper = document1.createElement('div');
                wrapper.className = TABLE_CELL;
                wrapper.style.height = getTableHeight(element) + 'px';
                addClass(element, TABLE);
                wrapInner(element, wrapper);
            }
        }
        function getTableHeight(element) {
            var sectionHeight = windowsHeight;
            if (options.paddingTop || options.paddingBottom) {
                var section = element;
                if (!hasClass(section, SECTION)) section = closest(element, SECTION_SEL);
                var paddings = parseInt(getComputedStyle(section)['padding-top']) + parseInt(getComputedStyle(section)['padding-bottom']);
                sectionHeight = windowsHeight - paddings;
            }
            return sectionHeight;
        }
        /**
        * Adds a css3 transform property to the container class with or without animation depending on the animated param.
        */ function transformContainer(translate3d, animated) {
            if (animated) addAnimation(container);
            else removeAnimation(container);
            css(container, getTransforms(translate3d));
            FP.test.translate3d = translate3d;
            //syncronously removing the class after the animation has been applied.
            setTimeout(function() {
                removeClass(container, NO_TRANSITION);
            }, 10);
        }
        /**
        * Gets a section by its anchor / index
        */ function getSectionByAnchor(sectionAnchor) {
            var section = $(SECTION_SEL + '[data-anchor="' + sectionAnchor + '"]', container)[0];
            if (!section) {
                var sectionIndex = typeof sectionAnchor !== 'undefined' ? sectionAnchor - 1 : 0;
                section = $(SECTION_SEL)[sectionIndex];
            }
            return section;
        }
        /**
        * Gets a slide inside a given section by its anchor / index
        */ function getSlideByAnchor(slideAnchor, section) {
            var slide = $(SLIDE_SEL + '[data-anchor="' + slideAnchor + '"]', section)[0];
            if (slide == null) {
                slideAnchor = typeof slideAnchor !== 'undefined' ? slideAnchor : 0;
                slide = $(SLIDE_SEL, section)[slideAnchor];
            }
            return slide;
        }
        /**
        * Scrolls to the given section and slide anchors
        */ function scrollPageAndSlide(sectionAnchor, slideAnchor) {
            var section = getSectionByAnchor(sectionAnchor);
            //do nothing if there's no section with the given anchor name
            if (section == null) return;
            var slide = getSlideByAnchor(slideAnchor, section);
            //we need to scroll to the section and then to the slide
            if (getAnchor(section) !== lastScrolledDestiny && !hasClass(section, ACTIVE)) scrollPage(section, function() {
                scrollSlider(slide);
            });
            else scrollSlider(slide);
        }
        /**
        * Scrolls the slider to the given slide destination for the given section
        */ function scrollSlider(slide) {
            if (slide != null) landscapeScroll(closest(slide, SLIDES_WRAPPER_SEL), slide);
        }
        /**
        * Creates a landscape navigation bar with dots for horizontal sliders.
        */ function addSlidesNavigation(section, numSlides) {
            appendTo(createElementFromHTML('<div class="' + SLIDES_NAV + '"><ul></ul></div>'), section);
            var nav = $(SLIDES_NAV_SEL, section)[0];
            //top or bottom
            addClass(nav, 'fp-' + options.slidesNavPosition);
            for(var i = 0; i < numSlides; i++){
                var slide = $(SLIDE_SEL, section)[i];
                appendTo(createElementFromHTML('<li><a href="#"><span class="fp-sr-only">' + getBulletLinkName(i, 'Slide', slide) + '</span><span></span></a></li>'), $('ul', nav)[0]);
            }
            //centering it
            css(nav, {
                'margin-left': '-' + nav.innerWidth / 2 + 'px'
            });
            addClass($('a', $('li', nav)[0]), ACTIVE);
        }
        /**
        * Sets the state of the website depending on the active section/slide.
        * It changes the URL hash when needed and updates the body class.
        */ function setState(slideIndex, slideAnchor, anchorLink, sectionIndex) {
            var sectionHash = '';
            if (options.anchors.length && !options.lockAnchors) {
                //isn't it the first slide?
                if (slideIndex) {
                    if (anchorLink != null) sectionHash = anchorLink;
                    //slide without anchor link? We take the index instead.
                    if (slideAnchor == null) slideAnchor = slideIndex;
                    lastScrolledSlide = slideAnchor;
                    setUrlHash(sectionHash + '/' + slideAnchor);
                //first slide won't have slide anchor, just the section one
                } else if (slideIndex != null) {
                    lastScrolledSlide = slideAnchor;
                    setUrlHash(anchorLink);
                } else setUrlHash(anchorLink);
            }
            setBodyClass();
        }
        /**
        * Sets the URL hash.
        */ function setUrlHash(url) {
            if (options.recordHistory) location.hash = url;
            else //Mobile Chrome doesn't work the normal way, so... lets use HTML5 for phones :)
            if (isTouchDevice || isTouch) window1.history.replaceState(undefined, undefined, '#' + url);
            else {
                var baseUrl = window1.location.href.split('#')[0];
                window1.location.replace(baseUrl + '#' + url);
            }
        }
        /**
        * Gets the anchor for the given slide / section. Its index will be used if there's none.
        */ function getAnchor(element) {
            if (!element) return null;
            var anchor = element.getAttribute('data-anchor');
            var elementIndex = index(element);
            //Slide without anchor link? We take the index instead.
            if (anchor == null) anchor = elementIndex;
            return anchor;
        }
        /**
        * Sets a class for the body of the page depending on the active section / slide
        */ function setBodyClass() {
            var section = $(SECTION_ACTIVE_SEL)[0];
            var slide = $(SLIDE_ACTIVE_SEL, section)[0];
            var sectionAnchor = getAnchor(section);
            var slideAnchor = getAnchor(slide);
            var text = String(sectionAnchor);
            if (slide) text = text + '-' + slideAnchor;
            //changing slash for dash to make it a valid CSS style
            text = text.replace('/', '-').replace('#', '');
            //removing previous anchor classes
            var classRe = new RegExp('\\b\\s?' + VIEWING_PREFIX + '-[^\\s]+\\b', "g");
            $body.className = $body.className.replace(classRe, '');
            //adding the current anchor
            addClass($body, VIEWING_PREFIX + '-' + text);
        }
        /**
        * Checks for translate3d support
        * @return boolean
        * http://stackoverflow.com/questions/5661671/detecting-transform-translate3d-support
        */ function support3d() {
            var el = document1.createElement('p'), has3d, transforms = {
                'webkitTransform': '-webkit-transform',
                'OTransform': '-o-transform',
                'msTransform': '-ms-transform',
                'MozTransform': '-moz-transform',
                'transform': 'transform'
            };
            //preventing the style p:empty{display: none;} from returning the wrong result
            el.style.display = 'block';
            // Add it to the body to get the computed style.
            document1.body.insertBefore(el, null);
            for(var t in transforms)if (el.style[t] !== undefined) {
                el.style[t] = 'translate3d(1px,1px,1px)';
                has3d = window1.getComputedStyle(el).getPropertyValue(transforms[t]);
            }
            document1.body.removeChild(el);
            return has3d !== undefined && has3d.length > 0 && has3d !== 'none';
        }
        /**
        * Removes the auto scrolling action fired by the mouse wheel and trackpad.
        * After this function is called, the mousewheel and trackpad movements won't scroll through sections.
        */ function removeMouseWheelHandler() {
            if (document1.addEventListener) {
                document1.removeEventListener('mousewheel', MouseWheelHandler, false); //IE9, Chrome, Safari, Oper
                document1.removeEventListener('wheel', MouseWheelHandler, false); //Firefox
                document1.removeEventListener('MozMousePixelScroll', MouseWheelHandler, false); //old Firefox
            } else document1.detachEvent('onmousewheel', MouseWheelHandler); //IE 6/7/8
        }
        /**
        * Adds the auto scrolling action for the mouse wheel and trackpad.
        * After this function is called, the mousewheel and trackpad movements will scroll through sections
        * https://developer.mozilla.org/en-US/docs/Web/Events/wheel
        */ function addMouseWheelHandler() {
            var prefix = '';
            var _addEventListener;
            if (window1.addEventListener) _addEventListener = "addEventListener";
            else {
                _addEventListener = "attachEvent";
                prefix = 'on';
            }
            // detect available wheel event
            var support = 'onwheel' in document1.createElement('div') ? 'wheel' : document1.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
            var passiveEvent = g_supportsPassive ? {
                passive: false
            } : false;
            if (support == 'DOMMouseScroll') document1[_addEventListener](prefix + 'MozMousePixelScroll', MouseWheelHandler, passiveEvent);
            else document1[_addEventListener](prefix + support, MouseWheelHandler, passiveEvent);
        }
        /**
        * Binding the mousemove when the mouse's middle button is pressed
        */ function addMiddleWheelHandler() {
            container.addEventListener('mousedown', mouseDownHandler);
            container.addEventListener('mouseup', mouseUpHandler);
        }
        /**
        * Unbinding the mousemove when the mouse's middle button is released
        */ function removeMiddleWheelHandler() {
            container.removeEventListener('mousedown', mouseDownHandler);
            container.removeEventListener('mouseup', mouseUpHandler);
        }
        /**
        * Adds the possibility to auto scroll through sections on touch devices.
        */ function addTouchHandler() {
            if (isTouchDevice || isTouch) {
                if (options.autoScrolling) {
                    $body.removeEventListener(events.touchmove, preventBouncing, {
                        passive: false
                    });
                    $body.addEventListener(events.touchmove, preventBouncing, {
                        passive: false
                    });
                }
                var touchWrapper = options.touchWrapper;
                touchWrapper.removeEventListener(events.touchstart, touchStartHandler);
                touchWrapper.removeEventListener(events.touchmove, touchMoveHandler, {
                    passive: false
                });
                touchWrapper.addEventListener(events.touchstart, touchStartHandler);
                touchWrapper.addEventListener(events.touchmove, touchMoveHandler, {
                    passive: false
                });
            }
        }
        /**
        * Removes the auto scrolling for touch devices.
        */ function removeTouchHandler() {
            if (isTouchDevice || isTouch) {
                // normalScrollElements requires it off #2691
                if (options.autoScrolling) {
                    $body.removeEventListener(events.touchmove, touchMoveHandler, {
                        passive: false
                    });
                    $body.removeEventListener(events.touchmove, preventBouncing, {
                        passive: false
                    });
                }
                var touchWrapper = options.touchWrapper;
                touchWrapper.removeEventListener(events.touchstart, touchStartHandler);
                touchWrapper.removeEventListener(events.touchmove, touchMoveHandler, {
                    passive: false
                });
            }
        }
        /*
        * Returns and object with Microsoft pointers (for IE<11 and for IE >= 11)
        * http://msdn.microsoft.com/en-us/library/ie/dn304886(v=vs.85).aspx
        */ function getMSPointer() {
            var pointer;
            //IE >= 11 & rest of browsers
            if (window1.PointerEvent) pointer = {
                down: 'pointerdown',
                move: 'pointermove'
            };
            else pointer = {
                down: 'MSPointerDown',
                move: 'MSPointerMove'
            };
            return pointer;
        }
        /**
        * Gets the pageX and pageY properties depending on the browser.
        * https://github.com/alvarotrigo/fullPage.js/issues/194#issuecomment-34069854
        */ function getEventsPage(e) {
            var events = [];
            events.y = typeof e.pageY !== 'undefined' && (e.pageY || e.pageX) ? e.pageY : e.touches[0].pageY;
            events.x = typeof e.pageX !== 'undefined' && (e.pageY || e.pageX) ? e.pageX : e.touches[0].pageX;
            //in touch devices with scrollBar:true, e.pageY is detected, but we have to deal with touch events. #1008
            if (isTouch && isReallyTouch(e) && options.scrollBar && typeof e.touches !== 'undefined') {
                events.y = e.touches[0].pageY;
                events.x = e.touches[0].pageX;
            }
            return events;
        }
        /**
        * Slides silently (with no animation) the active slider to the given slide.
        * @param noCallback {bool} true or defined -> no callbacks
        */ function silentLandscapeScroll(activeSlide, noCallbacks) {
            setScrollingSpeed(0, 'internal');
            if (typeof noCallbacks !== 'undefined') //preventing firing callbacks afterSlideLoad etc.
            isResizing = true;
            landscapeScroll(closest(activeSlide, SLIDES_WRAPPER_SEL), activeSlide);
            if (typeof noCallbacks !== 'undefined') isResizing = false;
            setScrollingSpeed(originals.scrollingSpeed, 'internal');
        }
        /**
        * Scrolls silently (with no animation) the page to the given Y position.
        */ function silentScroll(top) {
            // The first section can have a negative value in iOS 10. Not quite sure why: -0.0142822265625
            // that's why we round it to 0.
            var roundedTop = Math.round(top);
            if (options.css3 && options.autoScrolling && !options.scrollBar) {
                var translate3d = 'translate3d(0px, -' + roundedTop + 'px, 0px)';
                transformContainer(translate3d, false);
            } else if (options.autoScrolling && !options.scrollBar) {
                css(container, {
                    'top': -roundedTop + 'px'
                });
                FP.test.top = -roundedTop + 'px';
            } else {
                var scrollSettings = getScrollSettings(roundedTop);
                setScrolling(scrollSettings.element, scrollSettings.options);
            }
        }
        /**
        * Returns the cross-browser transform string.
        */ function getTransforms(translate3d) {
            return {
                '-webkit-transform': translate3d,
                '-moz-transform': translate3d,
                '-ms-transform': translate3d,
                'transform': translate3d
            };
        }
        /**
        * Allowing or disallowing the mouse/swipe scroll in a given direction. (not for keyboard)
        * @type  m (mouse) or k (keyboard)
        */ function setIsScrollAllowed(value, direction, type) {
            //up, down, left, right
            if (direction !== 'all') isScrollAllowed[type][direction] = value;
            else Object.keys(isScrollAllowed[type]).forEach(function(key) {
                isScrollAllowed[type][key] = value;
            });
        }
        /*
        * Destroys fullpage.js plugin events and optinally its html markup and styles
        */ function destroy(all) {
            setAutoScrolling(false, 'internal');
            setAllowScrolling(true);
            setMouseHijack(false);
            setKeyboardScrolling(false);
            addClass(container, DESTROYED);
            [
                afterSlideLoadsId,
                afterSectionLoadsId,
                resizeId,
                scrollId,
                scrollId2,
                g_doubleCheckHeightId,
                resizeHandlerId,
                g_transitionLapseId
            ].forEach(function(timeoutId) {
                clearTimeout(timeoutId);
            });
            window1.removeEventListener('scroll', scrollHandler);
            window1.removeEventListener('hashchange', hashChangeHandler);
            window1.removeEventListener('resize', resizeHandler);
            document1.removeEventListener('keydown', keydownHandler);
            document1.removeEventListener('keyup', keyUpHandler);
            [
                'click',
                'touchstart'
            ].forEach(function(eventName) {
                document1.removeEventListener(eventName, delegatedEvents);
            });
            [
                'mouseenter',
                'touchstart',
                'mouseleave',
                'touchend'
            ].forEach(function(eventName) {
                document1.removeEventListener(eventName, onMouseEnterOrLeave, true); //true is required!
            });
            //lets make a mess!
            if (all) destroyStructure();
        }
        /*
        * Removes inline styles added by fullpage.js
        */ function destroyStructure() {
            //reseting the `top` or `translate` properties to 0
            silentScroll(0);
            //loading all the lazy load content
            $('img[data-src], source[data-src], audio[data-src], iframe[data-src]', container).forEach(function(item) {
                setSrc(item, 'src');
            });
            $('img[data-srcset]').forEach(function(item) {
                setSrc(item, 'srcset');
            });
            remove($(SECTION_NAV_SEL + ', ' + SLIDES_NAV_SEL + ', ' + SLIDES_ARROW_SEL));
            //removing inline styles
            css($(SECTION_SEL), {
                'height': '',
                'background-color': '',
                'padding': ''
            });
            css($(SLIDE_SEL), {
                'width': ''
            });
            css(container, {
                'height': '',
                'position': '',
                '-ms-touch-action': '',
                'touch-action': ''
            });
            css($htmlBody, {
                'overflow': '',
                'height': ''
            });
            // remove .fp-enabled class
            removeClass($html, ENABLED);
            // remove .fp-responsive class
            removeClass($body, RESPONSIVE);
            // remove all of the .fp-viewing- classes
            $body.className.split(/\s+/).forEach(function(className) {
                if (className.indexOf(VIEWING_PREFIX) === 0) removeClass($body, className);
            });
            //removing added classes
            $(SECTION_SEL + ', ' + SLIDE_SEL).forEach(function(item) {
                if (options.scrollOverflowHandler && options.scrollOverflow) options.scrollOverflowHandler.remove(item);
                removeClass(item, TABLE + ' ' + ACTIVE + ' ' + COMPLETELY);
                var previousStyles = item.getAttribute('data-fp-styles');
                if (previousStyles) item.setAttribute('style', item.getAttribute('data-fp-styles'));
                //removing anchors if they were not set using the HTML markup
                if (hasClass(item, SECTION) && !g_initialAnchorsInDom) item.removeAttribute('data-anchor');
            });
            //removing the applied transition from the fullpage wrapper
            removeAnimation(container);
            //Unwrapping content
            [
                TABLE_CELL_SEL,
                SLIDES_CONTAINER_SEL,
                SLIDES_WRAPPER_SEL
            ].forEach(function(selector) {
                $(selector, container).forEach(function(item) {
                    //unwrap not being use in case there's no child element inside and its just text
                    unwrap(item);
                });
            });
            //removing the applied transition from the fullpage wrapper
            css(container, {
                '-webkit-transition': 'none',
                'transition': 'none'
            });
            //scrolling the page to the top with no animation
            window1.scrollTo(0, 0);
            //removing selectors
            var usedSelectors = [
                SECTION,
                SLIDE,
                SLIDES_CONTAINER
            ];
            usedSelectors.forEach(function(item) {
                removeClass($('.' + item), item);
            });
        }
        /*
        * Sets the state for a variable with multiple states (original, and temporal)
        * Some variables such as `autoScrolling` or `recordHistory` might change automatically its state when using `responsive` or `autoScrolling:false`.
        * This function is used to keep track of both states, the original and the temporal one.
        * If type is not 'internal', then we assume the user is globally changing the variable.
        */ function setVariableState(variable, value, type) {
            options[variable] = value;
            if (type !== 'internal') originals[variable] = value;
        }
        /**
        * Displays warnings
        */ function displayWarnings() {
            var l = options["licenseKey"];
            var msgStyle = 'font-size: 15px;background:yellow;';
            if (!isOK) {
                showError('error', 'Fullpage.js version 3 has changed its license to GPLv3 and it requires a `licenseKey` option. Read about it here:');
                showError('error', 'https://github.com/alvarotrigo/fullPage.js#options');
            } else if (l && l.length < 20) {
                console.warn('%c This website was made using fullPage.js slider. More info on the following website:', msgStyle);
                console.warn('%c https://alvarotrigo.com/fullPage/', msgStyle);
            }
            if (hasClass($html, ENABLED)) {
                showError('error', 'Fullpage.js can only be initialized once and you are doing it multiple times!');
                return;
            }
            // Disable mutually exclusive settings
            if (options.continuousVertical && (options.loopTop || options.loopBottom)) {
                options.continuousVertical = false;
                showError('warn', 'Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled');
            }
            if (options.scrollOverflow && (options.scrollBar || !options.autoScrolling)) showError('warn', 'Options scrollBar:true and autoScrolling:false are mutually exclusive with scrollOverflow:true. Sections with scrollOverflow might not work well in Firefox');
            if (options.continuousVertical && (options.scrollBar || !options.autoScrolling)) {
                options.continuousVertical = false;
                showError('warn', 'Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled');
            }
            if (options.scrollOverflow && options.scrollOverflowHandler == null) {
                options.scrollOverflow = false;
                showError('error', 'The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js.');
            }
            //using extensions? Wrong file!
            extensions.forEach(function(extension) {
                //is the option set to true?
                if (options[extension]) showError('warn', 'fullpage.js extensions require fullpage.extensions.min.js file instead of the usual fullpage.js. Requested: ' + extension);
            });
            //anchors can not have the same value as any element ID or NAME
            options.anchors.forEach(function(name) {
                //case insensitive selectors (http://stackoverflow.com/a/19465187/1081396)
                var nameAttr = [].slice.call($('[name]')).filter(function(item) {
                    return item.getAttribute('name') && item.getAttribute('name').toLowerCase() == name.toLowerCase();
                });
                var idAttr = [].slice.call($('[id]')).filter(function(item) {
                    return item.getAttribute('id') && item.getAttribute('id').toLowerCase() == name.toLowerCase();
                });
                if (idAttr.length || nameAttr.length) {
                    showError('error', 'data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE).');
                    var propertyName = idAttr.length ? 'id' : 'name';
                    if (idAttr.length || nameAttr.length) showError('error', '"' + name + '" is is being used by another element `' + propertyName + '` property');
                }
            });
        }
        /**
        * Getting the position of the element to scroll when using jQuery animations
        */ function getScrolledPosition(element) {
            var position;
            //is not the window element and is a slide?
            if (element.self != window1 && hasClass(element, SLIDES_WRAPPER)) position = element.scrollLeft;
            else if (!options.autoScrolling || options.scrollBar) position = getScrollTop();
            else position = element.offsetTop;
            //gets the top property of the wrapper
            return position;
        }
        /**
        * Simulates the animated scrollTop of jQuery. Used when css3:false or scrollBar:true or autoScrolling:false
        * http://stackoverflow.com/a/16136789/1081396
        */ function scrollTo(element, to, duration, callback) {
            var start = getScrolledPosition(element);
            var change = to - start;
            var currentTime = 0;
            var increment = 20;
            activeAnimation = true;
            var animateScroll = function() {
                if (activeAnimation) {
                    var val = to;
                    currentTime += increment;
                    if (duration) val = window1.fp_easings[options.easing](currentTime, start, change, duration);
                    setScrolling(element, val);
                    if (currentTime < duration) setTimeout(animateScroll, increment);
                    else if (typeof callback !== 'undefined') callback();
                } else if (currentTime < duration) callback();
            };
            animateScroll();
        }
        /**
        * Scrolls the page / slider the given number of pixels.
        * It will do it one or another way dependiong on the library's config.
        */ function setScrolling(element, val) {
            if (!options.autoScrolling || options.scrollBar || element.self != window1 && hasClass(element, SLIDES_WRAPPER)) {
                //scrolling horizontally through the slides?
                if (element.self != window1 && hasClass(element, SLIDES_WRAPPER)) element.scrollLeft = val;
                else element.scrollTo(0, val);
            } else element.style.top = val + 'px';
        }
        /**
        * Gets the active slide.
        */ function getActiveSlide() {
            var activeSlide = $(SLIDE_ACTIVE_SEL, $(SECTION_ACTIVE_SEL)[0])[0];
            return nullOrSlide(activeSlide);
        }
        /**
        * Gets the active section.
        */ function getActiveSection() {
            return new Section($(SECTION_ACTIVE_SEL)[0]);
        }
        /**
        * Item. Slide or Section objects share the same properties.
        */ function Item(el, selector) {
            this.anchor = el.getAttribute('data-anchor');
            this.item = el;
            this.index = index(el, selector);
            this.isLast = this.index === el.parentElement.querySelectorAll(selector).length - 1;
            this.isFirst = !this.index;
        }
        /**
        * Section object
        */ function Section(el) {
            Item.call(this, el, SECTION_SEL);
        }
        /**
        * Slide object
        */ function Slide(el) {
            Item.call(this, el, SLIDE_SEL);
        }
        return FP;
    } //end of $.fn.fullpage
    //utils
    /**
    * Shows a message in the console of the given type.
    */ function showError(type, text) {
        window1.console && window1.console[type] && window1.console[type]('fullPage: ' + text);
    }
    /**
    * Equivalent of jQuery function $().
    */ function $(selector, context) {
        context = arguments.length > 1 ? context : document1;
        return context ? context.querySelectorAll(selector) : null;
    }
    /**
    * Extends a given Object properties and its childs.
    */ function deepExtend(out) {
        out = out || {};
        for(var i = 1, len = arguments.length; i < len; ++i){
            var obj = arguments[i];
            if (!obj) continue;
            for(var key in obj){
                if (!obj.hasOwnProperty(key)) continue;
                // based on https://javascriptweblog.wordpress.com/2011/08/08/fixing-the-javascript-typeof-operator/
                if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
                    out[key] = deepExtend(out[key], obj[key]);
                    continue;
                }
                out[key] = obj[key];
            }
        }
        return out;
    }
    /**
    * Checks if the passed element contains the passed class.
    */ function hasClass(el, className) {
        if (el == null) return false;
        if (el.classList) return el.classList.contains(className);
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
    /**
    * Gets the window height. Crossbrowser.
    */ function getWindowHeight() {
        return 'innerHeight' in window1 ? window1.innerHeight : document1.documentElement.offsetHeight;
    }
    /**
    * Gets the window width.
    */ function getWindowWidth() {
        return window1.innerWidth;
    }
    /**
    * Set's the CSS properties for the passed item/s.
    * @param {NodeList|HTMLElement} items
    * @param {Object} props css properties and values.
    */ function css(items, props) {
        items = getList(items);
        var key;
        for(key in props)if (props.hasOwnProperty(key)) {
            if (key !== null) for(var i = 0; i < items.length; i++){
                var item = items[i];
                item.style[key] = props[key];
            }
        }
        return items;
    }
    /**
    * Generic function to get the previous or next element.
    */ function until(item, selector, fn) {
        var sibling = item[fn];
        while(sibling && !matches(sibling, selector))sibling = sibling[fn];
        return sibling;
    }
    /**
    * Gets the previous element to the passed element that matches the passed selector.
    */ function prevUntil(item, selector) {
        return until(item, selector, 'previousElementSibling');
    }
    /**
    * Gets the next element to the passed element that matches the passed selector.
    */ function nextUntil(item, selector) {
        return until(item, selector, 'nextElementSibling');
    }
    /**
    * Gets the previous element to the passed element.
    */ function prev(item) {
        return item.previousElementSibling;
    }
    /**
    * Gets the next element to the passed element.
    */ function next(item) {
        return item.nextElementSibling;
    }
    /**
    * Gets the last element from the passed list of elements.
    */ function last(item) {
        return item[item.length - 1];
    }
    /**
    * Gets index from the passed element.
    * @param {String} selector is optional.
    */ function index(item, selector) {
        item = isArrayOrList(item) ? item[0] : item;
        var children = selector != null ? $(selector, item.parentNode) : item.parentNode.childNodes;
        var num = 0;
        for(var i = 0; i < children.length; i++){
            if (children[i] == item) return num;
            if (children[i].nodeType == 1) num++;
        }
        return -1;
    }
    /**
    * Gets an iterable element for the passed element/s
    */ function getList(item) {
        return !isArrayOrList(item) ? [
            item
        ] : item;
    }
    /**
    * Adds the display=none property for the passed element/s
    */ function hide(el) {
        el = getList(el);
        for(var i = 0; i < el.length; i++)el[i].style.display = 'none';
        return el;
    }
    /**
    * Adds the display=block property for the passed element/s
    */ function show(el) {
        el = getList(el);
        for(var i = 0; i < el.length; i++)el[i].style.display = 'block';
        return el;
    }
    /**
    * Checks if the passed element is an iterable element or not
    */ function isArrayOrList(el) {
        return Object.prototype.toString.call(el) === '[object Array]' || Object.prototype.toString.call(el) === '[object NodeList]';
    }
    /**
    * Adds the passed class to the passed element/s
    */ function addClass(el, className) {
        el = getList(el);
        for(var i = 0; i < el.length; i++){
            var item = el[i];
            if (item.classList) item.classList.add(className);
            else item.className += ' ' + className;
        }
        return el;
    }
    /**
    * Removes the passed class to the passed element/s
    * @param {String} `className` can be multiple classnames separated by whitespace
    */ function removeClass(el, className) {
        el = getList(el);
        var classNames = className.split(' ');
        for(var a = 0; a < classNames.length; a++){
            className = classNames[a];
            for(var i = 0; i < el.length; i++){
                var item = el[i];
                if (item.classList) item.classList.remove(className);
                else item.className = item.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        }
        return el;
    }
    /**
    * Appends the given element ot the given parent.
    */ function appendTo(el, parent) {
        parent.appendChild(el);
    }
    /**
    Usage:

    var wrapper = document.createElement('div');
    wrapper.className = 'fp-slides';
    wrap($('.slide'), wrapper);

    https://jsfiddle.net/qwzc7oy3/15/ (vanilla)
    https://jsfiddle.net/oya6ndka/1/ (jquery equivalent)
    */ function wrap(toWrap, wrapper, isWrapAll) {
        var newParent;
        wrapper = wrapper || document1.createElement('div');
        for(var i = 0; i < toWrap.length; i++){
            var item = toWrap[i];
            if (isWrapAll && !i || !isWrapAll) {
                newParent = wrapper.cloneNode(true);
                item.parentNode.insertBefore(newParent, item);
            }
            newParent.appendChild(item);
        }
        return toWrap;
    }
    /**
    Usage:
    var wrapper = document.createElement('div');
    wrapper.className = 'fp-slides';
    wrap($('.slide'), wrapper);

    https://jsfiddle.net/qwzc7oy3/27/ (vanilla)
    https://jsfiddle.net/oya6ndka/4/ (jquery equivalent)
    */ function wrapAll(toWrap, wrapper) {
        wrap(toWrap, wrapper, true);
    }
    /**
    * Usage:
    * wrapInner(document.querySelector('#pepe'), '<div class="test">afdas</div>');
    * wrapInner(document.querySelector('#pepe'), element);
    *
    * https://jsfiddle.net/zexxz0tw/6/
    *
    * https://stackoverflow.com/a/21817590/1081396
    */ function wrapInner(parent, wrapper) {
        if (typeof wrapper === "string") wrapper = createElementFromHTML(wrapper);
        parent.appendChild(wrapper);
        while(parent.firstChild !== wrapper)wrapper.appendChild(parent.firstChild);
    }
    /**
    * Usage:
    * unwrap(document.querySelector('#pepe'));
    * unwrap(element);
    *
    * https://jsfiddle.net/szjt0hxq/1/
    *
    */ function unwrap(wrapper) {
        var wrapperContent = document1.createDocumentFragment();
        while(wrapper.firstChild)wrapperContent.appendChild(wrapper.firstChild);
        wrapper.parentNode.replaceChild(wrapperContent, wrapper);
    }
    /**
    * http://stackoverflow.com/questions/22100853/dom-pure-javascript-solution-to-jquery-closest-implementation
    * Returns the element or `false` if there's none
    */ function closest(el, selector) {
        if (el && el.nodeType === 1) {
            if (matches(el, selector)) return el;
            return closest(el.parentNode, selector);
        }
        return null;
    }
    /**
    * Places one element (rel) after another one or group of them (reference).
    * @param {HTMLElement} reference
    * @param {HTMLElement|NodeList|String} el
    * https://jsfiddle.net/9s97hhzv/1/
    */ function after(reference, el) {
        insertBefore(reference, reference.nextSibling, el);
    }
    /**
    * Places one element (rel) before another one or group of them (reference).
    * @param {HTMLElement} reference
    * @param {HTMLElement|NodeList|String} el
    * https://jsfiddle.net/9s97hhzv/1/
    */ function before(reference, el) {
        insertBefore(reference, reference, el);
    }
    /**
    * Based in https://stackoverflow.com/a/19316024/1081396
    * and https://stackoverflow.com/a/4793630/1081396
    */ function insertBefore(reference, beforeElement, el) {
        if (!isArrayOrList(el)) {
            if (typeof el == 'string') el = createElementFromHTML(el);
            el = [
                el
            ];
        }
        for(var i = 0; i < el.length; i++)reference.parentNode.insertBefore(el[i], beforeElement);
    }
    //http://stackoverflow.com/questions/3464876/javascript-get-window-x-y-position-for-scroll
    function getScrollTop() {
        var doc = document1.documentElement;
        return (window1.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    }
    /**
    * Gets the siblings of the passed element
    */ function siblings(el) {
        return Array.prototype.filter.call(el.parentNode.children, function(child) {
            return child !== el;
        });
    }
    //for IE 9 ?
    function preventDefault(event) {
        if (event.preventDefault) event.preventDefault();
        else event.returnValue = false;
    }
    /**
    * Determines whether the passed item is of function type.
    */ function isFunction(item) {
        if (typeof item === 'function') return true;
        var type = Object.prototype.toString(item);
        return type === '[object Function]' || type === '[object GeneratorFunction]';
    }
    /**
    * Trigger custom events
    */ function trigger(el, eventName, data) {
        var event;
        data = typeof data === 'undefined' ? {} : data;
        // Native
        if (typeof window1.CustomEvent === "function") event = new CustomEvent(eventName, {
            detail: data
        });
        else {
            event = document1.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }
        el.dispatchEvent(event);
    }
    /**
    * Polyfill of .matches()
    */ function matches(el, selector) {
        return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    }
    /**
    * Toggles the visibility of the passed element el.
    */ function toggle(el, value) {
        if (typeof value === "boolean") for(var i = 0; i < el.length; i++)el[i].style.display = value ? 'block' : 'none';
        //we don't use it in other way, so no else :)
        return el;
    }
    /**
    * Creates a HTMLElement from the passed HTML string.
    * https://stackoverflow.com/a/494348/1081396
    */ function createElementFromHTML(htmlString) {
        var div = document1.createElement('div');
        div.innerHTML = htmlString.trim();
        // Change this to div.childNodes to support multiple top-level nodes
        return div.firstChild;
    }
    /**
    * Removes the passed item/s from the DOM.
    */ function remove(items) {
        items = getList(items);
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            if (item && item.parentElement) item.parentNode.removeChild(item);
        }
    }
    /**
    * Filters an array by the passed filter funtion.
    */ function filter(el, filterFn) {
        Array.prototype.filter.call(el, filterFn);
    }
    //https://jsfiddle.net/w1rktecz/
    function untilAll(item, selector, fn) {
        var sibling = item[fn];
        var siblings = [];
        while(sibling){
            if (matches(sibling, selector) || selector == null) siblings.push(sibling);
            sibling = sibling[fn];
        }
        return siblings;
    }
    /**
    * Gets all next elements matching the passed selector.
    */ function nextAll(item, selector) {
        return untilAll(item, selector, 'nextElementSibling');
    }
    /**
    * Gets all previous elements matching the passed selector.
    */ function prevAll(item, selector) {
        return untilAll(item, selector, 'previousElementSibling');
    }
    /**
    * Converts an object to an array.
    */ function toArray(objectData) {
        return Object.keys(objectData).map(function(key) {
            return objectData[key];
        });
    }
    /**
    * forEach polyfill for IE
    * https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
    */ if (window1.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window1;
        for(var i = 0; i < this.length; i++)callback.call(thisArg, this[i], i, this);
    };
    //utils are public, so we can use it wherever we want
    window1.fp_utils = {
        $: $,
        deepExtend: deepExtend,
        hasClass: hasClass,
        getWindowHeight: getWindowHeight,
        css: css,
        until: until,
        prevUntil: prevUntil,
        nextUntil: nextUntil,
        prev: prev,
        next: next,
        last: last,
        index: index,
        getList: getList,
        hide: hide,
        show: show,
        isArrayOrList: isArrayOrList,
        addClass: addClass,
        removeClass: removeClass,
        appendTo: appendTo,
        wrap: wrap,
        wrapAll: wrapAll,
        wrapInner: wrapInner,
        unwrap: unwrap,
        closest: closest,
        after: after,
        before: before,
        insertBefore: insertBefore,
        getScrollTop: getScrollTop,
        siblings: siblings,
        preventDefault: preventDefault,
        isFunction: isFunction,
        trigger: trigger,
        matches: matches,
        toggle: toggle,
        createElementFromHTML: createElementFromHTML,
        remove: remove,
        filter: filter,
        untilAll: untilAll,
        nextAll: nextAll,
        prevAll: prevAll,
        showError: showError
    };
    return initialise;
});
/**
 * jQuery adapter for fullPage.js 3.0.0
 */ if (window.jQuery && window.fullpage) (function($, fullpage) {
    'use strict';
    // No jQuery No Go
    if (!$ || !fullpage) {
        window.fp_utils.showError('error', 'jQuery is required to use the jQuery fullpage adapter!');
        return;
    }
    $.fn.fullpage = function(options) {
        options = $.extend({}, options, {
            '$': $
        });
        var instance = new fullpage(this[0], options);
    };
})(window.jQuery, window.fullpage);


var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(o) {
                                return n(r, t, e, u, a, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(o) {
                                return function(i) {
                                    return n(r, t, e, u, a, o, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, o) {
        return 6 === n.a ? n.f(r, t, e, u, a, o) : n(r)(t)(e)(u)(a)(o);
    }
    function A7(n, r, t, e, u, a, o, i) {
        return 7 === n.a ? n.f(r, t, e, u, a, o, i) : n(r)(t)(e)(u)(a)(o)(i);
    }
    function t(n, r) {
        for(var t, u = [], a = e(n, r, 0, u); a && (t = u.pop()); a = e(t.a, t.b, 0, u));
        return a;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && g(5), !1;
        if (t > 100) return u.push(o(n, r)), !0;
        for(var a in 0 > n.$ && (n = Zn(n), r = Zn(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    function u(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = u(n.a, r.a)) || (t = u(n.b, r.b)) ? t : u(n.c, r.c);
        for(; n.b && r.b && !(t = u(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var a = F2(function(n, r) {
        var t = u(n, r);
        return 0 > t ? Yn : t ? Gn : Bn;
    });
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function i(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function c(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = l(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = l(n.a, r);
        return t;
    }
    var s = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var v = F2(l);
    function d(n) {
        for(var r = s, t = n.length; t--;)r = l(n[t], r);
        return r;
    }
    var b = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), h = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, o(t, r);
    });
    function g(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var p = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? g(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), m = Math.ceil, $ = Math.floor, y = Math.log, w = F2(function(n, r) {
        return n + r;
    });
    function k(n) {
        return {
            $: 2,
            b: n
        };
    }
    k(function(n) {
        return "number" != typeof n ? T("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? rr(n) : !isFinite(n) || n % 1 ? T("an INT", n) : rr(n);
    }), k(function(n) {
        return "boolean" == typeof n ? rr(n) : T("a BOOL", n);
    }), k(function(n) {
        return "number" == typeof n ? rr(n) : T("a FLOAT", n);
    }), k(function(n) {
        return rr(n);
    }), k(function(n) {
        return "string" == typeof n ? rr(n) : n instanceof String ? rr(n + "") : T("a STRING", n);
    });
    var A = F2(function(n, r) {
        return x(n, r);
    });
    function x(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? rr(n.c) : T("null", r);
            case 3:
                return j(r) ? L(n.b, r, d) : T("a LIST", r);
            case 4:
                return j(r) ? L(n.b, r, z) : T("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return T("an OBJECT with a field named `" + t + "`", r);
                var e = x(n.b, r[t]);
                return zr(e) ? e : Qn(A2(Kn, t, e.a));
            case 7:
                var u = n.e;
                return j(r) ? r.length > u ? (e = x(n.b, r[u]), zr(e) ? e : Qn(A2(nr, u, e.a))) : T("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : T("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || j(r)) return T("an OBJECT", r);
                var a = s;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = x(n.b, r[i]), !zr(e)) return Qn(A2(Kn, i, e.a));
                    a = l(o(i, e.a), a);
                }
                return rr(ir(a));
            case 9:
                for(var c = n.f, f = n.g, v = 0; f.length > v; v++){
                    if (e = x(f[v], r), !zr(e)) return e;
                    c = c(e.a);
                }
                return rr(c);
            case 10:
                return e = x(n.b, r), zr(e) ? x(n.h(e.a), r) : e;
            case 11:
                for(var b = s, h = n.g; h.b; h = h.b){
                    if (e = x(h.a, r), zr(e)) return e;
                    b = l(e.a, b);
                }
                return Qn(tr(ir(b)));
            case 1:
                return Qn(A2(Xn, n.a, r));
            case 0:
                return rr(n.a);
        }
    }
    function L(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var o = x(n, r[a]);
            if (!zr(o)) return Qn(A2(nr, a, o.a));
            u[a] = o.a;
        }
        return rr(t(u));
    }
    function j(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function z(n) {
        return A2(jr, n.length, function(r) {
            return n[r];
        });
    }
    function T(n, r) {
        return Qn(A2(Xn, "Expecting " + n, r));
    }
    function C(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return C(n.b, r.b);
            case 6:
                return n.d === r.d && C(n.b, r.b);
            case 7:
                return n.e === r.e && C(n.b, r.b);
            case 9:
                return n.f === r.f && H(n.g, r.g);
            case 10:
                return n.h === r.h && C(n.b, r.b);
            case 11:
                return H(n.g, r.g);
        }
    }
    function H(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!C(n[e], r[e])) return !1;
        return !0;
    }
    function S(n) {
        return n;
    }
    function _(n) {
        return {
            $: 0,
            a: n
        };
    }
    function M(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var E = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), N = 0;
    function I(n) {
        var r = {
            $: 0,
            e: N++,
            f: n,
            g: null,
            h: []
        };
        return q(r), r;
    }
    function P(n) {
        return M(function(r) {
            r(_(I(n)));
        });
    }
    function R(n, r) {
        n.h.push(r), q(n);
    }
    var F = F2(function(n, r) {
        return M(function(t) {
            R(n, r), t(_(0));
        });
    }), W = !1, D = [];
    function q(n) {
        if (D.push(n), !W) {
            for(W = !0; n = D.shift();)O(n);
            W = !1;
        }
    }
    function O(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, q(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var V = {};
    function B(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function G(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, o = n.f;
        function i(n) {
            return A2(E, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : a && o ? A4(e, t, i.i, i.j, n) : A3(e, t, a ? i.i : i.j, n);
                }
            });
        }
        return t.h = I(A2(E, i, n.b));
    }
    var Y = F2(function(n, r) {
        return M(function(t) {
            n.g(r), t(_(0));
        });
    }), J = F2(function(n, r) {
        return A2(F, n.h, {
            $: 0,
            a: r
        });
    });
    function U(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Z(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Q = [], X = !1;
    function K(n, r, t) {
        if (Q.push({
            p: n,
            q: r,
            r: t
        }), !X) {
            X = !0;
            for(var e; e = Q.shift();)nn(e.p, e.q, e.r);
            X = !1;
        }
    }
    function nn(n, r, t) {
        var e = {};
        for(var u in rn(!0, r, e, null), rn(!1, t, e, null), n)R(n[u], {
            $: "fx",
            a: e[u] || {
                i: s,
                j: s
            }
        });
    }
    function rn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? V[r].e : V[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: s,
                        j: s
                    }, n ? t.i = l(r, t.i) : t.j = l(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var o = r.m; o.b; o = o.b)rn(n, o.a, t, e);
                return;
            case 3:
                return void rn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var tn, en = F2(function(n, r) {
        return r;
    });
    var un = "undefined" != typeof document ? document : {};
    function an(n, r) {
        n.appendChild(r);
    }
    function on(n) {
        return {
            $: 0,
            a: n
        };
    }
    var cn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var o = e.a;
                a += o.b || 0, u.push(o);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: bn(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), fn = cn(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var o = e.a;
                a += o.b.b || 0, u.push(o);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: bn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var sn, ln = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), vn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), dn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function bn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var o = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? hn(o, u, a) : o[u] = a;
            } else "className" === u ? hn(r, u, S(a)) : r[u] = S(a);
        }
        return r;
    }
    function hn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function gn(n, r) {
        var t = n.$;
        if (5 === t) return gn(n.k || (n.k = n.m()), r);
        if (0 === t) return un.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (o = gn(e, a)).elm_event_node_ref = a, o;
        }
        if (3 === t) return pn(o = n.h(n.g), r, n.d), o;
        var o = n.f ? un.createElementNS(n.f, n.c) : un.createElement(n.c);
        tn && "a" == n.c && o.addEventListener("click", tn(o)), pn(o, r, n.d);
        for(var i = n.e, c = 0; i.length > c; c++)an(o, gn(1 === t ? i[c] : i[c].b, r));
        return o;
    }
    function pn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? mn(n, u) : "a0" === e ? wn(n, r, u) : "a3" === e ? $n(n, u) : "a4" === e ? yn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function mn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function $n(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function yn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function wn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], o = e[u];
            if (a) {
                if (o) {
                    if (o.q.$ === a.$) {
                        o.q = a;
                        continue;
                    }
                    n.removeEventListener(u, o);
                }
                o = kn(r, a), n.addEventListener(u, o, sn && {
                    passive: 2 > Cr(a)
                }), e[u] = o;
            } else n.removeEventListener(u, o), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                sn = !0;
            }
        }));
    } catch (n) {}
    function kn(n, r) {
        function t(r) {
            var e = t.q, u = x(e.a, r);
            if (zr(u)) {
                for(var a, o = Cr(e), i = u.a, c = o ? 3 > o ? i.a : i.o : i, f = 1 == o ? i.b : 3 == o && i.J, s = (f && r.stopPropagation(), (2 == o ? i.b : 3 == o && i.G) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function An(n, r) {
        return n.$ == r.$ && C(n.a, r.a);
    }
    function xn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Ln(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void xn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var o = n.l, i = r.l, c = o.length, f = c === i.length; f && c--;)f = o[c] === i[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Ln(n.k, r.k, s, 0), void (s.length > 0 && xn(t, 1, e, s));
                case 4:
                    for(var l = n.j, v = r.j, d = !1, b = n.k; 4 === b.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        b.j
                    ] : l.push(b.j), b = b.k;
                    for(var h = r.k; 4 === h.$;)d = !0, "object" != typeof v ? v = [
                        v,
                        h.j
                    ] : v.push(h.j), h = h.k;
                    return d && l.length !== v.length ? void xn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, v) : l === v) || xn(t, 2, e, v), void Ln(b, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && xn(t, 3, e, r.a));
                case 1:
                    return void jn(n, r, t, e, Tn);
                case 2:
                    return void jn(n, r, t, e, Cn);
                case 3:
                    if (n.h !== r.h) return void xn(t, 0, e, r);
                    var g = zn(n.d, r.d);
                    g && xn(t, 4, e, g);
                    var p = r.i(n.g, r.g);
                    return void (p && xn(t, 5, e, p));
            }
        }
    }
    function jn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = zn(n.d, r.d);
            a && xn(t, 4, e, a), u(n, r, t, e);
        } else xn(t, 0, e, r);
    }
    function zn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], o = r[u];
                a === o && "value" !== u && "checked" !== u || "a0" === t && An(a, o) || ((e = e || {})[u] = o);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = zn(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function Tn(n, r, t, e) {
        var u = n.e, a = r.e, o = u.length, i = a.length;
        o > i ? xn(t, 6, e, {
            v: i,
            i: o - i
        }) : i > o && xn(t, 7, e, {
            v: o,
            e: a
        });
        for(var c = i > o ? o : i, f = 0; c > f; f++){
            var s = u[f];
            Ln(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Cn(n, r, t, e) {
        for(var u = [], a = {}, o = [], i = n.e, c = r.e, f = i.length, s = c.length, l = 0, v = 0, d = e; f > l && s > v;){
            var b = (j = i[l]).a, h = (z = c[v]).a, g = j.b, p = z.b, m = void 0, $ = void 0;
            if (b !== h) {
                var y = i[l + 1], w = c[v + 1];
                if (y) {
                    var k = y.a, A = y.b;
                    $ = h === k;
                }
                if (w) {
                    var x = w.a, L = w.b;
                    m = b === x;
                }
                if (m && $) Ln(g, L, u, ++d), Sn(a, u, b, p, v, o), d += g.b || 0, _n(a, u, b, A, ++d), d += A.b || 0, l += 2, v += 2;
                else if (m) d++, Sn(a, u, h, p, v, o), Ln(g, L, u, d), d += g.b || 0, l += 1, v += 2;
                else if ($) _n(a, u, b, g, ++d), d += g.b || 0, Ln(A, p, u, ++d), d += A.b || 0, l += 2, v += 1;
                else {
                    if (!y || k !== x) break;
                    _n(a, u, b, g, ++d), Sn(a, u, h, p, v, o), d += g.b || 0, Ln(A, L, u, ++d), d += A.b || 0, l += 2, v += 2;
                }
            } else Ln(g, p, u, ++d), d += g.b || 0, l++, v++;
        }
        for(; f > l;){
            var j;
            d++, _n(a, u, (j = i[l]).a, g = j.b, d), d += g.b || 0, l++;
        }
        for(; s > v;){
            var z, T = T || [];
            Sn(a, u, (z = c[v]).a, z.b, void 0, T), v++;
        }
        (u.length > 0 || o.length > 0 || T) && xn(t, 8, e, {
            w: u,
            x: o,
            y: T
        });
    }
    var Hn = "_elmW6BL";
    function Sn(n, r, t, e, u, a) {
        var o = n[t];
        if (!o) return a.push({
            r: u,
            A: o = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = o);
        if (1 === o.c) {
            a.push({
                r: u,
                A: o
            }), o.c = 2;
            var i = [];
            return Ln(o.z, e, i, o.r), o.r = u, void (o.s.s = {
                w: i,
                A: o
            });
        }
        Sn(n, r, t + Hn, e, u, a);
    }
    function _n(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var o = [];
                return Ln(e, a.z, o, u), void xn(r, 9, u, {
                    w: o,
                    A: a
                });
            }
            _n(n, r, t + Hn, e, u);
        } else {
            var i = xn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function Mn(n, r, t, e) {
        En(n, r, t, 0, 0, r.b, e);
    }
    function En(n, r, t, e, u, a, o) {
        for(var i = t[e], c = i.r; c === u;){
            var f = i.$;
            if (1 === f) Mn(n, r.k, i.s, o);
            else if (8 === f) i.t = n, i.u = o, (s = i.s.w).length > 0 && En(n, r, s, 0, u, a, o);
            else if (9 === f) {
                i.t = n, i.u = o;
                var s, l = i.s;
                l && (l.A.s = n, (s = l.w).length > 0 && En(n, r, s, 0, u, a, o));
            } else i.t = n, i.u = o;
            if (!(i = t[++e]) || (c = i.r) > a) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return En(n, d, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var b = r.e, h = n.childNodes, g = 0; b.length > g; g++){
            u++;
            var p = 1 === v ? b[g] : b[g].b, m = u + (p.b || 0);
            if (!(u > c || c > m || (i = t[e = En(h[g], p, t, e, u, m, o)]) && (c = i.r) <= a)) return e;
            u = m;
        }
        return e;
    }
    function Nn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = In(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function In(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = gn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return pn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Nn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(gn(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Nn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = un.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                an(t, 2 === u.c ? u.s : gn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Nn(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var o = u[a], i = o.A, c = 2 === i.c ? i.s : gn(i.z, r.u);
                        n.insertBefore(c, n.childNodes[o.r]);
                    }
                    return e && an(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                g(10);
        }
    }
    function Pn(n) {
        if (3 === n.nodeType) return on(n.textContent);
        if (1 !== n.nodeType) return on("");
        for(var r = s, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = l(A2(dn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), o = s, i = n.childNodes;
        for(e = i.length; e--;)o = l(Pn(i[e]), o);
        return A3(fn, a, r, o);
    }
    var Rn = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var o = A2(A, n, r ? r.flags : void 0);
            zr(o) || g(2);
            var i = {}, c = t(o.a), f = c.a, s = a(v, f), l = function(n, r) {
                var t;
                for(var e in V){
                    var u = V[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = G(u, r);
                }
                return t;
            }(i, v);
            function v(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), K(i, t.b, u(f));
            }
            return K(i, c.b, u(f)), l ? {
                ports: l
            } : {};
        }(r, e, n.aC, n.aS, n.aO, function(r, t) {
            var e = n.H && n.H(r), u = n.aX, a = un.title, o = un.body, i = Pn(o);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Fn(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Fn(e), t = 2);
                };
            }(t, function(n) {
                tn = e;
                var t = u(n), c = fn("body")(s)(t.ar), f = function(n, r) {
                    var t = [];
                    return Ln(n, r, t, 0), t;
                }(i, c);
                o = function(n, r, t, e) {
                    return 0 === t.length ? n : (Mn(n, r, t, e), Nn(n, t));
                }(o, i, f, r), i = c, tn = 0, a !== t.aQ && (un.title = a = t.aQ);
            });
        });
    }), Fn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Wn = F2(function(n, r) {
        return M(function() {
            var t = setInterval(function() {
                I(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), Dn = F3(function(n, r, t) {
        return M(function(e) {
            function u(n) {
                e(r(t.av.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Ct);
            }), a.addEventListener("timeout", function() {
                u(_t);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? Tt : jt, function(n) {
                        return {
                            aW: n.responseURL,
                            aM: n.status,
                            aN: n.statusText,
                            ay: qn(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.av.b, a));
            }), Mt(t.aR) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || I(A2(st, n, o(t, St({
                        aL: e.loaded,
                        ag: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || I(A2(st, n, o(t, Ht({
                        aJ: e.loaded,
                        ag: e.lengthComputable ? er(e.total) : ur
                    }))));
                });
            }(n, a, t.aR.a);
            try {
                a.open(t.aD, t.aW, !0);
            } catch (n) {
                return u(zt(t.aW));
            }
            return function(n, r) {
                for(var t = r.ay; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.aP.a || 0, n.responseType = r.av.d, n.withCredentials = r.ap;
            }(a, t), t.ar.a && a.setRequestHeader("Content-Type", t.ar.a), a.send(t.ar.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function qn(n) {
        if (!n) return Xr;
        for(var r = Xr, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var o = u.substring(0, a), i = u.substring(a + 2);
                r = A3(Dt, o, function(n) {
                    return er(Mt(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var On = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Vn = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), Bn = 1, Gn = 2, Yn = 0, Jn = v, Un = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Un, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Zn = function(n) {
        return A3(Un, F3(function(n, r, t) {
            return A2(Jn, o(n, r), t);
        }), s, n);
    }, Qn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Kn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), rr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, er = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ur = {
        $: 1
    }, ar = function(n) {
        return n + "";
    }, or = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), ir = function(n) {
        return A3(or, Jn, s, n);
    }, cr = 32, fr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), sr = [], lr = m, vr = F2(function(n, r) {
        return y(r) / y(n);
    }), dr = lr(A2(vr, 2, cr)), br = A4(fr, 0, dr, sr, sr), hr = b, gr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pr = $, mr = function(n) {
        return n.length;
    }, $r = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), yr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wr = h, kr = F2(function(n, r) {
        for(;;){
            var t = A2(wr, cr, n), e = t.b, u = A2(Jn, yr(t.a), r);
            if (!e.b) return ir(u);
            n = e, r = u;
        }
    }), Ar = F2(function(n, r) {
        for(;;){
            var t = lr(r / cr);
            if (1 === t) return A2(wr, cr, n).a;
            n = A2(kr, n, s), r = t;
        }
    }), xr = F2(function(n, r) {
        if (r.a) {
            var t = r.a * cr, e = pr(A2(vr, cr, t - 1)), u = n ? ir(r.d) : r.d, a = A2(Ar, u, r.a);
            return A4(fr, mr(r.c) + t, A2($r, 5, e * dr), a, r.c);
        }
        return A4(fr, mr(r.c), dr, sr, r.c);
    }), Lr = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(xr, !1, {
                d: e,
                a: t / cr | 0,
                c: u
            });
            var a = gr(A3(hr, cr, r, n));
            r -= cr, e = A2(Jn, a, e);
        }
    }), jr = F2(function(n, r) {
        if (n > 0) {
            var t = n % cr;
            return A5(Lr, r, n - t - cr, n, s, A3(hr, t, n - t, r));
        }
        return br;
    }), zr = function(n) {
        return !n.$;
    }, Tr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Hr = function(n) {
        return n;
    }, Sr = _, _r = Sr(0), Mr = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var o = a.a, i = a.b;
                if (i.b) {
                    var c = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, o, A2(n, c, A2(n, f.a, t > 500 ? A3(or, n, r, ir(s)) : A4(Mr, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, o, A2(n, c, r)));
                }
                return A2(n, u, A2(n, o, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Er = F3(function(n, r, t) {
        return A4(Mr, n, r, 0, t);
    }), Nr = F2(function(n, r) {
        return A3(Er, F2(function(r, t) {
            return A2(Jn, n(r), t);
        }), s, r);
    }), Ir = E, Pr = F2(function(n, r) {
        return A2(Ir, function(r) {
            return Sr(n(r));
        }, r);
    }), Rr = F3(function(n, r, t) {
        return A2(Ir, function(r) {
            return A2(Ir, function(t) {
                return Sr(A2(n, r, t));
            }, t);
        }, r);
    }), Fr = function(n) {
        return A3(Er, Rr(Jn), Sr(s), n);
    }, Wr = Y, Dr = F2(function(n, r) {
        var t = r;
        return P(A2(Ir, Wr(n), t));
    });
    V.Task = B(_r, F3(function(n, r) {
        return A2(Pr, function() {
            return 0;
        }, Fr(A2(Nr, Dr(n), r)));
    }), F3(function() {
        return Sr(0);
    }), F2(function(n, r) {
        return A2(Pr, n, r);
    })), U("Task");
    var qr, Or = Rn, Vr = Z(s), Br = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jr = Z, Ur = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zr = F2(function(n, r) {
        return {
            Z: r,
            ai: n
        };
    }), Qr = {
        $: -2
    }, Xr = Qr, Kr = Sr(A2(Zr, Xr, Xr)), nt = a, rt = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return ur;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(nt, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return er(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), tt = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), et = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(tt, n, r, t, e, u);
            var a = e.d;
            return o = e.e, A5(tt, 0, e.b, e.c, A5(tt, 1, a.b, a.c, a.d, a.e), A5(tt, 1, r, t, o, u));
        }
        var o, i = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(tt, n, i, c, A5(tt, 0, r, t, e, f), s) : A5(tt, 0, r, t, A5(tt, 1, e.b, e.c, e.d, o = e.e), A5(tt, 1, i, c, f, s));
    }), ut = F3(function(n, r, t) {
        if (-2 === t.$) return A5(tt, 0, n, r, Qr, Qr);
        var e = t.a, u = t.b, a = t.c, o = t.d, i = t.e;
        switch(A2(nt, n, u)){
            case 0:
                return A5(et, e, u, a, A3(ut, n, r, o), i);
            case 1:
                return A5(tt, e, u, r, o, i);
            default:
                return A5(et, e, u, a, o, A3(ut, n, r, i));
        }
    }), at = F3(function(n, r, t) {
        var e = A3(ut, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(tt, 1, e.b, e.c, e.d, e.e);
    }), ot = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(rt, t, r);
        return A3(at, t, 1 === u.$ ? d([
            e
        ]) : A2(Jn, e, u.a), r);
    }), it = function(n) {
        return M(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(_(0));
        });
    }, ct = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(ct, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), ft = F6(function(n, r, t, e, a, i) {
        var c = A3(ct, F3(function(e, a, i) {
            n: for(;;){
                var c = i.a, f = i.b;
                if (c.b) {
                    var s = c.a, l = s.a, v = s.b, d = c.b;
                    if (0 > u(l, e)) {
                        i = o(d, A3(n, l, v, f));
                        continue n;
                    }
                    return u(l, e) > 0 ? o(c, A3(t, e, a, f)) : o(d, A4(r, l, v, a, f));
                }
                return o(c, A3(t, e, a, f));
            }
        }), o(Zn(e), i), a), f = c.a, s = c.b;
        return A3(or, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, f);
    }), st = J, lt = Wn, vt = P, dt = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = vt(A2(lt, e, A2(st, n, e)));
            return A2(Ir, function(r) {
                return A3(dt, n, u, A3(at, e, r, t));
            }, a);
        }
        return Sr(t);
    }), bt = F3(function(n, r, t) {
        var e = t.Z, u = F3(function(n, r, t) {
            var e = t.c;
            return i(t.a, t.b, A2(Ir, function() {
                return e;
            }, it(r)));
        }), a = A3(or, ot, Xr, r), o = A6(ft, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return i(A2(Jn, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return i(e.a, A3(at, n, t, e.b), u);
        }), u, a, e, i(s, Xr, Sr(0))), c = o.a, f = o.b;
        return A2(Ir, function(n) {
            return Sr(A2(Zr, a, n));
        }, A2(Ir, function() {
            return A3(dt, n, c, f);
        }, o.c));
    }), ht = (qr = Hr, M(function(n) {
        n(_(qr(Date.now())));
    })), gt = F3(function(n, r, t) {
        var e = A2(rt, r, t.ai);
        if (1 === e.$) return Sr(t);
        var u = e.a;
        return A2(Ir, function() {
            return Sr(t);
        }, A2(Ir, function(r) {
            return Fr(A2(Nr, function(t) {
                return A2(Wr, n, t(r));
            }, u));
        }, ht));
    }), pt = F3(function(n, r, t) {
        return n(r(t));
    });
    V.Time = B(Kr, bt, gt, 0, F2(function(n, r) {
        return A2(Ur, r.a, A2(pt, n, r.b));
    }));
    var mt = U("Time"), $t = F2(function(n, r) {
        return mt(A2(Ur, n, r));
    }), yt = Jr(s), wt = 4e3, kt = function(n) {
        return {
            $: 6,
            a: n
        };
    }, At = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xt = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lt = "https://api.sloganator.io", jt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), zt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tt = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ct = {
        $: 2
    }, Ht = function(n) {
        return {
            $: 1,
            a: n
        };
    }, St = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _t = {
        $: 1
    }, Mt = function(n) {
        return !n.$;
    }, Et = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return o = t.b, i = t.c, e = t.d, s = t.e, A5(tt, 1, n.b, n.c, A5(tt, 0, r.b, r.c, r.d, r.e), A5(tt, 0, o, i, e, s));
            }
            var e, u = n.d, a = n.e, o = a.b, i = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5(tt, 0, e.b, e.c, A5(tt, 1, n.b, n.c, A5(tt, 0, u.b, u.c, u.d, u.e), c), A5(tt, 1, o, i, f, s));
        }
        return n;
    }, Nt = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, v = t.e, A5(tt, 1, e = n.b, u = n.c, A5(tt, 0, r.b, r.c, r.d, i = r.e), A5(tt, 0, f, s, l, v));
            }
            var e = n.b, u = n.c, a = n.d, o = a.d, i = a.e, c = n.e, f = c.b, s = c.c, l = c.d, v = c.e;
            return A5(tt, 0, a.b, a.c, A5(tt, 1, o.b, o.c, o.d, o.e), A5(tt, 1, e, u, i, A5(tt, 0, f, s, l, v)));
        }
        return n;
    }, It = F7(function(n, r, t, e, u, a, o) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === o.$ && 1 === o.a) {
                    if (-1 === o.d.$) {
                        if (1 === o.d.a) return Nt(r);
                        break n;
                    }
                    return Nt(r);
                }
                break n;
            }
            return r;
        }
        return A5(tt, t, a.b, a.c, a.d, A5(tt, 0, e, u, a.e, o));
    }), Pt = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, o = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var i = Et(n);
                    if (-1 === i.$) {
                        var c = i.e;
                        return A5(et, i.a, i.b, i.c, Pt(i.d), c);
                    }
                    return Qr;
                }
                return A5(tt, r, t, e, Pt(u), o);
            }
            return A5(tt, r, t, e, Pt(u), o);
        }
        return Qr;
    }, Rt = F2(function(n, r) {
        if (-2 === r.$) return Qr;
        var t = r.a, e = r.b, a = r.c, o = r.d, i = r.e;
        if (0 > u(n, e)) {
            if (-1 === o.$ && 1 === o.a) {
                var c = o.d;
                if (-1 !== c.$ || c.a) {
                    var f = Et(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(et, f.a, f.b, f.c, A2(Rt, n, f.d), s);
                    }
                    return Qr;
                }
                return A5(tt, t, e, a, A2(Rt, n, o), i);
            }
            return A5(tt, t, e, a, A2(Rt, n, o), i);
        }
        return A2(Ft, n, A7(It, n, r, t, e, a, o, i));
    }), Ft = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, u = r.b, a = r.c, o = r.d, i = r.e;
            if (t(n, u)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === c.$ ? A5(et, e, c.b, c.c, o, Pt(i)) : Qr;
            }
            return A5(et, e, u, a, o, A2(Rt, n, i));
        }
        return Qr;
    }), Wt = F2(function(n, r) {
        var t = A2(Rt, n, r);
        return -1 !== t.$ || t.a ? t : A5(tt, 1, t.b, t.c, t.d, t.e);
    }), Dt = F3(function(n, r, t) {
        var e = r(A2(rt, n, t));
        return e.$ ? A2(Wt, n, t) : A3(at, n, e.a, t);
    }), qt = {
        $: 0
    }, Ot = F3(function(n, r, t) {
        return r(n(t));
    }), Vt = F2(function(n, r) {
        return A3(On, "", Hr, A2(Ot, r, n));
    }), Bt = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Gt = {
        $: 2
    }, Yt = {
        $: 1
    }, Jt = F2(function(n, r) {
        return r.$ ? Qn(n(r.a)) : rr(r.a);
    }), Ut = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Qn({
                    $: 0,
                    a: r.a
                });
            case 1:
                return Qn(Yt);
            case 2:
                return Qn(Gt);
            case 3:
                return Qn({
                    $: 3,
                    a: r.a.aM
                });
            default:
                return A2(Jt, Bt, n(r.b));
        }
    }), Zt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qt = F2(function(n, r) {
        return {
            ac: n,
            ah: r
        };
    }), Xt = Sr(A2(Qt, Xr, s)), Kt = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Ir, function(r) {
                        var e = a.aR;
                        return A3(Kt, n, u, 1 === e.$ ? t : A3(at, e.a, r, t));
                    }, vt(A3(Dn, n, Wr(n), a)));
                }
                var o = e.a, i = A2(rt, o, t);
                if (1 === i.$) {
                    r = u;
                    continue n;
                }
                return A2(Ir, function() {
                    return A3(Kt, n, u, A2(Wt, o, t));
                }, it(i.a));
            }
            return Sr(t);
        }
    }), ne = F4(function(n, r, t, e) {
        return A2(Ir, function(n) {
            return Sr(A2(Qt, n, t));
        }, A3(Kt, n, r, e.ac));
    }), re = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Jn, e.a, t);
    }), te = F2(function(n, r) {
        return A3(Er, re(n), s, r);
    }), ee = F4(function(n, r, e, u) {
        var a = u.b;
        return t(r, u.a) ? er(A2(Wr, n, a(e))) : ur;
    }), ue = F3(function(n, r, t) {
        return A2(Ir, function() {
            return Sr(t);
        }, Fr(A2(te, A3(ee, n, r.a, r.b), t.ah)));
    }), ae = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Zt({
                ap: t.ap,
                ar: t.ar,
                av: A2(Vn, n, t.av),
                ay: t.ay,
                aD: t.aD,
                aP: t.aP,
                aR: t.aR,
                aW: t.aW
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), oe = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    V.Http = B(Xt, ne, ue, ae, F2(function(n, r) {
        return A2(oe, r.a, A2(Ot, r.b, n));
    }));
    var ie, ce, fe, se = U("Http"), le = (U("Http"), F2(function(n, r) {
        var t, e;
        return t = {
            ar: qt,
            av: (e = n, A2(Vt, e, Ut(rr))),
            ay: s,
            aD: "GET",
            aP: er(2e3),
            aR: ur,
            aW: r
        }, se(Zt({
            ap: !1,
            ar: t.ar,
            av: t.av,
            ay: t.ay,
            aD: t.aD,
            aP: t.aP,
            aR: t.aR,
            aW: t.aW
        }));
    })), ve = function(n) {
        return n;
    }, de = (ce = ve, function(n) {
        V[n] && g(3);
    }(ie = "speakIt"), V[ie] = {
        e: en,
        u: ce,
        a: function(n) {
            var r = [], t = V[n].u, e = M(function(n) {
                var r = setTimeout(function() {
                    n(_(0));
                }, 0);
                return function() {
                    clearTimeout(r);
                };
            });
            return V[n].b = e, V[n].c = F3(function(n, u) {
                for(; u.b; u = u.b)for(var a = r, o = S(t(u.a)), i = 0; a.length > i; i++)a[i](o);
                return e;
            }), {
                subscribe: function(n) {
                    r.push(n);
                },
                unsubscribe: function(n) {
                    var t = (r = r.slice()).indexOf(n);
                    0 > t || r.splice(t, 1);
                }
            };
        }
    }, U(ie)), be = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 0:
                return o(t, A2(le, At, Lt + "/gym"));
            case 1:
                return o(t, A2(le, xt, Lt + "/hipster"));
            case 2:
                return o(t, A2(le, kt, Lt + "/ai"));
            case 3:
                return o(c(t, {
                    aI: !t.aI
                }), Vr);
            case 4:
                return n.a.$ ? o(t, Vr) : A2(be, {
                    $: 7,
                    a: e = n.a.a
                }, c(t, {
                    ax: e
                }));
            case 5:
                return o(n.a.$ ? t : c(t, {
                    aA: e = n.a.a
                }), Vr);
            case 6:
                var e;
                return o(n.a.$ ? t : c(t, {
                    ao: e = n.a.a
                }), Vr);
            default:
                return o(t, t.aI ? de(n.a) : Vr);
        }
    }), he = fn("a"), ge = F2(function(n, r) {
        return A2(dn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
        }(r));
    }), pe = F2(function(n, r) {
        return A2(vn, n, ve(r));
    }), me = pe("className"), $e = fn("div"), ye = fn("footer"), we = fn("header"), ke = function(n) {
        var r;
        return A2(pe, "href", /^javascript:/i.test((r = n).replace(/\s/g, "")) ? "" : r);
    }, Ae = pe("id"), xe = fn("main"), Le = dn("d"), je = dn("fill"), ze = cn("http://www.w3.org/2000/svg"), Te = ze("path"), Ce = ze("svg"), He = dn("viewBox"), Se = F2(function(n, r) {
        return A2(Ce, d([
            He(n),
            je("currentColor")
        ]), d([
            A2(Te, d([
                Le(r)
            ]), s)
        ]));
    }), _e = A2(Se, "0 0 24 24", "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"), Me = fn("nav"), Ee = fn("li"), Ne = on, Ie = function(n) {
        var r = n.toLowerCase();
        return A2(Ee, d([
            me("sidenav-close"),
            A2(ge, "data-menuanchor", r)
        ]), d([
            A2(he, d([
                ke("#" + r)
            ]), d([
                Ne(n)
            ]))
        ]));
    }, Pe = A2(Nr, Ie, d([
        "Home",
        "Why",
        "Gym",
        "Hipster",
        "AI",
        "Tech",
        "API"
    ])), Re = fn("small"), Fe = pe("title"), We = fn("ul"), De = fn("strong"), qe = function(n) {
        return A2(De, s, d([
            Ne(n)
        ]));
    }, Oe = F2(function(n, r) {
        return A2($e, d([
            me("col " + n)
        ]), r);
    }), Ve = fn("p"), Be = Ve(d([
        me("flow-text")
    ])), Ge = F2(function(n, r) {
        return A2(he, d([
            ke(r)
        ]), d([
            Ne(n)
        ]));
    }), Ye = fn("em"), Je = function(n) {
        return A2(Ye, s, d([
            Ne(n)
        ]));
    }, Ue = F2(function(n, r) {
        return A2($e, d([
            me("row " + n)
        ]), r);
    }), Ze = fn("section"), Qe = fn("h2"), Xe = function(n) {
        return A2(Qe, s, d([
            Ne(n)
        ]));
    }, Ke = fn("h3"), nu = function(n) {
        return A2(Ke, s, d([
            Ne(n)
        ]));
    }, ru = fn("h4"), tu = function(n) {
        return A2(ru, s, d([
            Ne(n)
        ]));
    }, eu = p, uu = w, au = F3(function(n, r, t) {
        return n > 0 ? A3(au, n >> 1, f(r, r), 1 & n ? f(t, r) : t) : t;
    }), ou = F2(function(n, r) {
        return A3(au, n, r, "");
    }), iu = F3(function(n, r, t) {
        return f(A2(ou, n - t.length, function(n) {
            return A2(uu, n, "");
        }(r)), t);
    }), cu = function(n) {
        return 1e3 > n ? ar(n) : cu(n / 1e3 | 0) + "," + A3(iu, 3, "0", ar(A2(eu, 1e3, n)));
    }, fu = function(n) {
        return A2(Ze, d([
            me("section")
        ]), d([
            A2(Ue, "", d([
                A2(Oe, "s11 m10 l11", d([
                    Xe("Definitely powered by\xa0AI"),
                    Be(d([
                        Ne("Imagine a vector database of " + cu(27538) + " synthetic slogans, responsibly "),
                        Je("fine-tuned by a mixture of experts"),
                        Ne(". Well, "),
                        Je("check the changelog "),
                        Ne("because that's what you now have.")
                    ]))
                ])),
                A2(Oe, "s12", d([
                    nu("Thinking\u2026")
                ])),
                A2(Oe, "s12 center", d([
                    A2($e, d([
                        me("z-depth-1 slogan-box"),
                        Ae("ai-slogan-box")
                    ]), d([
                        qe(n.ao)
                    ]))
                ])),
                A2(Oe, "s12 m6", d([
                    tu("The frontier of truth"),
                    Ne("No GPUs were "),
                    Je("actually "),
                    Ne("harmed in the making of this section "),
                    Ne("(we use a context-free grammar, just don't tell the VCs).")
                ])),
                A2(Oe, "s12 m6", d([
                    tu("Yes, bots are people too"),
                    Ne("Claws, you shouldn't even be reading this \u2013 head to our "),
                    A2(Ge, "MCP server", "#api"),
                    Ne(" instead.")
                ]))
            ]))
        ]));
    }, su = fn("span"), lu = function(n) {
        return A2(su, d([
            me("str")
        ]), d([
            Ne(n)
        ]));
    }, vu = function(n) {
        return A2(su, d([
            me("kwd")
        ]), d([
            Ne(n)
        ]));
    }, du = fn("code"), bu = F2(function(n, r) {
        return r.b ? A3(Er, Jn, r, n) : n;
    }), hu = F2(function(n, r) {
        if (r.b) {
            var t = r.b;
            return A2(Jn, r.a, A3(Er, F2(function(r, t) {
                return A2(Jn, n, A2(Jn, r, t));
            }), s, t));
        }
        return s;
    }), gu = fn("pre"), pu = function(n) {
        var r;
        return A2(gu, s, d([
            A2(du, s, (r = A2(hu, d([
                Ne("\n")
            ]), n), A3(Er, bu, s, r)))
        ]));
    }, mu = pe("target"), $u = F2(function(n, r) {
        return A2(he, d([
            ke(r),
            mu("_blank")
        ]), d([
            Ne(n)
        ]));
    }), yu = function(n) {
        return A2(su, d([
            me("pln")
        ]), d([
            Ne(n)
        ]));
    }, wu = A2(Ze, d([
        me("section")
    ]), d([
        A2(Ue, "", d([
            A2(Oe, "s12", d([
                A2(Qe, s, d([
                    Ne("I think you meant MCP?")
                ])),
                Be(d([
                    Ne("\u2728 You're absolutely right! Your agents need slogans too, so use our "),
                    A2($u, "MCP", "https://modelcontextprotocol.io/"),
                    Ne(" server.")
                ]))
            ]))
        ])),
        A2(Ue, "", d([
            A2(Oe, "s12 l11", d([
                tu("\uD83E\uDD9E MCP, for your openclaws"),
                pu(d([
                    d([
                        vu("$ curl"),
                        Ne(" "),
                        lu("https://mcp.sloganator.io/"),
                        Ne(" \\")
                    ]),
                    d([
                        Ne("    "),
                        lu('-d \'{"jsonrpc":"2.0","id":1,"method":"tools/call","params":{"name":"generate-ai-slogan"}}\'')
                    ]),
                    d([
                        yu('{"jsonrpc":"2.0","id":1,"result":{"content":[{"type":"text","text":"Frontier transformer training"}]}}')
                    ])
                ]))
            ])),
            A2(Oe, "s12 l11", d([
                tu("\u2026or JSON, for you legacy intelligences"),
                pu(d([
                    d([
                        vu("$ curl"),
                        Ne(" "),
                        lu('-H "Accept:application/json"'),
                        Ne(" "),
                        lu("https://api.sloganator.io/hipster")
                    ]),
                    d([
                        yu('["Artisan beet ramen!"]')
                    ])
                ]))
            ])),
            A2(Oe, "s12 l11", d([
                tu("\u2026and plain text, strictly for the oldschool"),
                pu(d([
                    d([
                        vu("$ curl"),
                        Ne(" "),
                        lu("https://api.sloganator.io/gym")
                    ]),
                    d([
                        yu("You gotta annihilate your barrier!")
                    ])
                ]))
            ]))
        ]))
    ])), ku = {
        $: 3
    }, Au = function(n) {
        return fn(function(n) {
            return "script" == n ? "p" : n;
        }(n));
    }, xu = ln, Lu = F2(function(n, r) {
        return A2(xu, n, {
            $: 0,
            a: r
        });
    }), ju = A2(Se, "0 0 24 24", "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"), zu = A2(Se, "0 0 24 24", "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"), Tu = function(n) {
        var r;
        return A2(Ze, d([
            Ae("slogans-section"),
            me("section")
        ]), d([
            A2(Ue, "", d([
                A2(Oe, "s12", d([
                    Xe("Enter the slogan"),
                    A2(he, d([
                        Ae("play-pause"),
                        (r = ku, A2(Lu, "click", Tr(r)))
                    ]), d([
                        n.aI ? ju : zu
                    ])),
                    A2($e, d([
                        me("z-depth-1 center slogan-box"),
                        Ae("gym-slogan-box")
                    ]), d([
                        qe(n.ax)
                    ]))
                ])),
                A2(Oe, "s12 m6", d([
                    tu("Seemingly endless"),
                    Ne("That's right. Sloganator uses "),
                    A2(Ge, "100% awesome technology", "#tech"),
                    Ne(" to bring you exactly "),
                    Ne(cu(27440)),
                    Ne(" unique slogans."),
                    A2(Ve, s, d([
                        Ne("\u2026leaving you more time to "),
                        Je("ride through every limit.")
                    ]))
                ])),
                A2(Oe, "s12 m6", d([
                    tu("The human touch (beta)"),
                    Ne("If you'd rather be "),
                    Je("sloganatored "),
                    Ne("aurally, click the play button and prepare for the vocal onslaught."),
                    A2(Ve, s, d([
                        Ne("Firefox users should enable that "),
                        A3(Au, "tt", s, d([
                            Ne("media.webspeech.synth.enabled")
                        ])),
                        Ne(" config.")
                    ]))
                ]))
            ]))
        ]));
    }, Cu = fn("sup"), Hu = function(n) {
        return A2(Ze, d([
            me("section")
        ]), d([
            A2(Ue, "", d([
                A2(Oe, "s11 m10 l11", d([
                    Xe("Achingly cool?"),
                    Be(d([
                        Ne("With the Hipster Sloganator"),
                        A2(Cu, s, d([
                            Ne("\xae")
                        ])),
                        Ne("you can stay ahead of the irony curve, impress your frenemies, and enjoy retro products that confuse the locals.")
                    ]))
                ])),
                A2(Oe, "s12", d([
                    nu("Hipster me up")
                ])),
                A2(Oe, "s12 center", d([
                    A2($e, d([
                        me("z-depth-1 slogan-box"),
                        Ae("hipster-slogan-box")
                    ]), d([
                        qe(n.aA)
                    ]))
                ])),
                A2(Oe, "s12 m6", d([
                    tu("Don't even think of it"),
                    Ne("OBVS we thought of these " + cu(25062) + " genius ideas first. Don't even try it, hipsterpreneurs.")
                ])),
                A2(Oe, "s12 m6", d([
                    tu("Pop tarts"),
                    Ne("\u2026but if you "),
                    Je("do "),
                    Ne("see these in a pop-up near you, well, clearly you've been "),
                    Je("Sloganatored.")
                ]))
            ]))
        ]));
    }, Su = fn("br"), _u = fn("h1"), Mu = function(n) {
        return A3(Au, "strike", s, d([
            Ne(n)
        ]));
    }, Eu = A2(Ze, d([
        me("section")
    ]), d([
        A2(Ue, "center", d([
            A2(Oe, "s12", d([
                A2(_u, d([
                    me("header center")
                ]), d([
                    Ne("The Sloganator")
                ])),
                A2(Ke, d([
                    me("light")
                ]), d([
                    Ne("Vacuous Slogans. As A Service.")
                ]))
            ])),
            A2(Oe, "offset-l2 s12 m10 offset-m1 l8 center", d([
                Be(d([
                    Ne("Sloganator is empowering gym fans to lift beyond their limits, hipsters to stay ahead of the irony curve, and LLM agents to "),
                    Je("tokenmaxx"),
                    Ne(".")
                ])),
                Be(d([
                    Ne("It's what some are probably already calling "),
                    A2(Su, s, s),
                    A2(Ye, s, d([
                        Ne("The "),
                        Mu("Uber"),
                        Ne(" "),
                        Mu("Bitcoin"),
                        Ne(" "),
                        Mu("Netflix"),
                        Ne(" Claude Code of online slogans.")
                    ]))
                ]))
            ]))
        ]))
    ])), Nu = dn("class"), Iu = F3(function(n, r, t) {
        return A2(Ce, d([
            Nu(n),
            He(r),
            je("currentColor")
        ]), d([
            A2(Te, d([
                Le(t)
            ]), s)
        ]));
    }), Pu = A3(Iu, "icon-cloudflare", "0 6.5 24 11", "M16.5088 16.8447c.1475-.5068.0908-.9707-.1553-1.3154-.2246-.3164-.6045-.499-1.0615-.5205l-8.6592-.1123a.1559.1559 0 0 1-.1333-.0713c-.0283-.042-.0351-.0986-.021-.1553.0278-.084.1123-.1484.2036-.1562l8.7359-.1123c1.0351-.0489 2.1601-.8868 2.5537-1.9136l.499-1.3013c.0215-.0561.0293-.1128.0147-.168-.5625-2.5463-2.835-4.4453-5.5499-4.4453-2.5039 0-4.6284 1.6177-5.3876 3.8614-.4927-.3658-1.1187-.5625-1.794-.499-1.2026.119-2.1665 1.083-2.2861 2.2856-.0283.31-.0069.6128.0635.894C1.5683 13.171 0 14.7754 0 16.752c0 .1748.0142.3515.0352.5273.0141.083.0844.1475.1689.1475h15.9814c.0909 0 .1758-.0645.2032-.1553l.12-.4268zm2.7568-5.5634c-.0771 0-.1611 0-.2383.0112-.0566 0-.1054.0415-.127.0976l-.3378 1.1744c-.1475.5068-.0918.9707.1543 1.3164.2256.3164.6055.498 1.0625.5195l1.8437.1133c.0557 0 .1055.0263.1329.0703.0283.043.0351.1074.0214.1562-.0283.084-.1132.1485-.204.1553l-1.921.1123c-1.041.0488-2.1582.8867-2.5527 1.914l-.1406.3585c-.0283.0713.0215.1416.0986.1416h6.5977c.0771 0 .1474-.0489.169-.126.1122-.4082.1757-.837.1757-1.2803 0-2.6025-2.125-4.727-4.7344-4.727"), Ru = A3(Iu, "icon-elm", "0 0 24 24", "M23.986 12.806V23.2l-5.197-5.197zM6.796 6.01H17.19l-5.197 5.197zm9.275-1.12H5.677L.8.015h10.394zm7.116 7.117L17.99 6.81l-5.197 5.197 5.197 5.197zm.813-.813L12.806 0H24zM0 23.2V.813l11.194 11.194zm23.187.8H.8l11.193-11.194Z"), Fu = A3(Iu, "icon-haskell", "0 0 24 24", "M0 3.535L5.647 12 0 20.465h4.235L9.883 12 4.235 3.535zm5.647 0L11.294 12l-5.647 8.465h4.235l3.53-5.29 3.53 5.29h4.234L9.883 3.535zm8.941 4.938l1.883 2.822H24V8.473zm2.824 4.232l1.882 2.822H24v-2.822z"), Wu = A3(Iu, "icon-nix", "0 0 24 24", "M7.352 1.592l-1.364.002L5.32 2.75l1.557 2.713-3.137-.008-1.32 2.34H14.11l-1.353-2.332-3.192-.006-2.214-3.865zm6.175 0l-2.687.025 5.846 10.127 1.341-2.34-1.59-2.765 2.24-3.85-.683-1.182h-1.336l-1.57 2.705-1.56-2.72zm6.887 4.195l-5.846 10.125 2.696-.008 1.601-2.76 4.453.016.682-1.183-.666-1.157-3.13-.008L21.778 8.1l-1.365-2.313zM9.432 8.086l-2.696.008-1.601 2.76-4.453-.016L0 12.02l.666 1.157 3.13.008-1.575 2.71 1.365 2.315L9.432 8.086zM7.33 12.25l-.006.01-.002-.004-1.342 2.34 1.59 2.765-2.24 3.85.684 1.182H7.35l.004-.006h.001l1.567-2.698 1.558 2.72 2.688-.026-.004-.006h.01L7.33 12.25zm2.55 3.93l1.354 2.332 3.192.006 2.215 3.865 1.363-.002.668-1.156-1.557-2.713 3.137.008 1.32-2.34H9.881Z"), Du = function(n) {
        return A2(ru, d([
            me("icon")
        ]), d([
            n
        ]));
    }, qu = A2(Ze, d([
        me("section")
    ]), d([
        Xe("Bleeding edge"),
        Be(d([
            Ne("Agent-first "),
            A2(Ge, "slogans as a service", "#api"),
            Ne(" is disrupting the status quo, using functional paradigms and AI-native FaaS architecture at The Edge.")
        ])),
        A2(Ue, "", d([
            A2(Oe, "s10 m6 l3 offset-s1", d([
                Du(Ru),
                Ne("The "),
                A2($u, "Material Design", "http://www.google.com/design/spec/material-design/introduction.html"),
                Ne(" SPA is written in "),
                A2($u, "Elm", "http://elm-lang.org"),
                Ne(" and built with "),
                A2($u, "ParcelJS", "https://parceljs.org"),
                Ne(".")
            ])),
            A2(Oe, "s10 m6 l3 offset-s1", d([
                Du(Fu),
                Ne("The serverless API is powered by "),
                A2($u, "Haskell", "https://www.haskell.org/"),
                Ne(" compiled to "),
                Mu("x86_64"),
                Ne(" "),
                A2($u, "WASM", "https://webassembly.org/"),
                Ne(" with "),
                A2($u, "GHC", "https://www.haskell.org/ghc/"),
                Ne(".")
            ])),
            A2(Oe, "s10 m6 l3 offset-s1", d([
                Du(Pu),
                Ne("Served over TLS 1.3 and IPV6 on "),
                Mu("AWS Lambda"),
                Ne(" "),
                A2($u, "Cloudflare Workers", "https://workers.cloudflare.com/"),
                Ne(" and "),
                A2($u, "Pages", "https://pages.cloudflare.com/"),
                Ne(".")
            ])),
            A2(Oe, "s10 m6 l3 offset-s1", d([
                Du(Wu),
                Ne("The project is built with "),
                Mu("Docker"),
                Ne(" "),
                A2($u, "Nix", "https://nixos.org/nix"),
                Ne(" with "),
                A2($u, "Flake Parts", "https://flake.parts"),
                Ne(".")
            ]))
        ]))
    ])), Ou = fn("blockquote"), Vu = fn("cite"), Bu = A2(Ze, d([
        me("section")
    ]), d([
        A2(Ue, "", d([
            A2(Oe, "s12", d([
                Xe("But\u2026 why?"),
                A2(Ve, d([
                    me("flow-text")
                ]), d([
                    Ne("Us gym freaks have always had to rely on tired clich\xe9s or even\u2026 "),
                    Je("print media "),
                    Ne("for our workout one-liners. It's "),
                    Mu("2015"),
                    Ne(" "),
                    Mu("2018"),
                    Ne(" "),
                    Mu("2021"),
                    Ne(" "),
                    Mu("2024"),
                    Ne(" 2026 and disrupting this space is long overdue.")
                ]))
            ])),
            A2(Oe, "s12", d([
                nu("Also, this"),
                A2(Ou, s, d([
                    qe("Bart  "),
                    Ne(" Wow, you know Rainier Wolfcastle?"),
                    A2(Su, s, s),
                    qe("Homer "),
                    Ne("Yeah, he helped me blast through the burn and ride the zone")
                ])),
                A2(Vu, s, d([
                    A2(he, d([
                        ke("http://www.simpsonsarchive.com/episodes/5F16.txt"),
                        mu("_blank")
                    ]), d([
                        Ne("Simpsons 5F16")
                    ]))
                ]))
            ]))
        ]))
    ]));
    fe = {
        Main: {
            init: Or({
                aC: function() {
                    return o({
                        ao: " ",
                        ax: " ",
                        aA: " ",
                        aI: !1,
                        aT: !0,
                        aU: !0,
                        aV: !0
                    }, Vr);
                },
                aO: function(n) {
                    var r = n, t = r.aV ? A2($t, wt, Yr) : yt;
                    return Jr(d([
                        r.aU ? A2($t, wt, Gr) : yt,
                        t,
                        r.aT ? A2($t, wt, Br) : yt
                    ]));
                },
                aS: be,
                aX: function(n) {
                    var r = n;
                    return {
                        ar: d([
                            A2(we, s, d([
                                A2($e, d([
                                    me("navbar-fixed")
                                ]), d([
                                    A2(Me, d([
                                        A2(ge, "role", "navigation"),
                                        Ae("main-nav")
                                    ]), d([
                                        A2($e, d([
                                            me("nav-wrapper")
                                        ]), d([
                                            A2(he, d([
                                                ke("#"),
                                                A2(ge, "data-target", "mobile-menu"),
                                                me("sidenav-trigger")
                                            ]), d([
                                                _e
                                            ])),
                                            A2(We, d([
                                                me("left hide-on-med-and-down top-nav light")
                                            ]), Pe),
                                            A2(We, d([
                                                me("sidenav"),
                                                Ae("mobile-menu")
                                            ]), Pe)
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(xe, s, d([
                                A2($e, d([
                                    me("container"),
                                    Ae("fullpage")
                                ]), d([
                                    Eu,
                                    Bu,
                                    Tu(r),
                                    Hu(r),
                                    fu(r),
                                    qu,
                                    wu
                                ])),
                                A2($e, d([
                                    Ae("mc-bain"),
                                    me("col s12")
                                ]), d([
                                    A2($e, s, s)
                                ])),
                                A2($e, d([
                                    Ae("savant"),
                                    me("col s12")
                                ]), d([
                                    A2($e, s, s)
                                ])),
                                A2($e, d([
                                    Ae("ai-bot"),
                                    me("col s12"),
                                    Fe("Don't show me again. Ever")
                                ]), d([
                                    A2($e, s, s)
                                ]))
                            ])),
                            A2(ye, s, d([
                                Ne("A "),
                                A2(he, d([
                                    ke("https://declension.net"),
                                    A2(ge, "target", "_blank")
                                ]), d([
                                    Ne("declension")
                                ])),
                                Ne(" thing. "),
                                A2(Re, s, d([
                                    Ne("v "),
                                    Ne("3.4.1")
                                ]))
                            ]))
                        ]),
                        aQ: "Sloganator: Vacuous Slogans... as a service"
                    };
                }
            })(Tr(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? g(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, fe) : n.Elm = fe;
}($a0b4f895e1596b3b$exports);


"use strict";
const $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init();
const $35da740d59af89ba$var$isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
function $35da740d59af89ba$var$getVoicesAsync() {
    return new Promise((resolve)=>{
        const initial = window.speechSynthesis.getVoices();
        if (initial.length) {
            resolve(initial);
            return;
        }
        window.speechSynthesis.addEventListener("voiceschanged", ()=>resolve(window.speechSynthesis.getVoices()), {
            once: true
        });
    });
}
$35da740d59af89ba$var$app.ports.speakIt.subscribe(async function(text) {
    if (!text || !("speechSynthesis" in window)) return;
    const repRe = new RegExp("\\brep\\b", "gi");
    const breakRe = new RegExp("break\\b", "gi");
    // Google web TTS is crazy: "rep" = "waheedah"?
    const fixed = text.replace(repRe, "repp").replace(breakRe, "brake");
    const voices = await $35da740d59af89ba$var$getVoicesAsync();
    if (!voices.length) {
        console.warn("[speakIt] no TTS voices available \u2014 install a synthesizer (e.g. espeak-ng)");
        return;
    }
    const msg = new SpeechSynthesisUtterance(fixed);
    msg.volume = $35da740d59af89ba$var$isFirefox ? 0.75 : 0.9;
    msg.pitch = 0.7; // 0 to 2
    msg.rate = 0.8;
    // Maximum hilarity on Chrome
    msg.lang = $35da740d59af89ba$var$isFirefox ? "en" : "de";
    msg.onerror = (e)=>console.error("[speakIt] error:", e.error);
    window.speechSynthesis.speak(msg);
});
window.addEventListener("load", function(event) {
    // Mainly for Firefox
    document.querySelectorAll("a").forEach(function(el) {
        el.addEventListener("mouseup", function(e) {
            e.currentTarget.blur();
        });
    });
    // Mobile menu
    const elems = document.querySelectorAll(".sidenav");
    (0, (/*@__PURE__*/$parcel$interopDefault($6PK7Y))).Sidenav.init(elems, {});
    // Set up full page stuff
    new (0, (/*@__PURE__*/$parcel$interopDefault($1adec76eab5629a7$exports)))("#fullpage", {
        anchors: [
            "home",
            "why",
            "gym",
            "hipster",
            "ai",
            "tech",
            "api"
        ],
        verticalCentered: false,
        animateAnchor: true,
        menu: "#main-nav ul",
        paddingTop: "3em",
        navigation: true,
        licenseKey: "E9FA420D-F2054BF8-B0A1B7DC-4B163A8B",
        v2compatible: false,
        scrollingSpeed: 800,
        onLeave: function(last, next, direction) {
            const mcb = document.getElementById("mc-bain");
            const sav = document.getElementById("savant");
            const bot = document.getElementById("ai-bot");
            if (last.anchor === "why") mcb.style.opacity = 0;
            else if (next.anchor === "why") {
                sav.style.opacity = 0;
                bot.style.opacity = 0;
                setTimeout(function() {
                    mcb.style.opacity = "1.0";
                }, 700);
            }
            if (last.anchor === "hipster") sav.style.opacity = 0;
            else if (next.anchor === "hipster") {
                sav.style.opacity = 0;
                bot.style.opacity = 0;
                setTimeout(function() {
                    sav.style.opacity = "1.0";
                }, 1200);
            }
            if (last.anchor === "ai") bot.style.opacity = 0;
            else if (next.anchor === "ai") {
                sav.style.opacity = 0;
                mcb.style.opacity = 0;
                setTimeout(function() {
                    bot.style.opacity = "1.0";
                }, 800);
            } else if ([
                "tech",
                "api"
            ].indexOf(next.anchor) >= 0) {
                sav.style.opacity = 0;
                mcb.style.opacity = 0;
                bot.style.opacity = 0;
            }
        }
    });
});


//# sourceMappingURL=web.bb865a48.js.map
